
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire10c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire10c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c985A", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8d7c999c8cc5c6bc$export$ffb0004e005737fa; }, function (v) { return $8d7c999c8cc5c6bc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8d7c999c8cc5c6bc$export$34b9dba7ce09269b; }, function (v) { return $8d7c999c8cc5c6bc$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8d7c999c8cc5c6bc$export$25062201e9e25d76; }, function (v) { return $8d7c999c8cc5c6bc$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8d7c999c8cc5c6bc$export$ffb0004e005737fa;
var $8d7c999c8cc5c6bc$export$34b9dba7ce09269b;
var $8d7c999c8cc5c6bc$export$25062201e9e25d76;
"use strict";
var $8d7c999c8cc5c6bc$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8d7c999c8cc5c6bc$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $8d7c999c8cc5c6bc$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $8d7c999c8cc5c6bc$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$8d7c999c8cc5c6bc$export$ffb0004e005737fa = $8d7c999c8cc5c6bc$var$REACT_FRAGMENT_TYPE;
$8d7c999c8cc5c6bc$export$34b9dba7ce09269b = $8d7c999c8cc5c6bc$var$jsxProd;
$8d7c999c8cc5c6bc$export$25062201e9e25d76 = $8d7c999c8cc5c6bc$var$jsxProd;

});

parcelRegister("7jZ3t", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $5549ab07803c56cb$export$9c16c1426311996d; }, function (v) { return $5549ab07803c56cb$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $5549ab07803c56cb$export$dca3b0875bd9a954; }, function (v) { return $5549ab07803c56cb$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5549ab07803c56cb$export$16fa2f45be04daa8; }, function (v) { return $5549ab07803c56cb$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5549ab07803c56cb$export$ffb0004e005737fa; }, function (v) { return $5549ab07803c56cb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $5549ab07803c56cb$export$e2c29f18771995cb; }, function (v) { return $5549ab07803c56cb$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5549ab07803c56cb$export$221d75b3f55bb0bd; }, function (v) { return $5549ab07803c56cb$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5549ab07803c56cb$export$5f8d39834fd61797; }, function (v) { return $5549ab07803c56cb$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5549ab07803c56cb$export$74bf444e3cd11ea5; }, function (v) { return $5549ab07803c56cb$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $5549ab07803c56cb$export$1ced07cd6b1985ce; }, function (v) { return $5549ab07803c56cb$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $5549ab07803c56cb$export$abd8e32b826d7ea7; }, function (v) { return $5549ab07803c56cb$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $5549ab07803c56cb$export$69a3209f1a06c04d; }, function (v) { return $5549ab07803c56cb$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $5549ab07803c56cb$export$8c538325882c7eec; }, function (v) { return $5549ab07803c56cb$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5549ab07803c56cb$export$e530037191fcd5d7; }, function (v) { return $5549ab07803c56cb$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5549ab07803c56cb$export$fd42f52fd3ae1109; }, function (v) { return $5549ab07803c56cb$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5549ab07803c56cb$export$c8a8987d4410bf2d; }, function (v) { return $5549ab07803c56cb$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $5549ab07803c56cb$export$7d1e3a5e95ceca43; }, function (v) { return $5549ab07803c56cb$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5549ab07803c56cb$export$257a8862b851cb5b; }, function (v) { return $5549ab07803c56cb$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5549ab07803c56cb$export$a8257692ac88316c; }, function (v) { return $5549ab07803c56cb$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5549ab07803c56cb$export$488013bae63b21da; }, function (v) { return $5549ab07803c56cb$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5549ab07803c56cb$export$7c73462e0d25e514; }, function (v) { return $5549ab07803c56cb$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $5549ab07803c56cb$export$7568632d0d33d16d; }, function (v) { return $5549ab07803c56cb$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $5549ab07803c56cb$export$f93f40ac0ca7e3a8; }, function (v) { return $5549ab07803c56cb$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $5549ab07803c56cb$export$1f96ae73734a86cc; }, function (v) { return $5549ab07803c56cb$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $5549ab07803c56cb$export$9a47ced3238df325; }, function (v) { return $5549ab07803c56cb$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5549ab07803c56cb$export$35808ee640e87ca7; }, function (v) { return $5549ab07803c56cb$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5549ab07803c56cb$export$fae74005e78b1a27; }, function (v) { return $5549ab07803c56cb$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5549ab07803c56cb$export$dc8fbce3eb94dc1e; }, function (v) { return $5549ab07803c56cb$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $5549ab07803c56cb$export$6a7bc4e911dc01cf; }, function (v) { return $5549ab07803c56cb$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $5549ab07803c56cb$export$6d9c69b0de29b591; }, function (v) { return $5549ab07803c56cb$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $5549ab07803c56cb$export$7f54fc3180508a52; }, function (v) { return $5549ab07803c56cb$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $5549ab07803c56cb$export$f680877a34711e37; }, function (v) { return $5549ab07803c56cb$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5549ab07803c56cb$export$d5a552a76deda3c2; }, function (v) { return $5549ab07803c56cb$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $5549ab07803c56cb$export$aaabe4eda9ed9969; }, function (v) { return $5549ab07803c56cb$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5549ab07803c56cb$export$e5c5a5f917a5871c; }, function (v) { return $5549ab07803c56cb$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5549ab07803c56cb$export$1538c33de8887b59; }, function (v) { return $5549ab07803c56cb$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $5549ab07803c56cb$export$fca7f784ae7a249a; }, function (v) { return $5549ab07803c56cb$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $5549ab07803c56cb$export$13e3392192263954; }, function (v) { return $5549ab07803c56cb$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5549ab07803c56cb$export$b8f5890fc79d6aca; }, function (v) { return $5549ab07803c56cb$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5549ab07803c56cb$export$60241385465d0a34; }, function (v) { return $5549ab07803c56cb$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $5549ab07803c56cb$export$306c0aa65ff9ec16; }, function (v) { return $5549ab07803c56cb$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $5549ab07803c56cb$export$7b286972b8d8ccbf; }, function (v) { return $5549ab07803c56cb$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $5549ab07803c56cb$export$83d89fbfd8236492; }, function (v) { return $5549ab07803c56cb$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5549ab07803c56cb$export$9c16c1426311996d;
var $5549ab07803c56cb$export$dca3b0875bd9a954;
var $5549ab07803c56cb$export$16fa2f45be04daa8;
var $5549ab07803c56cb$export$ffb0004e005737fa;
var $5549ab07803c56cb$export$e2c29f18771995cb;
var $5549ab07803c56cb$export$221d75b3f55bb0bd;
var $5549ab07803c56cb$export$5f8d39834fd61797;
var $5549ab07803c56cb$export$74bf444e3cd11ea5;
var $5549ab07803c56cb$export$1ced07cd6b1985ce;
var $5549ab07803c56cb$export$abd8e32b826d7ea7;
var $5549ab07803c56cb$export$69a3209f1a06c04d;
var $5549ab07803c56cb$export$8c538325882c7eec;
var $5549ab07803c56cb$export$e530037191fcd5d7;
var $5549ab07803c56cb$export$fd42f52fd3ae1109;
var $5549ab07803c56cb$export$c8a8987d4410bf2d;
var $5549ab07803c56cb$export$7d1e3a5e95ceca43;
var $5549ab07803c56cb$export$257a8862b851cb5b;
var $5549ab07803c56cb$export$a8257692ac88316c;
var $5549ab07803c56cb$export$488013bae63b21da;
var $5549ab07803c56cb$export$7c73462e0d25e514;
var $5549ab07803c56cb$export$7568632d0d33d16d;
var $5549ab07803c56cb$export$f93f40ac0ca7e3a8;
var $5549ab07803c56cb$export$1f96ae73734a86cc;
var $5549ab07803c56cb$export$9a47ced3238df325;
var $5549ab07803c56cb$export$35808ee640e87ca7;
var $5549ab07803c56cb$export$fae74005e78b1a27;
var $5549ab07803c56cb$export$dc8fbce3eb94dc1e;
var $5549ab07803c56cb$export$6a7bc4e911dc01cf;
var $5549ab07803c56cb$export$6d9c69b0de29b591;
var $5549ab07803c56cb$export$7f54fc3180508a52;
var $5549ab07803c56cb$export$f680877a34711e37;
var $5549ab07803c56cb$export$d5a552a76deda3c2;
var $5549ab07803c56cb$export$aaabe4eda9ed9969;
var $5549ab07803c56cb$export$e5c5a5f917a5871c;
var $5549ab07803c56cb$export$1538c33de8887b59;
var $5549ab07803c56cb$export$fca7f784ae7a249a;
var $5549ab07803c56cb$export$13e3392192263954;
var $5549ab07803c56cb$export$b8f5890fc79d6aca;
var $5549ab07803c56cb$export$60241385465d0a34;
var $5549ab07803c56cb$export$306c0aa65ff9ec16;
var $5549ab07803c56cb$export$7b286972b8d8ccbf;
var $5549ab07803c56cb$export$83d89fbfd8236492;
"use strict";
var $5549ab07803c56cb$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5549ab07803c56cb$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $5549ab07803c56cb$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $5549ab07803c56cb$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $5549ab07803c56cb$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $5549ab07803c56cb$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $5549ab07803c56cb$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $5549ab07803c56cb$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $5549ab07803c56cb$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $5549ab07803c56cb$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $5549ab07803c56cb$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $5549ab07803c56cb$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $5549ab07803c56cb$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $5549ab07803c56cb$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $5549ab07803c56cb$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$5549ab07803c56cb$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $5549ab07803c56cb$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5549ab07803c56cb$var$assign = Object.assign, $5549ab07803c56cb$var$emptyObject = {};
function $5549ab07803c56cb$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5549ab07803c56cb$var$emptyObject;
    this.updater = updater || $5549ab07803c56cb$var$ReactNoopUpdateQueue;
}
$5549ab07803c56cb$var$Component.prototype.isReactComponent = {};
$5549ab07803c56cb$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$5549ab07803c56cb$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $5549ab07803c56cb$var$ComponentDummy() {}
$5549ab07803c56cb$var$ComponentDummy.prototype = $5549ab07803c56cb$var$Component.prototype;
function $5549ab07803c56cb$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5549ab07803c56cb$var$emptyObject;
    this.updater = updater || $5549ab07803c56cb$var$ReactNoopUpdateQueue;
}
var $5549ab07803c56cb$var$pureComponentPrototype = $5549ab07803c56cb$var$PureComponent.prototype = new $5549ab07803c56cb$var$ComponentDummy();
$5549ab07803c56cb$var$pureComponentPrototype.constructor = $5549ab07803c56cb$var$PureComponent;
$5549ab07803c56cb$var$assign($5549ab07803c56cb$var$pureComponentPrototype, $5549ab07803c56cb$var$Component.prototype);
$5549ab07803c56cb$var$pureComponentPrototype.isPureReactComponent = !0;
var $5549ab07803c56cb$var$isArrayImpl = Array.isArray;
function $5549ab07803c56cb$var$noop() {}
var $5549ab07803c56cb$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $5549ab07803c56cb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $5549ab07803c56cb$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $5549ab07803c56cb$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $5549ab07803c56cb$var$cloneAndReplaceKey(oldElement, newKey) {
    return $5549ab07803c56cb$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $5549ab07803c56cb$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $5549ab07803c56cb$var$REACT_ELEMENT_TYPE;
}
function $5549ab07803c56cb$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $5549ab07803c56cb$var$userProvidedKeyEscapeRegex = /\/+/g;
function $5549ab07803c56cb$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $5549ab07803c56cb$var$escape("" + element.key) : index.toString(36);
}
function $5549ab07803c56cb$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($5549ab07803c56cb$var$noop, $5549ab07803c56cb$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $5549ab07803c56cb$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $5549ab07803c56cb$var$REACT_ELEMENT_TYPE:
                case $5549ab07803c56cb$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $5549ab07803c56cb$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $5549ab07803c56cb$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $5549ab07803c56cb$var$getElementKey(children, 0) : nameSoFar, $5549ab07803c56cb$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($5549ab07803c56cb$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $5549ab07803c56cb$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($5549ab07803c56cb$var$isValidElement(callback) && (callback = $5549ab07803c56cb$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($5549ab07803c56cb$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($5549ab07803c56cb$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $5549ab07803c56cb$var$getElementKey(nameSoFar, i), invokeCallback += $5549ab07803c56cb$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $5549ab07803c56cb$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $5549ab07803c56cb$var$getElementKey(nameSoFar, i++), invokeCallback += $5549ab07803c56cb$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $5549ab07803c56cb$var$mapIntoArray($5549ab07803c56cb$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $5549ab07803c56cb$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $5549ab07803c56cb$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $5549ab07803c56cb$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $5549ab07803c56cb$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $5549ab07803c56cb$var$Children = {
    map: $5549ab07803c56cb$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $5549ab07803c56cb$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $5549ab07803c56cb$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $5549ab07803c56cb$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$5549ab07803c56cb$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$5549ab07803c56cb$export$9c16c1426311996d = $5549ab07803c56cb$var$REACT_ACTIVITY_TYPE;
$5549ab07803c56cb$export$dca3b0875bd9a954 = $5549ab07803c56cb$var$Children;
$5549ab07803c56cb$export$16fa2f45be04daa8 = $5549ab07803c56cb$var$Component;
$5549ab07803c56cb$export$ffb0004e005737fa = $5549ab07803c56cb$var$REACT_FRAGMENT_TYPE;
$5549ab07803c56cb$export$e2c29f18771995cb = $5549ab07803c56cb$var$REACT_PROFILER_TYPE;
$5549ab07803c56cb$export$221d75b3f55bb0bd = $5549ab07803c56cb$var$PureComponent;
$5549ab07803c56cb$export$5f8d39834fd61797 = $5549ab07803c56cb$var$REACT_STRICT_MODE_TYPE;
$5549ab07803c56cb$export$74bf444e3cd11ea5 = $5549ab07803c56cb$var$REACT_SUSPENSE_TYPE;
$5549ab07803c56cb$export$1ced07cd6b1985ce = $5549ab07803c56cb$var$ReactSharedInternals;
$5549ab07803c56cb$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $5549ab07803c56cb$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$5549ab07803c56cb$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$5549ab07803c56cb$export$8c538325882c7eec = function() {
    return null;
};
$5549ab07803c56cb$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $5549ab07803c56cb$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$5549ab07803c56cb$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $5549ab07803c56cb$var$ReactElement(element.type, key, props);
};
$5549ab07803c56cb$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $5549ab07803c56cb$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $5549ab07803c56cb$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$5549ab07803c56cb$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$5549ab07803c56cb$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $5549ab07803c56cb$var$ReactElement(type, key, props);
};
$5549ab07803c56cb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5549ab07803c56cb$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $5549ab07803c56cb$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$5549ab07803c56cb$export$a8257692ac88316c = $5549ab07803c56cb$var$isValidElement;
$5549ab07803c56cb$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $5549ab07803c56cb$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $5549ab07803c56cb$var$lazyInitializer
    };
};
$5549ab07803c56cb$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $5549ab07803c56cb$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$5549ab07803c56cb$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $5549ab07803c56cb$var$ReactSharedInternals.T, currentTransition = {};
    $5549ab07803c56cb$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $5549ab07803c56cb$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($5549ab07803c56cb$var$noop, $5549ab07803c56cb$var$reportGlobalError);
    } catch (error) {
        $5549ab07803c56cb$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5549ab07803c56cb$var$ReactSharedInternals.T = prevTransition;
    }
};
$5549ab07803c56cb$export$f93f40ac0ca7e3a8 = function() {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useCacheRefresh();
};
$5549ab07803c56cb$export$1f96ae73734a86cc = function(usable) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.use(usable);
};
$5549ab07803c56cb$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$5549ab07803c56cb$export$35808ee640e87ca7 = function(callback, deps) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$5549ab07803c56cb$export$fae74005e78b1a27 = function(Context) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useContext(Context);
};
$5549ab07803c56cb$export$dc8fbce3eb94dc1e = function() {};
$5549ab07803c56cb$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$5549ab07803c56cb$export$6d9c69b0de29b591 = function(create, deps) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useEffect(create, deps);
};
$5549ab07803c56cb$export$7f54fc3180508a52 = function(callback) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$5549ab07803c56cb$export$f680877a34711e37 = function() {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useId();
};
$5549ab07803c56cb$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$5549ab07803c56cb$export$aaabe4eda9ed9969 = function(create, deps) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$5549ab07803c56cb$export$e5c5a5f917a5871c = function(create, deps) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$5549ab07803c56cb$export$1538c33de8887b59 = function(create, deps) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useMemo(create, deps);
};
$5549ab07803c56cb$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$5549ab07803c56cb$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$5549ab07803c56cb$export$b8f5890fc79d6aca = function(initialValue) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useRef(initialValue);
};
$5549ab07803c56cb$export$60241385465d0a34 = function(initialState) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useState(initialState);
};
$5549ab07803c56cb$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$5549ab07803c56cb$export$7b286972b8d8ccbf = function() {
    return $5549ab07803c56cb$var$ReactSharedInternals.H.useTransition();
};
$5549ab07803c56cb$export$83d89fbfd8236492 = "19.2.0";

});

parcelRegister("gHXVo", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $c29f254ace5bce01$export$69ce8ef3fe5cead0; }, function (v) { return $c29f254ace5bce01$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $c29f254ace5bce01$export$d39a5bbd09211389; }, function (v) { return $c29f254ace5bce01$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c29f254ace5bce01$export$cd75ccfd720a3cd4; }, function (v) { return $c29f254ace5bce01$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $c29f254ace5bce01$export$a0816fa17a9e79be; }, function (v) { return $c29f254ace5bce01$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $c29f254ace5bce01$export$7292efcadded39f3; }, function (v) { return $c29f254ace5bce01$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $c29f254ace5bce01$export$da407abadb9b8f86; }, function (v) { return $c29f254ace5bce01$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $c29f254ace5bce01$export$314cfea32580671c; }, function (v) { return $c29f254ace5bce01$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $c29f254ace5bce01$export$513ccb98c53b8039; }, function (v) { return $c29f254ace5bce01$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $c29f254ace5bce01$export$dbca993bc2d264a; }, function (v) { return $c29f254ace5bce01$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $c29f254ace5bce01$export$4797a8006f0655d0; }, function (v) { return $c29f254ace5bce01$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c29f254ace5bce01$export$c78a37762a8d58e1; }, function (v) { return $c29f254ace5bce01$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $c29f254ace5bce01$export$606f11b2eb45ecc6; }, function (v) { return $c29f254ace5bce01$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $c29f254ace5bce01$export$f7e8a0bf92324b1e; }, function (v) { return $c29f254ace5bce01$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $c29f254ace5bce01$export$83d89fbfd8236492; }, function (v) { return $c29f254ace5bce01$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c29f254ace5bce01$export$69ce8ef3fe5cead0;
var $c29f254ace5bce01$export$d39a5bbd09211389;
var $c29f254ace5bce01$export$cd75ccfd720a3cd4;
var $c29f254ace5bce01$export$a0816fa17a9e79be;
var $c29f254ace5bce01$export$7292efcadded39f3;
var $c29f254ace5bce01$export$da407abadb9b8f86;
var $c29f254ace5bce01$export$314cfea32580671c;
var $c29f254ace5bce01$export$513ccb98c53b8039;
var $c29f254ace5bce01$export$dbca993bc2d264a;
var $c29f254ace5bce01$export$4797a8006f0655d0;
var $c29f254ace5bce01$export$c78a37762a8d58e1;
var $c29f254ace5bce01$export$606f11b2eb45ecc6;
var $c29f254ace5bce01$export$f7e8a0bf92324b1e;
var $c29f254ace5bce01$export$83d89fbfd8236492;
"use strict";

var $46wWE = parcelRequire("46wWE");
function $c29f254ace5bce01$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c29f254ace5bce01$var$noop() {}
var $c29f254ace5bce01$var$Internals = {
    d: {
        f: $c29f254ace5bce01$var$noop,
        r: function() {
            throw Error($c29f254ace5bce01$var$formatProdErrorMessage(522));
        },
        D: $c29f254ace5bce01$var$noop,
        C: $c29f254ace5bce01$var$noop,
        L: $c29f254ace5bce01$var$noop,
        m: $c29f254ace5bce01$var$noop,
        X: $c29f254ace5bce01$var$noop,
        S: $c29f254ace5bce01$var$noop,
        M: $c29f254ace5bce01$var$noop
    },
    p: 0,
    findDOMNode: null
}, $c29f254ace5bce01$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $c29f254ace5bce01$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c29f254ace5bce01$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $c29f254ace5bce01$var$ReactSharedInternals = $46wWE.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $c29f254ace5bce01$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$c29f254ace5bce01$export$69ce8ef3fe5cead0 = $c29f254ace5bce01$var$Internals;
$c29f254ace5bce01$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($c29f254ace5bce01$var$formatProdErrorMessage(299));
    return $c29f254ace5bce01$var$createPortal$1(children, container, null, key);
};
$c29f254ace5bce01$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $c29f254ace5bce01$var$ReactSharedInternals.T, previousUpdatePriority = $c29f254ace5bce01$var$Internals.p;
    try {
        if ($c29f254ace5bce01$var$ReactSharedInternals.T = null, $c29f254ace5bce01$var$Internals.p = 2, fn) return fn();
    } finally{
        $c29f254ace5bce01$var$ReactSharedInternals.T = previousTransition, $c29f254ace5bce01$var$Internals.p = previousUpdatePriority, $c29f254ace5bce01$var$Internals.d.f();
    }
};
$c29f254ace5bce01$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $c29f254ace5bce01$var$Internals.d.C(href, options));
};
$c29f254ace5bce01$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $c29f254ace5bce01$var$Internals.d.D(href);
};
$c29f254ace5bce01$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c29f254ace5bce01$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $c29f254ace5bce01$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $c29f254ace5bce01$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$c29f254ace5bce01$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $c29f254ace5bce01$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $c29f254ace5bce01$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $c29f254ace5bce01$var$Internals.d.M(href);
    }
};
$c29f254ace5bce01$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c29f254ace5bce01$var$getCrossOriginStringAs(as, options.crossOrigin);
        $c29f254ace5bce01$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$c29f254ace5bce01$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $c29f254ace5bce01$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $c29f254ace5bce01$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $c29f254ace5bce01$var$Internals.d.m(href);
    }
};
$c29f254ace5bce01$export$4797a8006f0655d0 = function(form) {
    $c29f254ace5bce01$var$Internals.d.r(form);
};
$c29f254ace5bce01$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$c29f254ace5bce01$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $c29f254ace5bce01$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$c29f254ace5bce01$export$f7e8a0bf92324b1e = function() {
    return $c29f254ace5bce01$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$c29f254ace5bce01$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("46wWE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7jZ3t"));

});


parcelRegister("b5Cpj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $jC7el = parcelRequire("jC7el");
function $812df432faa9ffda$var$emptyFunction() {}
function $812df432faa9ffda$var$emptyFunctionWithReset() {}
$812df432faa9ffda$var$emptyFunctionWithReset.resetWarningCache = $812df432faa9ffda$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $jC7el) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $812df432faa9ffda$var$emptyFunctionWithReset,
        resetWarningCache: $812df432faa9ffda$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("jC7el", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $e4772cb5bfa08a2c$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $e4772cb5bfa08a2c$var$ReactPropTypesSecret;

});


parcelRegister("8nNUC", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $61a730376fe10b90$export$306c0aa65ff9ec16; }, function (v) { return $61a730376fe10b90$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $61a730376fe10b90$export$306c0aa65ff9ec16;
"use strict";

var $46wWE = parcelRequire("46wWE");
function $61a730376fe10b90$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $61a730376fe10b90$var$objectIs = "function" === typeof Object.is ? Object.is : $61a730376fe10b90$var$is, $61a730376fe10b90$var$useState = $46wWE.useState, $61a730376fe10b90$var$useEffect = $46wWE.useEffect, $61a730376fe10b90$var$useLayoutEffect = $46wWE.useLayoutEffect, $61a730376fe10b90$var$useDebugValue = $46wWE.useDebugValue;
function $61a730376fe10b90$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $61a730376fe10b90$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $61a730376fe10b90$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $61a730376fe10b90$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $61a730376fe10b90$var$useEffect(function() {
        $61a730376fe10b90$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $61a730376fe10b90$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $61a730376fe10b90$var$useDebugValue(value);
    return value;
}
function $61a730376fe10b90$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$61a730376fe10b90$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $61a730376fe10b90$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $61a730376fe10b90$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $61a730376fe10b90$var$useSyncExternalStore$1 : $61a730376fe10b90$var$useSyncExternalStore$2;
$61a730376fe10b90$export$306c0aa65ff9ec16 = void 0 !== $46wWE.useSyncExternalStore ? $46wWE.useSyncExternalStore : $61a730376fe10b90$var$shim;

});

parcelRegister("1GfRv", function(module, exports) {
"use strict";
var $13960486ef591666$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $13960486ef591666$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $13960486ef591666$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


$13960486ef591666$var$__exportStar(module.exports, module.exports);

});

parcelRegister("4QmxT", function(module, exports) {
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */ (function() {
    'use strict';
    /** Used to determine if values are of the language type `Object`. */ var objectTypes = {
        'function': true,
        'object': true
    };
    /** Used as a reference to the global object. */ var root = objectTypes[typeof window] && window || this;
    /** Backup possible global object. */ var oldRoot = root;
    /** Detect free variable `exports`. */ var freeExports = objectTypes["object"] && exports;
    /** Detect free variable `module`. */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */ var freeGlobal = freeExports && freeModule && typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) root = freeGlobal;
    /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */ var maxSafeInteger = Math.pow(2, 53) - 1;
    /** Regular expression to detect Opera. */ var reOpera = /\bOpera/;
    /** Possible global object. */ var thisBinding = this;
    /** Used for native method references. */ var objectProto = Object.prototype;
    /** Used to check for own properties of an object. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to resolve the internal `[[Class]]` of values. */ var toString = objectProto.toString;
    /*--------------------------------------------------------------------------*/ /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */ function capitalize(string) {
        string = String(string);
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */ function cleanupOS(os, pattern, label) {
        // Platform tokens are defined at:
        // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        var data = {
            '10.0': '10',
            '6.4': '10 Technical Preview',
            '6.3': '8.1',
            '6.2': '8',
            '6.1': 'Server 2008 R2 / 7',
            '6.0': 'Server 2008 / Vista',
            '5.2': 'Server 2003 / XP 64-bit',
            '5.1': 'XP',
            '5.01': '2000 SP1',
            '5.0': '2000',
            '4.0': 'NT',
            '4.90': 'ME'
        };
        // Detect Windows version from platform tokens.
        if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) os = 'Windows ' + data;
        // Correct character case and cleanup string.
        os = String(os);
        if (pattern && label) os = os.replace(RegExp(pattern, 'i'), label);
        os = format(os.replace(/ ce$/i, ' CE').replace(/\bhpw/i, 'web').replace(/\bMacintosh\b/, 'Mac OS').replace(/_PowerPC\b/i, ' OS').replace(/\b(OS X) [^ \d]+/i, '$1').replace(/\bMac (OS X)\b/, '$1').replace(/\/(\d)/, ' $1').replace(/_/g, '.').replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '').replace(/\bx86\.64\b/gi, 'x86_64').replace(/\b(Windows Phone) OS\b/, '$1').replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1').split(' on ')[0]);
        return os;
    }
    /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */ function each(object, callback) {
        var index = -1, length = object ? object.length : 0;
        if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) while(++index < length)callback(object[index], index, object);
        else forOwn(object, callback);
    }
    /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */ function format(string) {
        string = trim(string);
        return /^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string);
    }
    /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */ function forOwn(object, callback) {
        for(var key in object)if (hasOwnProperty.call(object, key)) callback(object[key], key, object);
    }
    /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */ function getClassOf(value) {
        return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
    }
    /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */ function isHostType(object, property) {
        var type = object != null ? typeof object[property] : 'number';
        return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == 'object' ? !!object[property] : true);
    }
    /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */ function qualify(string) {
        return String(string).replace(/([ -])(?!$)/g, '$1?');
    }
    /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */ function reduce(array, callback) {
        var accumulator = null;
        each(array, function(value, index) {
            accumulator = callback(accumulator, value, index, array);
        });
        return accumulator;
    }
    /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */ function trim(string) {
        return String(string).replace(/^ +| +$/g, '');
    }
    /*--------------------------------------------------------------------------*/ /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */ function parse(ua) {
        /** The environment context object. */ var context = root;
        /** Used to flag when a custom context is provided. */ var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
        // Juggle arguments.
        if (isCustomContext) {
            context = ua;
            ua = null;
        }
        /** Browser navigator object. */ var nav = context.navigator || {};
        /** Browser user agent string. */ var userAgent = nav.userAgent || '';
        ua || (ua = userAgent);
        /** Used to flag when `thisBinding` is the [ModuleScope]. */ var isModuleScope = isCustomContext || thisBinding == oldRoot;
        /** Used to detect if browser is like Chrome. */ var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
        /** Internal `[[Class]]` value shortcuts. */ var objectClass = 'Object', airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject', enviroClass = isCustomContext ? objectClass : 'Environment', javaClass = isCustomContext && context.java ? 'JavaPackage' : getClassOf(context.java), phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
        /** Detect Java environments. */ var java = /\bJava/.test(javaClass) && context.java;
        /** Detect Rhino. */ var rhino = java && getClassOf(context.environment) == enviroClass;
        /** A character to represent alpha. */ var alpha = java ? 'a' : '\u03b1';
        /** A character to represent beta. */ var beta = java ? 'b' : '\u03b2';
        /** Browser document object. */ var doc = context.document || {};
        /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */ var opera = context.operamini || context.opera;
        /** Opera `[[Class]]`. */ var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera['[[Class]]'] : getClassOf(opera)) ? operaClass : opera = null;
        /*------------------------------------------------------------------------*/ /** Temporary variable used over the script's lifetime. */ var data;
        /** The CPU architecture. */ var arch = ua;
        /** Platform description array. */ var description = [];
        /** Platform alpha/beta indicator. */ var prerelease = null;
        /** A flag to indicate that environment features should be used to resolve the platform. */ var useFeatures = ua == userAgent;
        /** The browser/environment version. */ var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
        /** A flag to indicate if the OS ends with "/ Version" */ var isSpecialCasedOS;
        /* Detectable layout engines (order is important). */ var layout = getLayout([
            {
                'label': 'EdgeHTML',
                'pattern': 'Edge'
            },
            'Trident',
            {
                'label': 'WebKit',
                'pattern': 'AppleWebKit'
            },
            'iCab',
            'Presto',
            'NetFront',
            'Tasman',
            'KHTML',
            'Gecko'
        ]);
        /* Detectable browser names (order is important). */ var name = getName([
            'Adobe AIR',
            'Arora',
            'Avant Browser',
            'Breach',
            'Camino',
            'Electron',
            'Epiphany',
            'Fennec',
            'Flock',
            'Galeon',
            'GreenBrowser',
            'iCab',
            'Iceweasel',
            'K-Meleon',
            'Konqueror',
            'Lunascape',
            'Maxthon',
            {
                'label': 'Microsoft Edge',
                'pattern': '(?:Edge|Edg|EdgA|EdgiOS)'
            },
            'Midori',
            'Nook Browser',
            'PaleMoon',
            'PhantomJS',
            'Raven',
            'Rekonq',
            'RockMelt',
            {
                'label': 'Samsung Internet',
                'pattern': 'SamsungBrowser'
            },
            'SeaMonkey',
            {
                'label': 'Silk',
                'pattern': '(?:Cloud9|Silk-Accelerated)'
            },
            'Sleipnir',
            'SlimBrowser',
            {
                'label': 'SRWare Iron',
                'pattern': 'Iron'
            },
            'Sunrise',
            'Swiftfox',
            'Vivaldi',
            'Waterfox',
            'WebPositive',
            {
                'label': 'Yandex Browser',
                'pattern': 'YaBrowser'
            },
            {
                'label': 'UC Browser',
                'pattern': 'UCBrowser'
            },
            'Opera Mini',
            {
                'label': 'Opera Mini',
                'pattern': 'OPiOS'
            },
            'Opera',
            {
                'label': 'Opera',
                'pattern': 'OPR'
            },
            'Chromium',
            'Chrome',
            {
                'label': 'Chrome',
                'pattern': '(?:HeadlessChrome)'
            },
            {
                'label': 'Chrome Mobile',
                'pattern': '(?:CriOS|CrMo)'
            },
            {
                'label': 'Firefox',
                'pattern': '(?:Firefox|Minefield)'
            },
            {
                'label': 'Firefox for iOS',
                'pattern': 'FxiOS'
            },
            {
                'label': 'IE',
                'pattern': 'IEMobile'
            },
            {
                'label': 'IE',
                'pattern': 'MSIE'
            },
            'Safari'
        ]);
        /* Detectable products (order is important). */ var product = getProduct([
            {
                'label': 'BlackBerry',
                'pattern': 'BB10'
            },
            'BlackBerry',
            {
                'label': 'Galaxy S',
                'pattern': 'GT-I9000'
            },
            {
                'label': 'Galaxy S2',
                'pattern': 'GT-I9100'
            },
            {
                'label': 'Galaxy S3',
                'pattern': 'GT-I9300'
            },
            {
                'label': 'Galaxy S4',
                'pattern': 'GT-I9500'
            },
            {
                'label': 'Galaxy S5',
                'pattern': 'SM-G900'
            },
            {
                'label': 'Galaxy S6',
                'pattern': 'SM-G920'
            },
            {
                'label': 'Galaxy S6 Edge',
                'pattern': 'SM-G925'
            },
            {
                'label': 'Galaxy S7',
                'pattern': 'SM-G930'
            },
            {
                'label': 'Galaxy S7 Edge',
                'pattern': 'SM-G935'
            },
            'Google TV',
            'Lumia',
            'iPad',
            'iPod',
            'iPhone',
            'Kindle',
            {
                'label': 'Kindle Fire',
                'pattern': '(?:Cloud9|Silk-Accelerated)'
            },
            'Nexus',
            'Nook',
            'PlayBook',
            'PlayStation Vita',
            'PlayStation',
            'TouchPad',
            'Transformer',
            {
                'label': 'Wii U',
                'pattern': 'WiiU'
            },
            'Wii',
            'Xbox One',
            {
                'label': 'Xbox 360',
                'pattern': 'Xbox'
            },
            'Xoom'
        ]);
        /* Detectable manufacturers. */ var manufacturer = getManufacturer({
            'Apple': {
                'iPad': 1,
                'iPhone': 1,
                'iPod': 1
            },
            'Alcatel': {},
            'Archos': {},
            'Amazon': {
                'Kindle': 1,
                'Kindle Fire': 1
            },
            'Asus': {
                'Transformer': 1
            },
            'Barnes & Noble': {
                'Nook': 1
            },
            'BlackBerry': {
                'PlayBook': 1
            },
            'Google': {
                'Google TV': 1,
                'Nexus': 1
            },
            'HP': {
                'TouchPad': 1
            },
            'HTC': {},
            'Huawei': {},
            'Lenovo': {},
            'LG': {},
            'Microsoft': {
                'Xbox': 1,
                'Xbox One': 1
            },
            'Motorola': {
                'Xoom': 1
            },
            'Nintendo': {
                'Wii U': 1,
                'Wii': 1
            },
            'Nokia': {
                'Lumia': 1
            },
            'Oppo': {},
            'Samsung': {
                'Galaxy S': 1,
                'Galaxy S2': 1,
                'Galaxy S3': 1,
                'Galaxy S4': 1
            },
            'Sony': {
                'PlayStation': 1,
                'PlayStation Vita': 1
            },
            'Xiaomi': {
                'Mi': 1,
                'Redmi': 1
            }
        });
        /* Detectable operating systems (order is important). */ var os = getOS([
            'Windows Phone',
            'KaiOS',
            'Android',
            'CentOS',
            {
                'label': 'Chrome OS',
                'pattern': 'CrOS'
            },
            'Debian',
            {
                'label': 'DragonFly BSD',
                'pattern': 'DragonFly'
            },
            'Fedora',
            'FreeBSD',
            'Gentoo',
            'Haiku',
            'Kubuntu',
            'Linux Mint',
            'OpenBSD',
            'Red Hat',
            'SuSE',
            'Ubuntu',
            'Xubuntu',
            'Cygwin',
            'Symbian OS',
            'hpwOS',
            'webOS ',
            'webOS',
            'Tablet OS',
            'Tizen',
            'Linux',
            'Mac OS X',
            'Macintosh',
            'Mac',
            'Windows 98;',
            'Windows '
        ]);
        /*------------------------------------------------------------------------*/ /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */ function getLayout(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */ function getManufacturer(guesses) {
            return reduce(guesses, function(result, value, key) {
                // Lookup the manufacturer by product or scan the UA for the manufacturer.
                return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)) && key;
            });
        }
        /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */ function getName(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */ function getOS(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua))) result = cleanupOS(result, pattern, guess.label || guess);
                return result;
            });
        }
        /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */ function getProduct(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) || RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) || RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua))) {
                    // Split by forward slash and append product version if needed.
                    if ((result = String(guess.label && !RegExp(pattern, 'i').test(guess.label) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) result[0] += ' ' + result[1];
                    // Correct character case and cleanup string.
                    guess = guess.label || guess;
                    result = format(result[0].replace(RegExp(pattern, 'i'), guess).replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ').replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
                }
                return result;
            });
        }
        /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */ function getVersion(patterns) {
            return reduce(patterns, function(result, pattern) {
                return result || (RegExp(pattern + '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
            });
        }
        /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */ function toStringPlatform() {
            return this.description || '';
        }
        /*------------------------------------------------------------------------*/ // Convert layout to an array so we can add extra details.
        layout && (layout = [
            layout
        ]);
        // Detect Android products.
        // Browsers on Android devices typically provide their product IDS after "Android;"
        // up to "Build" or ") AppleWebKit".
        // Example:
        // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
        // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
        if (/\bAndroid\b/.test(os) && !product && (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) product = trim(data[1])// Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '') || null;
        // Detect product names that contain their manufacturer's name.
        if (manufacturer && !product) product = getProduct([
            manufacturer
        ]);
        else if (manufacturer && product) product = product.replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ').replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
        // Clean up Google TV.
        if (data = /\bGoogle TV\b/.exec(product)) product = data[0];
        // Detect simulators.
        if (/\bSimulator\b/i.test(ua)) product = (product ? product + ' ' : '') + 'Simulator';
        // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
        if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) description.push('running in Turbo/Uncompressed mode');
        // Detect IE Mobile 11.
        if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
            data = parse(ua.replace(/like iPhone OS/, ''));
            manufacturer = data.manufacturer;
            product = data.product;
        } else if (/^iP/.test(product)) {
            name || (name = 'Safari');
            os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua)) ? ' ' + data[1].replace(/_/g, '.') : '');
        } else if (name == 'Konqueror' && /^Linux\b/i.test(os)) os = 'Kubuntu';
        else if (manufacturer && manufacturer != 'Google' && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
            name = 'Android Browser';
            os = /\bAndroid\b/.test(os) ? os : 'Android';
        } else if (name == 'Silk') {
            if (!/\bMobi/i.test(ua)) {
                os = 'Android';
                description.unshift('desktop mode');
            }
            if (/Accelerated *= *true/i.test(ua)) description.unshift('accelerated');
        } else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) description.push('speed mode');
        else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) description.push('identifying as Firefox ' + data[1]);
        else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
            os || (os = 'Firefox OS');
            product || (product = data[1]);
        } else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
            // Escape the `/` for Firefox 1.
            if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) // Clear name of false positives.
            name = null;
            // Reassign a generic name.
            if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
        } else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) description.push('Chromium ' + data);
        // Detect non-Opera (Presto-based) versions (order is important).
        if (!version) version = getVersion([
            '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
            'Version',
            qualify(name),
            '(?:Firefox|Minefield|NetFront)'
        ]);
        // Detect stubborn layout engines.
        if (data = layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' || !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') || layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront') layout = [
            data
        ];
        // Detect Windows Phone 7 desktop mode.
        if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
            name += ' Mobile';
            os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
            description.unshift('desktop mode');
        } else if (/\bWPDesktop\b/i.test(ua)) {
            name = 'IE Mobile';
            os = 'Windows Phone 8.x';
            description.unshift('desktop mode');
            version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
        } else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
            if (name) description.push('identifying as ' + name + (version ? ' ' + version : ''));
            name = 'IE';
            version = data[1];
        }
        // Leverage environment features.
        if (useFeatures) {
            // Detect server-side environments.
            // Rhino has a global function while others have a global object.
            if (isHostType(context, 'global')) {
                if (java) {
                    data = java.lang.System;
                    arch = data.getProperty('os.arch');
                    os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
                }
                if (rhino) {
                    try {
                        version = context.require('ringo/engine').version.join('.');
                        name = 'RingoJS';
                    } catch (e) {
                        if ((data = context.system) && data.global.system == context.system) {
                            name = 'Narwhal';
                            os || (os = data[0].os || null);
                        }
                    }
                    if (!name) name = 'Rhino';
                } else if (typeof context.process == 'object' && !context.process.browser && (data = context.process)) {
                    if (typeof data.versions == 'object') {
                        if (typeof data.versions.electron == 'string') {
                            description.push('Node ' + data.versions.node);
                            name = 'Electron';
                            version = data.versions.electron;
                        } else if (typeof data.versions.nw == 'string') {
                            description.push('Chromium ' + version, 'Node ' + data.versions.node);
                            name = 'NW.js';
                            version = data.versions.nw;
                        }
                    }
                    if (!name) {
                        name = 'Node.js';
                        arch = data.arch;
                        os = data.platform;
                        version = /[\d.]+/.exec(data.version);
                        version = version ? version[0] : null;
                    }
                }
            } else if (getClassOf(data = context.runtime) == airRuntimeClass) {
                name = 'Adobe AIR';
                os = data.flash.system.Capabilities.os;
            } else if (getClassOf(data = context.phantom) == phantomClass) {
                name = 'PhantomJS';
                version = (data = data.version || null) && data.major + '.' + data.minor + '.' + data.patch;
            } else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
                // We're in compatibility mode when the Trident version + 4 doesn't
                // equal the document mode.
                version = [
                    version,
                    doc.documentMode
                ];
                if ((data = +data[1] + 4) != version[1]) {
                    description.push('IE ' + version[1] + ' mode');
                    layout && (layout[1] = '');
                    version[1] = data;
                }
                version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
            } else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
                description.push('masking as ' + name + ' ' + version);
                name = 'IE';
                version = '11.0';
                layout = [
                    'Trident'
                ];
                os = 'Windows';
            }
            os = os && format(os);
        }
        // Detect prerelease phases.
        if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && 'a')) {
            prerelease = /b/i.test(data) ? 'beta' : 'alpha';
            version = version.replace(RegExp(data + '\\+?$'), '') + (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
        }
        // Detect Firefox Mobile.
        if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) name = 'Firefox Mobile';
        else if (name == 'Maxthon' && version) version = version.replace(/\.[\d.]+/, '.x');
        else if (/\bXbox\b/i.test(product)) {
            if (product == 'Xbox 360') os = null;
            if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) description.unshift('mobile mode');
        } else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == 'Windows CE' || /Mobi/i.test(ua))) name += ' Mobile';
        else if (name == 'IE' && useFeatures) try {
            if (context.external === null) description.unshift('platform preview');
        } catch (e) {
            description.unshift('embedded');
        }
        else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] || version)) {
            data = [
                data,
                /BB10/.test(ua)
            ];
            os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
            version = null;
        } else if (this != forOwn && product != 'Wii' && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os) || name == 'IE' && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, '') + ';')) && data.name) {
            // When "identifying", the UA contains both Opera and the other browser's name.
            data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
            if (reOpera.test(name)) {
                if (/\bIE\b/.test(data) && os == 'Mac OS') os = null;
                data = 'identify' + data;
            } else {
                data = 'mask' + data;
                if (operaClass) name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
                else name = 'Opera';
                if (/\bIE\b/.test(data)) os = null;
                if (!useFeatures) version = null;
            }
            layout = [
                'Presto'
            ];
            description.push(data);
        }
        // Detect WebKit Nightly and approximate Chrome/Safari versions.
        if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
            // Correct build number for numeric comparison.
            // (e.g. "532.5" becomes "532.05")
            data = [
                parseFloat(data.replace(/\.(\d)$/, '.0$1')),
                data
            ];
            // Nightly builds are postfixed with a "+".
            if (name == 'Safari' && data[1].slice(-1) == '+') {
                name = 'WebKit Nightly';
                prerelease = 'alpha';
                version = data[1].slice(0, -1);
            } else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) version = null;
            // Use the full Chrome version when available.
            data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
            // Detect Blink layout engine.
            if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') layout = [
                'Blink'
            ];
            // Detect JavaScriptCore.
            // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
            if (!useFeatures || !likeChrome && !data[1]) {
                layout && (layout[1] = 'like Safari');
                data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
            } else {
                layout && (layout[1] = 'like Chrome');
                data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
            }
            // Add the postfix of ".x" or "+" for approximate versions.
            layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
            // Obscure version for some Safari 1-2 releases.
            if (name == 'Safari' && (!version || parseInt(version) > 45)) version = data;
            else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) description.unshift('headless');
        }
        // Detect Opera desktop modes.
        if (name == 'Opera' && (data = /\bzbov|zvav$/.exec(os))) {
            name += ' ';
            description.unshift('desktop mode');
            if (data == 'zvav') {
                name += 'Mini';
                version = null;
            } else name += 'Mobile';
            os = os.replace(RegExp(' *' + data + '$'), '');
        } else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
            description.unshift('desktop mode');
            name = 'Chrome Mobile';
            version = null;
            if (/\bOS X\b/.test(os)) {
                manufacturer = 'Apple';
                os = 'iOS 4.3+';
            } else os = null;
        } else if (/\bSRWare Iron\b/.test(name) && !version) version = getVersion('Chrome');
        // Strip incorrect OS versions.
        if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf('/' + data + '-') > -1) os = trim(os.replace(data, ''));
        // Ensure OS does not include the browser name.
        if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
        // Add layout engine.
        if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) // Don't add layout details to description if they are falsey.
        (data = layout[layout.length - 1]) && description.push(data);
        // Combine contextual information.
        if (description.length) description = [
            '(' + description.join('; ') + ')'
        ];
        // Append manufacturer to description.
        if (manufacturer && product && product.indexOf(manufacturer) < 0) description.push('on ' + manufacturer);
        // Append product to description.
        if (product) description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
        // Parse the OS into an object.
        if (os) {
            data = / ([\d.+]+)$/.exec(os);
            isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
            os = {
                'architecture': 32,
                'family': data && !isSpecialCasedOS ? os.replace(data[0], '') : os,
                'version': data ? data[1] : null,
                'toString': function() {
                    var version = this.version;
                    return this.family + (version && !isSpecialCasedOS ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
                }
            };
        }
        // Add browser/OS architecture.
        if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
            if (os) {
                os.architecture = 64;
                os.family = os.family.replace(RegExp(' *' + data), '');
            }
            if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) description.unshift('32-bit');
        } else if (os && /^OS X/.test(os.family) && name == 'Chrome' && parseFloat(version) >= 39) os.architecture = 64;
        ua || (ua = null);
        /*------------------------------------------------------------------------*/ /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */ var platform = {};
        /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */ platform.description = ua;
        /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */ platform.layout = layout && layout[0];
        /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */ platform.manufacturer = manufacturer;
        /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */ platform.name = name;
        /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */ platform.prerelease = prerelease;
        /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */ platform.product = product;
        /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */ platform.ua = ua;
        /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */ platform.version = name && version;
        /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */ platform.os = os || {
            /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */ 'architecture': null,
            /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */ 'family': null,
            /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */ 'version': null,
            /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */ 'toString': function() {
                return 'null';
            }
        };
        platform.parse = parse;
        platform.toString = toStringPlatform;
        if (platform.version) description.unshift(version);
        if (platform.name) description.unshift(name);
        if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) description.push(product ? '(' + os + ')' : 'on ' + os);
        if (description.length) platform.description = description.join(' ');
        return platform;
    }
    /*--------------------------------------------------------------------------*/ // Export platform.
    var platform = parse();
    // Some AMD build optimizers, like r.js, check for condition patterns like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose platform on the global object to prevent errors when platform is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        root.platform = platform;
        // Define as an anonymous module so platform can be aliased through path mapping.
        define(function() {
            return platform;
        });
    } else if (freeExports && freeModule) // Export for CommonJS support.
    forOwn(platform, function(value, key) {
        freeExports[key] = value;
    });
    else // Export to the global object.
    root.platform = platform;
}).call(this);

});

parcelRegister("1zCs8", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        var global1 = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || typeof global1 !== 'undefined' && global1;
        var support = {
            searchParams: 'URLSearchParams' in global1,
            iterable: 'Symbol' in global1 && 'iterator' in Symbol,
            blob: 'FileReader' in global1 && 'Blob' in global1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in global1,
            arrayBuffer: 'ArrayBuffer' in global1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) {
                        var isConsumed = consumed(this);
                        if (isConsumed) return isConsumed;
                        if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                        else return Promise.resolve(this._bodyArrayBuffer);
                    } else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = global1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && global1.location.href ? global1.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer && request.headers.get('Content-Type') && request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                });
                else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!global1.fetch) {
            global1.fetch = fetch;
            global1.Headers = Headers;
            global1.Request = Request;
            global1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("6nJ62", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $4a57df467ec2c8e6$export$882461b6382ed46c; }, function (v) { return $4a57df467ec2c8e6$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4a57df467ec2c8e6$export$757ceba2d55c277e; }, function (v) { return $4a57df467ec2c8e6$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $4a57df467ec2c8e6$export$83d89fbfd8236492; }, function (v) { return $4a57df467ec2c8e6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4a57df467ec2c8e6$export$882461b6382ed46c;
var $4a57df467ec2c8e6$export$757ceba2d55c277e;
var $4a57df467ec2c8e6$export$83d89fbfd8236492;
"use strict";

var $gARKC = parcelRequire("gARKC");

var $46wWE = parcelRequire("46wWE");

var $2jkQi = parcelRequire("2jkQi");
function $4a57df467ec2c8e6$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4a57df467ec2c8e6$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $4a57df467ec2c8e6$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $4a57df467ec2c8e6$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $4a57df467ec2c8e6$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $4a57df467ec2c8e6$var$assertIsMounted(fiber) {
    if ($4a57df467ec2c8e6$var$getNearestMountedFiber(fiber) !== fiber) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(188));
}
function $4a57df467ec2c8e6$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $4a57df467ec2c8e6$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $4a57df467ec2c8e6$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $4a57df467ec2c8e6$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $4a57df467ec2c8e6$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $4a57df467ec2c8e6$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $4a57df467ec2c8e6$var$assign = Object.assign, $4a57df467ec2c8e6$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $4a57df467ec2c8e6$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $4a57df467ec2c8e6$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4a57df467ec2c8e6$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $4a57df467ec2c8e6$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $4a57df467ec2c8e6$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $4a57df467ec2c8e6$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $4a57df467ec2c8e6$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $4a57df467ec2c8e6$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $4a57df467ec2c8e6$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $4a57df467ec2c8e6$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $4a57df467ec2c8e6$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $4a57df467ec2c8e6$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $4a57df467ec2c8e6$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $4a57df467ec2c8e6$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $4a57df467ec2c8e6$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $4a57df467ec2c8e6$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$4a57df467ec2c8e6$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $4a57df467ec2c8e6$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $4a57df467ec2c8e6$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $4a57df467ec2c8e6$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $4a57df467ec2c8e6$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $4a57df467ec2c8e6$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $4a57df467ec2c8e6$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $4a57df467ec2c8e6$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $4a57df467ec2c8e6$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $4a57df467ec2c8e6$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $4a57df467ec2c8e6$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $4a57df467ec2c8e6$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $4a57df467ec2c8e6$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $4a57df467ec2c8e6$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $4a57df467ec2c8e6$var$getComponentNameFromType(type.type) || "Memo";
        case $4a57df467ec2c8e6$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $4a57df467ec2c8e6$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $4a57df467ec2c8e6$var$isArrayImpl = Array.isArray, $4a57df467ec2c8e6$var$ReactSharedInternals = $46wWE.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $4a57df467ec2c8e6$var$ReactDOMSharedInternals = $2jkQi.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $4a57df467ec2c8e6$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $4a57df467ec2c8e6$var$valueStack = [], $4a57df467ec2c8e6$var$index = -1;
function $4a57df467ec2c8e6$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $4a57df467ec2c8e6$var$pop(cursor) {
    0 > $4a57df467ec2c8e6$var$index || (cursor.current = $4a57df467ec2c8e6$var$valueStack[$4a57df467ec2c8e6$var$index], $4a57df467ec2c8e6$var$valueStack[$4a57df467ec2c8e6$var$index] = null, $4a57df467ec2c8e6$var$index--);
}
function $4a57df467ec2c8e6$var$push(cursor, value) {
    $4a57df467ec2c8e6$var$index++;
    $4a57df467ec2c8e6$var$valueStack[$4a57df467ec2c8e6$var$index] = cursor.current;
    cursor.current = value;
}
var $4a57df467ec2c8e6$var$contextStackCursor = $4a57df467ec2c8e6$var$createCursor(null), $4a57df467ec2c8e6$var$contextFiberStackCursor = $4a57df467ec2c8e6$var$createCursor(null), $4a57df467ec2c8e6$var$rootInstanceStackCursor = $4a57df467ec2c8e6$var$createCursor(null), $4a57df467ec2c8e6$var$hostTransitionProviderCursor = $4a57df467ec2c8e6$var$createCursor(null);
function $4a57df467ec2c8e6$var$pushHostContainer(fiber, nextRootInstance) {
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$rootInstanceStackCursor, nextRootInstance);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$contextFiberStackCursor, fiber);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $4a57df467ec2c8e6$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $4a57df467ec2c8e6$var$getOwnHostContext(nextRootInstance), fiber = $4a57df467ec2c8e6$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$contextStackCursor);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$contextStackCursor, fiber);
}
function $4a57df467ec2c8e6$var$popHostContainer() {
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$contextStackCursor);
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$contextFiberStackCursor);
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$rootInstanceStackCursor);
}
function $4a57df467ec2c8e6$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$hostTransitionProviderCursor, fiber);
    var context = $4a57df467ec2c8e6$var$contextStackCursor.current;
    var JSCompiler_inline_result = $4a57df467ec2c8e6$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$contextFiberStackCursor, fiber), $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$contextStackCursor, JSCompiler_inline_result));
}
function $4a57df467ec2c8e6$var$popHostContext(fiber) {
    $4a57df467ec2c8e6$var$contextFiberStackCursor.current === fiber && ($4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$contextStackCursor), $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$contextFiberStackCursor));
    $4a57df467ec2c8e6$var$hostTransitionProviderCursor.current === fiber && ($4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$hostTransitionProviderCursor), $4a57df467ec2c8e6$var$HostTransitionContext._currentValue = $4a57df467ec2c8e6$var$sharedNotPendingObject);
}
var $4a57df467ec2c8e6$var$prefix, $4a57df467ec2c8e6$var$suffix;
function $4a57df467ec2c8e6$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $4a57df467ec2c8e6$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $4a57df467ec2c8e6$var$prefix = match && match[1] || "";
        $4a57df467ec2c8e6$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $4a57df467ec2c8e6$var$prefix + name + $4a57df467ec2c8e6$var$suffix;
}
var $4a57df467ec2c8e6$var$reentry = !1;
function $4a57df467ec2c8e6$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $4a57df467ec2c8e6$var$reentry) return "";
    $4a57df467ec2c8e6$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $4a57df467ec2c8e6$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $4a57df467ec2c8e6$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $4a57df467ec2c8e6$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $4a57df467ec2c8e6$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $4a57df467ec2c8e6$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $4a57df467ec2c8e6$var$describeBuiltInComponentFrame("Suspense Fallback") : $4a57df467ec2c8e6$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $4a57df467ec2c8e6$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $4a57df467ec2c8e6$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $4a57df467ec2c8e6$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $4a57df467ec2c8e6$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $4a57df467ec2c8e6$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $4a57df467ec2c8e6$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $4a57df467ec2c8e6$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $4a57df467ec2c8e6$var$hasOwnProperty = Object.prototype.hasOwnProperty, $4a57df467ec2c8e6$var$scheduleCallback$3 = $gARKC.unstable_scheduleCallback, $4a57df467ec2c8e6$var$cancelCallback$1 = $gARKC.unstable_cancelCallback, $4a57df467ec2c8e6$var$shouldYield = $gARKC.unstable_shouldYield, $4a57df467ec2c8e6$var$requestPaint = $gARKC.unstable_requestPaint, $4a57df467ec2c8e6$var$now = $gARKC.unstable_now, $4a57df467ec2c8e6$var$getCurrentPriorityLevel = $gARKC.unstable_getCurrentPriorityLevel, $4a57df467ec2c8e6$var$ImmediatePriority = $gARKC.unstable_ImmediatePriority, $4a57df467ec2c8e6$var$UserBlockingPriority = $gARKC.unstable_UserBlockingPriority, $4a57df467ec2c8e6$var$NormalPriority$1 = $gARKC.unstable_NormalPriority, $4a57df467ec2c8e6$var$LowPriority = $gARKC.unstable_LowPriority, $4a57df467ec2c8e6$var$IdlePriority = $gARKC.unstable_IdlePriority, $4a57df467ec2c8e6$var$log$1 = $gARKC.log, $4a57df467ec2c8e6$var$unstable_setDisableYieldValue = $gARKC.unstable_setDisableYieldValue, $4a57df467ec2c8e6$var$rendererID = null, $4a57df467ec2c8e6$var$injectedHook = null;
function $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $4a57df467ec2c8e6$var$log$1 && $4a57df467ec2c8e6$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($4a57df467ec2c8e6$var$injectedHook && "function" === typeof $4a57df467ec2c8e6$var$injectedHook.setStrictMode) try {
        $4a57df467ec2c8e6$var$injectedHook.setStrictMode($4a57df467ec2c8e6$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $4a57df467ec2c8e6$var$clz32 = Math.clz32 ? Math.clz32 : $4a57df467ec2c8e6$var$clz32Fallback, $4a57df467ec2c8e6$var$log = Math.log, $4a57df467ec2c8e6$var$LN2 = Math.LN2;
function $4a57df467ec2c8e6$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($4a57df467ec2c8e6$var$log(x) / $4a57df467ec2c8e6$var$LN2 | 0) | 0;
}
var $4a57df467ec2c8e6$var$nextTransitionUpdateLane = 256, $4a57df467ec2c8e6$var$nextTransitionDeferredLane = 262144, $4a57df467ec2c8e6$var$nextRetryLane = 4194304;
function $4a57df467ec2c8e6$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $4a57df467ec2c8e6$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $4a57df467ec2c8e6$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $4a57df467ec2c8e6$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $4a57df467ec2c8e6$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $4a57df467ec2c8e6$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $4a57df467ec2c8e6$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $4a57df467ec2c8e6$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $4a57df467ec2c8e6$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $4a57df467ec2c8e6$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4a57df467ec2c8e6$var$claimNextRetryLane() {
    var lane = $4a57df467ec2c8e6$var$nextRetryLane;
    $4a57df467ec2c8e6$var$nextRetryLane <<= 1;
    0 === ($4a57df467ec2c8e6$var$nextRetryLane & 62914560) && ($4a57df467ec2c8e6$var$nextRetryLane = 4194304);
    return lane;
}
function $4a57df467ec2c8e6$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $4a57df467ec2c8e6$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $4a57df467ec2c8e6$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $4a57df467ec2c8e6$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $4a57df467ec2c8e6$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $4a57df467ec2c8e6$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $4a57df467ec2c8e6$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $4a57df467ec2c8e6$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $4a57df467ec2c8e6$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $4a57df467ec2c8e6$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $4a57df467ec2c8e6$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $4a57df467ec2c8e6$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $4a57df467ec2c8e6$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $4a57df467ec2c8e6$var$resolveUpdatePriority() {
    var updatePriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $4a57df467ec2c8e6$var$getEventPriority(updatePriority.type);
}
function $4a57df467ec2c8e6$var$runWithPriority(priority, fn) {
    var previousPriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
    try {
        return $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $4a57df467ec2c8e6$var$randomKey = Math.random().toString(36).slice(2), $4a57df467ec2c8e6$var$internalInstanceKey = "__reactFiber$" + $4a57df467ec2c8e6$var$randomKey, $4a57df467ec2c8e6$var$internalPropsKey = "__reactProps$" + $4a57df467ec2c8e6$var$randomKey, $4a57df467ec2c8e6$var$internalContainerInstanceKey = "__reactContainer$" + $4a57df467ec2c8e6$var$randomKey, $4a57df467ec2c8e6$var$internalEventHandlersKey = "__reactEvents$" + $4a57df467ec2c8e6$var$randomKey, $4a57df467ec2c8e6$var$internalEventHandlerListenersKey = "__reactListeners$" + $4a57df467ec2c8e6$var$randomKey, $4a57df467ec2c8e6$var$internalEventHandlesSetKey = "__reactHandles$" + $4a57df467ec2c8e6$var$randomKey, $4a57df467ec2c8e6$var$internalRootNodeResourcesKey = "__reactResources$" + $4a57df467ec2c8e6$var$randomKey, $4a57df467ec2c8e6$var$internalHoistableMarker = "__reactMarker$" + $4a57df467ec2c8e6$var$randomKey;
function $4a57df467ec2c8e6$var$detachDeletedInstance(node) {
    delete node[$4a57df467ec2c8e6$var$internalInstanceKey];
    delete node[$4a57df467ec2c8e6$var$internalPropsKey];
    delete node[$4a57df467ec2c8e6$var$internalEventHandlersKey];
    delete node[$4a57df467ec2c8e6$var$internalEventHandlerListenersKey];
    delete node[$4a57df467ec2c8e6$var$internalEventHandlesSetKey];
}
function $4a57df467ec2c8e6$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$4a57df467ec2c8e6$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$4a57df467ec2c8e6$var$internalContainerInstanceKey] || parentNode[$4a57df467ec2c8e6$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $4a57df467ec2c8e6$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$4a57df467ec2c8e6$var$internalInstanceKey]) return parentNode;
                targetNode = $4a57df467ec2c8e6$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $4a57df467ec2c8e6$var$getInstanceFromNode(node) {
    if (node = node[$4a57df467ec2c8e6$var$internalInstanceKey] || node[$4a57df467ec2c8e6$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $4a57df467ec2c8e6$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(33));
}
function $4a57df467ec2c8e6$var$getResourcesFromRoot(root) {
    var resources = root[$4a57df467ec2c8e6$var$internalRootNodeResourcesKey];
    resources || (resources = root[$4a57df467ec2c8e6$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $4a57df467ec2c8e6$var$markNodeAsHoistable(node) {
    node[$4a57df467ec2c8e6$var$internalHoistableMarker] = !0;
}
var $4a57df467ec2c8e6$var$allNativeEvents = new Set(), $4a57df467ec2c8e6$var$registrationNameDependencies = {};
function $4a57df467ec2c8e6$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $4a57df467ec2c8e6$var$registerDirectEvent(registrationName, dependencies);
    $4a57df467ec2c8e6$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $4a57df467ec2c8e6$var$registerDirectEvent(registrationName, dependencies) {
    $4a57df467ec2c8e6$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$4a57df467ec2c8e6$var$allNativeEvents.add(dependencies[registrationName]);
}
var $4a57df467ec2c8e6$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $4a57df467ec2c8e6$var$illegalAttributeNameCache = {}, $4a57df467ec2c8e6$var$validatedAttributeNameCache = {};
function $4a57df467ec2c8e6$var$isAttributeNameSafe(attributeName) {
    if ($4a57df467ec2c8e6$var$hasOwnProperty.call($4a57df467ec2c8e6$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($4a57df467ec2c8e6$var$hasOwnProperty.call($4a57df467ec2c8e6$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($4a57df467ec2c8e6$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $4a57df467ec2c8e6$var$validatedAttributeNameCache[attributeName] = !0;
    $4a57df467ec2c8e6$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $4a57df467ec2c8e6$var$setValueForAttribute(node, name, value) {
    if ($4a57df467ec2c8e6$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $4a57df467ec2c8e6$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $4a57df467ec2c8e6$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $4a57df467ec2c8e6$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $4a57df467ec2c8e6$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $4a57df467ec2c8e6$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $4a57df467ec2c8e6$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $4a57df467ec2c8e6$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $4a57df467ec2c8e6$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $4a57df467ec2c8e6$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $4a57df467ec2c8e6$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $4a57df467ec2c8e6$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $4a57df467ec2c8e6$var$getToStringValue(value);
        } else element.value !== "" + $4a57df467ec2c8e6$var$getToStringValue(value) && (element.value = "" + $4a57df467ec2c8e6$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $4a57df467ec2c8e6$var$setDefaultValue(element, type, $4a57df467ec2c8e6$var$getToStringValue(value)) : null != defaultValue ? $4a57df467ec2c8e6$var$setDefaultValue(element, type, $4a57df467ec2c8e6$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $4a57df467ec2c8e6$var$getToStringValue(name) : element.removeAttribute("name");
}
function $4a57df467ec2c8e6$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $4a57df467ec2c8e6$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $4a57df467ec2c8e6$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $4a57df467ec2c8e6$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $4a57df467ec2c8e6$var$track(element);
}
function $4a57df467ec2c8e6$var$setDefaultValue(node, type, value) {
    "number" === type && $4a57df467ec2c8e6$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $4a57df467ec2c8e6$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $4a57df467ec2c8e6$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $4a57df467ec2c8e6$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $4a57df467ec2c8e6$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $4a57df467ec2c8e6$var$getToStringValue(defaultValue) : "";
}
function $4a57df467ec2c8e6$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(92));
            if ($4a57df467ec2c8e6$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $4a57df467ec2c8e6$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $4a57df467ec2c8e6$var$track(element);
}
function $4a57df467ec2c8e6$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $4a57df467ec2c8e6$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $4a57df467ec2c8e6$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $4a57df467ec2c8e6$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $4a57df467ec2c8e6$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $4a57df467ec2c8e6$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $4a57df467ec2c8e6$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $4a57df467ec2c8e6$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4a57df467ec2c8e6$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $4a57df467ec2c8e6$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $4a57df467ec2c8e6$var$sanitizeURL(url) {
    return $4a57df467ec2c8e6$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $4a57df467ec2c8e6$var$noop$1() {}
var $4a57df467ec2c8e6$var$currentReplayingEvent = null;
function $4a57df467ec2c8e6$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $4a57df467ec2c8e6$var$restoreTarget = null, $4a57df467ec2c8e6$var$restoreQueue = null;
function $4a57df467ec2c8e6$var$restoreStateOfTarget(target) {
    var internalInstance = $4a57df467ec2c8e6$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$4a57df467ec2c8e6$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $4a57df467ec2c8e6$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$4a57df467ec2c8e6$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(90));
                            $4a57df467ec2c8e6$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $4a57df467ec2c8e6$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $4a57df467ec2c8e6$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $4a57df467ec2c8e6$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $4a57df467ec2c8e6$var$isInsideEventHandler = !1;
function $4a57df467ec2c8e6$var$batchedUpdates$1(fn, a, b) {
    if ($4a57df467ec2c8e6$var$isInsideEventHandler) return fn(a, b);
    $4a57df467ec2c8e6$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($4a57df467ec2c8e6$var$isInsideEventHandler = !1, null !== $4a57df467ec2c8e6$var$restoreTarget || null !== $4a57df467ec2c8e6$var$restoreQueue) {
            if ($4a57df467ec2c8e6$var$flushSyncWork$1(), $4a57df467ec2c8e6$var$restoreTarget && (a = $4a57df467ec2c8e6$var$restoreTarget, fn = $4a57df467ec2c8e6$var$restoreQueue, $4a57df467ec2c8e6$var$restoreQueue = $4a57df467ec2c8e6$var$restoreTarget = null, $4a57df467ec2c8e6$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$4a57df467ec2c8e6$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $4a57df467ec2c8e6$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$4a57df467ec2c8e6$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $4a57df467ec2c8e6$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4a57df467ec2c8e6$var$passiveBrowserEventsSupported = !1;
if ($4a57df467ec2c8e6$var$canUseDOM) try {
    var $4a57df467ec2c8e6$var$options = {};
    Object.defineProperty($4a57df467ec2c8e6$var$options, "passive", {
        get: function() {
            $4a57df467ec2c8e6$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $4a57df467ec2c8e6$var$options, $4a57df467ec2c8e6$var$options);
    window.removeEventListener("test", $4a57df467ec2c8e6$var$options, $4a57df467ec2c8e6$var$options);
} catch (e) {
    $4a57df467ec2c8e6$var$passiveBrowserEventsSupported = !1;
}
var $4a57df467ec2c8e6$var$root = null, $4a57df467ec2c8e6$var$startText = null, $4a57df467ec2c8e6$var$fallbackText = null;
function $4a57df467ec2c8e6$var$getData() {
    if ($4a57df467ec2c8e6$var$fallbackText) return $4a57df467ec2c8e6$var$fallbackText;
    var start, startValue = $4a57df467ec2c8e6$var$startText, startLength = startValue.length, end, endValue = "value" in $4a57df467ec2c8e6$var$root ? $4a57df467ec2c8e6$var$root.value : $4a57df467ec2c8e6$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $4a57df467ec2c8e6$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $4a57df467ec2c8e6$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $4a57df467ec2c8e6$var$functionThatReturnsTrue() {
    return !0;
}
function $4a57df467ec2c8e6$var$functionThatReturnsFalse() {
    return !1;
}
function $4a57df467ec2c8e6$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $4a57df467ec2c8e6$var$functionThatReturnsTrue : $4a57df467ec2c8e6$var$functionThatReturnsFalse;
        this.isPropagationStopped = $4a57df467ec2c8e6$var$functionThatReturnsFalse;
        return this;
    }
    $4a57df467ec2c8e6$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $4a57df467ec2c8e6$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $4a57df467ec2c8e6$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $4a57df467ec2c8e6$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $4a57df467ec2c8e6$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4a57df467ec2c8e6$var$SyntheticEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$EventInterface), $4a57df467ec2c8e6$var$UIEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$EventInterface, {
    view: 0,
    detail: 0
}), $4a57df467ec2c8e6$var$SyntheticUIEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$UIEventInterface), $4a57df467ec2c8e6$var$lastMovementX, $4a57df467ec2c8e6$var$lastMovementY, $4a57df467ec2c8e6$var$lastMouseEvent, $4a57df467ec2c8e6$var$MouseEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4a57df467ec2c8e6$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $4a57df467ec2c8e6$var$lastMouseEvent && ($4a57df467ec2c8e6$var$lastMouseEvent && "mousemove" === event.type ? ($4a57df467ec2c8e6$var$lastMovementX = event.screenX - $4a57df467ec2c8e6$var$lastMouseEvent.screenX, $4a57df467ec2c8e6$var$lastMovementY = event.screenY - $4a57df467ec2c8e6$var$lastMouseEvent.screenY) : $4a57df467ec2c8e6$var$lastMovementY = $4a57df467ec2c8e6$var$lastMovementX = 0, $4a57df467ec2c8e6$var$lastMouseEvent = event);
        return $4a57df467ec2c8e6$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $4a57df467ec2c8e6$var$lastMovementY;
    }
}), $4a57df467ec2c8e6$var$SyntheticMouseEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$MouseEventInterface), $4a57df467ec2c8e6$var$DragEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$MouseEventInterface, {
    dataTransfer: 0
}), $4a57df467ec2c8e6$var$SyntheticDragEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$DragEventInterface), $4a57df467ec2c8e6$var$FocusEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$UIEventInterface, {
    relatedTarget: 0
}), $4a57df467ec2c8e6$var$SyntheticFocusEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$FocusEventInterface), $4a57df467ec2c8e6$var$AnimationEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4a57df467ec2c8e6$var$SyntheticAnimationEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$AnimationEventInterface), $4a57df467ec2c8e6$var$ClipboardEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $4a57df467ec2c8e6$var$SyntheticClipboardEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$ClipboardEventInterface), $4a57df467ec2c8e6$var$CompositionEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$EventInterface, {
    data: 0
}), $4a57df467ec2c8e6$var$SyntheticCompositionEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$CompositionEventInterface), $4a57df467ec2c8e6$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4a57df467ec2c8e6$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4a57df467ec2c8e6$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4a57df467ec2c8e6$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $4a57df467ec2c8e6$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $4a57df467ec2c8e6$var$getEventModifierState() {
    return $4a57df467ec2c8e6$var$modifierStateGetter;
}
var $4a57df467ec2c8e6$var$KeyboardEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $4a57df467ec2c8e6$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $4a57df467ec2c8e6$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $4a57df467ec2c8e6$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4a57df467ec2c8e6$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $4a57df467ec2c8e6$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $4a57df467ec2c8e6$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $4a57df467ec2c8e6$var$SyntheticKeyboardEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$KeyboardEventInterface), $4a57df467ec2c8e6$var$PointerEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4a57df467ec2c8e6$var$SyntheticPointerEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$PointerEventInterface), $4a57df467ec2c8e6$var$TouchEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4a57df467ec2c8e6$var$getEventModifierState
}), $4a57df467ec2c8e6$var$SyntheticTouchEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$TouchEventInterface), $4a57df467ec2c8e6$var$TransitionEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4a57df467ec2c8e6$var$SyntheticTransitionEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$TransitionEventInterface), $4a57df467ec2c8e6$var$WheelEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4a57df467ec2c8e6$var$SyntheticWheelEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$WheelEventInterface), $4a57df467ec2c8e6$var$ToggleEventInterface = $4a57df467ec2c8e6$var$assign({}, $4a57df467ec2c8e6$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $4a57df467ec2c8e6$var$SyntheticToggleEvent = $4a57df467ec2c8e6$var$createSyntheticEvent($4a57df467ec2c8e6$var$ToggleEventInterface), $4a57df467ec2c8e6$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $4a57df467ec2c8e6$var$canUseCompositionEvent = $4a57df467ec2c8e6$var$canUseDOM && "CompositionEvent" in window, $4a57df467ec2c8e6$var$documentMode = null;
$4a57df467ec2c8e6$var$canUseDOM && "documentMode" in document && ($4a57df467ec2c8e6$var$documentMode = document.documentMode);
var $4a57df467ec2c8e6$var$canUseTextInputEvent = $4a57df467ec2c8e6$var$canUseDOM && "TextEvent" in window && !$4a57df467ec2c8e6$var$documentMode, $4a57df467ec2c8e6$var$useFallbackCompositionData = $4a57df467ec2c8e6$var$canUseDOM && (!$4a57df467ec2c8e6$var$canUseCompositionEvent || $4a57df467ec2c8e6$var$documentMode && 8 < $4a57df467ec2c8e6$var$documentMode && 11 >= $4a57df467ec2c8e6$var$documentMode), $4a57df467ec2c8e6$var$SPACEBAR_CHAR = String.fromCharCode(32), $4a57df467ec2c8e6$var$hasSpaceKeypress = !1;
function $4a57df467ec2c8e6$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $4a57df467ec2c8e6$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4a57df467ec2c8e6$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $4a57df467ec2c8e6$var$isComposing = !1;
function $4a57df467ec2c8e6$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $4a57df467ec2c8e6$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $4a57df467ec2c8e6$var$hasSpaceKeypress = !0;
            return $4a57df467ec2c8e6$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $4a57df467ec2c8e6$var$SPACEBAR_CHAR && $4a57df467ec2c8e6$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $4a57df467ec2c8e6$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($4a57df467ec2c8e6$var$isComposing) return "compositionend" === domEventName || !$4a57df467ec2c8e6$var$canUseCompositionEvent && $4a57df467ec2c8e6$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $4a57df467ec2c8e6$var$getData(), $4a57df467ec2c8e6$var$fallbackText = $4a57df467ec2c8e6$var$startText = $4a57df467ec2c8e6$var$root = null, $4a57df467ec2c8e6$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $4a57df467ec2c8e6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $4a57df467ec2c8e6$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4a57df467ec2c8e6$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$4a57df467ec2c8e6$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $4a57df467ec2c8e6$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $4a57df467ec2c8e6$var$restoreTarget ? $4a57df467ec2c8e6$var$restoreQueue ? $4a57df467ec2c8e6$var$restoreQueue.push(target) : $4a57df467ec2c8e6$var$restoreQueue = [
        target
    ] : $4a57df467ec2c8e6$var$restoreTarget = target;
    inst = $4a57df467ec2c8e6$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $4a57df467ec2c8e6$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $4a57df467ec2c8e6$var$activeElement$1 = null, $4a57df467ec2c8e6$var$activeElementInst$1 = null;
function $4a57df467ec2c8e6$var$runEventInBatch(dispatchQueue) {
    $4a57df467ec2c8e6$var$processDispatchQueue(dispatchQueue, 0);
}
function $4a57df467ec2c8e6$var$getInstIfValueChanged(targetInst) {
    var targetNode = $4a57df467ec2c8e6$var$getNodeFromInstance(targetInst);
    if ($4a57df467ec2c8e6$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $4a57df467ec2c8e6$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $4a57df467ec2c8e6$var$isInputEventSupported = !1;
if ($4a57df467ec2c8e6$var$canUseDOM) {
    var $4a57df467ec2c8e6$var$JSCompiler_inline_result$jscomp$286;
    if ($4a57df467ec2c8e6$var$canUseDOM) {
        var $4a57df467ec2c8e6$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$4a57df467ec2c8e6$var$isSupported$jscomp$inline_427) {
            var $4a57df467ec2c8e6$var$element$jscomp$inline_428 = document.createElement("div");
            $4a57df467ec2c8e6$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $4a57df467ec2c8e6$var$isSupported$jscomp$inline_427 = "function" === typeof $4a57df467ec2c8e6$var$element$jscomp$inline_428.oninput;
        }
        $4a57df467ec2c8e6$var$JSCompiler_inline_result$jscomp$286 = $4a57df467ec2c8e6$var$isSupported$jscomp$inline_427;
    } else $4a57df467ec2c8e6$var$JSCompiler_inline_result$jscomp$286 = !1;
    $4a57df467ec2c8e6$var$isInputEventSupported = $4a57df467ec2c8e6$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $4a57df467ec2c8e6$var$stopWatchingForValueChange() {
    $4a57df467ec2c8e6$var$activeElement$1 && ($4a57df467ec2c8e6$var$activeElement$1.detachEvent("onpropertychange", $4a57df467ec2c8e6$var$handlePropertyChange), $4a57df467ec2c8e6$var$activeElementInst$1 = $4a57df467ec2c8e6$var$activeElement$1 = null);
}
function $4a57df467ec2c8e6$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $4a57df467ec2c8e6$var$getInstIfValueChanged($4a57df467ec2c8e6$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $4a57df467ec2c8e6$var$createAndAccumulateChangeEvent(dispatchQueue, $4a57df467ec2c8e6$var$activeElementInst$1, nativeEvent, $4a57df467ec2c8e6$var$getEventTarget(nativeEvent));
        $4a57df467ec2c8e6$var$batchedUpdates$1($4a57df467ec2c8e6$var$runEventInBatch, dispatchQueue);
    }
}
function $4a57df467ec2c8e6$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($4a57df467ec2c8e6$var$stopWatchingForValueChange(), $4a57df467ec2c8e6$var$activeElement$1 = target, $4a57df467ec2c8e6$var$activeElementInst$1 = targetInst, $4a57df467ec2c8e6$var$activeElement$1.attachEvent("onpropertychange", $4a57df467ec2c8e6$var$handlePropertyChange)) : "focusout" === domEventName && $4a57df467ec2c8e6$var$stopWatchingForValueChange();
}
function $4a57df467ec2c8e6$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $4a57df467ec2c8e6$var$getInstIfValueChanged($4a57df467ec2c8e6$var$activeElementInst$1);
}
function $4a57df467ec2c8e6$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $4a57df467ec2c8e6$var$getInstIfValueChanged(targetInst);
}
function $4a57df467ec2c8e6$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $4a57df467ec2c8e6$var$getInstIfValueChanged(targetInst);
}
function $4a57df467ec2c8e6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $4a57df467ec2c8e6$var$objectIs = "function" === typeof Object.is ? Object.is : $4a57df467ec2c8e6$var$is;
function $4a57df467ec2c8e6$var$shallowEqual(objA, objB) {
    if ($4a57df467ec2c8e6$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$4a57df467ec2c8e6$var$hasOwnProperty.call(objB, currentKey) || !$4a57df467ec2c8e6$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $4a57df467ec2c8e6$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $4a57df467ec2c8e6$var$getNodeForCharacterOffset(root, offset) {
    var node = $4a57df467ec2c8e6$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $4a57df467ec2c8e6$var$getLeafNode(node);
    }
}
function $4a57df467ec2c8e6$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $4a57df467ec2c8e6$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $4a57df467ec2c8e6$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $4a57df467ec2c8e6$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $4a57df467ec2c8e6$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $4a57df467ec2c8e6$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $4a57df467ec2c8e6$var$skipSelectionChangeEvent = $4a57df467ec2c8e6$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $4a57df467ec2c8e6$var$activeElement = null, $4a57df467ec2c8e6$var$activeElementInst = null, $4a57df467ec2c8e6$var$lastSelection = null, $4a57df467ec2c8e6$var$mouseDown = !1;
function $4a57df467ec2c8e6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $4a57df467ec2c8e6$var$mouseDown || null == $4a57df467ec2c8e6$var$activeElement || $4a57df467ec2c8e6$var$activeElement !== $4a57df467ec2c8e6$var$getActiveElement(doc) || (doc = $4a57df467ec2c8e6$var$activeElement, "selectionStart" in doc && $4a57df467ec2c8e6$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $4a57df467ec2c8e6$var$lastSelection && $4a57df467ec2c8e6$var$shallowEqual($4a57df467ec2c8e6$var$lastSelection, doc) || ($4a57df467ec2c8e6$var$lastSelection = doc, doc = $4a57df467ec2c8e6$var$accumulateTwoPhaseListeners($4a57df467ec2c8e6$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $4a57df467ec2c8e6$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $4a57df467ec2c8e6$var$activeElement)));
}
function $4a57df467ec2c8e6$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $4a57df467ec2c8e6$var$vendorPrefixes = {
    animationend: $4a57df467ec2c8e6$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $4a57df467ec2c8e6$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $4a57df467ec2c8e6$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $4a57df467ec2c8e6$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $4a57df467ec2c8e6$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $4a57df467ec2c8e6$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $4a57df467ec2c8e6$var$makePrefixMap("Transition", "TransitionEnd")
}, $4a57df467ec2c8e6$var$prefixedEventNames = {}, $4a57df467ec2c8e6$var$style = {};
$4a57df467ec2c8e6$var$canUseDOM && ($4a57df467ec2c8e6$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $4a57df467ec2c8e6$var$vendorPrefixes.animationend.animation, delete $4a57df467ec2c8e6$var$vendorPrefixes.animationiteration.animation, delete $4a57df467ec2c8e6$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $4a57df467ec2c8e6$var$vendorPrefixes.transitionend.transition);
function $4a57df467ec2c8e6$var$getVendorPrefixedEventName(eventName) {
    if ($4a57df467ec2c8e6$var$prefixedEventNames[eventName]) return $4a57df467ec2c8e6$var$prefixedEventNames[eventName];
    if (!$4a57df467ec2c8e6$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $4a57df467ec2c8e6$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $4a57df467ec2c8e6$var$style) return $4a57df467ec2c8e6$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $4a57df467ec2c8e6$var$ANIMATION_END = $4a57df467ec2c8e6$var$getVendorPrefixedEventName("animationend"), $4a57df467ec2c8e6$var$ANIMATION_ITERATION = $4a57df467ec2c8e6$var$getVendorPrefixedEventName("animationiteration"), $4a57df467ec2c8e6$var$ANIMATION_START = $4a57df467ec2c8e6$var$getVendorPrefixedEventName("animationstart"), $4a57df467ec2c8e6$var$TRANSITION_RUN = $4a57df467ec2c8e6$var$getVendorPrefixedEventName("transitionrun"), $4a57df467ec2c8e6$var$TRANSITION_START = $4a57df467ec2c8e6$var$getVendorPrefixedEventName("transitionstart"), $4a57df467ec2c8e6$var$TRANSITION_CANCEL = $4a57df467ec2c8e6$var$getVendorPrefixedEventName("transitioncancel"), $4a57df467ec2c8e6$var$TRANSITION_END = $4a57df467ec2c8e6$var$getVendorPrefixedEventName("transitionend"), $4a57df467ec2c8e6$var$topLevelEventsToReactNames = new Map(), $4a57df467ec2c8e6$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$4a57df467ec2c8e6$var$simpleEventPluginEvents.push("scrollEnd");
function $4a57df467ec2c8e6$var$registerSimpleEvent(domEventName, reactName) {
    $4a57df467ec2c8e6$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $4a57df467ec2c8e6$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $4a57df467ec2c8e6$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $4a57df467ec2c8e6$var$concurrentQueues = [], $4a57df467ec2c8e6$var$concurrentQueuesIndex = 0, $4a57df467ec2c8e6$var$concurrentlyUpdatedLanes = 0;
function $4a57df467ec2c8e6$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $4a57df467ec2c8e6$var$concurrentQueuesIndex, i = $4a57df467ec2c8e6$var$concurrentlyUpdatedLanes = $4a57df467ec2c8e6$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $4a57df467ec2c8e6$var$concurrentQueues[i];
        $4a57df467ec2c8e6$var$concurrentQueues[i++] = null;
        var queue = $4a57df467ec2c8e6$var$concurrentQueues[i];
        $4a57df467ec2c8e6$var$concurrentQueues[i++] = null;
        var update = $4a57df467ec2c8e6$var$concurrentQueues[i];
        $4a57df467ec2c8e6$var$concurrentQueues[i++] = null;
        var lane = $4a57df467ec2c8e6$var$concurrentQueues[i];
        $4a57df467ec2c8e6$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $4a57df467ec2c8e6$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $4a57df467ec2c8e6$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $4a57df467ec2c8e6$var$concurrentQueues[$4a57df467ec2c8e6$var$concurrentQueuesIndex++] = fiber;
    $4a57df467ec2c8e6$var$concurrentQueues[$4a57df467ec2c8e6$var$concurrentQueuesIndex++] = queue;
    $4a57df467ec2c8e6$var$concurrentQueues[$4a57df467ec2c8e6$var$concurrentQueuesIndex++] = update;
    $4a57df467ec2c8e6$var$concurrentQueues[$4a57df467ec2c8e6$var$concurrentQueuesIndex++] = lane;
    $4a57df467ec2c8e6$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $4a57df467ec2c8e6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $4a57df467ec2c8e6$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $4a57df467ec2c8e6$var$getRootForUpdatedFiber(fiber);
}
function $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $4a57df467ec2c8e6$var$enqueueUpdate$1(fiber, null, null, lane);
    return $4a57df467ec2c8e6$var$getRootForUpdatedFiber(fiber);
}
function $4a57df467ec2c8e6$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $4a57df467ec2c8e6$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $4a57df467ec2c8e6$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $4a57df467ec2c8e6$var$nestedUpdateCount) throw $4a57df467ec2c8e6$var$nestedUpdateCount = 0, $4a57df467ec2c8e6$var$rootWithNestedUpdates = null, Error($4a57df467ec2c8e6$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $4a57df467ec2c8e6$var$emptyContextObject = {};
function $4a57df467ec2c8e6$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4a57df467ec2c8e6$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $4a57df467ec2c8e6$var$FiberNode(tag, pendingProps, key, mode);
}
function $4a57df467ec2c8e6$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $4a57df467ec2c8e6$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $4a57df467ec2c8e6$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $4a57df467ec2c8e6$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $4a57df467ec2c8e6$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $4a57df467ec2c8e6$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $4a57df467ec2c8e6$var$isHostHoistableType(type, pendingProps, $4a57df467ec2c8e6$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $4a57df467ec2c8e6$var$REACT_ACTIVITY_TYPE:
            return type = $4a57df467ec2c8e6$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $4a57df467ec2c8e6$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $4a57df467ec2c8e6$var$REACT_FRAGMENT_TYPE:
            return $4a57df467ec2c8e6$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $4a57df467ec2c8e6$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $4a57df467ec2c8e6$var$REACT_PROFILER_TYPE:
            return type = $4a57df467ec2c8e6$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $4a57df467ec2c8e6$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $4a57df467ec2c8e6$var$REACT_SUSPENSE_TYPE:
            return type = $4a57df467ec2c8e6$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $4a57df467ec2c8e6$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $4a57df467ec2c8e6$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $4a57df467ec2c8e6$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $4a57df467ec2c8e6$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $4a57df467ec2c8e6$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $4a57df467ec2c8e6$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $4a57df467ec2c8e6$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $4a57df467ec2c8e6$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $4a57df467ec2c8e6$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $4a57df467ec2c8e6$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $4a57df467ec2c8e6$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $4a57df467ec2c8e6$var$createFiberFromText(content, mode, lanes) {
    content = $4a57df467ec2c8e6$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $4a57df467ec2c8e6$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $4a57df467ec2c8e6$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $4a57df467ec2c8e6$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $4a57df467ec2c8e6$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $4a57df467ec2c8e6$var$CapturedStacks = new WeakMap();
function $4a57df467ec2c8e6$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $4a57df467ec2c8e6$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $4a57df467ec2c8e6$var$getStackByFiberInDevAndProd(source)
        };
        $4a57df467ec2c8e6$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $4a57df467ec2c8e6$var$getStackByFiberInDevAndProd(source)
    };
}
var $4a57df467ec2c8e6$var$forkStack = [], $4a57df467ec2c8e6$var$forkStackIndex = 0, $4a57df467ec2c8e6$var$treeForkProvider = null, $4a57df467ec2c8e6$var$treeForkCount = 0, $4a57df467ec2c8e6$var$idStack = [], $4a57df467ec2c8e6$var$idStackIndex = 0, $4a57df467ec2c8e6$var$treeContextProvider = null, $4a57df467ec2c8e6$var$treeContextId = 1, $4a57df467ec2c8e6$var$treeContextOverflow = "";
function $4a57df467ec2c8e6$var$pushTreeFork(workInProgress, totalChildren) {
    $4a57df467ec2c8e6$var$forkStack[$4a57df467ec2c8e6$var$forkStackIndex++] = $4a57df467ec2c8e6$var$treeForkCount;
    $4a57df467ec2c8e6$var$forkStack[$4a57df467ec2c8e6$var$forkStackIndex++] = $4a57df467ec2c8e6$var$treeForkProvider;
    $4a57df467ec2c8e6$var$treeForkProvider = workInProgress;
    $4a57df467ec2c8e6$var$treeForkCount = totalChildren;
}
function $4a57df467ec2c8e6$var$pushTreeId(workInProgress, totalChildren, index) {
    $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex++] = $4a57df467ec2c8e6$var$treeContextId;
    $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex++] = $4a57df467ec2c8e6$var$treeContextOverflow;
    $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex++] = $4a57df467ec2c8e6$var$treeContextProvider;
    $4a57df467ec2c8e6$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $4a57df467ec2c8e6$var$treeContextId;
    workInProgress = $4a57df467ec2c8e6$var$treeContextOverflow;
    var baseLength = 32 - $4a57df467ec2c8e6$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $4a57df467ec2c8e6$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $4a57df467ec2c8e6$var$treeContextId = 1 << 32 - $4a57df467ec2c8e6$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $4a57df467ec2c8e6$var$treeContextOverflow = length + workInProgress;
    } else $4a57df467ec2c8e6$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $4a57df467ec2c8e6$var$treeContextOverflow = workInProgress;
}
function $4a57df467ec2c8e6$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($4a57df467ec2c8e6$var$pushTreeFork(workInProgress, 1), $4a57df467ec2c8e6$var$pushTreeId(workInProgress, 1, 0));
}
function $4a57df467ec2c8e6$var$popTreeContext(workInProgress) {
    for(; workInProgress === $4a57df467ec2c8e6$var$treeForkProvider;)$4a57df467ec2c8e6$var$treeForkProvider = $4a57df467ec2c8e6$var$forkStack[--$4a57df467ec2c8e6$var$forkStackIndex], $4a57df467ec2c8e6$var$forkStack[$4a57df467ec2c8e6$var$forkStackIndex] = null, $4a57df467ec2c8e6$var$treeForkCount = $4a57df467ec2c8e6$var$forkStack[--$4a57df467ec2c8e6$var$forkStackIndex], $4a57df467ec2c8e6$var$forkStack[$4a57df467ec2c8e6$var$forkStackIndex] = null;
    for(; workInProgress === $4a57df467ec2c8e6$var$treeContextProvider;)$4a57df467ec2c8e6$var$treeContextProvider = $4a57df467ec2c8e6$var$idStack[--$4a57df467ec2c8e6$var$idStackIndex], $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex] = null, $4a57df467ec2c8e6$var$treeContextOverflow = $4a57df467ec2c8e6$var$idStack[--$4a57df467ec2c8e6$var$idStackIndex], $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex] = null, $4a57df467ec2c8e6$var$treeContextId = $4a57df467ec2c8e6$var$idStack[--$4a57df467ec2c8e6$var$idStackIndex], $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex] = null;
}
function $4a57df467ec2c8e6$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex++] = $4a57df467ec2c8e6$var$treeContextId;
    $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex++] = $4a57df467ec2c8e6$var$treeContextOverflow;
    $4a57df467ec2c8e6$var$idStack[$4a57df467ec2c8e6$var$idStackIndex++] = $4a57df467ec2c8e6$var$treeContextProvider;
    $4a57df467ec2c8e6$var$treeContextId = suspendedContext.id;
    $4a57df467ec2c8e6$var$treeContextOverflow = suspendedContext.overflow;
    $4a57df467ec2c8e6$var$treeContextProvider = workInProgress;
}
var $4a57df467ec2c8e6$var$hydrationParentFiber = null, $4a57df467ec2c8e6$var$nextHydratableInstance = null, $4a57df467ec2c8e6$var$isHydrating = !1, $4a57df467ec2c8e6$var$hydrationErrors = null, $4a57df467ec2c8e6$var$rootOrSingletonContext = !1, $4a57df467ec2c8e6$var$HydrationMismatchException = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(519));
function $4a57df467ec2c8e6$var$throwOnHydrationMismatch(fiber) {
    var error = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $4a57df467ec2c8e6$var$queueHydrationError($4a57df467ec2c8e6$var$createCapturedValueAtFiber(error, fiber));
    throw $4a57df467ec2c8e6$var$HydrationMismatchException;
}
function $4a57df467ec2c8e6$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$4a57df467ec2c8e6$var$internalInstanceKey] = fiber;
    instance[$4a57df467ec2c8e6$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("cancel", instance);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $4a57df467ec2c8e6$var$mediaEventTypes.length; type++)$4a57df467ec2c8e6$var$listenToNonDelegatedEvent($4a57df467ec2c8e6$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("error", instance);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("invalid", instance);
            $4a57df467ec2c8e6$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("invalid", instance), $4a57df467ec2c8e6$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $4a57df467ec2c8e6$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($4a57df467ec2c8e6$var$listenToNonDelegatedEvent("beforetoggle", instance), $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $4a57df467ec2c8e6$var$noop$1), instance = !0) : instance = !1;
    instance || $4a57df467ec2c8e6$var$throwOnHydrationMismatch(fiber, !0);
}
function $4a57df467ec2c8e6$var$popToNextHostParent(fiber) {
    for($4a57df467ec2c8e6$var$hydrationParentFiber = fiber.return; $4a57df467ec2c8e6$var$hydrationParentFiber;)switch($4a57df467ec2c8e6$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $4a57df467ec2c8e6$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $4a57df467ec2c8e6$var$rootOrSingletonContext = !0;
            return;
        default:
            $4a57df467ec2c8e6$var$hydrationParentFiber = $4a57df467ec2c8e6$var$hydrationParentFiber.return;
    }
}
function $4a57df467ec2c8e6$var$popHydrationState(fiber) {
    if (fiber !== $4a57df467ec2c8e6$var$hydrationParentFiber) return !1;
    if (!$4a57df467ec2c8e6$var$isHydrating) return $4a57df467ec2c8e6$var$popToNextHostParent(fiber), $4a57df467ec2c8e6$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $4a57df467ec2c8e6$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $4a57df467ec2c8e6$var$nextHydratableInstance && $4a57df467ec2c8e6$var$throwOnHydrationMismatch(fiber);
    $4a57df467ec2c8e6$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(317));
        $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(317));
        $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $4a57df467ec2c8e6$var$nextHydratableInstance, $4a57df467ec2c8e6$var$isSingletonScope(fiber.type) ? (fiber = $4a57df467ec2c8e6$var$previousHydratableOnEnteringScopedSingleton, $4a57df467ec2c8e6$var$previousHydratableOnEnteringScopedSingleton = null, $4a57df467ec2c8e6$var$nextHydratableInstance = fiber) : $4a57df467ec2c8e6$var$nextHydratableInstance = tag) : $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$hydrationParentFiber ? $4a57df467ec2c8e6$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $4a57df467ec2c8e6$var$resetHydrationState() {
    $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$hydrationParentFiber = null;
    $4a57df467ec2c8e6$var$isHydrating = !1;
}
function $4a57df467ec2c8e6$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $4a57df467ec2c8e6$var$hydrationErrors;
    null !== queuedErrors && (null === $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors ? $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors = queuedErrors : $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors.push.apply($4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors, queuedErrors), $4a57df467ec2c8e6$var$hydrationErrors = null);
    return queuedErrors;
}
function $4a57df467ec2c8e6$var$queueHydrationError(error) {
    null === $4a57df467ec2c8e6$var$hydrationErrors ? $4a57df467ec2c8e6$var$hydrationErrors = [
        error
    ] : $4a57df467ec2c8e6$var$hydrationErrors.push(error);
}
var $4a57df467ec2c8e6$var$valueCursor = $4a57df467ec2c8e6$var$createCursor(null), $4a57df467ec2c8e6$var$currentlyRenderingFiber$1 = null, $4a57df467ec2c8e6$var$lastContextDependency = null;
function $4a57df467ec2c8e6$var$pushProvider(providerFiber, context, nextValue) {
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $4a57df467ec2c8e6$var$popProvider(context) {
    context._currentValue = $4a57df467ec2c8e6$var$valueCursor.current;
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$valueCursor);
}
function $4a57df467ec2c8e6$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $4a57df467ec2c8e6$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $4a57df467ec2c8e6$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $4a57df467ec2c8e6$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $4a57df467ec2c8e6$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $4a57df467ec2c8e6$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $4a57df467ec2c8e6$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($4a57df467ec2c8e6$var$HostTransitionContext) : current = [
                $4a57df467ec2c8e6$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $4a57df467ec2c8e6$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $4a57df467ec2c8e6$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$4a57df467ec2c8e6$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $4a57df467ec2c8e6$var$prepareToReadContext(workInProgress) {
    $4a57df467ec2c8e6$var$currentlyRenderingFiber$1 = workInProgress;
    $4a57df467ec2c8e6$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $4a57df467ec2c8e6$var$readContext(context) {
    return $4a57df467ec2c8e6$var$readContextForConsumer($4a57df467ec2c8e6$var$currentlyRenderingFiber$1, context);
}
function $4a57df467ec2c8e6$var$readContextDuringReconciliation(consumer, context) {
    null === $4a57df467ec2c8e6$var$currentlyRenderingFiber$1 && $4a57df467ec2c8e6$var$prepareToReadContext(consumer);
    return $4a57df467ec2c8e6$var$readContextForConsumer(consumer, context);
}
function $4a57df467ec2c8e6$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $4a57df467ec2c8e6$var$lastContextDependency) {
        if (null === consumer) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(308));
        $4a57df467ec2c8e6$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $4a57df467ec2c8e6$var$lastContextDependency = $4a57df467ec2c8e6$var$lastContextDependency.next = context;
    return value;
}
var $4a57df467ec2c8e6$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $4a57df467ec2c8e6$var$scheduleCallback$2 = $gARKC.unstable_scheduleCallback, $4a57df467ec2c8e6$var$NormalPriority = $gARKC.unstable_NormalPriority, $4a57df467ec2c8e6$var$CacheContext = {
    $$typeof: $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $4a57df467ec2c8e6$var$createCache() {
    return {
        controller: new $4a57df467ec2c8e6$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $4a57df467ec2c8e6$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $4a57df467ec2c8e6$var$scheduleCallback$2($4a57df467ec2c8e6$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $4a57df467ec2c8e6$var$currentEntangledListeners = null, $4a57df467ec2c8e6$var$currentEntangledPendingCount = 0, $4a57df467ec2c8e6$var$currentEntangledLane = 0, $4a57df467ec2c8e6$var$currentEntangledActionThenable = null;
function $4a57df467ec2c8e6$var$entangleAsyncAction(transition, thenable) {
    if (null === $4a57df467ec2c8e6$var$currentEntangledListeners) {
        var entangledListeners = $4a57df467ec2c8e6$var$currentEntangledListeners = [];
        $4a57df467ec2c8e6$var$currentEntangledPendingCount = 0;
        $4a57df467ec2c8e6$var$currentEntangledLane = $4a57df467ec2c8e6$var$requestTransitionLane();
        $4a57df467ec2c8e6$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $4a57df467ec2c8e6$var$currentEntangledPendingCount++;
    thenable.then($4a57df467ec2c8e6$var$pingEngtangledActionScope, $4a57df467ec2c8e6$var$pingEngtangledActionScope);
    return thenable;
}
function $4a57df467ec2c8e6$var$pingEngtangledActionScope() {
    if (0 === --$4a57df467ec2c8e6$var$currentEntangledPendingCount && null !== $4a57df467ec2c8e6$var$currentEntangledListeners) {
        null !== $4a57df467ec2c8e6$var$currentEntangledActionThenable && ($4a57df467ec2c8e6$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $4a57df467ec2c8e6$var$currentEntangledListeners;
        $4a57df467ec2c8e6$var$currentEntangledListeners = null;
        $4a57df467ec2c8e6$var$currentEntangledLane = 0;
        $4a57df467ec2c8e6$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $4a57df467ec2c8e6$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $4a57df467ec2c8e6$var$prevOnStartTransitionFinish = $4a57df467ec2c8e6$var$ReactSharedInternals.S;
$4a57df467ec2c8e6$var$ReactSharedInternals.S = function(transition, returnValue) {
    $4a57df467ec2c8e6$var$globalMostRecentTransitionTime = $4a57df467ec2c8e6$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $4a57df467ec2c8e6$var$entangleAsyncAction(transition, returnValue);
    null !== $4a57df467ec2c8e6$var$prevOnStartTransitionFinish && $4a57df467ec2c8e6$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $4a57df467ec2c8e6$var$resumedCache = $4a57df467ec2c8e6$var$createCursor(null);
function $4a57df467ec2c8e6$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $4a57df467ec2c8e6$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $4a57df467ec2c8e6$var$workInProgressRoot.pooledCache;
}
function $4a57df467ec2c8e6$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$resumedCache, $4a57df467ec2c8e6$var$resumedCache.current) : $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$resumedCache, prevCachePool.pool);
}
function $4a57df467ec2c8e6$var$getSuspendedCache() {
    var cacheFromPool = $4a57df467ec2c8e6$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $4a57df467ec2c8e6$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $4a57df467ec2c8e6$var$SuspenseException = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(460)), $4a57df467ec2c8e6$var$SuspenseyCommitException = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(474)), $4a57df467ec2c8e6$var$SuspenseActionException = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(542)), $4a57df467ec2c8e6$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $4a57df467ec2c8e6$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $4a57df467ec2c8e6$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($4a57df467ec2c8e6$var$noop$1, $4a57df467ec2c8e6$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $4a57df467ec2c8e6$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($4a57df467ec2c8e6$var$noop$1, $4a57df467ec2c8e6$var$noop$1);
            else {
                thenableState = $4a57df467ec2c8e6$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $4a57df467ec2c8e6$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $4a57df467ec2c8e6$var$suspendedThenable = thenable;
            throw $4a57df467ec2c8e6$var$SuspenseException;
    }
}
function $4a57df467ec2c8e6$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $4a57df467ec2c8e6$var$suspendedThenable = x, $4a57df467ec2c8e6$var$SuspenseException;
        throw x;
    }
}
var $4a57df467ec2c8e6$var$suspendedThenable = null;
function $4a57df467ec2c8e6$var$getSuspendedThenable() {
    if (null === $4a57df467ec2c8e6$var$suspendedThenable) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(459));
    var thenable = $4a57df467ec2c8e6$var$suspendedThenable;
    $4a57df467ec2c8e6$var$suspendedThenable = null;
    return thenable;
}
function $4a57df467ec2c8e6$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $4a57df467ec2c8e6$var$SuspenseException || rejectedReason === $4a57df467ec2c8e6$var$SuspenseActionException) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(483));
}
var $4a57df467ec2c8e6$var$thenableState$1 = null, $4a57df467ec2c8e6$var$thenableIndexCounter$1 = 0;
function $4a57df467ec2c8e6$var$unwrapThenable(thenable) {
    var index = $4a57df467ec2c8e6$var$thenableIndexCounter$1;
    $4a57df467ec2c8e6$var$thenableIndexCounter$1 += 1;
    null === $4a57df467ec2c8e6$var$thenableState$1 && ($4a57df467ec2c8e6$var$thenableState$1 = []);
    return $4a57df467ec2c8e6$var$trackUsedThenable($4a57df467ec2c8e6$var$thenableState$1, thenable, index);
}
function $4a57df467ec2c8e6$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $4a57df467ec2c8e6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $4a57df467ec2c8e6$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $4a57df467ec2c8e6$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $4a57df467ec2c8e6$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $4a57df467ec2c8e6$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $4a57df467ec2c8e6$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $4a57df467ec2c8e6$var$REACT_LAZY_TYPE && $4a57df467ec2c8e6$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $4a57df467ec2c8e6$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $4a57df467ec2c8e6$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $4a57df467ec2c8e6$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $4a57df467ec2c8e6$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $4a57df467ec2c8e6$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $4a57df467ec2c8e6$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4a57df467ec2c8e6$var$REACT_ELEMENT_TYPE:
                    return lanes = $4a57df467ec2c8e6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $4a57df467ec2c8e6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $4a57df467ec2c8e6$var$REACT_PORTAL_TYPE:
                    return newChild = $4a57df467ec2c8e6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $4a57df467ec2c8e6$var$REACT_LAZY_TYPE:
                    return newChild = $4a57df467ec2c8e6$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($4a57df467ec2c8e6$var$isArrayImpl(newChild) || $4a57df467ec2c8e6$var$getIteratorFn(newChild)) return newChild = $4a57df467ec2c8e6$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $4a57df467ec2c8e6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $4a57df467ec2c8e6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4a57df467ec2c8e6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4a57df467ec2c8e6$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $4a57df467ec2c8e6$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $4a57df467ec2c8e6$var$REACT_LAZY_TYPE:
                    return newChild = $4a57df467ec2c8e6$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($4a57df467ec2c8e6$var$isArrayImpl(newChild) || $4a57df467ec2c8e6$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $4a57df467ec2c8e6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $4a57df467ec2c8e6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4a57df467ec2c8e6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4a57df467ec2c8e6$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $4a57df467ec2c8e6$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $4a57df467ec2c8e6$var$REACT_LAZY_TYPE:
                    return newChild = $4a57df467ec2c8e6$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($4a57df467ec2c8e6$var$isArrayImpl(newChild) || $4a57df467ec2c8e6$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $4a57df467ec2c8e6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $4a57df467ec2c8e6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4a57df467ec2c8e6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $4a57df467ec2c8e6$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $4a57df467ec2c8e6$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $4a57df467ec2c8e6$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $4a57df467ec2c8e6$var$REACT_LAZY_TYPE && $4a57df467ec2c8e6$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $4a57df467ec2c8e6$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $4a57df467ec2c8e6$var$REACT_FRAGMENT_TYPE ? (lanes = $4a57df467ec2c8e6$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $4a57df467ec2c8e6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $4a57df467ec2c8e6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $4a57df467ec2c8e6$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $4a57df467ec2c8e6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $4a57df467ec2c8e6$var$REACT_LAZY_TYPE:
                    return newChild = $4a57df467ec2c8e6$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($4a57df467ec2c8e6$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($4a57df467ec2c8e6$var$getIteratorFn(newChild)) {
                key = $4a57df467ec2c8e6$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $4a57df467ec2c8e6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $4a57df467ec2c8e6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $4a57df467ec2c8e6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $4a57df467ec2c8e6$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $4a57df467ec2c8e6$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $4a57df467ec2c8e6$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $4a57df467ec2c8e6$var$SuspenseException || x === $4a57df467ec2c8e6$var$SuspenseActionException) throw x;
            var fiber = $4a57df467ec2c8e6$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $4a57df467ec2c8e6$var$reconcileChildFibers = $4a57df467ec2c8e6$var$createChildReconciler(!0), $4a57df467ec2c8e6$var$mountChildFibers = $4a57df467ec2c8e6$var$createChildReconciler(!1), $4a57df467ec2c8e6$var$hasForceUpdate = !1;
function $4a57df467ec2c8e6$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $4a57df467ec2c8e6$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $4a57df467ec2c8e6$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4a57df467ec2c8e6$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($4a57df467ec2c8e6$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $4a57df467ec2c8e6$var$getRootForUpdatedFiber(fiber);
        $4a57df467ec2c8e6$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $4a57df467ec2c8e6$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $4a57df467ec2c8e6$var$getRootForUpdatedFiber(fiber);
}
function $4a57df467ec2c8e6$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $4a57df467ec2c8e6$var$markRootEntangled(root, lane);
    }
}
function $4a57df467ec2c8e6$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $4a57df467ec2c8e6$var$didReadFromEntangledAsyncAction = !1;
function $4a57df467ec2c8e6$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($4a57df467ec2c8e6$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $4a57df467ec2c8e6$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $4a57df467ec2c8e6$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $4a57df467ec2c8e6$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $4a57df467ec2c8e6$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $4a57df467ec2c8e6$var$currentEntangledLane && ($4a57df467ec2c8e6$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $4a57df467ec2c8e6$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $4a57df467ec2c8e6$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $4a57df467ec2c8e6$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $4a57df467ec2c8e6$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$4a57df467ec2c8e6$var$callCallback(callbacks[updateQueue], context);
}
var $4a57df467ec2c8e6$var$currentTreeHiddenStackCursor = $4a57df467ec2c8e6$var$createCursor(null), $4a57df467ec2c8e6$var$prevEntangledRenderLanesCursor = $4a57df467ec2c8e6$var$createCursor(0);
function $4a57df467ec2c8e6$var$pushHiddenContext(fiber, context) {
    fiber = $4a57df467ec2c8e6$var$entangledRenderLanes;
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$prevEntangledRenderLanesCursor, fiber);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$currentTreeHiddenStackCursor, context);
    $4a57df467ec2c8e6$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $4a57df467ec2c8e6$var$reuseHiddenContextOnStack() {
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$prevEntangledRenderLanesCursor, $4a57df467ec2c8e6$var$entangledRenderLanes);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$currentTreeHiddenStackCursor, $4a57df467ec2c8e6$var$currentTreeHiddenStackCursor.current);
}
function $4a57df467ec2c8e6$var$popHiddenContext() {
    $4a57df467ec2c8e6$var$entangledRenderLanes = $4a57df467ec2c8e6$var$prevEntangledRenderLanesCursor.current;
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$currentTreeHiddenStackCursor);
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$prevEntangledRenderLanesCursor);
}
var $4a57df467ec2c8e6$var$suspenseHandlerStackCursor = $4a57df467ec2c8e6$var$createCursor(null), $4a57df467ec2c8e6$var$shellBoundary = null;
function $4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, $4a57df467ec2c8e6$var$suspenseStackCursor.current & 1);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseHandlerStackCursor, handler);
    null === $4a57df467ec2c8e6$var$shellBoundary && (null === current || null !== $4a57df467ec2c8e6$var$currentTreeHiddenStackCursor.current ? $4a57df467ec2c8e6$var$shellBoundary = handler : null !== current.memoizedState && ($4a57df467ec2c8e6$var$shellBoundary = handler));
}
function $4a57df467ec2c8e6$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, $4a57df467ec2c8e6$var$suspenseStackCursor.current);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseHandlerStackCursor, fiber);
    null === $4a57df467ec2c8e6$var$shellBoundary && ($4a57df467ec2c8e6$var$shellBoundary = fiber);
}
function $4a57df467ec2c8e6$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, $4a57df467ec2c8e6$var$suspenseStackCursor.current), $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseHandlerStackCursor, fiber), null === $4a57df467ec2c8e6$var$shellBoundary && ($4a57df467ec2c8e6$var$shellBoundary = fiber)) : $4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(fiber);
}
function $4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack() {
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, $4a57df467ec2c8e6$var$suspenseStackCursor.current);
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseHandlerStackCursor, $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current);
}
function $4a57df467ec2c8e6$var$popSuspenseHandler(fiber) {
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$suspenseHandlerStackCursor);
    $4a57df467ec2c8e6$var$shellBoundary === fiber && ($4a57df467ec2c8e6$var$shellBoundary = null);
    $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$suspenseStackCursor);
}
var $4a57df467ec2c8e6$var$suspenseStackCursor = $4a57df467ec2c8e6$var$createCursor(0);
function $4a57df467ec2c8e6$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $4a57df467ec2c8e6$var$isSuspenseInstancePending(state) || $4a57df467ec2c8e6$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $4a57df467ec2c8e6$var$renderLanes = 0, $4a57df467ec2c8e6$var$currentlyRenderingFiber = null, $4a57df467ec2c8e6$var$currentHook = null, $4a57df467ec2c8e6$var$workInProgressHook = null, $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdate = !1, $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $4a57df467ec2c8e6$var$localIdCounter = 0, $4a57df467ec2c8e6$var$thenableIndexCounter = 0, $4a57df467ec2c8e6$var$thenableState = null, $4a57df467ec2c8e6$var$globalClientIdCounter = 0;
function $4a57df467ec2c8e6$var$throwInvalidHookError() {
    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(321));
}
function $4a57df467ec2c8e6$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$4a57df467ec2c8e6$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $4a57df467ec2c8e6$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $4a57df467ec2c8e6$var$renderLanes = nextRenderLanes;
    $4a57df467ec2c8e6$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $4a57df467ec2c8e6$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $4a57df467ec2c8e6$var$HooksDispatcherOnMount : $4a57df467ec2c8e6$var$HooksDispatcherOnUpdate;
    $4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $4a57df467ec2c8e6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $4a57df467ec2c8e6$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $4a57df467ec2c8e6$var$finishRenderingHooks(current) {
    $4a57df467ec2c8e6$var$ReactSharedInternals.H = $4a57df467ec2c8e6$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $4a57df467ec2c8e6$var$currentHook && null !== $4a57df467ec2c8e6$var$currentHook.next;
    $4a57df467ec2c8e6$var$renderLanes = 0;
    $4a57df467ec2c8e6$var$workInProgressHook = $4a57df467ec2c8e6$var$currentHook = $4a57df467ec2c8e6$var$currentlyRenderingFiber = null;
    $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdate = !1;
    $4a57df467ec2c8e6$var$thenableIndexCounter = 0;
    $4a57df467ec2c8e6$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(300));
    null === current || $4a57df467ec2c8e6$var$didReceiveUpdate || (current = current.dependencies, null !== current && $4a57df467ec2c8e6$var$checkIfContextChanged(current) && ($4a57df467ec2c8e6$var$didReceiveUpdate = !0));
}
function $4a57df467ec2c8e6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $4a57df467ec2c8e6$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdateDuringThisPass && ($4a57df467ec2c8e6$var$thenableState = null);
        $4a57df467ec2c8e6$var$thenableIndexCounter = 0;
        $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $4a57df467ec2c8e6$var$workInProgressHook = $4a57df467ec2c8e6$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $4a57df467ec2c8e6$var$ReactSharedInternals.H = $4a57df467ec2c8e6$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $4a57df467ec2c8e6$var$TransitionAwareHostComponent() {
    var dispatcher = $4a57df467ec2c8e6$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $4a57df467ec2c8e6$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $4a57df467ec2c8e6$var$currentHook ? $4a57df467ec2c8e6$var$currentHook.memoizedState : null) !== dispatcher && ($4a57df467ec2c8e6$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $4a57df467ec2c8e6$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $4a57df467ec2c8e6$var$localIdCounter;
    $4a57df467ec2c8e6$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $4a57df467ec2c8e6$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $4a57df467ec2c8e6$var$resetHooksOnUnwind(workInProgress) {
    if ($4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdate = !1;
    }
    $4a57df467ec2c8e6$var$renderLanes = 0;
    $4a57df467ec2c8e6$var$workInProgressHook = $4a57df467ec2c8e6$var$currentHook = $4a57df467ec2c8e6$var$currentlyRenderingFiber = null;
    $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $4a57df467ec2c8e6$var$thenableIndexCounter = $4a57df467ec2c8e6$var$localIdCounter = 0;
    $4a57df467ec2c8e6$var$thenableState = null;
}
function $4a57df467ec2c8e6$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4a57df467ec2c8e6$var$workInProgressHook ? $4a57df467ec2c8e6$var$currentlyRenderingFiber.memoizedState = $4a57df467ec2c8e6$var$workInProgressHook = hook : $4a57df467ec2c8e6$var$workInProgressHook = $4a57df467ec2c8e6$var$workInProgressHook.next = hook;
    return $4a57df467ec2c8e6$var$workInProgressHook;
}
function $4a57df467ec2c8e6$var$updateWorkInProgressHook() {
    if (null === $4a57df467ec2c8e6$var$currentHook) {
        var nextCurrentHook = $4a57df467ec2c8e6$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $4a57df467ec2c8e6$var$currentHook.next;
    var nextWorkInProgressHook = null === $4a57df467ec2c8e6$var$workInProgressHook ? $4a57df467ec2c8e6$var$currentlyRenderingFiber.memoizedState : $4a57df467ec2c8e6$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $4a57df467ec2c8e6$var$workInProgressHook = nextWorkInProgressHook, $4a57df467ec2c8e6$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $4a57df467ec2c8e6$var$currentlyRenderingFiber.alternate) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(467));
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(310));
        }
        $4a57df467ec2c8e6$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $4a57df467ec2c8e6$var$currentHook.memoizedState,
            baseState: $4a57df467ec2c8e6$var$currentHook.baseState,
            baseQueue: $4a57df467ec2c8e6$var$currentHook.baseQueue,
            queue: $4a57df467ec2c8e6$var$currentHook.queue,
            next: null
        };
        null === $4a57df467ec2c8e6$var$workInProgressHook ? $4a57df467ec2c8e6$var$currentlyRenderingFiber.memoizedState = $4a57df467ec2c8e6$var$workInProgressHook = nextCurrentHook : $4a57df467ec2c8e6$var$workInProgressHook = $4a57df467ec2c8e6$var$workInProgressHook.next = nextCurrentHook;
    }
    return $4a57df467ec2c8e6$var$workInProgressHook;
}
function $4a57df467ec2c8e6$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $4a57df467ec2c8e6$var$useThenable(thenable) {
    var index = $4a57df467ec2c8e6$var$thenableIndexCounter;
    $4a57df467ec2c8e6$var$thenableIndexCounter += 1;
    null === $4a57df467ec2c8e6$var$thenableState && ($4a57df467ec2c8e6$var$thenableState = []);
    thenable = $4a57df467ec2c8e6$var$trackUsedThenable($4a57df467ec2c8e6$var$thenableState, thenable, index);
    index = $4a57df467ec2c8e6$var$currentlyRenderingFiber;
    null === (null === $4a57df467ec2c8e6$var$workInProgressHook ? index.memoizedState : $4a57df467ec2c8e6$var$workInProgressHook.next) && (index = index.alternate, $4a57df467ec2c8e6$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $4a57df467ec2c8e6$var$HooksDispatcherOnMount : $4a57df467ec2c8e6$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $4a57df467ec2c8e6$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $4a57df467ec2c8e6$var$useThenable(usable);
        if (usable.$$typeof === $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE) return $4a57df467ec2c8e6$var$readContext(usable);
    }
    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(438, String(usable)));
}
function $4a57df467ec2c8e6$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $4a57df467ec2c8e6$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $4a57df467ec2c8e6$var$createFunctionComponentUpdateQueue(), $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $4a57df467ec2c8e6$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $4a57df467ec2c8e6$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $4a57df467ec2c8e6$var$updateReducer(reducer) {
    var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    return $4a57df467ec2c8e6$var$updateReducerImpl(hook, $4a57df467ec2c8e6$var$currentHook, reducer);
}
function $4a57df467ec2c8e6$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($4a57df467ec2c8e6$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $4a57df467ec2c8e6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($4a57df467ec2c8e6$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $4a57df467ec2c8e6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $4a57df467ec2c8e6$var$currentlyRenderingFiber.lanes |= revertLane, $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $4a57df467ec2c8e6$var$currentlyRenderingFiber.lanes |= updateLane, $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$4a57df467ec2c8e6$var$objectIs(pendingQueue, hook.memoizedState) && ($4a57df467ec2c8e6$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $4a57df467ec2c8e6$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $4a57df467ec2c8e6$var$rerenderReducer(reducer) {
    var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $4a57df467ec2c8e6$var$objectIs(newState, hook.memoizedState) || ($4a57df467ec2c8e6$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $4a57df467ec2c8e6$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $4a57df467ec2c8e6$var$currentlyRenderingFiber, hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $4a57df467ec2c8e6$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$4a57df467ec2c8e6$var$objectIs(($4a57df467ec2c8e6$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $4a57df467ec2c8e6$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $4a57df467ec2c8e6$var$updateEffect($4a57df467ec2c8e6$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $4a57df467ec2c8e6$var$workInProgressHook && $4a57df467ec2c8e6$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $4a57df467ec2c8e6$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $4a57df467ec2c8e6$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $4a57df467ec2c8e6$var$workInProgressRoot) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($4a57df467ec2c8e6$var$renderLanes & 127) || $4a57df467ec2c8e6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $4a57df467ec2c8e6$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $4a57df467ec2c8e6$var$createFunctionComponentUpdateQueue(), $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $4a57df467ec2c8e6$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $4a57df467ec2c8e6$var$checkIfSnapshotChanged(inst) && $4a57df467ec2c8e6$var$forceStoreRerender(fiber);
}
function $4a57df467ec2c8e6$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $4a57df467ec2c8e6$var$checkIfSnapshotChanged(inst) && $4a57df467ec2c8e6$var$forceStoreRerender(fiber);
    });
}
function $4a57df467ec2c8e6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$4a57df467ec2c8e6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $4a57df467ec2c8e6$var$forceStoreRerender(fiber) {
    var root = $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $4a57df467ec2c8e6$var$mountStateImpl(initialState) {
    var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4a57df467ec2c8e6$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $4a57df467ec2c8e6$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $4a57df467ec2c8e6$var$updateReducerImpl(hook, $4a57df467ec2c8e6$var$currentHook, "function" === typeof reducer ? reducer : $4a57df467ec2c8e6$var$basicStateReducer);
}
function $4a57df467ec2c8e6$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($4a57df467ec2c8e6$var$isRenderPhaseUpdate(fiber)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $4a57df467ec2c8e6$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $4a57df467ec2c8e6$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $4a57df467ec2c8e6$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $4a57df467ec2c8e6$var$ReactSharedInternals.T, currentTransition = {};
        $4a57df467ec2c8e6$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $4a57df467ec2c8e6$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $4a57df467ec2c8e6$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $4a57df467ec2c8e6$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $4a57df467ec2c8e6$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $4a57df467ec2c8e6$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $4a57df467ec2c8e6$var$onActionError(actionQueue, node, error$66);
    }
}
function $4a57df467ec2c8e6$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $4a57df467ec2c8e6$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $4a57df467ec2c8e6$var$onActionError(actionQueue, node, error);
    }) : $4a57df467ec2c8e6$var$onActionSuccess(actionQueue, node, returnValue);
}
function $4a57df467ec2c8e6$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $4a57df467ec2c8e6$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $4a57df467ec2c8e6$var$runActionStateAction(actionQueue, nextState)));
}
function $4a57df467ec2c8e6$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $4a57df467ec2c8e6$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $4a57df467ec2c8e6$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $4a57df467ec2c8e6$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $4a57df467ec2c8e6$var$mountActionState(action, initialStateProp) {
    if ($4a57df467ec2c8e6$var$isHydrating) {
        var ssrFormState = $4a57df467ec2c8e6$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $4a57df467ec2c8e6$var$currentlyRenderingFiber;
                if ($4a57df467ec2c8e6$var$isHydrating) {
                    if ($4a57df467ec2c8e6$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $4a57df467ec2c8e6$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $4a57df467ec2c8e6$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $4a57df467ec2c8e6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $4a57df467ec2c8e6$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4a57df467ec2c8e6$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $4a57df467ec2c8e6$var$dispatchSetState.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $4a57df467ec2c8e6$var$mountStateImpl(!1);
    inRootOrSingleton = $4a57df467ec2c8e6$var$dispatchOptimisticSetState.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $4a57df467ec2c8e6$var$dispatchActionState.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $4a57df467ec2c8e6$var$updateActionState(action) {
    var stateHook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    return $4a57df467ec2c8e6$var$updateActionStateImpl(stateHook, $4a57df467ec2c8e6$var$currentHook, action);
}
function $4a57df467ec2c8e6$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $4a57df467ec2c8e6$var$updateReducerImpl(stateHook, currentStateHook, $4a57df467ec2c8e6$var$actionStateReducer)[0];
    stateHook = $4a57df467ec2c8e6$var$updateReducer($4a57df467ec2c8e6$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $4a57df467ec2c8e6$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $4a57df467ec2c8e6$var$SuspenseException) throw $4a57df467ec2c8e6$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($4a57df467ec2c8e6$var$currentlyRenderingFiber.flags |= 2048, $4a57df467ec2c8e6$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $4a57df467ec2c8e6$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $4a57df467ec2c8e6$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $4a57df467ec2c8e6$var$rerenderActionState(action) {
    var stateHook = $4a57df467ec2c8e6$var$updateWorkInProgressHook(), currentStateHook = $4a57df467ec2c8e6$var$currentHook;
    if (null !== currentStateHook) return $4a57df467ec2c8e6$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $4a57df467ec2c8e6$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $4a57df467ec2c8e6$var$createFunctionComponentUpdateQueue(), $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $4a57df467ec2c8e6$var$updateRef() {
    return $4a57df467ec2c8e6$var$updateWorkInProgressHook().memoizedState;
}
function $4a57df467ec2c8e6$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
    $4a57df467ec2c8e6$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $4a57df467ec2c8e6$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $4a57df467ec2c8e6$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $4a57df467ec2c8e6$var$currentHook && null !== deps && $4a57df467ec2c8e6$var$areHookInputsEqual(deps, $4a57df467ec2c8e6$var$currentHook.memoizedState.deps) ? hook.memoizedState = $4a57df467ec2c8e6$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($4a57df467ec2c8e6$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $4a57df467ec2c8e6$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $4a57df467ec2c8e6$var$mountEffect(create, deps) {
    $4a57df467ec2c8e6$var$mountEffectImpl(8390656, 8, create, deps);
}
function $4a57df467ec2c8e6$var$updateEffect(create, deps) {
    $4a57df467ec2c8e6$var$updateEffectImpl(2048, 8, create, deps);
}
function $4a57df467ec2c8e6$var$useEffectEventImpl(payload) {
    $4a57df467ec2c8e6$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $4a57df467ec2c8e6$var$createFunctionComponentUpdateQueue(), $4a57df467ec2c8e6$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $4a57df467ec2c8e6$var$updateEvent(callback) {
    var ref = $4a57df467ec2c8e6$var$updateWorkInProgressHook().memoizedState;
    $4a57df467ec2c8e6$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($4a57df467ec2c8e6$var$executionContext & 2)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $4a57df467ec2c8e6$var$updateInsertionEffect(create, deps) {
    return $4a57df467ec2c8e6$var$updateEffectImpl(4, 2, create, deps);
}
function $4a57df467ec2c8e6$var$updateLayoutEffect(create, deps) {
    return $4a57df467ec2c8e6$var$updateEffectImpl(4, 4, create, deps);
}
function $4a57df467ec2c8e6$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $4a57df467ec2c8e6$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $4a57df467ec2c8e6$var$updateEffectImpl(4, 4, $4a57df467ec2c8e6$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $4a57df467ec2c8e6$var$mountDebugValue() {}
function $4a57df467ec2c8e6$var$updateCallback(callback, deps) {
    var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $4a57df467ec2c8e6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $4a57df467ec2c8e6$var$updateMemo(nextCreate, deps) {
    var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $4a57df467ec2c8e6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $4a57df467ec2c8e6$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($4a57df467ec2c8e6$var$renderLanes & 1073741824) && 0 === ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $4a57df467ec2c8e6$var$requestDeferredLane();
    $4a57df467ec2c8e6$var$currentlyRenderingFiber.lanes |= hook;
    $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $4a57df467ec2c8e6$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($4a57df467ec2c8e6$var$objectIs(value, prevValue)) return value;
    if (null !== $4a57df467ec2c8e6$var$currentTreeHiddenStackCursor.current) return hook = $4a57df467ec2c8e6$var$mountDeferredValueImpl(hook, value, initialValue), $4a57df467ec2c8e6$var$objectIs(hook, prevValue) || ($4a57df467ec2c8e6$var$didReceiveUpdate = !0), hook;
    if (0 === ($4a57df467ec2c8e6$var$renderLanes & 42) || 0 !== ($4a57df467ec2c8e6$var$renderLanes & 1073741824) && 0 === ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 261930)) return $4a57df467ec2c8e6$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $4a57df467ec2c8e6$var$requestDeferredLane();
    $4a57df467ec2c8e6$var$currentlyRenderingFiber.lanes |= hook;
    $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $4a57df467ec2c8e6$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
    $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $4a57df467ec2c8e6$var$ReactSharedInternals.T, currentTransition = {};
    $4a57df467ec2c8e6$var$ReactSharedInternals.T = currentTransition;
    $4a57df467ec2c8e6$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $4a57df467ec2c8e6$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $4a57df467ec2c8e6$var$chainThenableValue(returnValue, finishedState);
            $4a57df467ec2c8e6$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $4a57df467ec2c8e6$var$requestUpdateLane(fiber));
        } else $4a57df467ec2c8e6$var$dispatchSetStateInternal(fiber, queue, finishedState, $4a57df467ec2c8e6$var$requestUpdateLane(fiber));
    } catch (error) {
        $4a57df467ec2c8e6$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $4a57df467ec2c8e6$var$requestUpdateLane());
    } finally{
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $4a57df467ec2c8e6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4a57df467ec2c8e6$var$noop() {}
function $4a57df467ec2c8e6$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(476));
    var queue = $4a57df467ec2c8e6$var$ensureFormComponentIsStateful(formFiber).queue;
    $4a57df467ec2c8e6$var$startTransition(formFiber, queue, pendingState, $4a57df467ec2c8e6$var$sharedNotPendingObject, null === action ? $4a57df467ec2c8e6$var$noop : function() {
        $4a57df467ec2c8e6$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $4a57df467ec2c8e6$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $4a57df467ec2c8e6$var$sharedNotPendingObject,
        baseState: $4a57df467ec2c8e6$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $4a57df467ec2c8e6$var$basicStateReducer,
            lastRenderedState: $4a57df467ec2c8e6$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $4a57df467ec2c8e6$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $4a57df467ec2c8e6$var$requestFormReset$1(formFiber) {
    var stateHook = $4a57df467ec2c8e6$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $4a57df467ec2c8e6$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $4a57df467ec2c8e6$var$requestUpdateLane());
}
function $4a57df467ec2c8e6$var$useHostTransitionStatus() {
    return $4a57df467ec2c8e6$var$readContext($4a57df467ec2c8e6$var$HostTransitionContext);
}
function $4a57df467ec2c8e6$var$updateId() {
    return $4a57df467ec2c8e6$var$updateWorkInProgressHook().memoizedState;
}
function $4a57df467ec2c8e6$var$updateRefresh() {
    return $4a57df467ec2c8e6$var$updateWorkInProgressHook().memoizedState;
}
function $4a57df467ec2c8e6$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $4a57df467ec2c8e6$var$requestUpdateLane();
                fiber = $4a57df467ec2c8e6$var$createUpdate(lane);
                var root$69 = $4a57df467ec2c8e6$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($4a57df467ec2c8e6$var$scheduleUpdateOnFiber(root$69, provider, lane), $4a57df467ec2c8e6$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $4a57df467ec2c8e6$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $4a57df467ec2c8e6$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $4a57df467ec2c8e6$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $4a57df467ec2c8e6$var$isRenderPhaseUpdate(fiber) ? $4a57df467ec2c8e6$var$enqueueRenderPhaseUpdate(queue, action) : (action = $4a57df467ec2c8e6$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($4a57df467ec2c8e6$var$scheduleUpdateOnFiber(action, fiber, lane), $4a57df467ec2c8e6$var$entangleTransitionUpdate(action, queue, lane)));
}
function $4a57df467ec2c8e6$var$dispatchSetState(fiber, queue, action) {
    var lane = $4a57df467ec2c8e6$var$requestUpdateLane();
    $4a57df467ec2c8e6$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $4a57df467ec2c8e6$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4a57df467ec2c8e6$var$isRenderPhaseUpdate(fiber)) $4a57df467ec2c8e6$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($4a57df467ec2c8e6$var$objectIs(eagerState, currentState)) return $4a57df467ec2c8e6$var$enqueueUpdate$1(fiber, queue, update, 0), null === $4a57df467ec2c8e6$var$workInProgressRoot && $4a57df467ec2c8e6$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $4a57df467ec2c8e6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(action, fiber, lane), $4a57df467ec2c8e6$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $4a57df467ec2c8e6$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $4a57df467ec2c8e6$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4a57df467ec2c8e6$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $4a57df467ec2c8e6$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $4a57df467ec2c8e6$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $4a57df467ec2c8e6$var$currentlyRenderingFiber || null !== alternate && alternate === $4a57df467ec2c8e6$var$currentlyRenderingFiber;
}
function $4a57df467ec2c8e6$var$enqueueRenderPhaseUpdate(queue, update) {
    $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdateDuringThisPass = $4a57df467ec2c8e6$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $4a57df467ec2c8e6$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $4a57df467ec2c8e6$var$markRootEntangled(root, lane);
    }
}
var $4a57df467ec2c8e6$var$ContextOnlyDispatcher = {
    readContext: $4a57df467ec2c8e6$var$readContext,
    use: $4a57df467ec2c8e6$var$use,
    useCallback: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useContext: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useEffect: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useImperativeHandle: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useLayoutEffect: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useInsertionEffect: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useMemo: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useReducer: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useRef: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useState: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useDebugValue: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useDeferredValue: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useTransition: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useSyncExternalStore: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useId: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useHostTransitionStatus: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useFormState: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useActionState: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useOptimistic: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useMemoCache: $4a57df467ec2c8e6$var$throwInvalidHookError,
    useCacheRefresh: $4a57df467ec2c8e6$var$throwInvalidHookError
};
$4a57df467ec2c8e6$var$ContextOnlyDispatcher.useEffectEvent = $4a57df467ec2c8e6$var$throwInvalidHookError;
var $4a57df467ec2c8e6$var$HooksDispatcherOnMount = {
    readContext: $4a57df467ec2c8e6$var$readContext,
    use: $4a57df467ec2c8e6$var$use,
    useCallback: function(callback, deps) {
        $4a57df467ec2c8e6$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $4a57df467ec2c8e6$var$readContext,
    useEffect: $4a57df467ec2c8e6$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $4a57df467ec2c8e6$var$mountEffectImpl(4194308, 4, $4a57df467ec2c8e6$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $4a57df467ec2c8e6$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $4a57df467ec2c8e6$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($4a57df467ec2c8e6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $4a57df467ec2c8e6$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $4a57df467ec2c8e6$var$dispatchReducerAction.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $4a57df467ec2c8e6$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $4a57df467ec2c8e6$var$dispatchSetState.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $4a57df467ec2c8e6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
        return $4a57df467ec2c8e6$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $4a57df467ec2c8e6$var$mountStateImpl(!1);
        stateHook = $4a57df467ec2c8e6$var$startTransition.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $4a57df467ec2c8e6$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $4a57df467ec2c8e6$var$currentlyRenderingFiber, hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
        if ($4a57df467ec2c8e6$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $4a57df467ec2c8e6$var$workInProgressRoot) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(349));
            0 !== ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 127) || $4a57df467ec2c8e6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $4a57df467ec2c8e6$var$mountEffect($4a57df467ec2c8e6$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $4a57df467ec2c8e6$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $4a57df467ec2c8e6$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook(), identifierPrefix = $4a57df467ec2c8e6$var$workInProgressRoot.identifierPrefix;
        if ($4a57df467ec2c8e6$var$isHydrating) {
            var JSCompiler_inline_result = $4a57df467ec2c8e6$var$treeContextOverflow;
            var idWithLeadingBit = $4a57df467ec2c8e6$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $4a57df467ec2c8e6$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $4a57df467ec2c8e6$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $4a57df467ec2c8e6$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $4a57df467ec2c8e6$var$useHostTransitionStatus,
    useFormState: $4a57df467ec2c8e6$var$mountActionState,
    useActionState: $4a57df467ec2c8e6$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $4a57df467ec2c8e6$var$dispatchOptimisticSetState.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $4a57df467ec2c8e6$var$useMemoCache,
    useCacheRefresh: function() {
        return $4a57df467ec2c8e6$var$mountWorkInProgressHook().memoizedState = $4a57df467ec2c8e6$var$refreshCache.bind(null, $4a57df467ec2c8e6$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $4a57df467ec2c8e6$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($4a57df467ec2c8e6$var$executionContext & 2)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $4a57df467ec2c8e6$var$HooksDispatcherOnUpdate = {
    readContext: $4a57df467ec2c8e6$var$readContext,
    use: $4a57df467ec2c8e6$var$use,
    useCallback: $4a57df467ec2c8e6$var$updateCallback,
    useContext: $4a57df467ec2c8e6$var$readContext,
    useEffect: $4a57df467ec2c8e6$var$updateEffect,
    useImperativeHandle: $4a57df467ec2c8e6$var$updateImperativeHandle,
    useInsertionEffect: $4a57df467ec2c8e6$var$updateInsertionEffect,
    useLayoutEffect: $4a57df467ec2c8e6$var$updateLayoutEffect,
    useMemo: $4a57df467ec2c8e6$var$updateMemo,
    useReducer: $4a57df467ec2c8e6$var$updateReducer,
    useRef: $4a57df467ec2c8e6$var$updateRef,
    useState: function() {
        return $4a57df467ec2c8e6$var$updateReducer($4a57df467ec2c8e6$var$basicStateReducer);
    },
    useDebugValue: $4a57df467ec2c8e6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
        return $4a57df467ec2c8e6$var$updateDeferredValueImpl(hook, $4a57df467ec2c8e6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $4a57df467ec2c8e6$var$updateReducer($4a57df467ec2c8e6$var$basicStateReducer)[0], start = $4a57df467ec2c8e6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $4a57df467ec2c8e6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $4a57df467ec2c8e6$var$updateSyncExternalStore,
    useId: $4a57df467ec2c8e6$var$updateId,
    useHostTransitionStatus: $4a57df467ec2c8e6$var$useHostTransitionStatus,
    useFormState: $4a57df467ec2c8e6$var$updateActionState,
    useActionState: $4a57df467ec2c8e6$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
        return $4a57df467ec2c8e6$var$updateOptimisticImpl(hook, $4a57df467ec2c8e6$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $4a57df467ec2c8e6$var$useMemoCache,
    useCacheRefresh: $4a57df467ec2c8e6$var$updateRefresh
};
$4a57df467ec2c8e6$var$HooksDispatcherOnUpdate.useEffectEvent = $4a57df467ec2c8e6$var$updateEvent;
var $4a57df467ec2c8e6$var$HooksDispatcherOnRerender = {
    readContext: $4a57df467ec2c8e6$var$readContext,
    use: $4a57df467ec2c8e6$var$use,
    useCallback: $4a57df467ec2c8e6$var$updateCallback,
    useContext: $4a57df467ec2c8e6$var$readContext,
    useEffect: $4a57df467ec2c8e6$var$updateEffect,
    useImperativeHandle: $4a57df467ec2c8e6$var$updateImperativeHandle,
    useInsertionEffect: $4a57df467ec2c8e6$var$updateInsertionEffect,
    useLayoutEffect: $4a57df467ec2c8e6$var$updateLayoutEffect,
    useMemo: $4a57df467ec2c8e6$var$updateMemo,
    useReducer: $4a57df467ec2c8e6$var$rerenderReducer,
    useRef: $4a57df467ec2c8e6$var$updateRef,
    useState: function() {
        return $4a57df467ec2c8e6$var$rerenderReducer($4a57df467ec2c8e6$var$basicStateReducer);
    },
    useDebugValue: $4a57df467ec2c8e6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
        return null === $4a57df467ec2c8e6$var$currentHook ? $4a57df467ec2c8e6$var$mountDeferredValueImpl(hook, value, initialValue) : $4a57df467ec2c8e6$var$updateDeferredValueImpl(hook, $4a57df467ec2c8e6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $4a57df467ec2c8e6$var$rerenderReducer($4a57df467ec2c8e6$var$basicStateReducer)[0], start = $4a57df467ec2c8e6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $4a57df467ec2c8e6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $4a57df467ec2c8e6$var$updateSyncExternalStore,
    useId: $4a57df467ec2c8e6$var$updateId,
    useHostTransitionStatus: $4a57df467ec2c8e6$var$useHostTransitionStatus,
    useFormState: $4a57df467ec2c8e6$var$rerenderActionState,
    useActionState: $4a57df467ec2c8e6$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $4a57df467ec2c8e6$var$updateWorkInProgressHook();
        if (null !== $4a57df467ec2c8e6$var$currentHook) return $4a57df467ec2c8e6$var$updateOptimisticImpl(hook, $4a57df467ec2c8e6$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $4a57df467ec2c8e6$var$useMemoCache,
    useCacheRefresh: $4a57df467ec2c8e6$var$updateRefresh
};
$4a57df467ec2c8e6$var$HooksDispatcherOnRerender.useEffectEvent = $4a57df467ec2c8e6$var$updateEvent;
function $4a57df467ec2c8e6$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $4a57df467ec2c8e6$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $4a57df467ec2c8e6$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $4a57df467ec2c8e6$var$requestUpdateLane(), update = $4a57df467ec2c8e6$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $4a57df467ec2c8e6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($4a57df467ec2c8e6$var$scheduleUpdateOnFiber(payload, inst, lane), $4a57df467ec2c8e6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $4a57df467ec2c8e6$var$requestUpdateLane(), update = $4a57df467ec2c8e6$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $4a57df467ec2c8e6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($4a57df467ec2c8e6$var$scheduleUpdateOnFiber(payload, inst, lane), $4a57df467ec2c8e6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $4a57df467ec2c8e6$var$requestUpdateLane(), update = $4a57df467ec2c8e6$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $4a57df467ec2c8e6$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($4a57df467ec2c8e6$var$scheduleUpdateOnFiber(callback, inst, lane), $4a57df467ec2c8e6$var$entangleTransitions(callback, inst, lane));
    }
};
function $4a57df467ec2c8e6$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$4a57df467ec2c8e6$var$shallowEqual(oldProps, newProps) || !$4a57df467ec2c8e6$var$shallowEqual(oldState, newState) : !0;
}
function $4a57df467ec2c8e6$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $4a57df467ec2c8e6$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $4a57df467ec2c8e6$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $4a57df467ec2c8e6$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $4a57df467ec2c8e6$var$defaultOnUncaughtError(error) {
    $4a57df467ec2c8e6$var$reportGlobalError(error);
}
function $4a57df467ec2c8e6$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $4a57df467ec2c8e6$var$defaultOnRecoverableError(error) {
    $4a57df467ec2c8e6$var$reportGlobalError(error);
}
function $4a57df467ec2c8e6$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $4a57df467ec2c8e6$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $4a57df467ec2c8e6$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $4a57df467ec2c8e6$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $4a57df467ec2c8e6$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $4a57df467ec2c8e6$var$createClassErrorUpdate(lane) {
    lane = $4a57df467ec2c8e6$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $4a57df467ec2c8e6$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $4a57df467ec2c8e6$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $4a57df467ec2c8e6$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed ? $4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $4a57df467ec2c8e6$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $4a57df467ec2c8e6$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $4a57df467ec2c8e6$var$shellBoundary ? $4a57df467ec2c8e6$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $4a57df467ec2c8e6$var$workInProgressRootExitStatus && ($4a57df467ec2c8e6$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $4a57df467ec2c8e6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $4a57df467ec2c8e6$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $4a57df467ec2c8e6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $4a57df467ec2c8e6$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $4a57df467ec2c8e6$var$attachPingListener(root, value, rootRenderLanes);
        $4a57df467ec2c8e6$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($4a57df467ec2c8e6$var$isHydrating) return returnFiber = $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $4a57df467ec2c8e6$var$HydrationMismatchException && (root = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(422), {
        cause: value
    }), $4a57df467ec2c8e6$var$queueHydrationError($4a57df467ec2c8e6$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $4a57df467ec2c8e6$var$HydrationMismatchException && (returnFiber = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(423), {
        cause: value
    }), $4a57df467ec2c8e6$var$queueHydrationError($4a57df467ec2c8e6$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $4a57df467ec2c8e6$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $4a57df467ec2c8e6$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $4a57df467ec2c8e6$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $4a57df467ec2c8e6$var$workInProgressRootExitStatus && ($4a57df467ec2c8e6$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $4a57df467ec2c8e6$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $4a57df467ec2c8e6$var$workInProgressRootConcurrentErrors ? $4a57df467ec2c8e6$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $4a57df467ec2c8e6$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $4a57df467ec2c8e6$var$workInProgressRootExitStatus && ($4a57df467ec2c8e6$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $4a57df467ec2c8e6$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $4a57df467ec2c8e6$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $4a57df467ec2c8e6$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed || !$4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $4a57df467ec2c8e6$var$createClassErrorUpdate(rootRenderLanes), $4a57df467ec2c8e6$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $4a57df467ec2c8e6$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $4a57df467ec2c8e6$var$SelectiveHydrationException = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(461)), $4a57df467ec2c8e6$var$didReceiveUpdate = !1;
function $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $4a57df467ec2c8e6$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $4a57df467ec2c8e6$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $4a57df467ec2c8e6$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $4a57df467ec2c8e6$var$prepareToReadContext(workInProgress);
    nextProps = $4a57df467ec2c8e6$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $4a57df467ec2c8e6$var$checkDidRenderIdHook();
    if (null !== current && !$4a57df467ec2c8e6$var$didReceiveUpdate) return $4a57df467ec2c8e6$var$bailoutHooks(current, workInProgress, renderLanes), $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4a57df467ec2c8e6$var$isHydrating && key && $4a57df467ec2c8e6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $4a57df467ec2c8e6$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$4a57df467ec2c8e6$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $4a57df467ec2c8e6$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $4a57df467ec2c8e6$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$4a57df467ec2c8e6$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $4a57df467ec2c8e6$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $4a57df467ec2c8e6$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $4a57df467ec2c8e6$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($4a57df467ec2c8e6$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($4a57df467ec2c8e6$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $4a57df467ec2c8e6$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($4a57df467ec2c8e6$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $4a57df467ec2c8e6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $4a57df467ec2c8e6$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $4a57df467ec2c8e6$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $4a57df467ec2c8e6$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $4a57df467ec2c8e6$var$pushHiddenContext(workInProgress, prevState) : $4a57df467ec2c8e6$var$reuseHiddenContextOnStack(), $4a57df467ec2c8e6$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $4a57df467ec2c8e6$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($4a57df467ec2c8e6$var$pushTransition(workInProgress, prevState.cachePool), $4a57df467ec2c8e6$var$pushHiddenContext(workInProgress, prevState), $4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $4a57df467ec2c8e6$var$pushTransition(workInProgress, null), $4a57df467ec2c8e6$var$reuseHiddenContextOnStack(), $4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(workInProgress));
    $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $4a57df467ec2c8e6$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $4a57df467ec2c8e6$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $4a57df467ec2c8e6$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $4a57df467ec2c8e6$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $4a57df467ec2c8e6$var$pushTransition(workInProgress, null);
    $4a57df467ec2c8e6$var$reuseHiddenContextOnStack();
    $4a57df467ec2c8e6$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $4a57df467ec2c8e6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $4a57df467ec2c8e6$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $4a57df467ec2c8e6$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $4a57df467ec2c8e6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $4a57df467ec2c8e6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $4a57df467ec2c8e6$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $4a57df467ec2c8e6$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($4a57df467ec2c8e6$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $4a57df467ec2c8e6$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $4a57df467ec2c8e6$var$bailoutOffscreenComponent(null, current);
            $4a57df467ec2c8e6$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $4a57df467ec2c8e6$var$nextHydratableInstance) ? (current = $4a57df467ec2c8e6$var$canHydrateHydrationBoundary(current, $4a57df467ec2c8e6$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $4a57df467ec2c8e6$var$treeContextProvider ? {
                    id: $4a57df467ec2c8e6$var$treeContextId,
                    overflow: $4a57df467ec2c8e6$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $4a57df467ec2c8e6$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress, $4a57df467ec2c8e6$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $4a57df467ec2c8e6$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $4a57df467ec2c8e6$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $4a57df467ec2c8e6$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $4a57df467ec2c8e6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(558));
        } else if ($4a57df467ec2c8e6$var$didReceiveUpdate || $4a57df467ec2c8e6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $4a57df467ec2c8e6$var$didReceiveUpdate || didSuspend) {
            nextProps = $4a57df467ec2c8e6$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $4a57df467ec2c8e6$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(current, dehydrated), $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $4a57df467ec2c8e6$var$SelectiveHydrationException;
            $4a57df467ec2c8e6$var$renderDidSuspendDelayIfPossible();
            workInProgress = $4a57df467ec2c8e6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratable(dehydrated.nextSibling), $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress, $4a57df467ec2c8e6$var$isHydrating = !0, $4a57df467ec2c8e6$var$hydrationErrors = null, $4a57df467ec2c8e6$var$rootOrSingletonContext = !1, null !== current && $4a57df467ec2c8e6$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $4a57df467ec2c8e6$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $4a57df467ec2c8e6$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $4a57df467ec2c8e6$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $4a57df467ec2c8e6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $4a57df467ec2c8e6$var$prepareToReadContext(workInProgress);
    Component = $4a57df467ec2c8e6$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $4a57df467ec2c8e6$var$checkDidRenderIdHook();
    if (null !== current && !$4a57df467ec2c8e6$var$didReceiveUpdate) return $4a57df467ec2c8e6$var$bailoutHooks(current, workInProgress, renderLanes), $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4a57df467ec2c8e6$var$isHydrating && nextProps && $4a57df467ec2c8e6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $4a57df467ec2c8e6$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $4a57df467ec2c8e6$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $4a57df467ec2c8e6$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $4a57df467ec2c8e6$var$finishRenderingHooks(current);
    Component = $4a57df467ec2c8e6$var$checkDidRenderIdHook();
    if (null !== current && !$4a57df467ec2c8e6$var$didReceiveUpdate) return $4a57df467ec2c8e6$var$bailoutHooks(current, workInProgress, renderLanes), $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $4a57df467ec2c8e6$var$isHydrating && Component && $4a57df467ec2c8e6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $4a57df467ec2c8e6$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $4a57df467ec2c8e6$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $4a57df467ec2c8e6$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $4a57df467ec2c8e6$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $4a57df467ec2c8e6$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $4a57df467ec2c8e6$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $4a57df467ec2c8e6$var$readContext(contextType) : $4a57df467ec2c8e6$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($4a57df467ec2c8e6$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $4a57df467ec2c8e6$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $4a57df467ec2c8e6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $4a57df467ec2c8e6$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $4a57df467ec2c8e6$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $4a57df467ec2c8e6$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $4a57df467ec2c8e6$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $4a57df467ec2c8e6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $4a57df467ec2c8e6$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $4a57df467ec2c8e6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $4a57df467ec2c8e6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $4a57df467ec2c8e6$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($4a57df467ec2c8e6$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $4a57df467ec2c8e6$var$hasForceUpdate || $4a57df467ec2c8e6$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $4a57df467ec2c8e6$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $4a57df467ec2c8e6$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $4a57df467ec2c8e6$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $4a57df467ec2c8e6$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $4a57df467ec2c8e6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $4a57df467ec2c8e6$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $4a57df467ec2c8e6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $4a57df467ec2c8e6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $4a57df467ec2c8e6$var$hasForceUpdate || null !== current && null !== current.dependencies && $4a57df467ec2c8e6$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($4a57df467ec2c8e6$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $4a57df467ec2c8e6$var$hasForceUpdate || $4a57df467ec2c8e6$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $4a57df467ec2c8e6$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $4a57df467ec2c8e6$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $4a57df467ec2c8e6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $4a57df467ec2c8e6$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $4a57df467ec2c8e6$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $4a57df467ec2c8e6$var$resetHydrationState();
    workInProgress.flags |= 256;
    $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $4a57df467ec2c8e6$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $4a57df467ec2c8e6$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $4a57df467ec2c8e6$var$getSuspendedCache()
    };
}
function $4a57df467ec2c8e6$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $4a57df467ec2c8e6$var$workInProgressDeferredLane);
    return current;
}
function $4a57df467ec2c8e6$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($4a57df467ec2c8e6$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($4a57df467ec2c8e6$var$isHydrating) {
            showFallback ? $4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $4a57df467ec2c8e6$var$nextHydratableInstance) ? (current = $4a57df467ec2c8e6$var$canHydrateHydrationBoundary(current, $4a57df467ec2c8e6$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $4a57df467ec2c8e6$var$treeContextProvider ? {
                    id: $4a57df467ec2c8e6$var$treeContextId,
                    overflow: $4a57df467ec2c8e6$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $4a57df467ec2c8e6$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress, $4a57df467ec2c8e6$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $4a57df467ec2c8e6$var$throwOnHydrationMismatch(workInProgress);
            $4a57df467ec2c8e6$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $4a57df467ec2c8e6$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $4a57df467ec2c8e6$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $4a57df467ec2c8e6$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $4a57df467ec2c8e6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4a57df467ec2c8e6$var$SUSPENDED_MARKER, $4a57df467ec2c8e6$var$bailoutOffscreenComponent(null, nextProps);
        $4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $4a57df467ec2c8e6$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $4a57df467ec2c8e6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $4a57df467ec2c8e6$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $4a57df467ec2c8e6$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $4a57df467ec2c8e6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $4a57df467ec2c8e6$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $4a57df467ec2c8e6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4a57df467ec2c8e6$var$SUSPENDED_MARKER, workInProgress = $4a57df467ec2c8e6$var$bailoutOffscreenComponent(null, nextProps));
        else if ($4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress), $4a57df467ec2c8e6$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($4a57df467ec2c8e6$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $4a57df467ec2c8e6$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $4a57df467ec2c8e6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($4a57df467ec2c8e6$var$didReceiveUpdate || $4a57df467ec2c8e6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $4a57df467ec2c8e6$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $4a57df467ec2c8e6$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $4a57df467ec2c8e6$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(current, nextProps), $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $4a57df467ec2c8e6$var$SelectiveHydrationException;
            $4a57df467ec2c8e6$var$isSuspenseInstancePending(nextPrimaryChildren) || $4a57df467ec2c8e6$var$renderDidSuspendDelayIfPossible();
            workInProgress = $4a57df467ec2c8e6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $4a57df467ec2c8e6$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratable(nextPrimaryChildren.nextSibling), $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress, $4a57df467ec2c8e6$var$isHydrating = !0, $4a57df467ec2c8e6$var$hydrationErrors = null, $4a57df467ec2c8e6$var$rootOrSingletonContext = !1, null !== current && $4a57df467ec2c8e6$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $4a57df467ec2c8e6$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $4a57df467ec2c8e6$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $4a57df467ec2c8e6$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $4a57df467ec2c8e6$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $4a57df467ec2c8e6$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $4a57df467ec2c8e6$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $4a57df467ec2c8e6$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $4a57df467ec2c8e6$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $4a57df467ec2c8e6$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $4a57df467ec2c8e6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $4a57df467ec2c8e6$var$SUSPENDED_MARKER, $4a57df467ec2c8e6$var$bailoutOffscreenComponent(current.child, nextProps);
    $4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $4a57df467ec2c8e6$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $4a57df467ec2c8e6$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $4a57df467ec2c8e6$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $4a57df467ec2c8e6$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $4a57df467ec2c8e6$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $4a57df467ec2c8e6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $4a57df467ec2c8e6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $4a57df467ec2c8e6$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $4a57df467ec2c8e6$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $4a57df467ec2c8e6$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $4a57df467ec2c8e6$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $4a57df467ec2c8e6$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $4a57df467ec2c8e6$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, suspenseContext);
    $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $4a57df467ec2c8e6$var$isHydrating ? $4a57df467ec2c8e6$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $4a57df467ec2c8e6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $4a57df467ec2c8e6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $4a57df467ec2c8e6$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $4a57df467ec2c8e6$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $4a57df467ec2c8e6$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $4a57df467ec2c8e6$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $4a57df467ec2c8e6$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($4a57df467ec2c8e6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $4a57df467ec2c8e6$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $4a57df467ec2c8e6$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $4a57df467ec2c8e6$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $4a57df467ec2c8e6$var$checkIfContextChanged(current) ? !0 : !1;
}
function $4a57df467ec2c8e6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $4a57df467ec2c8e6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $4a57df467ec2c8e6$var$pushProvider(workInProgress, $4a57df467ec2c8e6$var$CacheContext, current.memoizedState.cache);
            $4a57df467ec2c8e6$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $4a57df467ec2c8e6$var$pushHostContext(workInProgress);
            break;
        case 4:
            $4a57df467ec2c8e6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $4a57df467ec2c8e6$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $4a57df467ec2c8e6$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $4a57df467ec2c8e6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $4a57df467ec2c8e6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($4a57df467ec2c8e6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $4a57df467ec2c8e6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, $4a57df467ec2c8e6$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $4a57df467ec2c8e6$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $4a57df467ec2c8e6$var$pushProvider(workInProgress, $4a57df467ec2c8e6$var$CacheContext, current.memoizedState.cache);
    }
    return $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $4a57df467ec2c8e6$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $4a57df467ec2c8e6$var$didReceiveUpdate = !0;
        else {
            if (!$4a57df467ec2c8e6$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $4a57df467ec2c8e6$var$didReceiveUpdate = !1, $4a57df467ec2c8e6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $4a57df467ec2c8e6$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $4a57df467ec2c8e6$var$didReceiveUpdate = !1, $4a57df467ec2c8e6$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $4a57df467ec2c8e6$var$pushTreeId(workInProgress, $4a57df467ec2c8e6$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $4a57df467ec2c8e6$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $4a57df467ec2c8e6$var$shouldConstruct(current) ? (props = $4a57df467ec2c8e6$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $4a57df467ec2c8e6$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $4a57df467ec2c8e6$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $4a57df467ec2c8e6$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $4a57df467ec2c8e6$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $4a57df467ec2c8e6$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $4a57df467ec2c8e6$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $4a57df467ec2c8e6$var$getComponentNameFromType(current) || current;
                    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $4a57df467ec2c8e6$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $4a57df467ec2c8e6$var$resolveClassComponentProps(props, workInProgress.pendingProps), $4a57df467ec2c8e6$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $4a57df467ec2c8e6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $4a57df467ec2c8e6$var$cloneUpdateQueue(current, workInProgress);
                $4a57df467ec2c8e6$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $4a57df467ec2c8e6$var$pushProvider(workInProgress, $4a57df467ec2c8e6$var$CacheContext, props);
                props !== prevState.cache && $4a57df467ec2c8e6$var$propagateContextChanges(workInProgress, [
                    $4a57df467ec2c8e6$var$CacheContext
                ], renderLanes, !0);
                $4a57df467ec2c8e6$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $4a57df467ec2c8e6$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $4a57df467ec2c8e6$var$createCapturedValueAtFiber(Error($4a57df467ec2c8e6$var$formatProdErrorMessage(424)), workInProgress);
                        $4a57df467ec2c8e6$var$queueHydrationError($$typeof);
                        workInProgress = $4a57df467ec2c8e6$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratable(current.firstChild);
                        $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress;
                        $4a57df467ec2c8e6$var$isHydrating = !0;
                        $4a57df467ec2c8e6$var$hydrationErrors = null;
                        $4a57df467ec2c8e6$var$rootOrSingletonContext = !0;
                        renderLanes = $4a57df467ec2c8e6$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $4a57df467ec2c8e6$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $4a57df467ec2c8e6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $4a57df467ec2c8e6$var$markRef(current, workInProgress), null === current ? (renderLanes = $4a57df467ec2c8e6$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $4a57df467ec2c8e6$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $4a57df467ec2c8e6$var$getOwnerDocumentFromRootContainer($4a57df467ec2c8e6$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$4a57df467ec2c8e6$var$internalInstanceKey] = workInProgress, props[$4a57df467ec2c8e6$var$internalPropsKey] = current, $4a57df467ec2c8e6$var$setInitialProperties(props, renderLanes, current), $4a57df467ec2c8e6$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $4a57df467ec2c8e6$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $4a57df467ec2c8e6$var$pushHostContext(workInProgress), null === current && $4a57df467ec2c8e6$var$isHydrating && (props = workInProgress.stateNode = $4a57df467ec2c8e6$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $4a57df467ec2c8e6$var$rootInstanceStackCursor.current), $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress, $4a57df467ec2c8e6$var$rootOrSingletonContext = !0, $$typeof = $4a57df467ec2c8e6$var$nextHydratableInstance, $4a57df467ec2c8e6$var$isSingletonScope(workInProgress.type) ? ($4a57df467ec2c8e6$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratable(props.firstChild)) : $4a57df467ec2c8e6$var$nextHydratableInstance = $$typeof), $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $4a57df467ec2c8e6$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $4a57df467ec2c8e6$var$isHydrating) {
                if ($$typeof = props = $4a57df467ec2c8e6$var$nextHydratableInstance) props = $4a57df467ec2c8e6$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $4a57df467ec2c8e6$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress, $4a57df467ec2c8e6$var$nextHydratableInstance = $4a57df467ec2c8e6$var$getNextHydratable(props.firstChild), $4a57df467ec2c8e6$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $4a57df467ec2c8e6$var$throwOnHydrationMismatch(workInProgress);
            }
            $4a57df467ec2c8e6$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $4a57df467ec2c8e6$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $4a57df467ec2c8e6$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $4a57df467ec2c8e6$var$renderWithHooks(current, workInProgress, $4a57df467ec2c8e6$var$TransitionAwareHostComponent, null, null, renderLanes), $4a57df467ec2c8e6$var$HostTransitionContext._currentValue = $$typeof);
            $4a57df467ec2c8e6$var$markRef(current, workInProgress);
            $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $4a57df467ec2c8e6$var$isHydrating) {
                if (current = renderLanes = $4a57df467ec2c8e6$var$nextHydratableInstance) renderLanes = $4a57df467ec2c8e6$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $4a57df467ec2c8e6$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $4a57df467ec2c8e6$var$hydrationParentFiber = workInProgress, $4a57df467ec2c8e6$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $4a57df467ec2c8e6$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $4a57df467ec2c8e6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $4a57df467ec2c8e6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $4a57df467ec2c8e6$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $4a57df467ec2c8e6$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $4a57df467ec2c8e6$var$pushProvider(workInProgress, workInProgress.type, props.value), $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $4a57df467ec2c8e6$var$prepareToReadContext(workInProgress), $$typeof = $4a57df467ec2c8e6$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $4a57df467ec2c8e6$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $4a57df467ec2c8e6$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $4a57df467ec2c8e6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $4a57df467ec2c8e6$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $4a57df467ec2c8e6$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $4a57df467ec2c8e6$var$prepareToReadContext(workInProgress), props = $4a57df467ec2c8e6$var$readContext($4a57df467ec2c8e6$var$CacheContext), null === current ? ($$typeof = $4a57df467ec2c8e6$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $4a57df467ec2c8e6$var$workInProgressRoot, prevState = $4a57df467ec2c8e6$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $4a57df467ec2c8e6$var$initializeUpdateQueue(workInProgress), $4a57df467ec2c8e6$var$pushProvider(workInProgress, $4a57df467ec2c8e6$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($4a57df467ec2c8e6$var$cloneUpdateQueue(current, workInProgress), $4a57df467ec2c8e6$var$processUpdateQueue(workInProgress, null, null, renderLanes), $4a57df467ec2c8e6$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $4a57df467ec2c8e6$var$pushProvider(workInProgress, $4a57df467ec2c8e6$var$CacheContext, props)) : (props = prevState.cache, $4a57df467ec2c8e6$var$pushProvider(workInProgress, $4a57df467ec2c8e6$var$CacheContext, props), props !== $$typeof.cache && $4a57df467ec2c8e6$var$propagateContextChanges(workInProgress, [
                $4a57df467ec2c8e6$var$CacheContext
            ], renderLanes, !0))), $4a57df467ec2c8e6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $4a57df467ec2c8e6$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $4a57df467ec2c8e6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($4a57df467ec2c8e6$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $4a57df467ec2c8e6$var$suspendedThenable = $4a57df467ec2c8e6$var$noopSuspenseyCommitThenable, $4a57df467ec2c8e6$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $4a57df467ec2c8e6$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$4a57df467ec2c8e6$var$preloadResource(resource)) {
        if ($4a57df467ec2c8e6$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $4a57df467ec2c8e6$var$suspendedThenable = $4a57df467ec2c8e6$var$noopSuspenseyCommitThenable, $4a57df467ec2c8e6$var$SuspenseyCommitException;
    }
}
function $4a57df467ec2c8e6$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $4a57df467ec2c8e6$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $4a57df467ec2c8e6$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $4a57df467ec2c8e6$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$4a57df467ec2c8e6$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $4a57df467ec2c8e6$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $4a57df467ec2c8e6$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $4a57df467ec2c8e6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), null;
        case 1:
            return $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $4a57df467ec2c8e6$var$popProvider($4a57df467ec2c8e6$var$CacheContext);
            $4a57df467ec2c8e6$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $4a57df467ec2c8e6$var$popHydrationState(workInProgress) ? $4a57df467ec2c8e6$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $4a57df467ec2c8e6$var$upgradeHydrationErrorsToRecoverable());
            $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($4a57df467ec2c8e6$var$markUpdate(workInProgress), null !== nextResource ? ($4a57df467ec2c8e6$var$bubbleProperties(workInProgress), $4a57df467ec2c8e6$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($4a57df467ec2c8e6$var$bubbleProperties(workInProgress), $4a57df467ec2c8e6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($4a57df467ec2c8e6$var$markUpdate(workInProgress), $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), $4a57df467ec2c8e6$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($4a57df467ec2c8e6$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $4a57df467ec2c8e6$var$markUpdate(workInProgress), $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), $4a57df467ec2c8e6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $4a57df467ec2c8e6$var$popHostContext(workInProgress);
            renderLanes = $4a57df467ec2c8e6$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4a57df467ec2c8e6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(166));
                    $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $4a57df467ec2c8e6$var$contextStackCursor.current;
                $4a57df467ec2c8e6$var$popHydrationState(workInProgress) ? $4a57df467ec2c8e6$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $4a57df467ec2c8e6$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $4a57df467ec2c8e6$var$markUpdate(workInProgress));
            }
            $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $4a57df467ec2c8e6$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4a57df467ec2c8e6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(166));
                    $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $4a57df467ec2c8e6$var$contextStackCursor.current;
                if ($4a57df467ec2c8e6$var$popHydrationState(workInProgress)) $4a57df467ec2c8e6$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $4a57df467ec2c8e6$var$getOwnerDocumentFromRootContainer($4a57df467ec2c8e6$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$4a57df467ec2c8e6$var$internalInstanceKey] = workInProgress;
                    nextResource[$4a57df467ec2c8e6$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($4a57df467ec2c8e6$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $4a57df467ec2c8e6$var$markUpdate(workInProgress);
                }
            }
            $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
            $4a57df467ec2c8e6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $4a57df467ec2c8e6$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(166));
                current = $4a57df467ec2c8e6$var$rootInstanceStackCursor.current;
                if ($4a57df467ec2c8e6$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $4a57df467ec2c8e6$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$4a57df467ec2c8e6$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $4a57df467ec2c8e6$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $4a57df467ec2c8e6$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $4a57df467ec2c8e6$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$4a57df467ec2c8e6$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $4a57df467ec2c8e6$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(557));
                        current[$4a57df467ec2c8e6$var$internalInstanceKey] = workInProgress;
                    } else $4a57df467ec2c8e6$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $4a57df467ec2c8e6$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress), workInProgress;
                    $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(558));
            }
            $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $4a57df467ec2c8e6$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(317));
                        type[$4a57df467ec2c8e6$var$internalInstanceKey] = workInProgress;
                    } else $4a57df467ec2c8e6$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $4a57df467ec2c8e6$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress), workInProgress;
                    $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $4a57df467ec2c8e6$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $4a57df467ec2c8e6$var$popHostContainer(), null === current && $4a57df467ec2c8e6$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), null;
        case 10:
            return $4a57df467ec2c8e6$var$popProvider(workInProgress.type), $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), null;
        case 19:
            $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $4a57df467ec2c8e6$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $4a57df467ec2c8e6$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $4a57df467ec2c8e6$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $4a57df467ec2c8e6$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $4a57df467ec2c8e6$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$4a57df467ec2c8e6$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, $4a57df467ec2c8e6$var$suspenseStackCursor.current & 1 | 2);
                            $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $4a57df467ec2c8e6$var$now() > $4a57df467ec2c8e6$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $4a57df467ec2c8e6$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $4a57df467ec2c8e6$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $4a57df467ec2c8e6$var$scheduleRetryEffect(workInProgress, current), $4a57df467ec2c8e6$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$4a57df467ec2c8e6$var$isHydrating) return $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), null;
                    } else 2 * $4a57df467ec2c8e6$var$now() - newProps.renderingStartTime > $4a57df467ec2c8e6$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $4a57df467ec2c8e6$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $4a57df467ec2c8e6$var$now(), current.sibling = null, renderLanes = $4a57df467ec2c8e6$var$suspenseStackCursor.current, $4a57df467ec2c8e6$var$push($4a57df467ec2c8e6$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $4a57df467ec2c8e6$var$isHydrating && $4a57df467ec2c8e6$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $4a57df467ec2c8e6$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress), $4a57df467ec2c8e6$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($4a57df467ec2c8e6$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $4a57df467ec2c8e6$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $4a57df467ec2c8e6$var$popProvider($4a57df467ec2c8e6$var$CacheContext), $4a57df467ec2c8e6$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $4a57df467ec2c8e6$var$unwindWork(current, workInProgress) {
    $4a57df467ec2c8e6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $4a57df467ec2c8e6$var$popProvider($4a57df467ec2c8e6$var$CacheContext), $4a57df467ec2c8e6$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $4a57df467ec2c8e6$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(340));
                $4a57df467ec2c8e6$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(340));
                $4a57df467ec2c8e6$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$suspenseStackCursor), null;
        case 4:
            return $4a57df467ec2c8e6$var$popHostContainer(), null;
        case 10:
            return $4a57df467ec2c8e6$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $4a57df467ec2c8e6$var$popSuspenseHandler(workInProgress), $4a57df467ec2c8e6$var$popHiddenContext(), null !== current && $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $4a57df467ec2c8e6$var$popProvider($4a57df467ec2c8e6$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $4a57df467ec2c8e6$var$unwindInterruptedWork(current, interruptedWork) {
    $4a57df467ec2c8e6$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $4a57df467ec2c8e6$var$popProvider($4a57df467ec2c8e6$var$CacheContext);
            $4a57df467ec2c8e6$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $4a57df467ec2c8e6$var$popHostContext(interruptedWork);
            break;
        case 4:
            $4a57df467ec2c8e6$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $4a57df467ec2c8e6$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $4a57df467ec2c8e6$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$suspenseStackCursor);
            break;
        case 10:
            $4a57df467ec2c8e6$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $4a57df467ec2c8e6$var$popSuspenseHandler(interruptedWork);
            $4a57df467ec2c8e6$var$popHiddenContext();
            null !== current && $4a57df467ec2c8e6$var$pop($4a57df467ec2c8e6$var$resumedCache);
            break;
        case 24:
            $4a57df467ec2c8e6$var$popProvider($4a57df467ec2c8e6$var$CacheContext);
    }
}
function $4a57df467ec2c8e6$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4a57df467ec2c8e6$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $4a57df467ec2c8e6$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4a57df467ec2c8e6$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $4a57df467ec2c8e6$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $4a57df467ec2c8e6$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $4a57df467ec2c8e6$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $4a57df467ec2c8e6$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $4a57df467ec2c8e6$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $4a57df467ec2c8e6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $4a57df467ec2c8e6$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $4a57df467ec2c8e6$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4a57df467ec2c8e6$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $4a57df467ec2c8e6$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$4a57df467ec2c8e6$var$internalPropsKey] = newProps;
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4a57df467ec2c8e6$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $4a57df467ec2c8e6$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $4a57df467ec2c8e6$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $4a57df467ec2c8e6$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $4a57df467ec2c8e6$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $4a57df467ec2c8e6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $4a57df467ec2c8e6$var$noop$1));
    else if (4 !== tag && (27 === tag && $4a57df467ec2c8e6$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($4a57df467ec2c8e6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$4a57df467ec2c8e6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $4a57df467ec2c8e6$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $4a57df467ec2c8e6$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($4a57df467ec2c8e6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$4a57df467ec2c8e6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $4a57df467ec2c8e6$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $4a57df467ec2c8e6$var$setInitialProperties(singleton, type, props);
        singleton[$4a57df467ec2c8e6$var$internalInstanceKey] = finishedWork;
        singleton[$4a57df467ec2c8e6$var$internalPropsKey] = props;
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden = !1, $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden = !1, $4a57df467ec2c8e6$var$needsFormReset = !1, $4a57df467ec2c8e6$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $4a57df467ec2c8e6$var$nextEffect = null;
function $4a57df467ec2c8e6$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $4a57df467ec2c8e6$var$eventsEnabled = $4a57df467ec2c8e6$var$_enabled;
    root = $4a57df467ec2c8e6$var$getActiveElementDeep(root);
    if ($4a57df467ec2c8e6$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $4a57df467ec2c8e6$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $4a57df467ec2c8e6$var$_enabled = !1;
    for($4a57df467ec2c8e6$var$nextEffect = firstChild; null !== $4a57df467ec2c8e6$var$nextEffect;)if (firstChild = $4a57df467ec2c8e6$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $4a57df467ec2c8e6$var$nextEffect = root;
    else for(; null !== $4a57df467ec2c8e6$var$nextEffect;){
        firstChild = $4a57df467ec2c8e6$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $4a57df467ec2c8e6$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $4a57df467ec2c8e6$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $4a57df467ec2c8e6$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $4a57df467ec2c8e6$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $4a57df467ec2c8e6$var$nextEffect = root;
            break;
        }
        $4a57df467ec2c8e6$var$nextEffect = firstChild.return;
    }
}
function $4a57df467ec2c8e6$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4a57df467ec2c8e6$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $4a57df467ec2c8e6$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $4a57df467ec2c8e6$var$commitClassCallbacks(finishedWork);
            flags & 512 && $4a57df467ec2c8e6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $4a57df467ec2c8e6$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $4a57df467ec2c8e6$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $4a57df467ec2c8e6$var$commitHostMount(finishedWork);
            flags & 512 && $4a57df467ec2c8e6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4a57df467ec2c8e6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $4a57df467ec2c8e6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $4a57df467ec2c8e6$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $4a57df467ec2c8e6$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden;
                prevProps = $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden;
                $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden = flags;
                ($4a57df467ec2c8e6$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden = prevProps;
                $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $4a57df467ec2c8e6$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $4a57df467ec2c8e6$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $4a57df467ec2c8e6$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $4a57df467ec2c8e6$var$hostParent = null, $4a57df467ec2c8e6$var$hostParentIsContainer = !1;
function $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$4a57df467ec2c8e6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $4a57df467ec2c8e6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($4a57df467ec2c8e6$var$injectedHook && "function" === typeof $4a57df467ec2c8e6$var$injectedHook.onCommitFiberUnmount) try {
        $4a57df467ec2c8e6$var$injectedHook.onCommitFiberUnmount($4a57df467ec2c8e6$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || $4a57df467ec2c8e6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || $4a57df467ec2c8e6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $4a57df467ec2c8e6$var$hostParent, prevHostParentIsContainer = $4a57df467ec2c8e6$var$hostParentIsContainer;
            $4a57df467ec2c8e6$var$isSingletonScope(deletedFiber.type) && ($4a57df467ec2c8e6$var$hostParent = deletedFiber.stateNode, $4a57df467ec2c8e6$var$hostParentIsContainer = !1);
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4a57df467ec2c8e6$var$releaseSingletonInstance(deletedFiber.stateNode);
            $4a57df467ec2c8e6$var$hostParent = prevHostParent;
            $4a57df467ec2c8e6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || $4a57df467ec2c8e6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $4a57df467ec2c8e6$var$hostParent;
            prevHostParentIsContainer = $4a57df467ec2c8e6$var$hostParentIsContainer;
            $4a57df467ec2c8e6$var$hostParent = null;
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4a57df467ec2c8e6$var$hostParent = prevHostParent;
            $4a57df467ec2c8e6$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $4a57df467ec2c8e6$var$hostParent) {
                if ($4a57df467ec2c8e6$var$hostParentIsContainer) try {
                    (9 === $4a57df467ec2c8e6$var$hostParent.nodeType ? $4a57df467ec2c8e6$var$hostParent.body : "HTML" === $4a57df467ec2c8e6$var$hostParent.nodeName ? $4a57df467ec2c8e6$var$hostParent.ownerDocument.body : $4a57df467ec2c8e6$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $4a57df467ec2c8e6$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $4a57df467ec2c8e6$var$hostParent && ($4a57df467ec2c8e6$var$hostParentIsContainer ? (finishedRoot = $4a57df467ec2c8e6$var$hostParent, $4a57df467ec2c8e6$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $4a57df467ec2c8e6$var$retryIfBlockedOn(finishedRoot)) : $4a57df467ec2c8e6$var$clearHydrationBoundary($4a57df467ec2c8e6$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $4a57df467ec2c8e6$var$hostParent;
            prevHostParentIsContainer = $4a57df467ec2c8e6$var$hostParentIsContainer;
            $4a57df467ec2c8e6$var$hostParent = deletedFiber.stateNode.containerInfo;
            $4a57df467ec2c8e6$var$hostParentIsContainer = !0;
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4a57df467ec2c8e6$var$hostParent = prevHostParent;
            $4a57df467ec2c8e6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $4a57df467ec2c8e6$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || $4a57df467ec2c8e6$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || ($4a57df467ec2c8e6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $4a57df467ec2c8e6$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden = (prevHostParent = $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $4a57df467ec2c8e6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $4a57df467ec2c8e6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $4a57df467ec2c8e6$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $4a57df467ec2c8e6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $4a57df467ec2c8e6$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $4a57df467ec2c8e6$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $4a57df467ec2c8e6$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $4a57df467ec2c8e6$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $4a57df467ec2c8e6$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $4a57df467ec2c8e6$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $4a57df467ec2c8e6$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($4a57df467ec2c8e6$var$isSingletonScope(parent.type)) {
                        $4a57df467ec2c8e6$var$hostParent = parent.stateNode;
                        $4a57df467ec2c8e6$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $4a57df467ec2c8e6$var$hostParent = parent.stateNode;
                    $4a57df467ec2c8e6$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $4a57df467ec2c8e6$var$hostParent = parent.stateNode.containerInfo;
                    $4a57df467ec2c8e6$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $4a57df467ec2c8e6$var$hostParent) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(160));
        $4a57df467ec2c8e6$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $4a57df467ec2c8e6$var$hostParent = null;
        $4a57df467ec2c8e6$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$4a57df467ec2c8e6$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $4a57df467ec2c8e6$var$currentHoistableRoot = null;
function $4a57df467ec2c8e6$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($4a57df467ec2c8e6$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $4a57df467ec2c8e6$var$commitHookEffectListMount(3, finishedWork), $4a57df467ec2c8e6$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || null === current || $4a57df467ec2c8e6$var$safelyDetachRef(current, current.return));
            flags & 64 && $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $4a57df467ec2c8e6$var$currentHoistableRoot;
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || null === current || $4a57df467ec2c8e6$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$4a57df467ec2c8e6$var$internalHoistableMarker] || currentResource[$4a57df467ec2c8e6$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $4a57df467ec2c8e6$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$4a57df467ec2c8e6$var$internalInstanceKey] = finishedWork;
                                        $4a57df467ec2c8e6$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $4a57df467ec2c8e6$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $4a57df467ec2c8e6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $4a57df467ec2c8e6$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $4a57df467ec2c8e6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$4a57df467ec2c8e6$var$internalInstanceKey] = finishedWork;
                                $4a57df467ec2c8e6$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $4a57df467ec2c8e6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $4a57df467ec2c8e6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $4a57df467ec2c8e6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $4a57df467ec2c8e6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $4a57df467ec2c8e6$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || null === current || $4a57df467ec2c8e6$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $4a57df467ec2c8e6$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || null === current || $4a57df467ec2c8e6$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $4a57df467ec2c8e6$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $4a57df467ec2c8e6$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($4a57df467ec2c8e6$var$needsFormReset = !0);
            break;
        case 6:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $4a57df467ec2c8e6$var$tagCaches = null;
            hoistableRoot = $4a57df467ec2c8e6$var$currentHoistableRoot;
            $4a57df467ec2c8e6$var$currentHoistableRoot = $4a57df467ec2c8e6$var$getHoistableRoot(root.containerInfo);
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$currentHoistableRoot = hoistableRoot;
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $4a57df467ec2c8e6$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $4a57df467ec2c8e6$var$needsFormReset && ($4a57df467ec2c8e6$var$needsFormReset = !1, $4a57df467ec2c8e6$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $4a57df467ec2c8e6$var$currentHoistableRoot;
            $4a57df467ec2c8e6$var$currentHoistableRoot = $4a57df467ec2c8e6$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            $4a57df467ec2c8e6$var$currentHoistableRoot = flags;
            break;
        case 12:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $4a57df467ec2c8e6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($4a57df467ec2c8e6$var$globalMostRecentFallbackTime = $4a57df467ec2c8e6$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $4a57df467ec2c8e6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden;
            $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $4a57df467ec2c8e6$var$offscreenSubtreeIsHidden || $4a57df467ec2c8e6$var$offscreenSubtreeWasHidden || $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $4a57df467ec2c8e6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $4a57df467ec2c8e6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $4a57df467ec2c8e6$var$hideOrUnhideDehydratedBoundary(instance, !0) : $4a57df467ec2c8e6$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $4a57df467ec2c8e6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $4a57df467ec2c8e6$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $4a57df467ec2c8e6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $4a57df467ec2c8e6$var$recursivelyTraverseMutationEffects(root, finishedWork), $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork);
    }
}
function $4a57df467ec2c8e6$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($4a57df467ec2c8e6$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $4a57df467ec2c8e6$var$getHostSibling(finishedWork);
                    $4a57df467ec2c8e6$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($4a57df467ec2c8e6$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $4a57df467ec2c8e6$var$getHostSibling(finishedWork);
                    $4a57df467ec2c8e6$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $4a57df467ec2c8e6$var$getHostSibling(finishedWork);
                    $4a57df467ec2c8e6$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $4a57df467ec2c8e6$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $4a57df467ec2c8e6$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $4a57df467ec2c8e6$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$4a57df467ec2c8e6$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $4a57df467ec2c8e6$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $4a57df467ec2c8e6$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $4a57df467ec2c8e6$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $4a57df467ec2c8e6$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $4a57df467ec2c8e6$var$safelyDetachRef(finishedWork, finishedWork.return);
                $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $4a57df467ec2c8e6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $4a57df467ec2c8e6$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$4a57df467ec2c8e6$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $4a57df467ec2c8e6$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $4a57df467ec2c8e6$var$commitClassCallbacks(finishedWork);
                $4a57df467ec2c8e6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $4a57df467ec2c8e6$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $4a57df467ec2c8e6$var$commitHostMount(finishedWork);
                $4a57df467ec2c8e6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $4a57df467ec2c8e6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $4a57df467ec2c8e6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $4a57df467ec2c8e6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $4a57df467ec2c8e6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4a57df467ec2c8e6$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $4a57df467ec2c8e6$var$releaseCache(previousCache));
}
function $4a57df467ec2c8e6$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $4a57df467ec2c8e6$var$releaseCache(current));
}
function $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$4a57df467ec2c8e6$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $4a57df467ec2c8e6$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $4a57df467ec2c8e6$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $4a57df467ec2c8e6$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $4a57df467ec2c8e6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $4a57df467ec2c8e6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $4a57df467ec2c8e6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $4a57df467ec2c8e6$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $4a57df467ec2c8e6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $4a57df467ec2c8e6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $4a57df467ec2c8e6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $4a57df467ec2c8e6$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $4a57df467ec2c8e6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $4a57df467ec2c8e6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $4a57df467ec2c8e6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $4a57df467ec2c8e6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $4a57df467ec2c8e6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $4a57df467ec2c8e6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $4a57df467ec2c8e6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4a57df467ec2c8e6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $4a57df467ec2c8e6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $4a57df467ec2c8e6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $4a57df467ec2c8e6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $4a57df467ec2c8e6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $4a57df467ec2c8e6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $4a57df467ec2c8e6$var$suspenseyCommitFlag = 8192;
function $4a57df467ec2c8e6$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $4a57df467ec2c8e6$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$4a57df467ec2c8e6$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $4a57df467ec2c8e6$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $4a57df467ec2c8e6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $4a57df467ec2c8e6$var$suspenseyCommitFlag && null !== fiber.memoizedState && $4a57df467ec2c8e6$var$suspendResource(suspendedState, $4a57df467ec2c8e6$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $4a57df467ec2c8e6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $4a57df467ec2c8e6$var$currentHoistableRoot;
            $4a57df467ec2c8e6$var$currentHoistableRoot = $4a57df467ec2c8e6$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $4a57df467ec2c8e6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $4a57df467ec2c8e6$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $4a57df467ec2c8e6$var$suspenseyCommitFlag, $4a57df467ec2c8e6$var$suspenseyCommitFlag = 16777216, $4a57df467ec2c8e6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $4a57df467ec2c8e6$var$suspenseyCommitFlag = previousHoistableRoot) : $4a57df467ec2c8e6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $4a57df467ec2c8e6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $4a57df467ec2c8e6$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $4a57df467ec2c8e6$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $4a57df467ec2c8e6$var$nextEffect = childToDelete;
            $4a57df467ec2c8e6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $4a57df467ec2c8e6$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$4a57df467ec2c8e6$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $4a57df467ec2c8e6$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $4a57df467ec2c8e6$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $4a57df467ec2c8e6$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $4a57df467ec2c8e6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $4a57df467ec2c8e6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $4a57df467ec2c8e6$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $4a57df467ec2c8e6$var$nextEffect = childToDelete;
            $4a57df467ec2c8e6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $4a57df467ec2c8e6$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $4a57df467ec2c8e6$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $4a57df467ec2c8e6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $4a57df467ec2c8e6$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $4a57df467ec2c8e6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $4a57df467ec2c8e6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $4a57df467ec2c8e6$var$nextEffect;){
        var fiber = $4a57df467ec2c8e6$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $4a57df467ec2c8e6$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $4a57df467ec2c8e6$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $4a57df467ec2c8e6$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $4a57df467ec2c8e6$var$nextEffect;){
            cache = $4a57df467ec2c8e6$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $4a57df467ec2c8e6$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $4a57df467ec2c8e6$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $4a57df467ec2c8e6$var$nextEffect = sibling;
                break a;
            }
            $4a57df467ec2c8e6$var$nextEffect = returnFiber;
        }
    }
}
var $4a57df467ec2c8e6$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $4a57df467ec2c8e6$var$readContext($4a57df467ec2c8e6$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $4a57df467ec2c8e6$var$readContext($4a57df467ec2c8e6$var$CacheContext).controller.signal;
    }
}, $4a57df467ec2c8e6$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $4a57df467ec2c8e6$var$executionContext = 0, $4a57df467ec2c8e6$var$workInProgressRoot = null, $4a57df467ec2c8e6$var$workInProgress = null, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes = 0, $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0, $4a57df467ec2c8e6$var$workInProgressThrownValue = null, $4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings = !1, $4a57df467ec2c8e6$var$workInProgressRootIsPrerendering = !1, $4a57df467ec2c8e6$var$workInProgressRootDidAttachPingListener = !1, $4a57df467ec2c8e6$var$entangledRenderLanes = 0, $4a57df467ec2c8e6$var$workInProgressRootExitStatus = 0, $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes = 0, $4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes = 0, $4a57df467ec2c8e6$var$workInProgressRootPingedLanes = 0, $4a57df467ec2c8e6$var$workInProgressDeferredLane = 0, $4a57df467ec2c8e6$var$workInProgressSuspendedRetryLanes = 0, $4a57df467ec2c8e6$var$workInProgressRootConcurrentErrors = null, $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors = null, $4a57df467ec2c8e6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $4a57df467ec2c8e6$var$globalMostRecentFallbackTime = 0, $4a57df467ec2c8e6$var$globalMostRecentTransitionTime = 0, $4a57df467ec2c8e6$var$workInProgressRootRenderTargetTime = Infinity, $4a57df467ec2c8e6$var$workInProgressTransitions = null, $4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed = null, $4a57df467ec2c8e6$var$pendingEffectsStatus = 0, $4a57df467ec2c8e6$var$pendingEffectsRoot = null, $4a57df467ec2c8e6$var$pendingFinishedWork = null, $4a57df467ec2c8e6$var$pendingEffectsLanes = 0, $4a57df467ec2c8e6$var$pendingEffectsRemainingLanes = 0, $4a57df467ec2c8e6$var$pendingPassiveTransitions = null, $4a57df467ec2c8e6$var$pendingRecoverableErrors = null, $4a57df467ec2c8e6$var$nestedUpdateCount = 0, $4a57df467ec2c8e6$var$rootWithNestedUpdates = null;
function $4a57df467ec2c8e6$var$requestUpdateLane() {
    return 0 !== ($4a57df467ec2c8e6$var$executionContext & 2) && 0 !== $4a57df467ec2c8e6$var$workInProgressRootRenderLanes ? $4a57df467ec2c8e6$var$workInProgressRootRenderLanes & -$4a57df467ec2c8e6$var$workInProgressRootRenderLanes : null !== $4a57df467ec2c8e6$var$ReactSharedInternals.T ? $4a57df467ec2c8e6$var$requestTransitionLane() : $4a57df467ec2c8e6$var$resolveUpdatePriority();
}
function $4a57df467ec2c8e6$var$requestDeferredLane() {
    if (0 === $4a57df467ec2c8e6$var$workInProgressDeferredLane) {
        if (0 === ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 536870912) || $4a57df467ec2c8e6$var$isHydrating) {
            var lane = $4a57df467ec2c8e6$var$nextTransitionDeferredLane;
            $4a57df467ec2c8e6$var$nextTransitionDeferredLane <<= 1;
            0 === ($4a57df467ec2c8e6$var$nextTransitionDeferredLane & 3932160) && ($4a57df467ec2c8e6$var$nextTransitionDeferredLane = 262144);
            $4a57df467ec2c8e6$var$workInProgressDeferredLane = lane;
        } else $4a57df467ec2c8e6$var$workInProgressDeferredLane = 536870912;
    }
    lane = $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $4a57df467ec2c8e6$var$workInProgressDeferredLane;
}
function $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $4a57df467ec2c8e6$var$workInProgressRoot && (2 === $4a57df467ec2c8e6$var$workInProgressSuspendedReason || 9 === $4a57df467ec2c8e6$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $4a57df467ec2c8e6$var$prepareFreshStack(root, 0), $4a57df467ec2c8e6$var$markRootSuspended(root, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes, $4a57df467ec2c8e6$var$workInProgressDeferredLane, !1);
    $4a57df467ec2c8e6$var$markRootUpdated$1(root, lane);
    if (0 === ($4a57df467ec2c8e6$var$executionContext & 2) || root !== $4a57df467ec2c8e6$var$workInProgressRoot) root === $4a57df467ec2c8e6$var$workInProgressRoot && (0 === ($4a57df467ec2c8e6$var$executionContext & 2) && ($4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $4a57df467ec2c8e6$var$workInProgressRootExitStatus && $4a57df467ec2c8e6$var$markRootSuspended(root, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes, $4a57df467ec2c8e6$var$workInProgressDeferredLane, !1)), $4a57df467ec2c8e6$var$ensureRootIsScheduled(root);
}
function $4a57df467ec2c8e6$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($4a57df467ec2c8e6$var$executionContext & 6)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $4a57df467ec2c8e6$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $4a57df467ec2c8e6$var$renderRootConcurrent(root$jscomp$0, lanes) : $4a57df467ec2c8e6$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $4a57df467ec2c8e6$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $4a57df467ec2c8e6$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$4a57df467ec2c8e6$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $4a57df467ec2c8e6$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $4a57df467ec2c8e6$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($4a57df467ec2c8e6$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $4a57df467ec2c8e6$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($4a57df467ec2c8e6$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors;
                            $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors ? $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors.push.apply($4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $4a57df467ec2c8e6$var$prepareFreshStack(root$jscomp$0, 0);
                $4a57df467ec2c8e6$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $4a57df467ec2c8e6$var$markRootSuspended(shouldTimeSlice, lanes, $4a57df467ec2c8e6$var$workInProgressDeferredLane, !$4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $4a57df467ec2c8e6$var$globalMostRecentFallbackTime + 300 - $4a57df467ec2c8e6$var$now(), 10 < exitStatus)) {
                    $4a57df467ec2c8e6$var$markRootSuspended(shouldTimeSlice, lanes, $4a57df467ec2c8e6$var$workInProgressDeferredLane, !$4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $4a57df467ec2c8e6$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $4a57df467ec2c8e6$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $4a57df467ec2c8e6$var$scheduleTimeout($4a57df467ec2c8e6$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors, $4a57df467ec2c8e6$var$workInProgressTransitions, $4a57df467ec2c8e6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $4a57df467ec2c8e6$var$workInProgressDeferredLane, $4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes, $4a57df467ec2c8e6$var$workInProgressSuspendedRetryLanes, $4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $4a57df467ec2c8e6$var$commitRootWhenReady(shouldTimeSlice, forceSync, $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors, $4a57df467ec2c8e6$var$workInProgressTransitions, $4a57df467ec2c8e6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $4a57df467ec2c8e6$var$workInProgressDeferredLane, $4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes, $4a57df467ec2c8e6$var$workInProgressSuspendedRetryLanes, $4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $4a57df467ec2c8e6$var$ensureRootIsScheduled(root$jscomp$0);
}
function $4a57df467ec2c8e6$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $4a57df467ec2c8e6$var$noop$1
        };
        $4a57df467ec2c8e6$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $4a57df467ec2c8e6$var$globalMostRecentFallbackTime - $4a57df467ec2c8e6$var$now() : (lanes & 4194048) === lanes ? $4a57df467ec2c8e6$var$globalMostRecentTransitionTime - $4a57df467ec2c8e6$var$now() : 0;
        timeoutOffset = $4a57df467ec2c8e6$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $4a57df467ec2c8e6$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($4a57df467ec2c8e6$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $4a57df467ec2c8e6$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $4a57df467ec2c8e6$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $4a57df467ec2c8e6$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$4a57df467ec2c8e6$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $4a57df467ec2c8e6$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$4a57df467ec2c8e6$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $4a57df467ec2c8e6$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $4a57df467ec2c8e6$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $4a57df467ec2c8e6$var$flushSyncWork$1() {
    return 0 === ($4a57df467ec2c8e6$var$executionContext & 6) ? ($4a57df467ec2c8e6$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $4a57df467ec2c8e6$var$resetWorkInProgressStack() {
    if (null !== $4a57df467ec2c8e6$var$workInProgress) {
        if (0 === $4a57df467ec2c8e6$var$workInProgressSuspendedReason) var interruptedWork = $4a57df467ec2c8e6$var$workInProgress.return;
        else interruptedWork = $4a57df467ec2c8e6$var$workInProgress, $4a57df467ec2c8e6$var$lastContextDependency = $4a57df467ec2c8e6$var$currentlyRenderingFiber$1 = null, $4a57df467ec2c8e6$var$resetHooksOnUnwind(interruptedWork), $4a57df467ec2c8e6$var$thenableState$1 = null, $4a57df467ec2c8e6$var$thenableIndexCounter$1 = 0, interruptedWork = $4a57df467ec2c8e6$var$workInProgress;
        for(; null !== interruptedWork;)$4a57df467ec2c8e6$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $4a57df467ec2c8e6$var$workInProgress = null;
    }
}
function $4a57df467ec2c8e6$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $4a57df467ec2c8e6$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $4a57df467ec2c8e6$var$pendingEffectsLanes = 0;
    $4a57df467ec2c8e6$var$resetWorkInProgressStack();
    $4a57df467ec2c8e6$var$workInProgressRoot = root;
    $4a57df467ec2c8e6$var$workInProgress = timeoutHandle = $4a57df467ec2c8e6$var$createWorkInProgress(root.current, null);
    $4a57df467ec2c8e6$var$workInProgressRootRenderLanes = lanes;
    $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0;
    $4a57df467ec2c8e6$var$workInProgressThrownValue = null;
    $4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $4a57df467ec2c8e6$var$workInProgressRootIsPrerendering = $4a57df467ec2c8e6$var$checkIfRootIsPrerendering(root, lanes);
    $4a57df467ec2c8e6$var$workInProgressRootDidAttachPingListener = !1;
    $4a57df467ec2c8e6$var$workInProgressSuspendedRetryLanes = $4a57df467ec2c8e6$var$workInProgressDeferredLane = $4a57df467ec2c8e6$var$workInProgressRootPingedLanes = $4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes = $4a57df467ec2c8e6$var$workInProgressRootSkippedLanes = $4a57df467ec2c8e6$var$workInProgressRootExitStatus = 0;
    $4a57df467ec2c8e6$var$workInProgressRootRecoverableErrors = $4a57df467ec2c8e6$var$workInProgressRootConcurrentErrors = null;
    $4a57df467ec2c8e6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $4a57df467ec2c8e6$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $4a57df467ec2c8e6$var$entangledRenderLanes = lanes;
    $4a57df467ec2c8e6$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $4a57df467ec2c8e6$var$handleThrow(root, thrownValue) {
    $4a57df467ec2c8e6$var$currentlyRenderingFiber = null;
    $4a57df467ec2c8e6$var$ReactSharedInternals.H = $4a57df467ec2c8e6$var$ContextOnlyDispatcher;
    thrownValue === $4a57df467ec2c8e6$var$SuspenseException || thrownValue === $4a57df467ec2c8e6$var$SuspenseActionException ? (thrownValue = $4a57df467ec2c8e6$var$getSuspendedThenable(), $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 3) : thrownValue === $4a57df467ec2c8e6$var$SuspenseyCommitException ? (thrownValue = $4a57df467ec2c8e6$var$getSuspendedThenable(), $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 4) : $4a57df467ec2c8e6$var$workInProgressSuspendedReason = thrownValue === $4a57df467ec2c8e6$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $4a57df467ec2c8e6$var$workInProgressThrownValue = thrownValue;
    null === $4a57df467ec2c8e6$var$workInProgress && ($4a57df467ec2c8e6$var$workInProgressRootExitStatus = 1, $4a57df467ec2c8e6$var$logUncaughtError(root, $4a57df467ec2c8e6$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $4a57df467ec2c8e6$var$shouldRemainOnPreviousScreen() {
    var handler = $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 4194048) === $4a57df467ec2c8e6$var$workInProgressRootRenderLanes ? null === $4a57df467ec2c8e6$var$shellBoundary ? !0 : !1 : ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 62914560) === $4a57df467ec2c8e6$var$workInProgressRootRenderLanes || 0 !== ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 536870912) ? handler === $4a57df467ec2c8e6$var$shellBoundary : !1;
}
function $4a57df467ec2c8e6$var$pushDispatcher() {
    var prevDispatcher = $4a57df467ec2c8e6$var$ReactSharedInternals.H;
    $4a57df467ec2c8e6$var$ReactSharedInternals.H = $4a57df467ec2c8e6$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $4a57df467ec2c8e6$var$ContextOnlyDispatcher : prevDispatcher;
}
function $4a57df467ec2c8e6$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $4a57df467ec2c8e6$var$ReactSharedInternals.A;
    $4a57df467ec2c8e6$var$ReactSharedInternals.A = $4a57df467ec2c8e6$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $4a57df467ec2c8e6$var$renderDidSuspendDelayIfPossible() {
    $4a57df467ec2c8e6$var$workInProgressRootExitStatus = 4;
    $4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings || ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 4194048) !== $4a57df467ec2c8e6$var$workInProgressRootRenderLanes && null !== $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current || ($4a57df467ec2c8e6$var$workInProgressRootIsPrerendering = !0);
    0 === ($4a57df467ec2c8e6$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($4a57df467ec2c8e6$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $4a57df467ec2c8e6$var$workInProgressRoot || $4a57df467ec2c8e6$var$markRootSuspended($4a57df467ec2c8e6$var$workInProgressRoot, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes, $4a57df467ec2c8e6$var$workInProgressDeferredLane, !1);
}
function $4a57df467ec2c8e6$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $4a57df467ec2c8e6$var$executionContext;
    $4a57df467ec2c8e6$var$executionContext |= 2;
    var prevDispatcher = $4a57df467ec2c8e6$var$pushDispatcher(), prevAsyncDispatcher = $4a57df467ec2c8e6$var$pushAsyncDispatcher();
    if ($4a57df467ec2c8e6$var$workInProgressRoot !== root || $4a57df467ec2c8e6$var$workInProgressRootRenderLanes !== lanes) $4a57df467ec2c8e6$var$workInProgressTransitions = null, $4a57df467ec2c8e6$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $4a57df467ec2c8e6$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $4a57df467ec2c8e6$var$workInProgressSuspendedReason && null !== $4a57df467ec2c8e6$var$workInProgress) {
            var unitOfWork = $4a57df467ec2c8e6$var$workInProgress, thrownValue = $4a57df467ec2c8e6$var$workInProgressThrownValue;
            switch($4a57df467ec2c8e6$var$workInProgressSuspendedReason){
                case 8:
                    $4a57df467ec2c8e6$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $4a57df467ec2c8e6$var$workInProgressSuspendedReason;
                    $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0;
                    $4a57df467ec2c8e6$var$workInProgressThrownValue = null;
                    $4a57df467ec2c8e6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $4a57df467ec2c8e6$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $4a57df467ec2c8e6$var$workInProgressSuspendedReason, $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0, $4a57df467ec2c8e6$var$workInProgressThrownValue = null, $4a57df467ec2c8e6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $4a57df467ec2c8e6$var$workLoopSync();
        exitStatus = $4a57df467ec2c8e6$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $4a57df467ec2c8e6$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $4a57df467ec2c8e6$var$lastContextDependency = $4a57df467ec2c8e6$var$currentlyRenderingFiber$1 = null;
    $4a57df467ec2c8e6$var$executionContext = prevExecutionContext;
    $4a57df467ec2c8e6$var$ReactSharedInternals.H = prevDispatcher;
    $4a57df467ec2c8e6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $4a57df467ec2c8e6$var$workInProgress && ($4a57df467ec2c8e6$var$workInProgressRoot = null, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes = 0, $4a57df467ec2c8e6$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $4a57df467ec2c8e6$var$workLoopSync() {
    for(; null !== $4a57df467ec2c8e6$var$workInProgress;)$4a57df467ec2c8e6$var$performUnitOfWork($4a57df467ec2c8e6$var$workInProgress);
}
function $4a57df467ec2c8e6$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $4a57df467ec2c8e6$var$executionContext;
    $4a57df467ec2c8e6$var$executionContext |= 2;
    var prevDispatcher = $4a57df467ec2c8e6$var$pushDispatcher(), prevAsyncDispatcher = $4a57df467ec2c8e6$var$pushAsyncDispatcher();
    $4a57df467ec2c8e6$var$workInProgressRoot !== root || $4a57df467ec2c8e6$var$workInProgressRootRenderLanes !== lanes ? ($4a57df467ec2c8e6$var$workInProgressTransitions = null, $4a57df467ec2c8e6$var$workInProgressRootRenderTargetTime = $4a57df467ec2c8e6$var$now() + 500, $4a57df467ec2c8e6$var$prepareFreshStack(root, lanes)) : $4a57df467ec2c8e6$var$workInProgressRootIsPrerendering = $4a57df467ec2c8e6$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $4a57df467ec2c8e6$var$workInProgressSuspendedReason && null !== $4a57df467ec2c8e6$var$workInProgress) {
            lanes = $4a57df467ec2c8e6$var$workInProgress;
            var thrownValue = $4a57df467ec2c8e6$var$workInProgressThrownValue;
            b: switch($4a57df467ec2c8e6$var$workInProgressSuspendedReason){
                case 1:
                    $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0;
                    $4a57df467ec2c8e6$var$workInProgressThrownValue = null;
                    $4a57df467ec2c8e6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($4a57df467ec2c8e6$var$isThenableResolved(thrownValue)) {
                        $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0;
                        $4a57df467ec2c8e6$var$workInProgressThrownValue = null;
                        $4a57df467ec2c8e6$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $4a57df467ec2c8e6$var$workInProgressSuspendedReason && 9 !== $4a57df467ec2c8e6$var$workInProgressSuspendedReason || $4a57df467ec2c8e6$var$workInProgressRoot !== root || ($4a57df467ec2c8e6$var$workInProgressSuspendedReason = 7);
                        $4a57df467ec2c8e6$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $4a57df467ec2c8e6$var$isThenableResolved(thrownValue) ? ($4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0, $4a57df467ec2c8e6$var$workInProgressThrownValue = null, $4a57df467ec2c8e6$var$replaySuspendedUnitOfWork(lanes)) : ($4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0, $4a57df467ec2c8e6$var$workInProgressThrownValue = null, $4a57df467ec2c8e6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($4a57df467ec2c8e6$var$workInProgress.tag){
                        case 26:
                            resource = $4a57df467ec2c8e6$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $4a57df467ec2c8e6$var$workInProgress;
                            if (resource ? $4a57df467ec2c8e6$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0;
                                $4a57df467ec2c8e6$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $4a57df467ec2c8e6$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($4a57df467ec2c8e6$var$workInProgress = returnFiber, $4a57df467ec2c8e6$var$completeUnitOfWork(returnFiber)) : $4a57df467ec2c8e6$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0;
                    $4a57df467ec2c8e6$var$workInProgressThrownValue = null;
                    $4a57df467ec2c8e6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $4a57df467ec2c8e6$var$workInProgressSuspendedReason = 0;
                    $4a57df467ec2c8e6$var$workInProgressThrownValue = null;
                    $4a57df467ec2c8e6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $4a57df467ec2c8e6$var$resetWorkInProgressStack();
                    $4a57df467ec2c8e6$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(462));
            }
        }
        $4a57df467ec2c8e6$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $4a57df467ec2c8e6$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $4a57df467ec2c8e6$var$lastContextDependency = $4a57df467ec2c8e6$var$currentlyRenderingFiber$1 = null;
    $4a57df467ec2c8e6$var$ReactSharedInternals.H = prevDispatcher;
    $4a57df467ec2c8e6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $4a57df467ec2c8e6$var$executionContext = prevExecutionContext;
    if (null !== $4a57df467ec2c8e6$var$workInProgress) return 0;
    $4a57df467ec2c8e6$var$workInProgressRoot = null;
    $4a57df467ec2c8e6$var$workInProgressRootRenderLanes = 0;
    $4a57df467ec2c8e6$var$finishQueueingConcurrentUpdates();
    return $4a57df467ec2c8e6$var$workInProgressRootExitStatus;
}
function $4a57df467ec2c8e6$var$workLoopConcurrentByScheduler() {
    for(; null !== $4a57df467ec2c8e6$var$workInProgress && !$4a57df467ec2c8e6$var$shouldYield();)$4a57df467ec2c8e6$var$performUnitOfWork($4a57df467ec2c8e6$var$workInProgress);
}
function $4a57df467ec2c8e6$var$performUnitOfWork(unitOfWork) {
    var next = $4a57df467ec2c8e6$var$beginWork(unitOfWork.alternate, unitOfWork, $4a57df467ec2c8e6$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $4a57df467ec2c8e6$var$completeUnitOfWork(unitOfWork) : $4a57df467ec2c8e6$var$workInProgress = next;
}
function $4a57df467ec2c8e6$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $4a57df467ec2c8e6$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $4a57df467ec2c8e6$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $4a57df467ec2c8e6$var$resetHooksOnUnwind(next);
        default:
            $4a57df467ec2c8e6$var$unwindInterruptedWork(current, next), next = $4a57df467ec2c8e6$var$workInProgress = $4a57df467ec2c8e6$var$resetWorkInProgress(next, $4a57df467ec2c8e6$var$entangledRenderLanes), next = $4a57df467ec2c8e6$var$beginWork(current, next, $4a57df467ec2c8e6$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $4a57df467ec2c8e6$var$completeUnitOfWork(unitOfWork) : $4a57df467ec2c8e6$var$workInProgress = next;
}
function $4a57df467ec2c8e6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $4a57df467ec2c8e6$var$lastContextDependency = $4a57df467ec2c8e6$var$currentlyRenderingFiber$1 = null;
    $4a57df467ec2c8e6$var$resetHooksOnUnwind(unitOfWork);
    $4a57df467ec2c8e6$var$thenableState$1 = null;
    $4a57df467ec2c8e6$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($4a57df467ec2c8e6$var$throwException(root, returnFiber, unitOfWork, thrownValue, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes)) {
            $4a57df467ec2c8e6$var$workInProgressRootExitStatus = 1;
            $4a57df467ec2c8e6$var$logUncaughtError(root, $4a57df467ec2c8e6$var$createCapturedValueAtFiber(thrownValue, root.current));
            $4a57df467ec2c8e6$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $4a57df467ec2c8e6$var$workInProgress = returnFiber, error;
        $4a57df467ec2c8e6$var$workInProgressRootExitStatus = 1;
        $4a57df467ec2c8e6$var$logUncaughtError(root, $4a57df467ec2c8e6$var$createCapturedValueAtFiber(thrownValue, root.current));
        $4a57df467ec2c8e6$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($4a57df467ec2c8e6$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($4a57df467ec2c8e6$var$workInProgressRootIsPrerendering || 0 !== ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $4a57df467ec2c8e6$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $4a57df467ec2c8e6$var$unwindUnitOfWork(unitOfWork, root);
    } else $4a57df467ec2c8e6$var$completeUnitOfWork(unitOfWork);
}
function $4a57df467ec2c8e6$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $4a57df467ec2c8e6$var$unwindUnitOfWork(completedWork, $4a57df467ec2c8e6$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $4a57df467ec2c8e6$var$completeWork(completedWork.alternate, completedWork, $4a57df467ec2c8e6$var$entangledRenderLanes);
        if (null !== next) {
            $4a57df467ec2c8e6$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $4a57df467ec2c8e6$var$workInProgress = completedWork;
            return;
        }
        $4a57df467ec2c8e6$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $4a57df467ec2c8e6$var$workInProgressRootExitStatus && ($4a57df467ec2c8e6$var$workInProgressRootExitStatus = 5);
}
function $4a57df467ec2c8e6$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $4a57df467ec2c8e6$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $4a57df467ec2c8e6$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $4a57df467ec2c8e6$var$workInProgress = unitOfWork;
            return;
        }
        $4a57df467ec2c8e6$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $4a57df467ec2c8e6$var$workInProgressRootExitStatus = 6;
    $4a57df467ec2c8e6$var$workInProgress = null;
}
function $4a57df467ec2c8e6$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $4a57df467ec2c8e6$var$flushPendingEffects();
    while (0 !== $4a57df467ec2c8e6$var$pendingEffectsStatus);
    if (0 !== ($4a57df467ec2c8e6$var$executionContext & 6)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $4a57df467ec2c8e6$var$concurrentlyUpdatedLanes;
        $4a57df467ec2c8e6$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $4a57df467ec2c8e6$var$workInProgressRoot && ($4a57df467ec2c8e6$var$workInProgress = $4a57df467ec2c8e6$var$workInProgressRoot = null, $4a57df467ec2c8e6$var$workInProgressRootRenderLanes = 0);
        $4a57df467ec2c8e6$var$pendingFinishedWork = finishedWork;
        $4a57df467ec2c8e6$var$pendingEffectsRoot = root;
        $4a57df467ec2c8e6$var$pendingEffectsLanes = lanes;
        $4a57df467ec2c8e6$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $4a57df467ec2c8e6$var$pendingPassiveTransitions = transitions;
        $4a57df467ec2c8e6$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $4a57df467ec2c8e6$var$scheduleCallback$1($4a57df467ec2c8e6$var$NormalPriority$1, function() {
            $4a57df467ec2c8e6$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $4a57df467ec2c8e6$var$ReactSharedInternals.T;
            $4a57df467ec2c8e6$var$ReactSharedInternals.T = null;
            transitions = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
            $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $4a57df467ec2c8e6$var$executionContext;
            $4a57df467ec2c8e6$var$executionContext |= 4;
            try {
                $4a57df467ec2c8e6$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $4a57df467ec2c8e6$var$executionContext = spawnedLane, $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = transitions, $4a57df467ec2c8e6$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $4a57df467ec2c8e6$var$pendingEffectsStatus = 1;
        $4a57df467ec2c8e6$var$flushMutationEffects();
        $4a57df467ec2c8e6$var$flushLayoutEffects();
        $4a57df467ec2c8e6$var$flushSpawnedWork();
    }
}
function $4a57df467ec2c8e6$var$flushMutationEffects() {
    if (1 === $4a57df467ec2c8e6$var$pendingEffectsStatus) {
        $4a57df467ec2c8e6$var$pendingEffectsStatus = 0;
        var root = $4a57df467ec2c8e6$var$pendingEffectsRoot, finishedWork = $4a57df467ec2c8e6$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $4a57df467ec2c8e6$var$ReactSharedInternals.T;
            $4a57df467ec2c8e6$var$ReactSharedInternals.T = null;
            var previousPriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
            $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $4a57df467ec2c8e6$var$executionContext;
            $4a57df467ec2c8e6$var$executionContext |= 4;
            try {
                $4a57df467ec2c8e6$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $4a57df467ec2c8e6$var$selectionInformation, curFocusedElem = $4a57df467ec2c8e6$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $4a57df467ec2c8e6$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $4a57df467ec2c8e6$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $4a57df467ec2c8e6$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $4a57df467ec2c8e6$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $4a57df467ec2c8e6$var$_enabled = !!$4a57df467ec2c8e6$var$eventsEnabled;
                $4a57df467ec2c8e6$var$selectionInformation = $4a57df467ec2c8e6$var$eventsEnabled = null;
            } finally{
                $4a57df467ec2c8e6$var$executionContext = prevExecutionContext, $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = previousPriority, $4a57df467ec2c8e6$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $4a57df467ec2c8e6$var$pendingEffectsStatus = 2;
    }
}
function $4a57df467ec2c8e6$var$flushLayoutEffects() {
    if (2 === $4a57df467ec2c8e6$var$pendingEffectsStatus) {
        $4a57df467ec2c8e6$var$pendingEffectsStatus = 0;
        var root = $4a57df467ec2c8e6$var$pendingEffectsRoot, finishedWork = $4a57df467ec2c8e6$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $4a57df467ec2c8e6$var$ReactSharedInternals.T;
            $4a57df467ec2c8e6$var$ReactSharedInternals.T = null;
            var previousPriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
            $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $4a57df467ec2c8e6$var$executionContext;
            $4a57df467ec2c8e6$var$executionContext |= 4;
            try {
                $4a57df467ec2c8e6$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $4a57df467ec2c8e6$var$executionContext = prevExecutionContext, $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = previousPriority, $4a57df467ec2c8e6$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $4a57df467ec2c8e6$var$pendingEffectsStatus = 3;
    }
}
function $4a57df467ec2c8e6$var$flushSpawnedWork() {
    if (4 === $4a57df467ec2c8e6$var$pendingEffectsStatus || 3 === $4a57df467ec2c8e6$var$pendingEffectsStatus) {
        $4a57df467ec2c8e6$var$pendingEffectsStatus = 0;
        $4a57df467ec2c8e6$var$requestPaint();
        var root = $4a57df467ec2c8e6$var$pendingEffectsRoot, finishedWork = $4a57df467ec2c8e6$var$pendingFinishedWork, lanes = $4a57df467ec2c8e6$var$pendingEffectsLanes, recoverableErrors = $4a57df467ec2c8e6$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $4a57df467ec2c8e6$var$pendingEffectsStatus = 5 : ($4a57df467ec2c8e6$var$pendingEffectsStatus = 0, $4a57df467ec2c8e6$var$pendingFinishedWork = $4a57df467ec2c8e6$var$pendingEffectsRoot = null, $4a57df467ec2c8e6$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $4a57df467ec2c8e6$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($4a57df467ec2c8e6$var$injectedHook && "function" === typeof $4a57df467ec2c8e6$var$injectedHook.onCommitFiberRoot) try {
            $4a57df467ec2c8e6$var$injectedHook.onCommitFiberRoot($4a57df467ec2c8e6$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $4a57df467ec2c8e6$var$ReactSharedInternals.T;
            remainingLanes = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
            $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 2;
            $4a57df467ec2c8e6$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $4a57df467ec2c8e6$var$ReactSharedInternals.T = finishedWork, $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($4a57df467ec2c8e6$var$pendingEffectsLanes & 3) && $4a57df467ec2c8e6$var$flushPendingEffects();
        $4a57df467ec2c8e6$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $4a57df467ec2c8e6$var$rootWithNestedUpdates ? $4a57df467ec2c8e6$var$nestedUpdateCount++ : ($4a57df467ec2c8e6$var$nestedUpdateCount = 0, $4a57df467ec2c8e6$var$rootWithNestedUpdates = root) : $4a57df467ec2c8e6$var$nestedUpdateCount = 0;
        $4a57df467ec2c8e6$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $4a57df467ec2c8e6$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $4a57df467ec2c8e6$var$releaseCache(remainingLanes)));
}
function $4a57df467ec2c8e6$var$flushPendingEffects() {
    $4a57df467ec2c8e6$var$flushMutationEffects();
    $4a57df467ec2c8e6$var$flushLayoutEffects();
    $4a57df467ec2c8e6$var$flushSpawnedWork();
    return $4a57df467ec2c8e6$var$flushPassiveEffects();
}
function $4a57df467ec2c8e6$var$flushPassiveEffects() {
    if (5 !== $4a57df467ec2c8e6$var$pendingEffectsStatus) return !1;
    var root = $4a57df467ec2c8e6$var$pendingEffectsRoot, remainingLanes = $4a57df467ec2c8e6$var$pendingEffectsRemainingLanes;
    $4a57df467ec2c8e6$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $4a57df467ec2c8e6$var$lanesToEventPriority($4a57df467ec2c8e6$var$pendingEffectsLanes), prevTransition = $4a57df467ec2c8e6$var$ReactSharedInternals.T, previousPriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
    try {
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $4a57df467ec2c8e6$var$ReactSharedInternals.T = null;
        renderPriority = $4a57df467ec2c8e6$var$pendingPassiveTransitions;
        $4a57df467ec2c8e6$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $4a57df467ec2c8e6$var$pendingEffectsRoot, lanes = $4a57df467ec2c8e6$var$pendingEffectsLanes;
        $4a57df467ec2c8e6$var$pendingEffectsStatus = 0;
        $4a57df467ec2c8e6$var$pendingFinishedWork = $4a57df467ec2c8e6$var$pendingEffectsRoot = null;
        $4a57df467ec2c8e6$var$pendingEffectsLanes = 0;
        if (0 !== ($4a57df467ec2c8e6$var$executionContext & 6)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(331));
        var prevExecutionContext = $4a57df467ec2c8e6$var$executionContext;
        $4a57df467ec2c8e6$var$executionContext |= 4;
        $4a57df467ec2c8e6$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $4a57df467ec2c8e6$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $4a57df467ec2c8e6$var$executionContext = prevExecutionContext;
        $4a57df467ec2c8e6$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($4a57df467ec2c8e6$var$injectedHook && "function" === typeof $4a57df467ec2c8e6$var$injectedHook.onPostCommitFiberRoot) try {
            $4a57df467ec2c8e6$var$injectedHook.onPostCommitFiberRoot($4a57df467ec2c8e6$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = previousPriority, $4a57df467ec2c8e6$var$ReactSharedInternals.T = prevTransition, $4a57df467ec2c8e6$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $4a57df467ec2c8e6$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $4a57df467ec2c8e6$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $4a57df467ec2c8e6$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $4a57df467ec2c8e6$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($4a57df467ec2c8e6$var$markRootUpdated$1(rootFiber, 2), $4a57df467ec2c8e6$var$ensureRootIsScheduled(rootFiber));
}
function $4a57df467ec2c8e6$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $4a57df467ec2c8e6$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $4a57df467ec2c8e6$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed || !$4a57df467ec2c8e6$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $4a57df467ec2c8e6$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $4a57df467ec2c8e6$var$createClassErrorUpdate(2);
                instance = $4a57df467ec2c8e6$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($4a57df467ec2c8e6$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $4a57df467ec2c8e6$var$markRootUpdated$1(instance, 2), $4a57df467ec2c8e6$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $4a57df467ec2c8e6$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $4a57df467ec2c8e6$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($4a57df467ec2c8e6$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $4a57df467ec2c8e6$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $4a57df467ec2c8e6$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $4a57df467ec2c8e6$var$workInProgressRoot === root && ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $4a57df467ec2c8e6$var$workInProgressRootExitStatus || 3 === $4a57df467ec2c8e6$var$workInProgressRootExitStatus && ($4a57df467ec2c8e6$var$workInProgressRootRenderLanes & 62914560) === $4a57df467ec2c8e6$var$workInProgressRootRenderLanes && 300 > $4a57df467ec2c8e6$var$now() - $4a57df467ec2c8e6$var$globalMostRecentFallbackTime ? 0 === ($4a57df467ec2c8e6$var$executionContext & 2) && $4a57df467ec2c8e6$var$prepareFreshStack(root, 0) : $4a57df467ec2c8e6$var$workInProgressRootPingedLanes |= pingedLanes, $4a57df467ec2c8e6$var$workInProgressSuspendedRetryLanes === $4a57df467ec2c8e6$var$workInProgressRootRenderLanes && ($4a57df467ec2c8e6$var$workInProgressSuspendedRetryLanes = 0));
    $4a57df467ec2c8e6$var$ensureRootIsScheduled(root);
}
function $4a57df467ec2c8e6$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $4a57df467ec2c8e6$var$claimNextRetryLane());
    boundaryFiber = $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($4a57df467ec2c8e6$var$markRootUpdated$1(boundaryFiber, retryLane), $4a57df467ec2c8e6$var$ensureRootIsScheduled(boundaryFiber));
}
function $4a57df467ec2c8e6$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $4a57df467ec2c8e6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $4a57df467ec2c8e6$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $4a57df467ec2c8e6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $4a57df467ec2c8e6$var$scheduleCallback$1(priorityLevel, callback) {
    return $4a57df467ec2c8e6$var$scheduleCallback$3(priorityLevel, callback);
}
var $4a57df467ec2c8e6$var$firstScheduledRoot = null, $4a57df467ec2c8e6$var$lastScheduledRoot = null, $4a57df467ec2c8e6$var$didScheduleMicrotask = !1, $4a57df467ec2c8e6$var$mightHavePendingSyncWork = !1, $4a57df467ec2c8e6$var$isFlushingWork = !1, $4a57df467ec2c8e6$var$currentEventTransitionLane = 0;
function $4a57df467ec2c8e6$var$ensureRootIsScheduled(root) {
    root !== $4a57df467ec2c8e6$var$lastScheduledRoot && null === root.next && (null === $4a57df467ec2c8e6$var$lastScheduledRoot ? $4a57df467ec2c8e6$var$firstScheduledRoot = $4a57df467ec2c8e6$var$lastScheduledRoot = root : $4a57df467ec2c8e6$var$lastScheduledRoot = $4a57df467ec2c8e6$var$lastScheduledRoot.next = root);
    $4a57df467ec2c8e6$var$mightHavePendingSyncWork = !0;
    $4a57df467ec2c8e6$var$didScheduleMicrotask || ($4a57df467ec2c8e6$var$didScheduleMicrotask = !0, $4a57df467ec2c8e6$var$scheduleImmediateRootScheduleTask());
}
function $4a57df467ec2c8e6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$4a57df467ec2c8e6$var$isFlushingWork && $4a57df467ec2c8e6$var$mightHavePendingSyncWork) {
        $4a57df467ec2c8e6$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $4a57df467ec2c8e6$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $4a57df467ec2c8e6$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $4a57df467ec2c8e6$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $4a57df467ec2c8e6$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $4a57df467ec2c8e6$var$getNextLanes(root$170, root$170 === $4a57df467ec2c8e6$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $4a57df467ec2c8e6$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $4a57df467ec2c8e6$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $4a57df467ec2c8e6$var$isFlushingWork = !1;
    }
}
function $4a57df467ec2c8e6$var$processRootScheduleInImmediateTask() {
    $4a57df467ec2c8e6$var$processRootScheduleInMicrotask();
}
function $4a57df467ec2c8e6$var$processRootScheduleInMicrotask() {
    $4a57df467ec2c8e6$var$mightHavePendingSyncWork = $4a57df467ec2c8e6$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $4a57df467ec2c8e6$var$currentEventTransitionLane && $4a57df467ec2c8e6$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $4a57df467ec2c8e6$var$currentEventTransitionLane);
    for(var currentTime = $4a57df467ec2c8e6$var$now(), prev = null, root = $4a57df467ec2c8e6$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $4a57df467ec2c8e6$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $4a57df467ec2c8e6$var$firstScheduledRoot = next : prev.next = next, null === next && ($4a57df467ec2c8e6$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $4a57df467ec2c8e6$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $4a57df467ec2c8e6$var$pendingEffectsStatus && 5 !== $4a57df467ec2c8e6$var$pendingEffectsStatus || $4a57df467ec2c8e6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $4a57df467ec2c8e6$var$currentEventTransitionLane && ($4a57df467ec2c8e6$var$currentEventTransitionLane = 0);
}
function $4a57df467ec2c8e6$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $4a57df467ec2c8e6$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $4a57df467ec2c8e6$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $4a57df467ec2c8e6$var$workInProgressRoot;
    suspendedLanes = $4a57df467ec2c8e6$var$workInProgressRootRenderLanes;
    suspendedLanes = $4a57df467ec2c8e6$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $4a57df467ec2c8e6$var$workInProgressSuspendedReason || 9 === $4a57df467ec2c8e6$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $4a57df467ec2c8e6$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $4a57df467ec2c8e6$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $4a57df467ec2c8e6$var$cancelCallback$1(pingedLanes);
        switch($4a57df467ec2c8e6$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $4a57df467ec2c8e6$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $4a57df467ec2c8e6$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $4a57df467ec2c8e6$var$IdlePriority;
                break;
            default:
                suspendedLanes = $4a57df467ec2c8e6$var$NormalPriority$1;
        }
        pingedLanes = $4a57df467ec2c8e6$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $4a57df467ec2c8e6$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $4a57df467ec2c8e6$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $4a57df467ec2c8e6$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $4a57df467ec2c8e6$var$pendingEffectsStatus && 5 !== $4a57df467ec2c8e6$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($4a57df467ec2c8e6$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $4a57df467ec2c8e6$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $4a57df467ec2c8e6$var$getNextLanes(root, root === $4a57df467ec2c8e6$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $4a57df467ec2c8e6$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $4a57df467ec2c8e6$var$scheduleTaskForRootDuringMicrotask(root, $4a57df467ec2c8e6$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $4a57df467ec2c8e6$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $4a57df467ec2c8e6$var$performSyncWorkOnRoot(root, lanes) {
    if ($4a57df467ec2c8e6$var$flushPendingEffects()) return null;
    $4a57df467ec2c8e6$var$performWorkOnRoot(root, lanes, !0);
}
function $4a57df467ec2c8e6$var$scheduleImmediateRootScheduleTask() {
    $4a57df467ec2c8e6$var$scheduleMicrotask(function() {
        0 !== ($4a57df467ec2c8e6$var$executionContext & 6) ? $4a57df467ec2c8e6$var$scheduleCallback$3($4a57df467ec2c8e6$var$ImmediatePriority, $4a57df467ec2c8e6$var$processRootScheduleInImmediateTask) : $4a57df467ec2c8e6$var$processRootScheduleInMicrotask();
    });
}
function $4a57df467ec2c8e6$var$requestTransitionLane() {
    if (0 === $4a57df467ec2c8e6$var$currentEventTransitionLane) {
        var actionScopeLane = $4a57df467ec2c8e6$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $4a57df467ec2c8e6$var$nextTransitionUpdateLane, $4a57df467ec2c8e6$var$nextTransitionUpdateLane <<= 1, 0 === ($4a57df467ec2c8e6$var$nextTransitionUpdateLane & 261888) && ($4a57df467ec2c8e6$var$nextTransitionUpdateLane = 256));
        $4a57df467ec2c8e6$var$currentEventTransitionLane = actionScopeLane;
    }
    return $4a57df467ec2c8e6$var$currentEventTransitionLane;
}
function $4a57df467ec2c8e6$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $4a57df467ec2c8e6$var$sanitizeURL("" + actionProp);
}
function $4a57df467ec2c8e6$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $4a57df467ec2c8e6$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $4a57df467ec2c8e6$var$coerceFormActionProp((nativeEventTarget[$4a57df467ec2c8e6$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$4a57df467ec2c8e6$var$internalPropsKey] || null) ? $4a57df467ec2c8e6$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $4a57df467ec2c8e6$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $4a57df467ec2c8e6$var$currentEventTransitionLane) {
                                var formData = submitter ? $4a57df467ec2c8e6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $4a57df467ec2c8e6$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $4a57df467ec2c8e6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $4a57df467ec2c8e6$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $4a57df467ec2c8e6$var$i$jscomp$inline_1577 = 0; $4a57df467ec2c8e6$var$i$jscomp$inline_1577 < $4a57df467ec2c8e6$var$simpleEventPluginEvents.length; $4a57df467ec2c8e6$var$i$jscomp$inline_1577++){
    var $4a57df467ec2c8e6$var$eventName$jscomp$inline_1578 = $4a57df467ec2c8e6$var$simpleEventPluginEvents[$4a57df467ec2c8e6$var$i$jscomp$inline_1577], $4a57df467ec2c8e6$var$domEventName$jscomp$inline_1579 = $4a57df467ec2c8e6$var$eventName$jscomp$inline_1578.toLowerCase(), $4a57df467ec2c8e6$var$capitalizedEvent$jscomp$inline_1580 = $4a57df467ec2c8e6$var$eventName$jscomp$inline_1578[0].toUpperCase() + $4a57df467ec2c8e6$var$eventName$jscomp$inline_1578.slice(1);
    $4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$domEventName$jscomp$inline_1579, "on" + $4a57df467ec2c8e6$var$capitalizedEvent$jscomp$inline_1580);
}
$4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$ANIMATION_END, "onAnimationEnd");
$4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$ANIMATION_ITERATION, "onAnimationIteration");
$4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$ANIMATION_START, "onAnimationStart");
$4a57df467ec2c8e6$var$registerSimpleEvent("dblclick", "onDoubleClick");
$4a57df467ec2c8e6$var$registerSimpleEvent("focusin", "onFocus");
$4a57df467ec2c8e6$var$registerSimpleEvent("focusout", "onBlur");
$4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$TRANSITION_RUN, "onTransitionRun");
$4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$TRANSITION_START, "onTransitionStart");
$4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$TRANSITION_CANCEL, "onTransitionCancel");
$4a57df467ec2c8e6$var$registerSimpleEvent($4a57df467ec2c8e6$var$TRANSITION_END, "onTransitionEnd");
$4a57df467ec2c8e6$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4a57df467ec2c8e6$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4a57df467ec2c8e6$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4a57df467ec2c8e6$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4a57df467ec2c8e6$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4a57df467ec2c8e6$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4a57df467ec2c8e6$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4a57df467ec2c8e6$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4a57df467ec2c8e6$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4a57df467ec2c8e6$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4a57df467ec2c8e6$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4a57df467ec2c8e6$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($4a57df467ec2c8e6$var$mediaEventTypes));
function $4a57df467ec2c8e6$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $4a57df467ec2c8e6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $4a57df467ec2c8e6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $4a57df467ec2c8e6$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$4a57df467ec2c8e6$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$4a57df467ec2c8e6$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($4a57df467ec2c8e6$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $4a57df467ec2c8e6$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $4a57df467ec2c8e6$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $4a57df467ec2c8e6$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $4a57df467ec2c8e6$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$4a57df467ec2c8e6$var$listeningMarker]) {
        rootContainerElement[$4a57df467ec2c8e6$var$listeningMarker] = !0;
        $4a57df467ec2c8e6$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($4a57df467ec2c8e6$var$nonDelegatedEvents.has(domEventName) || $4a57df467ec2c8e6$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $4a57df467ec2c8e6$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$4a57df467ec2c8e6$var$listeningMarker] || (ownerDocument[$4a57df467ec2c8e6$var$listeningMarker] = !0, $4a57df467ec2c8e6$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $4a57df467ec2c8e6$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($4a57df467ec2c8e6$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $4a57df467ec2c8e6$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $4a57df467ec2c8e6$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $4a57df467ec2c8e6$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$4a57df467ec2c8e6$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $4a57df467ec2c8e6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $4a57df467ec2c8e6$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $4a57df467ec2c8e6$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $4a57df467ec2c8e6$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $4a57df467ec2c8e6$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $4a57df467ec2c8e6$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticTouchEvent;
                        break;
                    case $4a57df467ec2c8e6$var$ANIMATION_END:
                    case $4a57df467ec2c8e6$var$ANIMATION_ITERATION:
                    case $4a57df467ec2c8e6$var$ANIMATION_START:
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticAnimationEvent;
                        break;
                    case $4a57df467ec2c8e6$var$TRANSITION_END:
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $4a57df467ec2c8e6$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $4a57df467ec2c8e6$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($4a57df467ec2c8e6$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $4a57df467ec2c8e6$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($4a57df467ec2c8e6$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$4a57df467ec2c8e6$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $4a57df467ec2c8e6$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $4a57df467ec2c8e6$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $4a57df467ec2c8e6$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $4a57df467ec2c8e6$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $4a57df467ec2c8e6$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $4a57df467ec2c8e6$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $4a57df467ec2c8e6$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $4a57df467ec2c8e6$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $4a57df467ec2c8e6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $4a57df467ec2c8e6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $4a57df467ec2c8e6$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $4a57df467ec2c8e6$var$getTargetInstForChangeEvent;
                else if ($4a57df467ec2c8e6$var$isTextInputElement(reactName)) {
                    if ($4a57df467ec2c8e6$var$isInputEventSupported) getTargetInstFunc = $4a57df467ec2c8e6$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $4a57df467ec2c8e6$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $4a57df467ec2c8e6$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $4a57df467ec2c8e6$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $4a57df467ec2c8e6$var$getTargetInstForChangeEvent) : getTargetInstFunc = $4a57df467ec2c8e6$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $4a57df467ec2c8e6$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $4a57df467ec2c8e6$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $4a57df467ec2c8e6$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($4a57df467ec2c8e6$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $4a57df467ec2c8e6$var$activeElement = handleEventFunc, $4a57df467ec2c8e6$var$activeElementInst = targetInst, $4a57df467ec2c8e6$var$lastSelection = null;
                    break;
                case "focusout":
                    $4a57df467ec2c8e6$var$lastSelection = $4a57df467ec2c8e6$var$activeElementInst = $4a57df467ec2c8e6$var$activeElement = null;
                    break;
                case "mousedown":
                    $4a57df467ec2c8e6$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4a57df467ec2c8e6$var$mouseDown = !1;
                    $4a57df467ec2c8e6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($4a57df467ec2c8e6$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $4a57df467ec2c8e6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($4a57df467ec2c8e6$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $4a57df467ec2c8e6$var$isComposing ? $4a57df467ec2c8e6$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($4a57df467ec2c8e6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($4a57df467ec2c8e6$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $4a57df467ec2c8e6$var$isComposing && (fallbackData = $4a57df467ec2c8e6$var$getData()) : ($4a57df467ec2c8e6$var$root = nativeEventTarget, $4a57df467ec2c8e6$var$startText = "value" in $4a57df467ec2c8e6$var$root ? $4a57df467ec2c8e6$var$root.value : $4a57df467ec2c8e6$var$root.textContent, $4a57df467ec2c8e6$var$isComposing = !0)), handleEventFunc = $4a57df467ec2c8e6$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $4a57df467ec2c8e6$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $4a57df467ec2c8e6$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $4a57df467ec2c8e6$var$canUseTextInputEvent ? $4a57df467ec2c8e6$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $4a57df467ec2c8e6$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $4a57df467ec2c8e6$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $4a57df467ec2c8e6$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $4a57df467ec2c8e6$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $4a57df467ec2c8e6$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $4a57df467ec2c8e6$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $4a57df467ec2c8e6$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $4a57df467ec2c8e6$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($4a57df467ec2c8e6$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $4a57df467ec2c8e6$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($4a57df467ec2c8e6$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $4a57df467ec2c8e6$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $4a57df467ec2c8e6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $4a57df467ec2c8e6$var$getListener(target, registrationName), null != stateNode && listeners.unshift($4a57df467ec2c8e6$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $4a57df467ec2c8e6$var$getListener(target, registrationName), null != stateNode && listeners.push($4a57df467ec2c8e6$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $4a57df467ec2c8e6$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $4a57df467ec2c8e6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $4a57df467ec2c8e6$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($4a57df467ec2c8e6$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($4a57df467ec2c8e6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $4a57df467ec2c8e6$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $4a57df467ec2c8e6$var$normalizeMarkupForTextOrAttribute(clientText);
    return $4a57df467ec2c8e6$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $4a57df467ec2c8e6$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $4a57df467ec2c8e6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $4a57df467ec2c8e6$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $4a57df467ec2c8e6$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $4a57df467ec2c8e6$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $4a57df467ec2c8e6$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $4a57df467ec2c8e6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $4a57df467ec2c8e6$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $4a57df467ec2c8e6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $4a57df467ec2c8e6$var$setProp(domElement, tag, "name", props.name, props, null), $4a57df467ec2c8e6$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $4a57df467ec2c8e6$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $4a57df467ec2c8e6$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($4a57df467ec2c8e6$var$setProp(domElement, tag, "encType", props.encType, props, null), $4a57df467ec2c8e6$var$setProp(domElement, tag, "method", props.method, props, null), $4a57df467ec2c8e6$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $4a57df467ec2c8e6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $4a57df467ec2c8e6$var$noop$1);
            break;
        case "onScroll":
            null != value && $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $4a57df467ec2c8e6$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("toggle", domElement);
            $4a57df467ec2c8e6$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $4a57df467ec2c8e6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $4a57df467ec2c8e6$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $4a57df467ec2c8e6$var$aliases.get(key) || key, $4a57df467ec2c8e6$var$setValueForAttribute(domElement, key, value);
    }
}
function $4a57df467ec2c8e6$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $4a57df467ec2c8e6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $4a57df467ec2c8e6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $4a57df467ec2c8e6$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $4a57df467ec2c8e6$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$4a57df467ec2c8e6$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$4a57df467ec2c8e6$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $4a57df467ec2c8e6$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $4a57df467ec2c8e6$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("error", domElement);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(137, tag));
                    default:
                        $4a57df467ec2c8e6$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $4a57df467ec2c8e6$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $4a57df467ec2c8e6$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $4a57df467ec2c8e6$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $4a57df467ec2c8e6$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $4a57df467ec2c8e6$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $4a57df467ec2c8e6$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(91));
                    break;
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $4a57df467ec2c8e6$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("toggle", domElement);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("cancel", domElement);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $4a57df467ec2c8e6$var$mediaEventTypes.length; hasSrc++)$4a57df467ec2c8e6$var$listenToNonDelegatedEvent($4a57df467ec2c8e6$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("error", domElement);
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("error", domElement), $4a57df467ec2c8e6$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(137, tag));
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($4a57df467ec2c8e6$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $4a57df467ec2c8e6$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $4a57df467ec2c8e6$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $4a57df467ec2c8e6$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $4a57df467ec2c8e6$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $4a57df467ec2c8e6$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $4a57df467ec2c8e6$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $4a57df467ec2c8e6$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $4a57df467ec2c8e6$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $4a57df467ec2c8e6$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $4a57df467ec2c8e6$var$updateOptions(domElement, !!lastProps, tag, !0) : $4a57df467ec2c8e6$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $4a57df467ec2c8e6$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $4a57df467ec2c8e6$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $4a57df467ec2c8e6$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $4a57df467ec2c8e6$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($4a57df467ec2c8e6$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $4a57df467ec2c8e6$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $4a57df467ec2c8e6$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $4a57df467ec2c8e6$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $4a57df467ec2c8e6$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $4a57df467ec2c8e6$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $4a57df467ec2c8e6$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $4a57df467ec2c8e6$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $4a57df467ec2c8e6$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $4a57df467ec2c8e6$var$eventsEnabled = null, $4a57df467ec2c8e6$var$selectionInformation = null;
function $4a57df467ec2c8e6$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $4a57df467ec2c8e6$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $4a57df467ec2c8e6$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $4a57df467ec2c8e6$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $4a57df467ec2c8e6$var$currentPopstateTransitionEvent = null;
function $4a57df467ec2c8e6$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $4a57df467ec2c8e6$var$currentPopstateTransitionEvent) return !1;
        $4a57df467ec2c8e6$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $4a57df467ec2c8e6$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $4a57df467ec2c8e6$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $4a57df467ec2c8e6$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $4a57df467ec2c8e6$var$localPromise = "function" === typeof Promise ? Promise : void 0, $4a57df467ec2c8e6$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4a57df467ec2c8e6$var$localPromise ? function(callback) {
    return $4a57df467ec2c8e6$var$localPromise.resolve(null).then(callback).catch($4a57df467ec2c8e6$var$handleErrorInNextTick);
} : $4a57df467ec2c8e6$var$scheduleTimeout;
function $4a57df467ec2c8e6$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $4a57df467ec2c8e6$var$isSingletonScope(type) {
    return "head" === type;
}
function $4a57df467ec2c8e6$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $4a57df467ec2c8e6$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $4a57df467ec2c8e6$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $4a57df467ec2c8e6$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$4a57df467ec2c8e6$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $4a57df467ec2c8e6$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $4a57df467ec2c8e6$var$retryIfBlockedOn(hydrationInstance);
}
function $4a57df467ec2c8e6$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $4a57df467ec2c8e6$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $4a57df467ec2c8e6$var$clearContainerSparingly(node);
                $4a57df467ec2c8e6$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $4a57df467ec2c8e6$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$4a57df467ec2c8e6$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $4a57df467ec2c8e6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $4a57df467ec2c8e6$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $4a57df467ec2c8e6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $4a57df467ec2c8e6$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $4a57df467ec2c8e6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $4a57df467ec2c8e6$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $4a57df467ec2c8e6$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $4a57df467ec2c8e6$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $4a57df467ec2c8e6$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $4a57df467ec2c8e6$var$previousHydratableOnEnteringScopedSingleton = null;
function $4a57df467ec2c8e6$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $4a57df467ec2c8e6$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $4a57df467ec2c8e6$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $4a57df467ec2c8e6$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $4a57df467ec2c8e6$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(451));
    }
}
function $4a57df467ec2c8e6$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $4a57df467ec2c8e6$var$detachDeletedInstance(instance);
}
var $4a57df467ec2c8e6$var$preloadPropsMap = new Map(), $4a57df467ec2c8e6$var$preconnectsSet = new Set();
function $4a57df467ec2c8e6$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $4a57df467ec2c8e6$var$previousDispatcher = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.d;
$4a57df467ec2c8e6$var$ReactDOMSharedInternals.d = {
    f: $4a57df467ec2c8e6$var$flushSyncWork,
    r: $4a57df467ec2c8e6$var$requestFormReset,
    D: $4a57df467ec2c8e6$var$prefetchDNS,
    C: $4a57df467ec2c8e6$var$preconnect,
    L: $4a57df467ec2c8e6$var$preload,
    m: $4a57df467ec2c8e6$var$preloadModule,
    X: $4a57df467ec2c8e6$var$preinitScript,
    S: $4a57df467ec2c8e6$var$preinitStyle,
    M: $4a57df467ec2c8e6$var$preinitModuleScript
};
function $4a57df467ec2c8e6$var$flushSyncWork() {
    var previousWasRendering = $4a57df467ec2c8e6$var$previousDispatcher.f(), wasRendering = $4a57df467ec2c8e6$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $4a57df467ec2c8e6$var$requestFormReset(form) {
    var formInst = $4a57df467ec2c8e6$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $4a57df467ec2c8e6$var$requestFormReset$1(formInst) : $4a57df467ec2c8e6$var$previousDispatcher.r(form);
}
var $4a57df467ec2c8e6$var$globalDocument = "undefined" === typeof document ? null : document;
function $4a57df467ec2c8e6$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $4a57df467ec2c8e6$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $4a57df467ec2c8e6$var$preconnectsSet.has(limitedEscapedHref) || ($4a57df467ec2c8e6$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $4a57df467ec2c8e6$var$setInitialProperties(href, "link", rel), $4a57df467ec2c8e6$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $4a57df467ec2c8e6$var$prefetchDNS(href) {
    $4a57df467ec2c8e6$var$previousDispatcher.D(href);
    $4a57df467ec2c8e6$var$preconnectAs("dns-prefetch", href, null);
}
function $4a57df467ec2c8e6$var$preconnect(href, crossOrigin) {
    $4a57df467ec2c8e6$var$previousDispatcher.C(href, crossOrigin);
    $4a57df467ec2c8e6$var$preconnectAs("preconnect", href, crossOrigin);
}
function $4a57df467ec2c8e6$var$preload(href, as, options) {
    $4a57df467ec2c8e6$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $4a57df467ec2c8e6$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $4a57df467ec2c8e6$var$getStyleKey(href);
                break;
            case "script":
                key = $4a57df467ec2c8e6$var$getScriptKey(href);
        }
        $4a57df467ec2c8e6$var$preloadPropsMap.has(key) || (href = $4a57df467ec2c8e6$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $4a57df467ec2c8e6$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($4a57df467ec2c8e6$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($4a57df467ec2c8e6$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $4a57df467ec2c8e6$var$setInitialProperties(as, "link", href), $4a57df467ec2c8e6$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $4a57df467ec2c8e6$var$preloadModule(href, options) {
    $4a57df467ec2c8e6$var$previousDispatcher.m(href, options);
    var ownerDocument = $4a57df467ec2c8e6$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $4a57df467ec2c8e6$var$getScriptKey(href);
        }
        if (!$4a57df467ec2c8e6$var$preloadPropsMap.has(key) && (href = $4a57df467ec2c8e6$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $4a57df467ec2c8e6$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($4a57df467ec2c8e6$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $4a57df467ec2c8e6$var$setInitialProperties(as, "link", href);
            $4a57df467ec2c8e6$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $4a57df467ec2c8e6$var$preinitStyle(href, precedence, options) {
    $4a57df467ec2c8e6$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $4a57df467ec2c8e6$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $4a57df467ec2c8e6$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $4a57df467ec2c8e6$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($4a57df467ec2c8e6$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $4a57df467ec2c8e6$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $4a57df467ec2c8e6$var$preloadPropsMap.get(key)) && $4a57df467ec2c8e6$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $4a57df467ec2c8e6$var$markNodeAsHoistable(link);
                $4a57df467ec2c8e6$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $4a57df467ec2c8e6$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $4a57df467ec2c8e6$var$preinitScript(src, options) {
    $4a57df467ec2c8e6$var$previousDispatcher.X(src, options);
    var ownerDocument = $4a57df467ec2c8e6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $4a57df467ec2c8e6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $4a57df467ec2c8e6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($4a57df467ec2c8e6$var$getScriptSelectorFromKey(key)), resource || (src = $4a57df467ec2c8e6$var$assign({
            src: src,
            async: !0
        }, options), (options = $4a57df467ec2c8e6$var$preloadPropsMap.get(key)) && $4a57df467ec2c8e6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $4a57df467ec2c8e6$var$markNodeAsHoistable(resource), $4a57df467ec2c8e6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $4a57df467ec2c8e6$var$preinitModuleScript(src, options) {
    $4a57df467ec2c8e6$var$previousDispatcher.M(src, options);
    var ownerDocument = $4a57df467ec2c8e6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $4a57df467ec2c8e6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $4a57df467ec2c8e6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($4a57df467ec2c8e6$var$getScriptSelectorFromKey(key)), resource || (src = $4a57df467ec2c8e6$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $4a57df467ec2c8e6$var$preloadPropsMap.get(key)) && $4a57df467ec2c8e6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $4a57df467ec2c8e6$var$markNodeAsHoistable(resource), $4a57df467ec2c8e6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $4a57df467ec2c8e6$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $4a57df467ec2c8e6$var$rootInstanceStackCursor.current) ? $4a57df467ec2c8e6$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $4a57df467ec2c8e6$var$getStyleKey(pendingProps.href), pendingProps = $4a57df467ec2c8e6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $4a57df467ec2c8e6$var$getStyleKey(pendingProps.href);
                var styles$243 = $4a57df467ec2c8e6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($4a57df467ec2c8e6$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $4a57df467ec2c8e6$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $4a57df467ec2c8e6$var$preloadPropsMap.set(type, pendingProps), styles$243 || $4a57df467ec2c8e6$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $4a57df467ec2c8e6$var$getScriptKey(pendingProps), pendingProps = $4a57df467ec2c8e6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(444, type));
    }
}
function $4a57df467ec2c8e6$var$getStyleKey(href) {
    return 'href="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $4a57df467ec2c8e6$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $4a57df467ec2c8e6$var$stylesheetPropsFromRawProps(rawProps) {
    return $4a57df467ec2c8e6$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $4a57df467ec2c8e6$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $4a57df467ec2c8e6$var$setInitialProperties(key, "link", preloadProps), $4a57df467ec2c8e6$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $4a57df467ec2c8e6$var$getScriptKey(src) {
    return '[src="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $4a57df467ec2c8e6$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $4a57df467ec2c8e6$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $4a57df467ec2c8e6$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $4a57df467ec2c8e6$var$markNodeAsHoistable(instance), instance;
            var styleProps = $4a57df467ec2c8e6$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $4a57df467ec2c8e6$var$markNodeAsHoistable(instance);
            $4a57df467ec2c8e6$var$setInitialProperties(instance, "style", styleProps);
            $4a57df467ec2c8e6$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $4a57df467ec2c8e6$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($4a57df467ec2c8e6$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $4a57df467ec2c8e6$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $4a57df467ec2c8e6$var$stylesheetPropsFromRawProps(props);
            (styleProps = $4a57df467ec2c8e6$var$preloadPropsMap.get(styleProps)) && $4a57df467ec2c8e6$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $4a57df467ec2c8e6$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $4a57df467ec2c8e6$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $4a57df467ec2c8e6$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $4a57df467ec2c8e6$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($4a57df467ec2c8e6$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $4a57df467ec2c8e6$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $4a57df467ec2c8e6$var$preloadPropsMap.get(instance$249)) instance = $4a57df467ec2c8e6$var$assign({}, props), $4a57df467ec2c8e6$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $4a57df467ec2c8e6$var$markNodeAsHoistable(styleProps);
            $4a57df467ec2c8e6$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $4a57df467ec2c8e6$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $4a57df467ec2c8e6$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $4a57df467ec2c8e6$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $4a57df467ec2c8e6$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $4a57df467ec2c8e6$var$tagCaches = null;
function $4a57df467ec2c8e6$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $4a57df467ec2c8e6$var$tagCaches) {
        var cache = new Map();
        var caches = $4a57df467ec2c8e6$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $4a57df467ec2c8e6$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$4a57df467ec2c8e6$var$internalHoistableMarker] || node[$4a57df467ec2c8e6$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $4a57df467ec2c8e6$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $4a57df467ec2c8e6$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $4a57df467ec2c8e6$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $4a57df467ec2c8e6$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $4a57df467ec2c8e6$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($4a57df467ec2c8e6$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $4a57df467ec2c8e6$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $4a57df467ec2c8e6$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $4a57df467ec2c8e6$var$stylesheetPropsFromRawProps(props);
            (key = $4a57df467ec2c8e6$var$preloadPropsMap.get(key)) && $4a57df467ec2c8e6$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $4a57df467ec2c8e6$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $4a57df467ec2c8e6$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $4a57df467ec2c8e6$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $4a57df467ec2c8e6$var$estimatedBytesWithinLimit = 0;
function $4a57df467ec2c8e6$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $4a57df467ec2c8e6$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $4a57df467ec2c8e6$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $4a57df467ec2c8e6$var$estimatedBytesWithinLimit && ($4a57df467ec2c8e6$var$estimatedBytesWithinLimit = 62500 * $4a57df467ec2c8e6$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $4a57df467ec2c8e6$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $4a57df467ec2c8e6$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $4a57df467ec2c8e6$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $4a57df467ec2c8e6$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $4a57df467ec2c8e6$var$precedencesByRoot = null;
function $4a57df467ec2c8e6$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $4a57df467ec2c8e6$var$precedencesByRoot = new Map(), resources.forEach($4a57df467ec2c8e6$var$insertStylesheetIntoRoot, state), $4a57df467ec2c8e6$var$precedencesByRoot = null, $4a57df467ec2c8e6$var$onUnsuspend.call(state));
}
function $4a57df467ec2c8e6$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $4a57df467ec2c8e6$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $4a57df467ec2c8e6$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $4a57df467ec2c8e6$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $4a57df467ec2c8e6$var$HostTransitionContext = {
    $$typeof: $4a57df467ec2c8e6$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $4a57df467ec2c8e6$var$sharedNotPendingObject,
    _currentValue2: $4a57df467ec2c8e6$var$sharedNotPendingObject,
    _threadCount: 0
};
function $4a57df467ec2c8e6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $4a57df467ec2c8e6$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4a57df467ec2c8e6$var$createLaneMap(0);
    this.hiddenUpdates = $4a57df467ec2c8e6$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $4a57df467ec2c8e6$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $4a57df467ec2c8e6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $4a57df467ec2c8e6$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $4a57df467ec2c8e6$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $4a57df467ec2c8e6$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $4a57df467ec2c8e6$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $4a57df467ec2c8e6$var$emptyContextObject;
    parentComponent = $4a57df467ec2c8e6$var$emptyContextObject;
    return parentComponent;
}
function $4a57df467ec2c8e6$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $4a57df467ec2c8e6$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $4a57df467ec2c8e6$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $4a57df467ec2c8e6$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($4a57df467ec2c8e6$var$scheduleUpdateOnFiber(element, rootFiber, lane), $4a57df467ec2c8e6$var$entangleTransitions(element, rootFiber, lane));
}
function $4a57df467ec2c8e6$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $4a57df467ec2c8e6$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $4a57df467ec2c8e6$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $4a57df467ec2c8e6$var$markRetryLaneImpl(fiber, retryLane);
}
function $4a57df467ec2c8e6$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $4a57df467ec2c8e6$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $4a57df467ec2c8e6$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $4a57df467ec2c8e6$var$requestUpdateLane();
        lane = $4a57df467ec2c8e6$var$getBumpedLaneForHydrationByLane(lane);
        var root = $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(root, fiber, lane);
        $4a57df467ec2c8e6$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $4a57df467ec2c8e6$var$_enabled = !0;
function $4a57df467ec2c8e6$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $4a57df467ec2c8e6$var$ReactSharedInternals.T;
    $4a57df467ec2c8e6$var$ReactSharedInternals.T = null;
    var previousPriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
    try {
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 2, $4a57df467ec2c8e6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = previousPriority, $4a57df467ec2c8e6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4a57df467ec2c8e6$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $4a57df467ec2c8e6$var$ReactSharedInternals.T;
    $4a57df467ec2c8e6$var$ReactSharedInternals.T = null;
    var previousPriority = $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p;
    try {
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = 8, $4a57df467ec2c8e6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $4a57df467ec2c8e6$var$ReactDOMSharedInternals.p = previousPriority, $4a57df467ec2c8e6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $4a57df467ec2c8e6$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($4a57df467ec2c8e6$var$_enabled) {
        var blockedOn = $4a57df467ec2c8e6$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $4a57df467ec2c8e6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $4a57df467ec2c8e6$var$return_targetInst, targetContainer), $4a57df467ec2c8e6$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($4a57df467ec2c8e6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($4a57df467ec2c8e6$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $4a57df467ec2c8e6$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $4a57df467ec2c8e6$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $4a57df467ec2c8e6$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $4a57df467ec2c8e6$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $4a57df467ec2c8e6$var$ensureRootIsScheduled(fiber);
                                0 === ($4a57df467ec2c8e6$var$executionContext & 6) && ($4a57df467ec2c8e6$var$workInProgressRootRenderTargetTime = $4a57df467ec2c8e6$var$now() + 500, $4a57df467ec2c8e6$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $4a57df467ec2c8e6$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $4a57df467ec2c8e6$var$scheduleUpdateOnFiber(root, fiber, 2), $4a57df467ec2c8e6$var$flushSyncWork$1(), $4a57df467ec2c8e6$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $4a57df467ec2c8e6$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $4a57df467ec2c8e6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $4a57df467ec2c8e6$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $4a57df467ec2c8e6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $4a57df467ec2c8e6$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $4a57df467ec2c8e6$var$getEventTarget(nativeEvent);
    return $4a57df467ec2c8e6$var$findInstanceBlockingTarget(nativeEvent);
}
var $4a57df467ec2c8e6$var$return_targetInst = null;
function $4a57df467ec2c8e6$var$findInstanceBlockingTarget(targetNode) {
    $4a57df467ec2c8e6$var$return_targetInst = null;
    targetNode = $4a57df467ec2c8e6$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $4a57df467ec2c8e6$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $4a57df467ec2c8e6$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $4a57df467ec2c8e6$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $4a57df467ec2c8e6$var$return_targetInst = targetNode;
    return null;
}
function $4a57df467ec2c8e6$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($4a57df467ec2c8e6$var$getCurrentPriorityLevel()){
                case $4a57df467ec2c8e6$var$ImmediatePriority:
                    return 2;
                case $4a57df467ec2c8e6$var$UserBlockingPriority:
                    return 8;
                case $4a57df467ec2c8e6$var$NormalPriority$1:
                case $4a57df467ec2c8e6$var$LowPriority:
                    return 32;
                case $4a57df467ec2c8e6$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $4a57df467ec2c8e6$var$hasScheduledReplayAttempt = !1, $4a57df467ec2c8e6$var$queuedFocus = null, $4a57df467ec2c8e6$var$queuedDrag = null, $4a57df467ec2c8e6$var$queuedMouse = null, $4a57df467ec2c8e6$var$queuedPointers = new Map(), $4a57df467ec2c8e6$var$queuedPointerCaptures = new Map(), $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets = [], $4a57df467ec2c8e6$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $4a57df467ec2c8e6$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $4a57df467ec2c8e6$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $4a57df467ec2c8e6$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $4a57df467ec2c8e6$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $4a57df467ec2c8e6$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4a57df467ec2c8e6$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $4a57df467ec2c8e6$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $4a57df467ec2c8e6$var$getInstanceFromNode(blockedOn), null !== blockedOn && $4a57df467ec2c8e6$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $4a57df467ec2c8e6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $4a57df467ec2c8e6$var$queuedFocus = $4a57df467ec2c8e6$var$accumulateOrCreateContinuousQueuedReplayableEvent($4a57df467ec2c8e6$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $4a57df467ec2c8e6$var$queuedDrag = $4a57df467ec2c8e6$var$accumulateOrCreateContinuousQueuedReplayableEvent($4a57df467ec2c8e6$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $4a57df467ec2c8e6$var$queuedMouse = $4a57df467ec2c8e6$var$accumulateOrCreateContinuousQueuedReplayableEvent($4a57df467ec2c8e6$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $4a57df467ec2c8e6$var$queuedPointers.set(pointerId, $4a57df467ec2c8e6$var$accumulateOrCreateContinuousQueuedReplayableEvent($4a57df467ec2c8e6$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $4a57df467ec2c8e6$var$queuedPointerCaptures.set(pointerId, $4a57df467ec2c8e6$var$accumulateOrCreateContinuousQueuedReplayableEvent($4a57df467ec2c8e6$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $4a57df467ec2c8e6$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $4a57df467ec2c8e6$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $4a57df467ec2c8e6$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $4a57df467ec2c8e6$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $4a57df467ec2c8e6$var$runWithPriority(queuedTarget.priority, function() {
                        $4a57df467ec2c8e6$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $4a57df467ec2c8e6$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $4a57df467ec2c8e6$var$runWithPriority(queuedTarget.priority, function() {
                        $4a57df467ec2c8e6$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $4a57df467ec2c8e6$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $4a57df467ec2c8e6$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $4a57df467ec2c8e6$var$currentReplayingEvent = null;
        } else return targetContainers = $4a57df467ec2c8e6$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $4a57df467ec2c8e6$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $4a57df467ec2c8e6$var$replayUnblockedEvents() {
    $4a57df467ec2c8e6$var$hasScheduledReplayAttempt = !1;
    null !== $4a57df467ec2c8e6$var$queuedFocus && $4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEvent($4a57df467ec2c8e6$var$queuedFocus) && ($4a57df467ec2c8e6$var$queuedFocus = null);
    null !== $4a57df467ec2c8e6$var$queuedDrag && $4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEvent($4a57df467ec2c8e6$var$queuedDrag) && ($4a57df467ec2c8e6$var$queuedDrag = null);
    null !== $4a57df467ec2c8e6$var$queuedMouse && $4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEvent($4a57df467ec2c8e6$var$queuedMouse) && ($4a57df467ec2c8e6$var$queuedMouse = null);
    $4a57df467ec2c8e6$var$queuedPointers.forEach($4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEventInMap);
    $4a57df467ec2c8e6$var$queuedPointerCaptures.forEach($4a57df467ec2c8e6$var$attemptReplayContinuousQueuedEventInMap);
}
function $4a57df467ec2c8e6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $4a57df467ec2c8e6$var$hasScheduledReplayAttempt || ($4a57df467ec2c8e6$var$hasScheduledReplayAttempt = !0, $gARKC.unstable_scheduleCallback($gARKC.unstable_NormalPriority, $4a57df467ec2c8e6$var$replayUnblockedEvents)));
}
var $4a57df467ec2c8e6$var$lastScheduledReplayQueue = null;
function $4a57df467ec2c8e6$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $4a57df467ec2c8e6$var$lastScheduledReplayQueue !== formReplayingQueue && ($4a57df467ec2c8e6$var$lastScheduledReplayQueue = formReplayingQueue, $gARKC.unstable_scheduleCallback($gARKC.unstable_NormalPriority, function() {
        $4a57df467ec2c8e6$var$lastScheduledReplayQueue === formReplayingQueue && ($4a57df467ec2c8e6$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $4a57df467ec2c8e6$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $4a57df467ec2c8e6$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $4a57df467ec2c8e6$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $4a57df467ec2c8e6$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $4a57df467ec2c8e6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $4a57df467ec2c8e6$var$queuedFocus && $4a57df467ec2c8e6$var$scheduleCallbackIfUnblocked($4a57df467ec2c8e6$var$queuedFocus, unblocked);
    null !== $4a57df467ec2c8e6$var$queuedDrag && $4a57df467ec2c8e6$var$scheduleCallbackIfUnblocked($4a57df467ec2c8e6$var$queuedDrag, unblocked);
    null !== $4a57df467ec2c8e6$var$queuedMouse && $4a57df467ec2c8e6$var$scheduleCallbackIfUnblocked($4a57df467ec2c8e6$var$queuedMouse, unblocked);
    $4a57df467ec2c8e6$var$queuedPointers.forEach(unblock);
    $4a57df467ec2c8e6$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets.length && (i = $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$4a57df467ec2c8e6$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$4a57df467ec2c8e6$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $4a57df467ec2c8e6$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$4a57df467ec2c8e6$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $4a57df467ec2c8e6$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $4a57df467ec2c8e6$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $4a57df467ec2c8e6$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $4a57df467ec2c8e6$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$4a57df467ec2c8e6$var$ReactDOMHydrationRoot.prototype.render = $4a57df467ec2c8e6$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(409));
    var current = root.current, lane = $4a57df467ec2c8e6$var$requestUpdateLane();
    $4a57df467ec2c8e6$var$updateContainerImpl(current, lane, children, root, null, null);
};
$4a57df467ec2c8e6$var$ReactDOMHydrationRoot.prototype.unmount = $4a57df467ec2c8e6$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $4a57df467ec2c8e6$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $4a57df467ec2c8e6$var$flushSyncWork$1();
        container[$4a57df467ec2c8e6$var$internalContainerInstanceKey] = null;
    }
};
function $4a57df467ec2c8e6$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$4a57df467ec2c8e6$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $4a57df467ec2c8e6$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets[i].priority; i++);
        $4a57df467ec2c8e6$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $4a57df467ec2c8e6$var$attemptExplicitHydrationTarget(target);
    }
};
var $4a57df467ec2c8e6$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $46wWE.version;
if ("19.2.0" !== $4a57df467ec2c8e6$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(527, $4a57df467ec2c8e6$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
$4a57df467ec2c8e6$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $4a57df467ec2c8e6$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $4a57df467ec2c8e6$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $4a57df467ec2c8e6$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $4a57df467ec2c8e6$var$ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4a57df467ec2c8e6$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4a57df467ec2c8e6$var$hook$jscomp$inline_2348.isDisabled && $4a57df467ec2c8e6$var$hook$jscomp$inline_2348.supportsFiber) try {
        $4a57df467ec2c8e6$var$rendererID = $4a57df467ec2c8e6$var$hook$jscomp$inline_2348.inject($4a57df467ec2c8e6$var$internals$jscomp$inline_2347), $4a57df467ec2c8e6$var$injectedHook = $4a57df467ec2c8e6$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$4a57df467ec2c8e6$export$882461b6382ed46c = function(container, options) {
    if (!$4a57df467ec2c8e6$var$isValidContainer(container)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $4a57df467ec2c8e6$var$defaultOnUncaughtError, onCaughtError = $4a57df467ec2c8e6$var$defaultOnCaughtError, onRecoverableError = $4a57df467ec2c8e6$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $4a57df467ec2c8e6$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $4a57df467ec2c8e6$var$defaultOnDefaultTransitionIndicator);
    container[$4a57df467ec2c8e6$var$internalContainerInstanceKey] = options.current;
    $4a57df467ec2c8e6$var$listenToAllSupportedEvents(container);
    return new $4a57df467ec2c8e6$var$ReactDOMRoot(options);
};
$4a57df467ec2c8e6$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$4a57df467ec2c8e6$var$isValidContainer(container)) throw Error($4a57df467ec2c8e6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $4a57df467ec2c8e6$var$defaultOnUncaughtError, onCaughtError = $4a57df467ec2c8e6$var$defaultOnCaughtError, onRecoverableError = $4a57df467ec2c8e6$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $4a57df467ec2c8e6$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $4a57df467ec2c8e6$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $4a57df467ec2c8e6$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $4a57df467ec2c8e6$var$requestUpdateLane();
    isStrictMode = $4a57df467ec2c8e6$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $4a57df467ec2c8e6$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $4a57df467ec2c8e6$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $4a57df467ec2c8e6$var$markRootUpdated$1(initialChildren, options);
    $4a57df467ec2c8e6$var$ensureRootIsScheduled(initialChildren);
    container[$4a57df467ec2c8e6$var$internalContainerInstanceKey] = initialChildren.current;
    $4a57df467ec2c8e6$var$listenToAllSupportedEvents(container);
    return new $4a57df467ec2c8e6$var$ReactDOMHydrationRoot(initialChildren);
};
$4a57df467ec2c8e6$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("gARKC", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bbVjl"));

});
parcelRegister("bbVjl", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $825d2d959911099c$export$c4744153514ff05d; }, function (v) { return $825d2d959911099c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $825d2d959911099c$export$3e506c1ccc9cc1a7; }, function (v) { return $825d2d959911099c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $825d2d959911099c$export$e26fe2ed2fa76875; }, function (v) { return $825d2d959911099c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $825d2d959911099c$export$502329bbf4b505b1; }, function (v) { return $825d2d959911099c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $825d2d959911099c$export$6e3807111c4874c4; }, function (v) { return $825d2d959911099c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $825d2d959911099c$export$c27134553091fb3a; }, function (v) { return $825d2d959911099c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $825d2d959911099c$export$33ee1acdc04fd2a2; }, function (v) { return $825d2d959911099c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $825d2d959911099c$export$b00a404bbd5edef2; }, function (v) { return $825d2d959911099c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $825d2d959911099c$export$d66a1c1c77bd778b; }, function (v) { return $825d2d959911099c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $825d2d959911099c$export$d3dfb8e4810cb555; }, function (v) { return $825d2d959911099c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $825d2d959911099c$export$72fdf0e06517287b; }, function (v) { return $825d2d959911099c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $825d2d959911099c$export$816d2913ae6b83b1; }, function (v) { return $825d2d959911099c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $825d2d959911099c$export$61bcfe829111a1d0; }, function (v) { return $825d2d959911099c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $825d2d959911099c$export$7ee8c9beb337bc3f; }, function (v) { return $825d2d959911099c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $825d2d959911099c$export$b5836b71941fa3ed; }, function (v) { return $825d2d959911099c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $825d2d959911099c$export$cf845f2c119da08a; }, function (v) { return $825d2d959911099c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $825d2d959911099c$export$c4744153514ff05d;
var $825d2d959911099c$export$3e506c1ccc9cc1a7;
var $825d2d959911099c$export$e26fe2ed2fa76875;
var $825d2d959911099c$export$502329bbf4b505b1;
var $825d2d959911099c$export$6e3807111c4874c4;
var $825d2d959911099c$export$c27134553091fb3a;
var $825d2d959911099c$export$33ee1acdc04fd2a2;
var $825d2d959911099c$export$b00a404bbd5edef2;
var $825d2d959911099c$export$d66a1c1c77bd778b;
var $825d2d959911099c$export$d3dfb8e4810cb555;
var $825d2d959911099c$export$72fdf0e06517287b;
var $825d2d959911099c$export$816d2913ae6b83b1;
var $825d2d959911099c$export$61bcfe829111a1d0;
var $825d2d959911099c$export$7ee8c9beb337bc3f;
var $825d2d959911099c$export$b5836b71941fa3ed;
var $825d2d959911099c$export$cf845f2c119da08a;
"use strict";
function $825d2d959911099c$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $825d2d959911099c$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $825d2d959911099c$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $825d2d959911099c$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $825d2d959911099c$var$compare(left, last)) rightIndex < length && 0 > $825d2d959911099c$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $825d2d959911099c$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $825d2d959911099c$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$825d2d959911099c$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $825d2d959911099c$var$localPerformance = performance;
    $825d2d959911099c$export$c4744153514ff05d = function() {
        return $825d2d959911099c$var$localPerformance.now();
    };
} else {
    var $825d2d959911099c$var$localDate = Date, $825d2d959911099c$var$initialTime = $825d2d959911099c$var$localDate.now();
    $825d2d959911099c$export$c4744153514ff05d = function() {
        return $825d2d959911099c$var$localDate.now() - $825d2d959911099c$var$initialTime;
    };
}
var $825d2d959911099c$var$taskQueue = [], $825d2d959911099c$var$timerQueue = [], $825d2d959911099c$var$taskIdCounter = 1, $825d2d959911099c$var$currentTask = null, $825d2d959911099c$var$currentPriorityLevel = 3, $825d2d959911099c$var$isPerformingWork = !1, $825d2d959911099c$var$isHostCallbackScheduled = !1, $825d2d959911099c$var$isHostTimeoutScheduled = !1, $825d2d959911099c$var$needsPaint = !1, $825d2d959911099c$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $825d2d959911099c$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $825d2d959911099c$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $825d2d959911099c$var$advanceTimers(currentTime) {
    for(var timer = $825d2d959911099c$var$peek($825d2d959911099c$var$timerQueue); null !== timer;){
        if (null === timer.callback) $825d2d959911099c$var$pop($825d2d959911099c$var$timerQueue);
        else if (timer.startTime <= currentTime) $825d2d959911099c$var$pop($825d2d959911099c$var$timerQueue), timer.sortIndex = timer.expirationTime, $825d2d959911099c$var$push($825d2d959911099c$var$taskQueue, timer);
        else break;
        timer = $825d2d959911099c$var$peek($825d2d959911099c$var$timerQueue);
    }
}
function $825d2d959911099c$var$handleTimeout(currentTime) {
    $825d2d959911099c$var$isHostTimeoutScheduled = !1;
    $825d2d959911099c$var$advanceTimers(currentTime);
    if (!$825d2d959911099c$var$isHostCallbackScheduled) {
        if (null !== $825d2d959911099c$var$peek($825d2d959911099c$var$taskQueue)) $825d2d959911099c$var$isHostCallbackScheduled = !0, $825d2d959911099c$var$isMessageLoopRunning || ($825d2d959911099c$var$isMessageLoopRunning = !0, $825d2d959911099c$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $825d2d959911099c$var$peek($825d2d959911099c$var$timerQueue);
            null !== firstTimer && $825d2d959911099c$var$requestHostTimeout($825d2d959911099c$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $825d2d959911099c$var$isMessageLoopRunning = !1, $825d2d959911099c$var$taskTimeoutID = -1, $825d2d959911099c$var$frameInterval = 5, $825d2d959911099c$var$startTime = -1;
function $825d2d959911099c$var$shouldYieldToHost() {
    return $825d2d959911099c$var$needsPaint ? !0 : $825d2d959911099c$export$c4744153514ff05d() - $825d2d959911099c$var$startTime < $825d2d959911099c$var$frameInterval ? !1 : !0;
}
function $825d2d959911099c$var$performWorkUntilDeadline() {
    $825d2d959911099c$var$needsPaint = !1;
    if ($825d2d959911099c$var$isMessageLoopRunning) {
        var currentTime = $825d2d959911099c$export$c4744153514ff05d();
        $825d2d959911099c$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $825d2d959911099c$var$isHostCallbackScheduled = !1;
                $825d2d959911099c$var$isHostTimeoutScheduled && ($825d2d959911099c$var$isHostTimeoutScheduled = !1, $825d2d959911099c$var$localClearTimeout($825d2d959911099c$var$taskTimeoutID), $825d2d959911099c$var$taskTimeoutID = -1);
                $825d2d959911099c$var$isPerformingWork = !0;
                var previousPriorityLevel = $825d2d959911099c$var$currentPriorityLevel;
                try {
                    b: {
                        $825d2d959911099c$var$advanceTimers(currentTime);
                        for($825d2d959911099c$var$currentTask = $825d2d959911099c$var$peek($825d2d959911099c$var$taskQueue); null !== $825d2d959911099c$var$currentTask && !($825d2d959911099c$var$currentTask.expirationTime > currentTime && $825d2d959911099c$var$shouldYieldToHost());){
                            var callback = $825d2d959911099c$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $825d2d959911099c$var$currentTask.callback = null;
                                $825d2d959911099c$var$currentPriorityLevel = $825d2d959911099c$var$currentTask.priorityLevel;
                                var continuationCallback = callback($825d2d959911099c$var$currentTask.expirationTime <= currentTime);
                                currentTime = $825d2d959911099c$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $825d2d959911099c$var$currentTask.callback = continuationCallback;
                                    $825d2d959911099c$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $825d2d959911099c$var$currentTask === $825d2d959911099c$var$peek($825d2d959911099c$var$taskQueue) && $825d2d959911099c$var$pop($825d2d959911099c$var$taskQueue);
                                $825d2d959911099c$var$advanceTimers(currentTime);
                            } else $825d2d959911099c$var$pop($825d2d959911099c$var$taskQueue);
                            $825d2d959911099c$var$currentTask = $825d2d959911099c$var$peek($825d2d959911099c$var$taskQueue);
                        }
                        if (null !== $825d2d959911099c$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $825d2d959911099c$var$peek($825d2d959911099c$var$timerQueue);
                            null !== firstTimer && $825d2d959911099c$var$requestHostTimeout($825d2d959911099c$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $825d2d959911099c$var$currentTask = null, $825d2d959911099c$var$currentPriorityLevel = previousPriorityLevel, $825d2d959911099c$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $825d2d959911099c$var$schedulePerformWorkUntilDeadline() : $825d2d959911099c$var$isMessageLoopRunning = !1;
        }
    }
}
var $825d2d959911099c$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $825d2d959911099c$var$localSetImmediate) $825d2d959911099c$var$schedulePerformWorkUntilDeadline = function() {
    $825d2d959911099c$var$localSetImmediate($825d2d959911099c$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $825d2d959911099c$var$channel = new MessageChannel(), $825d2d959911099c$var$port = $825d2d959911099c$var$channel.port2;
    $825d2d959911099c$var$channel.port1.onmessage = $825d2d959911099c$var$performWorkUntilDeadline;
    $825d2d959911099c$var$schedulePerformWorkUntilDeadline = function() {
        $825d2d959911099c$var$port.postMessage(null);
    };
} else $825d2d959911099c$var$schedulePerformWorkUntilDeadline = function() {
    $825d2d959911099c$var$localSetTimeout($825d2d959911099c$var$performWorkUntilDeadline, 0);
};
function $825d2d959911099c$var$requestHostTimeout(callback, ms) {
    $825d2d959911099c$var$taskTimeoutID = $825d2d959911099c$var$localSetTimeout(function() {
        callback($825d2d959911099c$export$c4744153514ff05d());
    }, ms);
}
$825d2d959911099c$export$3e506c1ccc9cc1a7 = 5;
$825d2d959911099c$export$e26fe2ed2fa76875 = 1;
$825d2d959911099c$export$502329bbf4b505b1 = 4;
$825d2d959911099c$export$6e3807111c4874c4 = 3;
$825d2d959911099c$export$c27134553091fb3a = null;
$825d2d959911099c$export$33ee1acdc04fd2a2 = 2;
$825d2d959911099c$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$825d2d959911099c$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $825d2d959911099c$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$825d2d959911099c$export$d3dfb8e4810cb555 = function() {
    return $825d2d959911099c$var$currentPriorityLevel;
};
$825d2d959911099c$export$72fdf0e06517287b = function(eventHandler) {
    switch($825d2d959911099c$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $825d2d959911099c$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $825d2d959911099c$var$currentPriorityLevel;
    $825d2d959911099c$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $825d2d959911099c$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$825d2d959911099c$export$816d2913ae6b83b1 = function() {
    $825d2d959911099c$var$needsPaint = !0;
};
$825d2d959911099c$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $825d2d959911099c$var$currentPriorityLevel;
    $825d2d959911099c$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $825d2d959911099c$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$825d2d959911099c$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $825d2d959911099c$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $825d2d959911099c$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $825d2d959911099c$var$push($825d2d959911099c$var$timerQueue, priorityLevel), null === $825d2d959911099c$var$peek($825d2d959911099c$var$taskQueue) && priorityLevel === $825d2d959911099c$var$peek($825d2d959911099c$var$timerQueue) && ($825d2d959911099c$var$isHostTimeoutScheduled ? ($825d2d959911099c$var$localClearTimeout($825d2d959911099c$var$taskTimeoutID), $825d2d959911099c$var$taskTimeoutID = -1) : $825d2d959911099c$var$isHostTimeoutScheduled = !0, $825d2d959911099c$var$requestHostTimeout($825d2d959911099c$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $825d2d959911099c$var$push($825d2d959911099c$var$taskQueue, priorityLevel), $825d2d959911099c$var$isHostCallbackScheduled || $825d2d959911099c$var$isPerformingWork || ($825d2d959911099c$var$isHostCallbackScheduled = !0, $825d2d959911099c$var$isMessageLoopRunning || ($825d2d959911099c$var$isMessageLoopRunning = !0, $825d2d959911099c$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$825d2d959911099c$export$b5836b71941fa3ed = $825d2d959911099c$var$shouldYieldToHost;
$825d2d959911099c$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $825d2d959911099c$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $825d2d959911099c$var$currentPriorityLevel;
        $825d2d959911099c$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $825d2d959911099c$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("2jkQi", function(module, exports) {
'use strict';
function $1aed85ff221eb9b4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1aed85ff221eb9b4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1aed85ff221eb9b4$var$checkDCE();

module.exports = (parcelRequire("gHXVo"));

});


var $0b75ea0b64c07b28$exports = {};
$parcel$extendImportMap({
    "Ry0pz": "fidodemo-success-1.52f8ecdf.svg",
    "l9tJ7": "account.0f81fd53.svg",
    "387UB": "android.fd36a63e.svg",
    "28dEk": "apple.a262eb67.svg",
    "3BoJ7": "apple-face-id.fc428faf.svg",
    "35MLC": "apple-touch-id.f0907262.svg",
    "i1UsS": "arrow.f6fc046a.svg",
    "e7ACG": "checkmark_purple.0faede77.svg",
    "8EHLx": "checkmark_purple_thin.484bd8fb.svg",
    "ku8O5": "checkmark_yellow.b256a7e6.svg",
    "bayQ3": "cp_manage.d1cd535e.svg",
    "7DB0o": "cp_password.04c155a4.svg",
    "8ZgKO": "cp_password_owned_ctrl.566ff8d3.svg",
    "95lB7": "cp_onboarding.8daddab5.svg",
    "9dFw2": "cp_problems.117a4475.svg",
    "4C8to": "cross-cyan.0ea80bf9.svg",
    "bPWBC": "cross-purple.cebe1a2d.svg",
    "8zXb5": "cross-red.e3c12ecd.svg",
    "9xypP": "cross-yellow.8117d99b.svg",
    "jGKIN": "plus-purple.ddb7e1db.svg",
    "b14Ku": "minus-purple.4a84964b.svg",
    "j9Sd7": "feedback.e17b2130.svg",
    "j5dXk": "help.b088e6d2.svg",
    "5Gzwd": "hero-authenticated.ebbbe217.svg",
    "ajLlI": "hero-done.0f4c3da0.svg",
    "jdx40": "hero-welcome.5b413b69.svg",
    "bVysc": "icon-error.edbe24e0.svg",
    "djEhh": "menu.7d9002e6.svg",
    "aoS90": "empty-circle.3b184013.svg",
    "8E9k8": "check-circle.93e19ac3.svg",
    "e862t": "x-circle.3636eae9.svg",
    "e6hTU": "x-circle-red.84c0228f.svg",
    "6qDg0": "logout.74a38d2a.svg",
    "g6zCj": "globe.cca29cfb.svg",
    "4qC36": "camera.52923c17.svg",
    "1diU2": "camera_black.3ea6e526.svg",
    "h9gxV": "eye_open.cf52326e.svg",
    "iwDis": "eye_closed.4a22992b.svg",
    "5dCoN": "search.c4d82cff.svg",
    "W3KSq": "home.f3f169e1.svg",
    "6C6PU": "userguide.15a95dae.svg",
    "kIylU": "book.e74c7e6e.svg",
    "6vm3r": "user.f08de1a2.svg",
    "4ANee": "users.96c015da.svg",
    "dNrbM": "icon-warning.daf631d9.svg",
    "dgRDk": "icon-success.702ba02b.svg",
    "X4CUq": "icon-info.82df0f4c.svg",
    "5WPBO": "none.83937059.svg",
    "34b6e": "other.2747840d.svg",
    "dAW5h": "other-disabled.b4d94b8a.svg",
    "idkqo": "fido-passkey.fb5d48a4.svg",
    "4zErv": "fido-passkey-disabled.59c8996c.svg",
    "d3GCi": "apple-disabled.9ab8f818.svg",
    "6vpfg": "windows-disabled.0032fde5.svg",
    "3BSGj": "android-disabled.cf544b6c.svg",
    "2fgBa": "securitykey.e2121ffa.svg",
    "gxHZS": "step-1.cffe6b5f.svg",
    "5Mbd6": "step-2-fido.d1e70595.svg",
    "isows": "step-2-onboarding.a8685388.svg",
    "cdZpZ": "step-2-password.d1e70595.svg",
    "cS9xu": "step-3-fido.00d506ed.svg",
    "4T45f": "step-3-onboarding.aaa6bf77.svg",
    "3xQ6T": "step-3-password.c4ce60fd.svg",
    "hAvtE": "step-3-detached.8bb35224.svg",
    "5XkEO": "smiley-unhappy.83937059.svg",
    "i6dKc": "windows.6df0d9c6.svg",
    "bPFzA": "windows-hello.e67ce979.svg",
    "foqWa": "loading-cyan.1467b899.gif",
    "gE8Fe": "loading-yellow.efb9033a.gif",
    "6OrcH": "loading-purple.e053a281.gif",
    "aSLfc": "device_switch_01.30347958.gif",
    "cNFWw": "device_switch_02.5815fa41.gif",
    "lkItf": "device_switch_03.75311140.gif",
    "19AV4": "android_authenticator_animation.51717c14.gif",
    "4VPWX": "fido_hardwaretoken_animation.b979b2b1.gif",
    "94rJn": "iphone_fido_animation.023b9300.gif",
    "6kU4E": "macbook_touchid_animation.6ed6507a.gif",
    "hOoaM": "windows_hello_animation.1de66755.gif",
    "1SGsS": "fidodemo-start.85525ce9.svg",
    "UHmAL": "copy_to_clipboard.cfd77c53.svg",
    "ki0qe": "windows-with-bluetooth-1-de.b1c1296c.webp",
    "dBT9i": "windows-with-bluetooth-2-de.3233cd8f.webp",
    "4b3b7": "windows-with-bluetooth-1-en.c80e19bd.webp",
    "dPb9k": "windows-with-bluetooth-2-en.535e4640.webp",
    "jvJP4": "windows-without-bluetooth-1-de.aa51c5b5.webp",
    "j96t7": "windows-without-bluetooth-2-de.3233cd8f.webp",
    "6CfMz": "windows-without-bluetooth-1-en.0ec24b9c.webp",
    "kmuN7": "windows-without-bluetooth-2-en.535e4640.webp",
    "fBB8w": "macos-without-bluetooth-1-de.208262c8.webp",
    "9auJa": "macos-without-bluetooth-2-de.9d28177f.webp",
    "7Tp3x": "macos-without-bluetooth-1-en.359255d7.webp",
    "2rbmG": "macos-without-bluetooth-2-en.8c7c82aa.webp",
    "e92hD": "macos-with-bluetooth-1-en.43536cd4.webp"
});

var $79c5e17b43bddc25$exports = {};
'use strict';

$79c5e17b43bddc25$exports = (parcelRequire("c985A"));


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $46wWE = parcelRequire("46wWE");

var $2jkQi = parcelRequire("2jkQi");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $9fdc5e205ef46e6a$var$_extends() {
    $9fdc5e205ef46e6a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9fdc5e205ef46e6a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $9fdc5e205ef46e6a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($9fdc5e205ef46e6a$export$e19cd5f9376f8cee || ($9fdc5e205ef46e6a$export$e19cd5f9376f8cee = {}));
const $9fdc5e205ef46e6a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $9fdc5e205ef46e6a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $9fdc5e205ef46e6a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $9fdc5e205ef46e6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $9fdc5e205ef46e6a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $9fdc5e205ef46e6a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $9fdc5e205ef46e6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $9fdc5e205ef46e6a$export$fe53371bee54353d(to);
    }
    return $9fdc5e205ef46e6a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $9fdc5e205ef46e6a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $9fdc5e205ef46e6a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $9fdc5e205ef46e6a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $9fdc5e205ef46e6a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $9fdc5e205ef46e6a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $9fdc5e205ef46e6a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $9fdc5e205ef46e6a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $9fdc5e205ef46e6a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $9fdc5e205ef46e6a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $9fdc5e205ef46e6a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $9fdc5e205ef46e6a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $9fdc5e205ef46e6a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $9fdc5e205ef46e6a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $9fdc5e205ef46e6a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($9fdc5e205ef46e6a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Push;
        let location = $9fdc5e205ef46e6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $9fdc5e205ef46e6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Replace;
        let location = $9fdc5e205ef46e6a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $9fdc5e205ef46e6a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $9fdc5e205ef46e6a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($9fdc5e205ef46e6a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($9fdc5e205ef46e6a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $9fdc5e205ef46e6a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($9fdc5e205ef46e6a$var$ResultType || ($9fdc5e205ef46e6a$var$ResultType = {}));
const $9fdc5e205ef46e6a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $9fdc5e205ef46e6a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $9fdc5e205ef46e6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($9fdc5e205ef46e6a$var$isIndexRoute(route)) {
            let indexRoute = $9fdc5e205ef46e6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $9fdc5e205ef46e6a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $9fdc5e205ef46e6a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $9fdc5e205ef46e6a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $9fdc5e205ef46e6a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $9fdc5e205ef46e6a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $9fdc5e205ef46e6a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $9fdc5e205ef46e6a$var$flattenRoutes(routes);
    $9fdc5e205ef46e6a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $9fdc5e205ef46e6a$export$30d21fd6d7295f52(pathname);
        matches = $9fdc5e205ef46e6a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $9fdc5e205ef46e6a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $9fdc5e205ef46e6a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $9fdc5e205ef46e6a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $9fdc5e205ef46e6a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $9fdc5e205ef46e6a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $9fdc5e205ef46e6a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $9fdc5e205ef46e6a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $9fdc5e205ef46e6a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $9fdc5e205ef46e6a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $9fdc5e205ef46e6a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $9fdc5e205ef46e6a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $9fdc5e205ef46e6a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $9fdc5e205ef46e6a$var$paramRe = /^:[\w-]+$/;
const $9fdc5e205ef46e6a$var$dynamicSegmentValue = 3;
const $9fdc5e205ef46e6a$var$indexRouteValue = 2;
const $9fdc5e205ef46e6a$var$emptySegmentValue = 1;
const $9fdc5e205ef46e6a$var$staticSegmentValue = 10;
const $9fdc5e205ef46e6a$var$splatPenalty = -2;
const $9fdc5e205ef46e6a$var$isSplat = (s)=>s === "*";
function $9fdc5e205ef46e6a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($9fdc5e205ef46e6a$var$isSplat)) initialScore += $9fdc5e205ef46e6a$var$splatPenalty;
    if (index) initialScore += $9fdc5e205ef46e6a$var$indexRouteValue;
    return segments.filter((s)=>!$9fdc5e205ef46e6a$var$isSplat(s)).reduce((score, segment)=>score + ($9fdc5e205ef46e6a$var$paramRe.test(segment) ? $9fdc5e205ef46e6a$var$dynamicSegmentValue : segment === "" ? $9fdc5e205ef46e6a$var$emptySegmentValue : $9fdc5e205ef46e6a$var$staticSegmentValue), initialScore);
}
function $9fdc5e205ef46e6a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $9fdc5e205ef46e6a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $9fdc5e205ef46e6a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $9fdc5e205ef46e6a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $9fdc5e205ef46e6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $9fdc5e205ef46e6a$export$a5c6d149b50c1d86($9fdc5e205ef46e6a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $9fdc5e205ef46e6a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $9fdc5e205ef46e6a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $9fdc5e205ef46e6a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $9fdc5e205ef46e6a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $9fdc5e205ef46e6a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $9fdc5e205ef46e6a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $9fdc5e205ef46e6a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $9fdc5e205ef46e6a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $9fdc5e205ef46e6a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $9fdc5e205ef46e6a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $9fdc5e205ef46e6a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $9fdc5e205ef46e6a$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $9fdc5e205ef46e6a$var$isAbsoluteUrl = (url)=>$9fdc5e205ef46e6a$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $9fdc5e205ef46e6a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($9fdc5e205ef46e6a$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $9fdc5e205ef46e6a$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $9fdc5e205ef46e6a$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $9fdc5e205ef46e6a$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $9fdc5e205ef46e6a$var$normalizeSearch(search),
        hash: $9fdc5e205ef46e6a$var$normalizeHash(hash)
    };
}
function $9fdc5e205ef46e6a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $9fdc5e205ef46e6a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $9fdc5e205ef46e6a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $9fdc5e205ef46e6a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $9fdc5e205ef46e6a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $9fdc5e205ef46e6a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $9fdc5e205ef46e6a$var$_extends({}, toArg);
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $9fdc5e205ef46e6a$var$getInvalidPathError("?", "pathname", "search", to));
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $9fdc5e205ef46e6a$var$getInvalidPathError("#", "pathname", "hash", to));
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $9fdc5e205ef46e6a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $9fdc5e205ef46e6a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $9fdc5e205ef46e6a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $9fdc5e205ef46e6a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $9fdc5e205ef46e6a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $9fdc5e205ef46e6a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $9fdc5e205ef46e6a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $9fdc5e205ef46e6a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $9fdc5e205ef46e6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $9fdc5e205ef46e6a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $9fdc5e205ef46e6a$export$4051a07651545597(data, init) {
    return new $9fdc5e205ef46e6a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $9fdc5e205ef46e6a$export$42a99a7a4bc0e76a extends Error {
}
class $9fdc5e205ef46e6a$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $9fdc5e205ef46e6a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $9fdc5e205ef46e6a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $9fdc5e205ef46e6a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $9fdc5e205ef46e6a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $9fdc5e205ef46e6a$var$unwrapTrackedPromise(value) {
    if (!$9fdc5e205ef46e6a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $9fdc5e205ef46e6a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $9fdc5e205ef46e6a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9fdc5e205ef46e6a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $9fdc5e205ef46e6a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9fdc5e205ef46e6a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $9fdc5e205ef46e6a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $9fdc5e205ef46e6a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $9fdc5e205ef46e6a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $9fdc5e205ef46e6a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $9fdc5e205ef46e6a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $9fdc5e205ef46e6a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $9fdc5e205ef46e6a$var$validMutationMethods = new Set($9fdc5e205ef46e6a$var$validMutationMethodsArr);
const $9fdc5e205ef46e6a$var$validRequestMethodsArr = [
    "get",
    ...$9fdc5e205ef46e6a$var$validMutationMethodsArr
];
const $9fdc5e205ef46e6a$var$validRequestMethods = new Set($9fdc5e205ef46e6a$var$validRequestMethodsArr);
const $9fdc5e205ef46e6a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $9fdc5e205ef46e6a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $9fdc5e205ef46e6a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $9fdc5e205ef46e6a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $9fdc5e205ef46e6a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $9fdc5e205ef46e6a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $9fdc5e205ef46e6a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $9fdc5e205ef46e6a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $9fdc5e205ef46e6a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $9fdc5e205ef46e6a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $9fdc5e205ef46e6a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $9fdc5e205ef46e6a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $9fdc5e205ef46e6a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $9fdc5e205ef46e6a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $9fdc5e205ef46e6a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $9fdc5e205ef46e6a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$9fdc5e205ef46e6a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$9fdc5e205ef46e6a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $9fdc5e205ef46e6a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $9fdc5e205ef46e6a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $9fdc5e205ef46e6a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $9fdc5e205ef46e6a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$9fdc5e205ef46e6a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $9fdc5e205ef46e6a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $9fdc5e205ef46e6a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $9fdc5e205ef46e6a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $9fdc5e205ef46e6a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $9fdc5e205ef46e6a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($9fdc5e205ef46e6a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $9fdc5e205ef46e6a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $9fdc5e205ef46e6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $9fdc5e205ef46e6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $9fdc5e205ef46e6a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $9fdc5e205ef46e6a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $9fdc5e205ef46e6a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $9fdc5e205ef46e6a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $9fdc5e205ef46e6a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $9fdc5e205ef46e6a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $9fdc5e205ef46e6a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $9fdc5e205ef46e6a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $9fdc5e205ef46e6a$var$findNearestBoundary(matches).route.id,
            {
                type: $9fdc5e205ef46e6a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $9fdc5e205ef46e6a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($9fdc5e205ef46e6a$var$isErrorResult(result) && $9fdc5e205ef46e6a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $9fdc5e205ef46e6a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $9fdc5e205ef46e6a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $9fdc5e205ef46e6a$var$_extends({
            matches: updatedMatches || matches
        }, $9fdc5e205ef46e6a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $9fdc5e205ef46e6a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $9fdc5e205ef46e6a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $9fdc5e205ef46e6a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $9fdc5e205ef46e6a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $9fdc5e205ef46e6a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $9fdc5e205ef46e6a$var$ResultType.error,
            error: $9fdc5e205ef46e6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($9fdc5e205ef46e6a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $9fdc5e205ef46e6a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($9fdc5e205ef46e6a$var$isDeferredResult(result)) throw $9fdc5e205ef46e6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($9fdc5e205ef46e6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $9fdc5e205ef46e6a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $9fdc5e205ef46e6a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $9fdc5e205ef46e6a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($9fdc5e205ef46e6a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $9fdc5e205ef46e6a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $9fdc5e205ef46e6a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $9fdc5e205ef46e6a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $9fdc5e205ef46e6a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $9fdc5e205ef46e6a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $9fdc5e205ef46e6a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $9fdc5e205ef46e6a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $9fdc5e205ef46e6a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $9fdc5e205ef46e6a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $9fdc5e205ef46e6a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $9fdc5e205ef46e6a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $9fdc5e205ef46e6a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $9fdc5e205ef46e6a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $9fdc5e205ef46e6a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $9fdc5e205ef46e6a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $9fdc5e205ef46e6a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9fdc5e205ef46e6a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9fdc5e205ef46e6a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $9fdc5e205ef46e6a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($9fdc5e205ef46e6a$var$isRedirectResult(actionResult) || $9fdc5e205ef46e6a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $9fdc5e205ef46e6a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($9fdc5e205ef46e6a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $9fdc5e205ef46e6a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $9fdc5e205ef46e6a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($9fdc5e205ef46e6a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($9fdc5e205ef46e6a$var$isDeferredResult(actionResult)) throw $9fdc5e205ef46e6a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $9fdc5e205ef46e6a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $9fdc5e205ef46e6a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $9fdc5e205ef46e6a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $9fdc5e205ef46e6a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $9fdc5e205ef46e6a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $9fdc5e205ef46e6a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $9fdc5e205ef46e6a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $9fdc5e205ef46e6a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $9fdc5e205ef46e6a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $9fdc5e205ef46e6a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $9fdc5e205ef46e6a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9fdc5e205ef46e6a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9fdc5e205ef46e6a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $9fdc5e205ef46e6a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($9fdc5e205ef46e6a$var$isDeferredResult(result)) result = await $9fdc5e205ef46e6a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $9fdc5e205ef46e6a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($9fdc5e205ef46e6a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $9fdc5e205ef46e6a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($9fdc5e205ef46e6a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(!$9fdc5e205ef46e6a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $9fdc5e205ef46e6a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $9fdc5e205ef46e6a$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $9fdc5e205ef46e6a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($9fdc5e205ef46e6a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $9fdc5e205ef46e6a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Replace : $9fdc5e205ef46e6a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $9fdc5e205ef46e6a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($9fdc5e205ef46e6a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $9fdc5e205ef46e6a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $9fdc5e205ef46e6a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $9fdc5e205ef46e6a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $9fdc5e205ef46e6a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $9fdc5e205ef46e6a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($9fdc5e205ef46e6a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $9fdc5e205ef46e6a$var$ResultType.redirect,
                response: $9fdc5e205ef46e6a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $9fdc5e205ef46e6a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $9fdc5e205ef46e6a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $9fdc5e205ef46e6a$var$ResultType.error,
                    error: $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $9fdc5e205ef46e6a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $9fdc5e205ef46e6a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $9fdc5e205ef46e6a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $9fdc5e205ef46e6a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $9fdc5e205ef46e6a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $9fdc5e205ef46e6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $9fdc5e205ef46e6a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $9fdc5e205ef46e6a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $9fdc5e205ef46e6a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $9fdc5e205ef46e6a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $9fdc5e205ef46e6a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $9fdc5e205ef46e6a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$9fdc5e205ef46e6a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $9fdc5e205ef46e6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $9fdc5e205ef46e6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $9fdc5e205ef46e6a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $9fdc5e205ef46e6a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $9fdc5e205ef46e6a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $9fdc5e205ef46e6a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $9fdc5e205ef46e6a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $9fdc5e205ef46e6a$export$4d0306f8f6a4585b = Symbol("deferred");
function $9fdc5e205ef46e6a$export$3336b097a6fbc59a(routes, opts) {
    $9fdc5e205ef46e6a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $9fdc5e205ef46e6a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $9fdc5e205ef46e6a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $9fdc5e205ef46e6a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $9fdc5e205ef46e6a$var$createLocation("", $9fdc5e205ef46e6a$export$fe53371bee54353d(url), null, "default");
        let matches = $9fdc5e205ef46e6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$9fdc5e205ef46e6a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $9fdc5e205ef46e6a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $9fdc5e205ef46e6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $9fdc5e205ef46e6a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($9fdc5e205ef46e6a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $9fdc5e205ef46e6a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $9fdc5e205ef46e6a$var$createLocation("", $9fdc5e205ef46e6a$export$fe53371bee54353d(url), null, "default");
        let matches = $9fdc5e205ef46e6a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$9fdc5e205ef46e6a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $9fdc5e205ef46e6a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $9fdc5e205ef46e6a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $9fdc5e205ef46e6a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($9fdc5e205ef46e6a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$9fdc5e205ef46e6a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($9fdc5e205ef46e6a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $9fdc5e205ef46e6a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $9fdc5e205ef46e6a$var$isResponse(result) ? result : $9fdc5e205ef46e6a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($9fdc5e205ef46e6a$var$isDataStrategyResult(e) && $9fdc5e205ef46e6a$var$isResponse(e.result)) {
                if (e.type === $9fdc5e205ef46e6a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($9fdc5e205ef46e6a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $9fdc5e205ef46e6a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $9fdc5e205ef46e6a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $9fdc5e205ef46e6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($9fdc5e205ef46e6a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($9fdc5e205ef46e6a$var$isDeferredResult(result)) {
            let error = $9fdc5e205ef46e6a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $9fdc5e205ef46e6a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($9fdc5e205ef46e6a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($9fdc5e205ef46e6a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $9fdc5e205ef46e6a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $9fdc5e205ef46e6a$var$_extends({}, context, {
                statusCode: $9fdc5e205ef46e6a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $9fdc5e205ef46e6a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $9fdc5e205ef46e6a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $9fdc5e205ef46e6a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1]) ? $9fdc5e205ef46e6a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $9fdc5e205ef46e6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $9fdc5e205ef46e6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $9fdc5e205ef46e6a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $9fdc5e205ef46e6a$var$callDataStrategyImpl(dataStrategy || $9fdc5e205ef46e6a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($9fdc5e205ef46e6a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $9fdc5e205ef46e6a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($9fdc5e205ef46e6a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $9fdc5e205ef46e6a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $9fdc5e205ef46e6a$export$fec11da027c70692(routes, context, error) {
    let newContext = $9fdc5e205ef46e6a$var$_extends({}, context, {
        statusCode: $9fdc5e205ef46e6a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $9fdc5e205ef46e6a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $9fdc5e205ef46e6a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $9fdc5e205ef46e6a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $9fdc5e205ef46e6a$export$cae722b0cc860f13(to ? to : ".", $9fdc5e205ef46e6a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $9fdc5e205ef46e6a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $9fdc5e205ef46e6a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $9fdc5e205ef46e6a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $9fdc5e205ef46e6a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $9fdc5e205ef46e6a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$9fdc5e205ef46e6a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$9fdc5e205ef46e6a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $9fdc5e205ef46e6a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $9fdc5e205ef46e6a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $9fdc5e205ef46e6a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$9fdc5e205ef46e6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$9fdc5e205ef46e6a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $9fdc5e205ef46e6a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $9fdc5e205ef46e6a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $9fdc5e205ef46e6a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $9fdc5e205ef46e6a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $9fdc5e205ef46e6a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($9fdc5e205ef46e6a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $9fdc5e205ef46e6a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $9fdc5e205ef46e6a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $9fdc5e205ef46e6a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $9fdc5e205ef46e6a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $9fdc5e205ef46e6a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $9fdc5e205ef46e6a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $9fdc5e205ef46e6a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($9fdc5e205ef46e6a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $9fdc5e205ef46e6a$var$shouldRevalidateLoader(match, $9fdc5e205ef46e6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $9fdc5e205ef46e6a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $9fdc5e205ef46e6a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $9fdc5e205ef46e6a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $9fdc5e205ef46e6a$var$shouldRevalidateLoader(fetcherMatch, $9fdc5e205ef46e6a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $9fdc5e205ef46e6a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $9fdc5e205ef46e6a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $9fdc5e205ef46e6a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $9fdc5e205ef46e6a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $9fdc5e205ef46e6a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$9fdc5e205ef46e6a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $9fdc5e205ef46e6a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $9fdc5e205ef46e6a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$9fdc5e205ef46e6a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $9fdc5e205ef46e6a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $9fdc5e205ef46e6a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $9fdc5e205ef46e6a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$9fdc5e205ef46e6a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $9fdc5e205ef46e6a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $9fdc5e205ef46e6a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $9fdc5e205ef46e6a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $9fdc5e205ef46e6a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $9fdc5e205ef46e6a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $9fdc5e205ef46e6a$var$ResultType.data,
                result: undefined
            });
        };
        return $9fdc5e205ef46e6a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $9fdc5e205ef46e6a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $9fdc5e205ef46e6a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $9fdc5e205ef46e6a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $9fdc5e205ef46e6a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $9fdc5e205ef46e6a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $9fdc5e205ef46e6a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($9fdc5e205ef46e6a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $9fdc5e205ef46e6a$var$ResultType.error,
                error: e
            };
        }
        if (type === $9fdc5e205ef46e6a$var$ResultType.error) return {
            type: $9fdc5e205ef46e6a$var$ResultType.error,
            error: new $9fdc5e205ef46e6a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $9fdc5e205ef46e6a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $9fdc5e205ef46e6a$var$ResultType.error) {
        if ($9fdc5e205ef46e6a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $9fdc5e205ef46e6a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $9fdc5e205ef46e6a$var$ResultType.error,
                error: new $9fdc5e205ef46e6a$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $9fdc5e205ef46e6a$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $9fdc5e205ef46e6a$var$ResultType.error,
            error: result,
            statusCode: $9fdc5e205ef46e6a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($9fdc5e205ef46e6a$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $9fdc5e205ef46e6a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($9fdc5e205ef46e6a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $9fdc5e205ef46e6a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $9fdc5e205ef46e6a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $9fdc5e205ef46e6a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $9fdc5e205ef46e6a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$9fdc5e205ef46e6a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $9fdc5e205ef46e6a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $9fdc5e205ef46e6a$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($9fdc5e205ef46e6a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $9fdc5e205ef46e6a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $9fdc5e205ef46e6a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($9fdc5e205ef46e6a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $9fdc5e205ef46e6a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $9fdc5e205ef46e6a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $9fdc5e205ef46e6a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $9fdc5e205ef46e6a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $9fdc5e205ef46e6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(!$9fdc5e205ef46e6a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($9fdc5e205ef46e6a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $9fdc5e205ef46e6a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $9fdc5e205ef46e6a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($9fdc5e205ef46e6a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $9fdc5e205ef46e6a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $9fdc5e205ef46e6a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($9fdc5e205ef46e6a$var$isErrorResult(result)) {
            let boundaryMatch = $9fdc5e205ef46e6a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $9fdc5e205ef46e6a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($9fdc5e205ef46e6a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($9fdc5e205ef46e6a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $9fdc5e205ef46e6a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $9fdc5e205ef46e6a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $9fdc5e205ef46e6a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $9fdc5e205ef46e6a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $9fdc5e205ef46e6a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $9fdc5e205ef46e6a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $9fdc5e205ef46e6a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $9fdc5e205ef46e6a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $9fdc5e205ef46e6a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $9fdc5e205ef46e6a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $9fdc5e205ef46e6a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($9fdc5e205ef46e6a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $9fdc5e205ef46e6a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(path) : path;
    return $9fdc5e205ef46e6a$export$fe53371bee54353d($9fdc5e205ef46e6a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $9fdc5e205ef46e6a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $9fdc5e205ef46e6a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $9fdc5e205ef46e6a$var$ResultType.data || result.type === $9fdc5e205ef46e6a$var$ResultType.error);
}
function $9fdc5e205ef46e6a$var$isRedirectDataStrategyResultResult(result) {
    return $9fdc5e205ef46e6a$var$isResponse(result.result) && $9fdc5e205ef46e6a$var$redirectStatusCodes.has(result.result.status);
}
function $9fdc5e205ef46e6a$var$isDeferredResult(result) {
    return result.type === $9fdc5e205ef46e6a$var$ResultType.deferred;
}
function $9fdc5e205ef46e6a$var$isErrorResult(result) {
    return result.type === $9fdc5e205ef46e6a$var$ResultType.error;
}
function $9fdc5e205ef46e6a$var$isRedirectResult(result) {
    return (result && result.type) === $9fdc5e205ef46e6a$var$ResultType.redirect;
}
function $9fdc5e205ef46e6a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $9fdc5e205ef46e6a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $9fdc5e205ef46e6a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $9fdc5e205ef46e6a$var$isRedirectResponse(result) {
    if (!$9fdc5e205ef46e6a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $9fdc5e205ef46e6a$var$isValidMethod(method) {
    return $9fdc5e205ef46e6a$var$validRequestMethods.has(method.toLowerCase());
}
function $9fdc5e205ef46e6a$var$isMutationMethod(method) {
    return $9fdc5e205ef46e6a$var$validMutationMethods.has(method.toLowerCase());
}
async function $9fdc5e205ef46e6a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$9fdc5e205ef46e6a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($9fdc5e205ef46e6a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $9fdc5e205ef46e6a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $9fdc5e205ef46e6a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($9fdc5e205ef46e6a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $9fdc5e205ef46e6a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $9fdc5e205ef46e6a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $9fdc5e205ef46e6a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $9fdc5e205ef46e6a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $9fdc5e205ef46e6a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $9fdc5e205ef46e6a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $9fdc5e205ef46e6a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $9fdc5e205ef46e6a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $9fdc5e205ef46e6a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $9fdc5e205ef46e6a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $9fdc5e205ef46e6a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $9fdc5e205ef46e6a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $9fdc5e205ef46e6a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $9fdc5e205ef46e6a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $9fdc5e205ef46e6a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $9fdc5e205ef46e6a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $9fdc5e205ef46e6a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $9fdc5e205ef46e6a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($9fdc5e205ef46e6a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $9fdc5e205ef46e6a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($9fdc5e205ef46e6a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $9fdc5e205ef46e6a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $46wWE = parcelRequire("46wWE");

function $9db2e3ca9c00f750$var$_extends() {
    $9db2e3ca9c00f750$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9db2e3ca9c00f750$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $9db2e3ca9c00f750$export$3add0d5dce533e2e = /*#__PURE__*/ $46wWE.createContext(null);
const $9db2e3ca9c00f750$export$145dfa71566a64dc = /*#__PURE__*/ $46wWE.createContext(null);
const $9db2e3ca9c00f750$var$AwaitContext = /*#__PURE__*/ $46wWE.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $9db2e3ca9c00f750$export$26749e8557646306 = /*#__PURE__*/ $46wWE.createContext(null);
const $9db2e3ca9c00f750$export$c7914228fb69b0f5 = /*#__PURE__*/ $46wWE.createContext(null);
const $9db2e3ca9c00f750$export$9072aa6dd1f93057 = /*#__PURE__*/ $46wWE.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $9db2e3ca9c00f750$var$RouteErrorContext = /*#__PURE__*/ $46wWE.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $9db2e3ca9c00f750$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$9db2e3ca9c00f750$export$9c954a9d03d32f4a() && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $46wWE.useContext($9db2e3ca9c00f750$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $9db2e3ca9c00f750$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $9fdc5e205ef46e6a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $9db2e3ca9c00f750$export$9c954a9d03d32f4a() {
    return $46wWE.useContext($9db2e3ca9c00f750$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $9db2e3ca9c00f750$export$45d76561a5302f2b() {
    !$9db2e3ca9c00f750$export$9c954a9d03d32f4a() && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    return $46wWE.useContext($9db2e3ca9c00f750$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $9db2e3ca9c00f750$export$1b3f31771c5d07c() {
    return $46wWE.useContext($9db2e3ca9c00f750$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $9db2e3ca9c00f750$export$6c330e8992e8a295(pattern) {
    !$9db2e3ca9c00f750$export$9c954a9d03d32f4a() && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $9db2e3ca9c00f750$export$45d76561a5302f2b();
    return $46wWE.useMemo(()=>(0, $9fdc5e205ef46e6a$export$81336c211d5ff295)(pattern, (0, $9fdc5e205ef46e6a$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $9db2e3ca9c00f750$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9db2e3ca9c00f750$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $46wWE.useContext($9db2e3ca9c00f750$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $46wWE.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $9db2e3ca9c00f750$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9db2e3ca9c00f750$var$useNavigateStable() : $9db2e3ca9c00f750$var$useNavigateUnstable();
}
function $9db2e3ca9c00f750$var$useNavigateUnstable() {
    !$9db2e3ca9c00f750$export$9c954a9d03d32f4a() && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $46wWE.useContext($9db2e3ca9c00f750$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $46wWE.useContext($9db2e3ca9c00f750$export$26749e8557646306);
    let { matches: matches } = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9db2e3ca9c00f750$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9fdc5e205ef46e6a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $46wWE.useRef(false);
    $9db2e3ca9c00f750$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $46wWE.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $9fdc5e205ef46e6a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9fdc5e205ef46e6a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $9db2e3ca9c00f750$var$OutletContext = /*#__PURE__*/ $46wWE.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $9db2e3ca9c00f750$export$4138103a3ae699cc() {
    return $46wWE.useContext($9db2e3ca9c00f750$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $9db2e3ca9c00f750$export$a3be3530d8e40d0b(context) {
    let outlet = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $9db2e3ca9c00f750$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $9db2e3ca9c00f750$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $46wWE.useContext($9db2e3ca9c00f750$export$26749e8557646306);
    let { matches: matches } = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9db2e3ca9c00f750$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9fdc5e205ef46e6a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $46wWE.useMemo(()=>(0, $9fdc5e205ef46e6a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $9db2e3ca9c00f750$export$5d3fca4a98652595(routes, locationArg) {
    return $9db2e3ca9c00f750$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9db2e3ca9c00f750$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9db2e3ca9c00f750$export$9c954a9d03d32f4a() && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $46wWE.useContext($9db2e3ca9c00f750$export$26749e8557646306);
    let { matches: parentMatches } = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $9db2e3ca9c00f750$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $9fdc5e205ef46e6a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $9fdc5e205ef46e6a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $9db2e3ca9c00f750$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $9fdc5e205ef46e6a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $9fdc5e205ef46e6a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9db2e3ca9c00f750$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $9fdc5e205ef46e6a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9db2e3ca9c00f750$var$DefaultErrorComponent() {
    let error = $9db2e3ca9c00f750$export$ed527bf60f6e05f2();
    let message = (0, $9fdc5e205ef46e6a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $46wWE.createElement($46wWE.Fragment, null, /*#__PURE__*/ $46wWE.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $46wWE.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $46wWE.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $9db2e3ca9c00f750$var$defaultErrorElement = /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$DefaultErrorComponent, null);
class $9db2e3ca9c00f750$var$RenderErrorBoundary extends $46wWE.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $9db2e3ca9c00f750$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $46wWE.useContext($9db2e3ca9c00f750$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9db2e3ca9c00f750$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9db2e3ca9c00f750$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9db2e3ca9c00f750$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $46wWE.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9db2e3ca9c00f750$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9db2e3ca9c00f750$var$DataRouterHook || {});
var $9db2e3ca9c00f750$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9db2e3ca9c00f750$var$DataRouterStateHook || {});
function $9db2e3ca9c00f750$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $9db2e3ca9c00f750$var$useDataRouterContext(hookName) {
    let ctx = $46wWE.useContext($9db2e3ca9c00f750$export$3add0d5dce533e2e);
    !ctx && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $9db2e3ca9c00f750$var$useDataRouterState(hookName) {
    let state = $46wWE.useContext($9db2e3ca9c00f750$export$145dfa71566a64dc);
    !state && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    return state;
}
function $9db2e3ca9c00f750$var$useRouteContext(hookName) {
    let route = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057);
    !route && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9db2e3ca9c00f750$var$useCurrentRouteId(hookName) {
    let route = $9db2e3ca9c00f750$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9db2e3ca9c00f750$export$5fc8298006ad9e58() {
    return $9db2e3ca9c00f750$var$useCurrentRouteId($9db2e3ca9c00f750$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9db2e3ca9c00f750$export$d0fd4b7106de2769() {
    let state = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9db2e3ca9c00f750$export$600dc272ed516c15() {
    let dataRouterContext = $9db2e3ca9c00f750$var$useDataRouterContext($9db2e3ca9c00f750$var$DataRouterHook.UseRevalidator);
    let state = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseRevalidator);
    return $46wWE.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9db2e3ca9c00f750$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseMatches);
    return $46wWE.useMemo(()=>matches.map((m)=>(0, $9fdc5e205ef46e6a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9db2e3ca9c00f750$export$1448a5050d252c4d() {
    let state = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseLoaderData);
    let routeId = $9db2e3ca9c00f750$var$useCurrentRouteId($9db2e3ca9c00f750$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9db2e3ca9c00f750$export$fd5d37484eab868d(routeId) {
    let state = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9db2e3ca9c00f750$export$fdc00f3f26066d5e() {
    let state = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseActionData);
    let routeId = $9db2e3ca9c00f750$var$useCurrentRouteId($9db2e3ca9c00f750$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9db2e3ca9c00f750$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $46wWE.useContext($9db2e3ca9c00f750$var$RouteErrorContext);
    let state = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseRouteError);
    let routeId = $9db2e3ca9c00f750$var$useCurrentRouteId($9db2e3ca9c00f750$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9db2e3ca9c00f750$export$78a72ddb39bdd145() {
    let value = $46wWE.useContext($9db2e3ca9c00f750$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9db2e3ca9c00f750$export$17f53340677d5831() {
    let value = $46wWE.useContext($9db2e3ca9c00f750$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $9db2e3ca9c00f750$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9db2e3ca9c00f750$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $9db2e3ca9c00f750$var$useDataRouterContext($9db2e3ca9c00f750$var$DataRouterHook.UseBlocker);
    let state = $9db2e3ca9c00f750$var$useDataRouterState($9db2e3ca9c00f750$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $46wWE.useState("");
    let blockerFunction = $46wWE.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $9db2e3ca9c00f750$var$_extends({}, currentLocation, {
                pathname: (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9db2e3ca9c00f750$var$_extends({}, nextLocation, {
                pathname: (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $46wWE.useEffect(()=>{
        let key = String(++$9db2e3ca9c00f750$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $46wWE.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $9fdc5e205ef46e6a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9db2e3ca9c00f750$var$useNavigateStable() {
    let { router: router } = $9db2e3ca9c00f750$var$useDataRouterContext($9db2e3ca9c00f750$var$DataRouterHook.UseNavigateStable);
    let id = $9db2e3ca9c00f750$var$useCurrentRouteId($9db2e3ca9c00f750$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $46wWE.useRef(false);
    $9db2e3ca9c00f750$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $46wWE.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9db2e3ca9c00f750$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $9db2e3ca9c00f750$var$alreadyWarned$1 = {};
function $9db2e3ca9c00f750$var$warningOnce(key, cond, message) {
    if (!cond && !$9db2e3ca9c00f750$var$alreadyWarned$1[key]) $9db2e3ca9c00f750$var$alreadyWarned$1[key] = true;
}
const $9db2e3ca9c00f750$var$alreadyWarned = {};
function $9db2e3ca9c00f750$var$warnOnce(key, message) {}
const $9db2e3ca9c00f750$var$logDeprecation = (flag, msg, link)=>$9db2e3ca9c00f750$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $9db2e3ca9c00f750$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $9db2e3ca9c00f750$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $9db2e3ca9c00f750$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $9db2e3ca9c00f750$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $9db2e3ca9c00f750$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $9db2e3ca9c00f750$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $9db2e3ca9c00f750$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $9db2e3ca9c00f750$var$START_TRANSITION = "startTransition";
const $9db2e3ca9c00f750$var$startTransitionImpl = $46wWE[$9db2e3ca9c00f750$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9db2e3ca9c00f750$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $46wWE.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $46wWE.useCallback((newState)=>{
        if (v7_startTransition && $9db2e3ca9c00f750$var$startTransitionImpl) $9db2e3ca9c00f750$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $46wWE.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $46wWE.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $46wWE.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $46wWE.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $46wWE.useEffect(()=>$9db2e3ca9c00f750$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $46wWE.createElement($46wWE.Fragment, null, /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9db2e3ca9c00f750$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $9db2e3ca9c00f750$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $9db2e3ca9c00f750$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $46wWE.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9fdc5e205ef46e6a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $46wWE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $46wWE.useCallback((newState)=>{
        v7_startTransition && $9db2e3ca9c00f750$var$startTransitionImpl ? $9db2e3ca9c00f750$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $46wWE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $46wWE.useEffect(()=>$9db2e3ca9c00f750$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $9db2e3ca9c00f750$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$9db2e3ca9c00f750$export$9c954a9d03d32f4a() && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $46wWE.useContext($9db2e3ca9c00f750$export$26749e8557646306);
    let { matches: matches } = $46wWE.useContext($9db2e3ca9c00f750$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9db2e3ca9c00f750$export$45d76561a5302f2b();
    let navigate = $9db2e3ca9c00f750$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $9fdc5e205ef46e6a$export$cae722b0cc860f13)(to, (0, $9fdc5e205ef46e6a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $46wWE.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $9db2e3ca9c00f750$export$910ae8079b2c2852(props) {
    return $9db2e3ca9c00f750$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $9db2e3ca9c00f750$export$e7b0ac011bb776c6(_props) {
    (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $9db2e3ca9c00f750$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $9fdc5e205ef46e6a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$9db2e3ca9c00f750$export$9c954a9d03d32f4a() && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $46wWE.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9db2e3ca9c00f750$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $9fdc5e205ef46e6a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $46wWE.useMemo(()=>{
        let trailingPathname = (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $9db2e3ca9c00f750$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $9db2e3ca9c00f750$export$5d3fca4a98652595($9db2e3ca9c00f750$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9db2e3ca9c00f750$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$ResolveAwait, null, children));
}
var $9db2e3ca9c00f750$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9db2e3ca9c00f750$var$AwaitRenderStatus || {});
const $9db2e3ca9c00f750$var$neverSettledPromise = new Promise(()=>{});
class $9db2e3ca9c00f750$var$AwaitErrorBoundary extends $46wWE.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $9db2e3ca9c00f750$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $9db2e3ca9c00f750$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $9db2e3ca9c00f750$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $9db2e3ca9c00f750$var$AwaitRenderStatus.error : "_data" in promise ? $9db2e3ca9c00f750$var$AwaitRenderStatus.success : $9db2e3ca9c00f750$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $9db2e3ca9c00f750$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $9db2e3ca9c00f750$var$AwaitRenderStatus.error && promise._error instanceof (0, $9fdc5e205ef46e6a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $9db2e3ca9c00f750$var$neverSettledPromise;
        if (status === $9db2e3ca9c00f750$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $9db2e3ca9c00f750$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $9db2e3ca9c00f750$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $46wWE.createElement($9db2e3ca9c00f750$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9db2e3ca9c00f750$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $9db2e3ca9c00f750$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $46wWE.createElement($46wWE.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $9db2e3ca9c00f750$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $46wWE.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $46wWE.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $46wWE.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9db2e3ca9c00f750$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9db2e3ca9c00f750$export$e7b0ac011bb776c6) && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9db2e3ca9c00f750$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9db2e3ca9c00f750$export$daf73786167a7f72(matches) {
    return $9db2e3ca9c00f750$var$_renderMatches(matches);
}
function $9db2e3ca9c00f750$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $46wWE.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $46wWE.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $46wWE.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9db2e3ca9c00f750$export$f30f7e456d254e83(routes, opts) {
    return (0, $9fdc5e205ef46e6a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9db2e3ca9c00f750$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9fdc5e205ef46e6a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9db2e3ca9c00f750$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $de85a50705c2b3be$var$_extends() {
    $de85a50705c2b3be$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de85a50705c2b3be$var$_extends.apply(this, arguments);
}
function $de85a50705c2b3be$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $de85a50705c2b3be$var$defaultMethod = "get";
const $de85a50705c2b3be$var$defaultEncType = "application/x-www-form-urlencoded";
function $de85a50705c2b3be$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $de85a50705c2b3be$var$isButtonElement(object) {
    return $de85a50705c2b3be$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $de85a50705c2b3be$var$isFormElement(object) {
    return $de85a50705c2b3be$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $de85a50705c2b3be$var$isInputElement(object) {
    return $de85a50705c2b3be$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $de85a50705c2b3be$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $de85a50705c2b3be$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$de85a50705c2b3be$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $de85a50705c2b3be$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $de85a50705c2b3be$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $de85a50705c2b3be$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $de85a50705c2b3be$var$_formDataSupportsSubmitter = null;
function $de85a50705c2b3be$var$isFormDataSubmitterSupported() {
    if ($de85a50705c2b3be$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $de85a50705c2b3be$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $de85a50705c2b3be$var$_formDataSupportsSubmitter = true;
    }
    return $de85a50705c2b3be$var$_formDataSupportsSubmitter;
}
const $de85a50705c2b3be$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $de85a50705c2b3be$var$getFormEncType(encType) {
    if (encType != null && !$de85a50705c2b3be$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $de85a50705c2b3be$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($de85a50705c2b3be$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $de85a50705c2b3be$var$defaultMethod;
        encType = $de85a50705c2b3be$var$getFormEncType(target.getAttribute("enctype")) || $de85a50705c2b3be$var$defaultEncType;
        formData = new FormData(target);
    } else if ($de85a50705c2b3be$var$isButtonElement(target) || $de85a50705c2b3be$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $de85a50705c2b3be$var$defaultMethod;
        encType = $de85a50705c2b3be$var$getFormEncType(target.getAttribute("formenctype")) || $de85a50705c2b3be$var$getFormEncType(form.getAttribute("enctype")) || $de85a50705c2b3be$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$de85a50705c2b3be$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($de85a50705c2b3be$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $de85a50705c2b3be$var$defaultMethod;
        action = null;
        encType = $de85a50705c2b3be$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $de85a50705c2b3be$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $de85a50705c2b3be$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $de85a50705c2b3be$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $de85a50705c2b3be$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $de85a50705c2b3be$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $de85a50705c2b3be$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9fdc5e205ef46e6a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $de85a50705c2b3be$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9fdc5e205ef46e6a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $de85a50705c2b3be$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9db2e3ca9c00f750$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $de85a50705c2b3be$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9fdc5e205ef46e6a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $de85a50705c2b3be$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9fdc5e205ef46e6a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $de85a50705c2b3be$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9db2e3ca9c00f750$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $de85a50705c2b3be$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $de85a50705c2b3be$var$_extends({}, state, {
        errors: $de85a50705c2b3be$var$deserializeErrors(state.errors)
    });
    return state;
}
function $de85a50705c2b3be$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $9fdc5e205ef46e6a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $de85a50705c2b3be$export$7ad602f0e94e62d1 = /*#__PURE__*/ $46wWE.createContext({
    isTransitioning: false
});
const $de85a50705c2b3be$export$148fd98d095596d4 = /*#__PURE__*/ $46wWE.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $de85a50705c2b3be$var$START_TRANSITION = "startTransition";
const $de85a50705c2b3be$var$startTransitionImpl = $46wWE[$de85a50705c2b3be$var$START_TRANSITION];
const $de85a50705c2b3be$var$FLUSH_SYNC = "flushSync";
const $de85a50705c2b3be$var$flushSyncImpl = $2jkQi[$de85a50705c2b3be$var$FLUSH_SYNC];
const $de85a50705c2b3be$var$USE_ID = "useId";
const $de85a50705c2b3be$var$useIdImpl = $46wWE[$de85a50705c2b3be$var$USE_ID];
function $de85a50705c2b3be$var$startTransitionSafe(cb) {
    if ($de85a50705c2b3be$var$startTransitionImpl) $de85a50705c2b3be$var$startTransitionImpl(cb);
    else cb();
}
function $de85a50705c2b3be$var$flushSyncSafe(cb) {
    if ($de85a50705c2b3be$var$flushSyncImpl) $de85a50705c2b3be$var$flushSyncImpl(cb);
    else cb();
}
class $de85a50705c2b3be$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $de85a50705c2b3be$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $46wWE.useState(router.state);
    let [pendingState, setPendingState] = $46wWE.useState();
    let [vtContext, setVtContext] = $46wWE.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $46wWE.useState();
    let [transition, setTransition] = $46wWE.useState();
    let [interruption, setInterruption] = $46wWE.useState();
    let fetcherData = $46wWE.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $46wWE.useCallback((cb)=>{
        if (v7_startTransition) $de85a50705c2b3be$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $46wWE.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $de85a50705c2b3be$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $de85a50705c2b3be$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $de85a50705c2b3be$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $de85a50705c2b3be$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $de85a50705c2b3be$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $46wWE.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $46wWE.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $de85a50705c2b3be$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $46wWE.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $46wWE.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $46wWE.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $46wWE.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $46wWE.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $46wWE.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $46wWE.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $46wWE.useEffect(()=>(0, $9db2e3ca9c00f750$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $46wWE.createElement($46wWE.Fragment, null, /*#__PURE__*/ $46wWE.createElement((0, $9db2e3ca9c00f750$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $46wWE.createElement((0, $9db2e3ca9c00f750$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $46wWE.createElement($de85a50705c2b3be$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $46wWE.createElement($de85a50705c2b3be$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $46wWE.createElement((0, $9db2e3ca9c00f750$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $46wWE.createElement($de85a50705c2b3be$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $de85a50705c2b3be$var$MemoizedDataRoutes = /*#__PURE__*/ $46wWE.memo($de85a50705c2b3be$var$DataRoutes);
function $de85a50705c2b3be$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $9db2e3ca9c00f750$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $de85a50705c2b3be$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $46wWE.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9fdc5e205ef46e6a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $46wWE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $46wWE.useCallback((newState)=>{
        v7_startTransition && $de85a50705c2b3be$var$startTransitionImpl ? $de85a50705c2b3be$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $46wWE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $46wWE.useEffect(()=>(0, $9db2e3ca9c00f750$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $46wWE.createElement((0, $9db2e3ca9c00f750$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $de85a50705c2b3be$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $46wWE.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9fdc5e205ef46e6a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $46wWE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $46wWE.useCallback((newState)=>{
        v7_startTransition && $de85a50705c2b3be$var$startTransitionImpl ? $de85a50705c2b3be$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $46wWE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $46wWE.useEffect(()=>(0, $9db2e3ca9c00f750$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $46wWE.createElement((0, $9db2e3ca9c00f750$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $de85a50705c2b3be$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $46wWE.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $46wWE.useCallback((newState)=>{
        v7_startTransition && $de85a50705c2b3be$var$startTransitionImpl ? $de85a50705c2b3be$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $46wWE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $46wWE.useEffect(()=>(0, $9db2e3ca9c00f750$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $46wWE.createElement((0, $9db2e3ca9c00f750$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $de85a50705c2b3be$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $de85a50705c2b3be$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $de85a50705c2b3be$export$a6c7ac8248d6e38a = /*#__PURE__*/ $46wWE.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $de85a50705c2b3be$var$_objectWithoutPropertiesLoose(_ref7, $de85a50705c2b3be$var$_excluded);
    let { basename: basename } = $46wWE.useContext((0, $9db2e3ca9c00f750$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $de85a50705c2b3be$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($de85a50705c2b3be$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $9db2e3ca9c00f750$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $de85a50705c2b3be$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $46wWE.createElement("a", $de85a50705c2b3be$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $de85a50705c2b3be$export$b0d92dbee9b5b60d = /*#__PURE__*/ $46wWE.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $de85a50705c2b3be$var$_objectWithoutPropertiesLoose(_ref8, $de85a50705c2b3be$var$_excluded2);
    let path = (0, $9db2e3ca9c00f750$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $9db2e3ca9c00f750$export$45d76561a5302f2b)();
    let routerState = $46wWE.useContext((0, $9db2e3ca9c00f750$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $46wWE.useContext((0, $9db2e3ca9c00f750$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $de85a50705c2b3be$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $46wWE.createElement($de85a50705c2b3be$export$a6c7ac8248d6e38a, $de85a50705c2b3be$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $de85a50705c2b3be$export$a7fed597f4b8afd8 = /*#__PURE__*/ $46wWE.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $de85a50705c2b3be$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $de85a50705c2b3be$var$_objectWithoutPropertiesLoose(_ref9, $de85a50705c2b3be$var$_excluded3);
    let submit = $de85a50705c2b3be$export$47c85c6e3a081d3();
    let formAction = $de85a50705c2b3be$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $46wWE.createElement("form", $de85a50705c2b3be$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $de85a50705c2b3be$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $de85a50705c2b3be$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $de85a50705c2b3be$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($de85a50705c2b3be$var$DataRouterHook || ($de85a50705c2b3be$var$DataRouterHook = {}));
var $de85a50705c2b3be$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($de85a50705c2b3be$var$DataRouterStateHook || ($de85a50705c2b3be$var$DataRouterStateHook = {}));
// Internal hooks
function $de85a50705c2b3be$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $de85a50705c2b3be$var$useDataRouterContext(hookName) {
    let ctx = $46wWE.useContext((0, $9db2e3ca9c00f750$export$3add0d5dce533e2e));
    !ctx && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $de85a50705c2b3be$var$useDataRouterState(hookName) {
    let state = $46wWE.useContext((0, $9db2e3ca9c00f750$export$145dfa71566a64dc));
    !state && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $de85a50705c2b3be$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $9db2e3ca9c00f750$export$9770f232ac06a008)();
    let location = (0, $9db2e3ca9c00f750$export$45d76561a5302f2b)();
    let path = (0, $9db2e3ca9c00f750$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $46wWE.useCallback((event)=>{
        if ($de85a50705c2b3be$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $9fdc5e205ef46e6a$export$fe53371bee54353d)(location) === (0, $9fdc5e205ef46e6a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $de85a50705c2b3be$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $46wWE.useRef($de85a50705c2b3be$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $46wWE.useRef(false);
    let location = (0, $9db2e3ca9c00f750$export$45d76561a5302f2b)();
    let searchParams = $46wWE.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $de85a50705c2b3be$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $9db2e3ca9c00f750$export$9770f232ac06a008)();
    let setSearchParams = $46wWE.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $de85a50705c2b3be$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $de85a50705c2b3be$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $de85a50705c2b3be$var$fetcherId = 0;
let $de85a50705c2b3be$var$getUniqueFetcherId = ()=>"__" + String(++$de85a50705c2b3be$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $de85a50705c2b3be$export$47c85c6e3a081d3() {
    let { router: router } = $de85a50705c2b3be$var$useDataRouterContext($de85a50705c2b3be$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $46wWE.useContext((0, $9db2e3ca9c00f750$export$26749e8557646306));
    let currentRouteId = (0, $9db2e3ca9c00f750$export$5fc8298006ad9e58)();
    return $46wWE.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $de85a50705c2b3be$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $de85a50705c2b3be$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $de85a50705c2b3be$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $de85a50705c2b3be$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $46wWE.useContext((0, $9db2e3ca9c00f750$export$26749e8557646306));
    let routeContext = $46wWE.useContext((0, $9db2e3ca9c00f750$export$9072aa6dd1f93057));
    !routeContext && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $de85a50705c2b3be$var$_extends({}, (0, $9db2e3ca9c00f750$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $9db2e3ca9c00f750$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9fdc5e205ef46e6a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $9fdc5e205ef46e6a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $de85a50705c2b3be$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $de85a50705c2b3be$var$useDataRouterContext($de85a50705c2b3be$var$DataRouterHook.UseFetcher);
    let state = $de85a50705c2b3be$var$useDataRouterState($de85a50705c2b3be$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $46wWE.useContext($de85a50705c2b3be$export$148fd98d095596d4);
    let route = $46wWE.useContext((0, $9db2e3ca9c00f750$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    !route && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $de85a50705c2b3be$var$useIdImpl ? $de85a50705c2b3be$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $46wWE.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($de85a50705c2b3be$var$getUniqueFetcherId());
    // Registration/cleanup
    $46wWE.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $46wWE.useCallback((href, opts)=>{
        !routeId && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $de85a50705c2b3be$export$47c85c6e3a081d3();
    let submit = $46wWE.useCallback((target, opts)=>{
        submitImpl(target, $de85a50705c2b3be$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $46wWE.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $46wWE.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $46wWE.createElement($de85a50705c2b3be$export$a7fed597f4b8afd8, $de85a50705c2b3be$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $9fdc5e205ef46e6a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $46wWE.useMemo(()=>$de85a50705c2b3be$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $de85a50705c2b3be$export$fa996778a3a31087() {
    let state = $de85a50705c2b3be$var$useDataRouterState($de85a50705c2b3be$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $de85a50705c2b3be$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $de85a50705c2b3be$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $de85a50705c2b3be$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $de85a50705c2b3be$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $de85a50705c2b3be$var$useDataRouterContext($de85a50705c2b3be$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $de85a50705c2b3be$var$useDataRouterState($de85a50705c2b3be$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $46wWE.useContext((0, $9db2e3ca9c00f750$export$26749e8557646306));
    let location = (0, $9db2e3ca9c00f750$export$45d76561a5302f2b)();
    let matches = (0, $9db2e3ca9c00f750$export$2378eb7f5ff86053)();
    let navigation = (0, $9db2e3ca9c00f750$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $46wWE.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $de85a50705c2b3be$var$usePageHide($46wWE.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $de85a50705c2b3be$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $de85a50705c2b3be$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($de85a50705c2b3be$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $46wWE.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $de85a50705c2b3be$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $de85a50705c2b3be$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $46wWE.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($de85a50705c2b3be$var$_extends({}, location, {
                    pathname: (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($de85a50705c2b3be$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $46wWE.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $de85a50705c2b3be$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $46wWE.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $de85a50705c2b3be$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $46wWE.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $de85a50705c2b3be$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $9db2e3ca9c00f750$export$b273b3273281a049)(when);
    $46wWE.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $46wWE.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $de85a50705c2b3be$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $46wWE.useContext($de85a50705c2b3be$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $9fdc5e205ef46e6a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $de85a50705c2b3be$var$useDataRouterContext($de85a50705c2b3be$var$DataRouterHook.useViewTransitionState);
    let path = (0, $9db2e3ca9c00f750$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $9fdc5e205ef46e6a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $9fdc5e205ef46e6a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $9fdc5e205ef46e6a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}








var $46wWE = parcelRequire("46wWE");
var $b26a11afd27fe909$exports = {};
/*
 *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
*****************************************************************************/ /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $4c935fff716c96e6$export$a143d493d941bafc;
var $4c935fff716c96e6$export$e4cf37d7f6fb9e0a;
var $4c935fff716c96e6$export$f99ded8fe4b79145;
var $4c935fff716c96e6$export$599f31c3813fae4d;
'use strict';
var $0c456621aad7eca2$export$a48f0734ac7c2329;
var $0c456621aad7eca2$export$d622b2ad8d90c771;
var $0c456621aad7eca2$export$6100ba28696e12de;
'use strict';
$0c456621aad7eca2$export$a48f0734ac7c2329 = $0c456621aad7eca2$var$byteLength;
$0c456621aad7eca2$export$d622b2ad8d90c771 = $0c456621aad7eca2$var$toByteArray;
$0c456621aad7eca2$export$6100ba28696e12de = $0c456621aad7eca2$var$fromByteArray;
var $0c456621aad7eca2$var$lookup = [];
var $0c456621aad7eca2$var$revLookup = [];
var $0c456621aad7eca2$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $0c456621aad7eca2$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $0c456621aad7eca2$var$i = 0, $0c456621aad7eca2$var$len = $0c456621aad7eca2$var$code.length; $0c456621aad7eca2$var$i < $0c456621aad7eca2$var$len; ++$0c456621aad7eca2$var$i){
    $0c456621aad7eca2$var$lookup[$0c456621aad7eca2$var$i] = $0c456621aad7eca2$var$code[$0c456621aad7eca2$var$i];
    $0c456621aad7eca2$var$revLookup[$0c456621aad7eca2$var$code.charCodeAt($0c456621aad7eca2$var$i)] = $0c456621aad7eca2$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0c456621aad7eca2$var$revLookup['-'.charCodeAt(0)] = 62;
$0c456621aad7eca2$var$revLookup['_'.charCodeAt(0)] = 63;
function $0c456621aad7eca2$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0c456621aad7eca2$var$byteLength(b64) {
    var lens = $0c456621aad7eca2$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0c456621aad7eca2$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0c456621aad7eca2$var$toByteArray(b64) {
    var tmp;
    var lens = $0c456621aad7eca2$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0c456621aad7eca2$var$Arr($0c456621aad7eca2$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i)] << 18 | $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i)] << 2 | $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i)] << 10 | $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0c456621aad7eca2$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0c456621aad7eca2$var$tripletToBase64(num) {
    return $0c456621aad7eca2$var$lookup[num >> 18 & 0x3F] + $0c456621aad7eca2$var$lookup[num >> 12 & 0x3F] + $0c456621aad7eca2$var$lookup[num >> 6 & 0x3F] + $0c456621aad7eca2$var$lookup[num & 0x3F];
}
function $0c456621aad7eca2$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0c456621aad7eca2$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $0c456621aad7eca2$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0c456621aad7eca2$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0c456621aad7eca2$var$lookup[tmp >> 2] + $0c456621aad7eca2$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0c456621aad7eca2$var$lookup[tmp >> 10] + $0c456621aad7eca2$var$lookup[tmp >> 4 & 0x3F] + $0c456621aad7eca2$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $978495953f61d162$export$aafa59e2e03f2942;
var $978495953f61d162$export$68d8715fc104d294;
$978495953f61d162$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$978495953f61d162$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $4c935fff716c96e6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$4c935fff716c96e6$export$a143d493d941bafc = $4c935fff716c96e6$var$Buffer;
$4c935fff716c96e6$export$e4cf37d7f6fb9e0a = $4c935fff716c96e6$var$SlowBuffer;
$4c935fff716c96e6$export$f99ded8fe4b79145 = 50;
const $4c935fff716c96e6$var$K_MAX_LENGTH = 0x7fffffff;
$4c935fff716c96e6$export$599f31c3813fae4d = $4c935fff716c96e6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $4c935fff716c96e6$var$Buffer.TYPED_ARRAY_SUPPORT = $4c935fff716c96e6$var$typedArraySupport();
if (!$4c935fff716c96e6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $4c935fff716c96e6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($4c935fff716c96e6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$4c935fff716c96e6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($4c935fff716c96e6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$4c935fff716c96e6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $4c935fff716c96e6$var$createBuffer(length) {
    if (length > $4c935fff716c96e6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $4c935fff716c96e6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $4c935fff716c96e6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $4c935fff716c96e6$var$allocUnsafe(arg);
    }
    return $4c935fff716c96e6$var$from(arg, encodingOrOffset, length);
}
$4c935fff716c96e6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $4c935fff716c96e6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $4c935fff716c96e6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $4c935fff716c96e6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($4c935fff716c96e6$var$isInstance(value, ArrayBuffer) || value && $4c935fff716c96e6$var$isInstance(value.buffer, ArrayBuffer)) return $4c935fff716c96e6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($4c935fff716c96e6$var$isInstance(value, SharedArrayBuffer) || value && $4c935fff716c96e6$var$isInstance(value.buffer, SharedArrayBuffer))) return $4c935fff716c96e6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $4c935fff716c96e6$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $4c935fff716c96e6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $4c935fff716c96e6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $4c935fff716c96e6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $4c935fff716c96e6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($4c935fff716c96e6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($4c935fff716c96e6$var$Buffer, Uint8Array);
function $4c935fff716c96e6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $4c935fff716c96e6$var$alloc(size, fill, encoding) {
    $4c935fff716c96e6$var$assertSize(size);
    if (size <= 0) return $4c935fff716c96e6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $4c935fff716c96e6$var$createBuffer(size).fill(fill, encoding) : $4c935fff716c96e6$var$createBuffer(size).fill(fill);
    return $4c935fff716c96e6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $4c935fff716c96e6$var$Buffer.alloc = function(size, fill, encoding) {
    return $4c935fff716c96e6$var$alloc(size, fill, encoding);
};
function $4c935fff716c96e6$var$allocUnsafe(size) {
    $4c935fff716c96e6$var$assertSize(size);
    return $4c935fff716c96e6$var$createBuffer(size < 0 ? 0 : $4c935fff716c96e6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $4c935fff716c96e6$var$Buffer.allocUnsafe = function(size) {
    return $4c935fff716c96e6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $4c935fff716c96e6$var$Buffer.allocUnsafeSlow = function(size) {
    return $4c935fff716c96e6$var$allocUnsafe(size);
};
function $4c935fff716c96e6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$4c935fff716c96e6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $4c935fff716c96e6$var$byteLength(string, encoding) | 0;
    let buf = $4c935fff716c96e6$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $4c935fff716c96e6$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $4c935fff716c96e6$var$checked(array.length) | 0;
    const buf = $4c935fff716c96e6$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $4c935fff716c96e6$var$fromArrayView(arrayView) {
    if ($4c935fff716c96e6$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $4c935fff716c96e6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $4c935fff716c96e6$var$fromArrayLike(arrayView);
}
function $4c935fff716c96e6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $4c935fff716c96e6$var$Buffer.prototype);
    return buf;
}
function $4c935fff716c96e6$var$fromObject(obj) {
    if ($4c935fff716c96e6$var$Buffer.isBuffer(obj)) {
        const len = $4c935fff716c96e6$var$checked(obj.length) | 0;
        const buf = $4c935fff716c96e6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $4c935fff716c96e6$var$numberIsNaN(obj.length)) return $4c935fff716c96e6$var$createBuffer(0);
        return $4c935fff716c96e6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $4c935fff716c96e6$var$fromArrayLike(obj.data);
}
function $4c935fff716c96e6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $4c935fff716c96e6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $4c935fff716c96e6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $4c935fff716c96e6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $4c935fff716c96e6$var$Buffer.alloc(+length);
}
$4c935fff716c96e6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $4c935fff716c96e6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$4c935fff716c96e6$var$Buffer.compare = function compare(a, b) {
    if ($4c935fff716c96e6$var$isInstance(a, Uint8Array)) a = $4c935fff716c96e6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($4c935fff716c96e6$var$isInstance(b, Uint8Array)) b = $4c935fff716c96e6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$4c935fff716c96e6$var$Buffer.isBuffer(a) || !$4c935fff716c96e6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$4c935fff716c96e6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$4c935fff716c96e6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $4c935fff716c96e6$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $4c935fff716c96e6$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($4c935fff716c96e6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$4c935fff716c96e6$var$Buffer.isBuffer(buf)) buf = $4c935fff716c96e6$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$4c935fff716c96e6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $4c935fff716c96e6$var$byteLength(string, encoding) {
    if ($4c935fff716c96e6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $4c935fff716c96e6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $4c935fff716c96e6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $4c935fff716c96e6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $4c935fff716c96e6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$4c935fff716c96e6$var$Buffer.byteLength = $4c935fff716c96e6$var$byteLength;
function $4c935fff716c96e6$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $4c935fff716c96e6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $4c935fff716c96e6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $4c935fff716c96e6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $4c935fff716c96e6$var$latin1Slice(this, start, end);
        case 'base64':
            return $4c935fff716c96e6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4c935fff716c96e6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$4c935fff716c96e6$var$Buffer.prototype._isBuffer = true;
function $4c935fff716c96e6$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$4c935fff716c96e6$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$4c935fff716c96e6$var$swap(this, i, i + 1);
    return this;
};
$4c935fff716c96e6$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $4c935fff716c96e6$var$swap(this, i, i + 3);
        $4c935fff716c96e6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$4c935fff716c96e6$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $4c935fff716c96e6$var$swap(this, i, i + 7);
        $4c935fff716c96e6$var$swap(this, i + 1, i + 6);
        $4c935fff716c96e6$var$swap(this, i + 2, i + 5);
        $4c935fff716c96e6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$4c935fff716c96e6$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $4c935fff716c96e6$var$utf8Slice(this, 0, length);
    return $4c935fff716c96e6$var$slowToString.apply(this, arguments);
};
$4c935fff716c96e6$var$Buffer.prototype.toLocaleString = $4c935fff716c96e6$var$Buffer.prototype.toString;
$4c935fff716c96e6$var$Buffer.prototype.equals = function equals(b) {
    if (!$4c935fff716c96e6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $4c935fff716c96e6$var$Buffer.compare(this, b) === 0;
};
$4c935fff716c96e6$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $4c935fff716c96e6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($4c935fff716c96e6$var$customInspectSymbol) $4c935fff716c96e6$var$Buffer.prototype[$4c935fff716c96e6$var$customInspectSymbol] = $4c935fff716c96e6$var$Buffer.prototype.inspect;
$4c935fff716c96e6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($4c935fff716c96e6$var$isInstance(target, Uint8Array)) target = $4c935fff716c96e6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$4c935fff716c96e6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $4c935fff716c96e6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($4c935fff716c96e6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $4c935fff716c96e6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($4c935fff716c96e6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $4c935fff716c96e6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $4c935fff716c96e6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $4c935fff716c96e6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$4c935fff716c96e6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$4c935fff716c96e6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $4c935fff716c96e6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$4c935fff716c96e6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $4c935fff716c96e6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $4c935fff716c96e6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($4c935fff716c96e6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $4c935fff716c96e6$var$utf8Write(buf, string, offset, length) {
    return $4c935fff716c96e6$var$blitBuffer($4c935fff716c96e6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $4c935fff716c96e6$var$asciiWrite(buf, string, offset, length) {
    return $4c935fff716c96e6$var$blitBuffer($4c935fff716c96e6$var$asciiToBytes(string), buf, offset, length);
}
function $4c935fff716c96e6$var$base64Write(buf, string, offset, length) {
    return $4c935fff716c96e6$var$blitBuffer($4c935fff716c96e6$var$base64ToBytes(string), buf, offset, length);
}
function $4c935fff716c96e6$var$ucs2Write(buf, string, offset, length) {
    return $4c935fff716c96e6$var$blitBuffer($4c935fff716c96e6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$4c935fff716c96e6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $4c935fff716c96e6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $4c935fff716c96e6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $4c935fff716c96e6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $4c935fff716c96e6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $4c935fff716c96e6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$4c935fff716c96e6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $4c935fff716c96e6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $0c456621aad7eca2$export$6100ba28696e12de(buf);
    else return $0c456621aad7eca2$export$6100ba28696e12de(buf.slice(start, end));
}
function $4c935fff716c96e6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $4c935fff716c96e6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $4c935fff716c96e6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $4c935fff716c96e6$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $4c935fff716c96e6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $4c935fff716c96e6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $4c935fff716c96e6$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $4c935fff716c96e6$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $4c935fff716c96e6$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $4c935fff716c96e6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $4c935fff716c96e6$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$4c935fff716c96e6$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $4c935fff716c96e6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $4c935fff716c96e6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$4c935fff716c96e6$var$Buffer.prototype.readUintLE = $4c935fff716c96e6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$4c935fff716c96e6$var$Buffer.prototype.readUintBE = $4c935fff716c96e6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$4c935fff716c96e6$var$Buffer.prototype.readUint8 = $4c935fff716c96e6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$4c935fff716c96e6$var$Buffer.prototype.readUint16LE = $4c935fff716c96e6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$4c935fff716c96e6$var$Buffer.prototype.readUint16BE = $4c935fff716c96e6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$4c935fff716c96e6$var$Buffer.prototype.readUint32LE = $4c935fff716c96e6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$4c935fff716c96e6$var$Buffer.prototype.readUint32BE = $4c935fff716c96e6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$4c935fff716c96e6$var$Buffer.prototype.readBigUInt64LE = $4c935fff716c96e6$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $4c935fff716c96e6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c935fff716c96e6$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$4c935fff716c96e6$var$Buffer.prototype.readBigUInt64BE = $4c935fff716c96e6$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $4c935fff716c96e6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c935fff716c96e6$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$4c935fff716c96e6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4c935fff716c96e6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$4c935fff716c96e6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$4c935fff716c96e6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4c935fff716c96e6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$4c935fff716c96e6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$4c935fff716c96e6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$4c935fff716c96e6$var$Buffer.prototype.readBigInt64LE = $4c935fff716c96e6$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $4c935fff716c96e6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c935fff716c96e6$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$4c935fff716c96e6$var$Buffer.prototype.readBigInt64BE = $4c935fff716c96e6$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $4c935fff716c96e6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $4c935fff716c96e6$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$4c935fff716c96e6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 4, this.length);
    return $978495953f61d162$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$4c935fff716c96e6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 4, this.length);
    return $978495953f61d162$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$4c935fff716c96e6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 8, this.length);
    return $978495953f61d162$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$4c935fff716c96e6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkOffset(offset, 8, this.length);
    return $978495953f61d162$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $4c935fff716c96e6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$4c935fff716c96e6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$4c935fff716c96e6$var$Buffer.prototype.writeUintLE = $4c935fff716c96e6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4c935fff716c96e6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4c935fff716c96e6$var$Buffer.prototype.writeUintBE = $4c935fff716c96e6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $4c935fff716c96e6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$4c935fff716c96e6$var$Buffer.prototype.writeUint8 = $4c935fff716c96e6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$4c935fff716c96e6$var$Buffer.prototype.writeUint16LE = $4c935fff716c96e6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4c935fff716c96e6$var$Buffer.prototype.writeUint16BE = $4c935fff716c96e6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4c935fff716c96e6$var$Buffer.prototype.writeUint32LE = $4c935fff716c96e6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$4c935fff716c96e6$var$Buffer.prototype.writeUint32BE = $4c935fff716c96e6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $4c935fff716c96e6$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $4c935fff716c96e6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $4c935fff716c96e6$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $4c935fff716c96e6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$4c935fff716c96e6$var$Buffer.prototype.writeBigUInt64LE = $4c935fff716c96e6$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $4c935fff716c96e6$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4c935fff716c96e6$var$Buffer.prototype.writeBigUInt64BE = $4c935fff716c96e6$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $4c935fff716c96e6$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$4c935fff716c96e6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4c935fff716c96e6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4c935fff716c96e6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $4c935fff716c96e6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$4c935fff716c96e6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$4c935fff716c96e6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$4c935fff716c96e6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$4c935fff716c96e6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$4c935fff716c96e6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$4c935fff716c96e6$var$Buffer.prototype.writeBigInt64LE = $4c935fff716c96e6$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $4c935fff716c96e6$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$4c935fff716c96e6$var$Buffer.prototype.writeBigInt64BE = $4c935fff716c96e6$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $4c935fff716c96e6$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $4c935fff716c96e6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $4c935fff716c96e6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $978495953f61d162$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$4c935fff716c96e6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $4c935fff716c96e6$var$writeFloat(this, value, offset, true, noAssert);
};
$4c935fff716c96e6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $4c935fff716c96e6$var$writeFloat(this, value, offset, false, noAssert);
};
function $4c935fff716c96e6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $4c935fff716c96e6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $978495953f61d162$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$4c935fff716c96e6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $4c935fff716c96e6$var$writeDouble(this, value, offset, true, noAssert);
};
$4c935fff716c96e6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $4c935fff716c96e6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$4c935fff716c96e6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$4c935fff716c96e6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$4c935fff716c96e6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$4c935fff716c96e6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $4c935fff716c96e6$var$Buffer.isBuffer(val) ? val : $4c935fff716c96e6$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $4c935fff716c96e6$var$errors = {};
function $4c935fff716c96e6$var$E(sym, getMessage, Base) {
    $4c935fff716c96e6$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$4c935fff716c96e6$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$4c935fff716c96e6$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$4c935fff716c96e6$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $4c935fff716c96e6$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $4c935fff716c96e6$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $4c935fff716c96e6$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $4c935fff716c96e6$var$checkBounds(buf, offset, byteLength) {
    $4c935fff716c96e6$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $4c935fff716c96e6$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $4c935fff716c96e6$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $4c935fff716c96e6$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $4c935fff716c96e6$var$checkBounds(buf, offset, byteLength);
}
function $4c935fff716c96e6$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $4c935fff716c96e6$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $4c935fff716c96e6$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $4c935fff716c96e6$var$validateNumber(value, type);
        throw new $4c935fff716c96e6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $4c935fff716c96e6$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $4c935fff716c96e6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $4c935fff716c96e6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $4c935fff716c96e6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($4c935fff716c96e6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $4c935fff716c96e6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $4c935fff716c96e6$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $4c935fff716c96e6$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $4c935fff716c96e6$var$base64ToBytes(str) {
    return $0c456621aad7eca2$export$d622b2ad8d90c771($4c935fff716c96e6$var$base64clean(str));
}
function $4c935fff716c96e6$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $4c935fff716c96e6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $4c935fff716c96e6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $4c935fff716c96e6$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $4c935fff716c96e6$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $4c935fff716c96e6$var$BufferBigIntNotDefined : fn;
}
function $4c935fff716c96e6$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $b26a11afd27fe909$require$Buffer = $4c935fff716c96e6$export$a143d493d941bafc;
'use strict';
Object.defineProperty($b26a11afd27fe909$exports, "__esModule", {
    value: !0
});
function $b26a11afd27fe909$var$_interopDefault(a) {
    return a && "object" === typeof a && "default" in a ? a["default"] : a;
}

var $46wWE = parcelRequire("46wWE");
var $b26a11afd27fe909$var$React__default = $b26a11afd27fe909$var$_interopDefault($46wWE), $b26a11afd27fe909$var$extendStatics = function(a, c) {
    $b26a11afd27fe909$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(a, c) {
        a.__proto__ = c;
    } || function(a, c) {
        for(var b in c)c.hasOwnProperty(b) && (a[b] = c[b]);
    };
    return $b26a11afd27fe909$var$extendStatics(a, c);
};
function $b26a11afd27fe909$var$__extends(a, c) {
    function f() {
        this.constructor = a;
    }
    $b26a11afd27fe909$var$extendStatics(a, c);
    a.prototype = null === c ? Object.create(c) : (f.prototype = c.prototype, new f);
}
var $b26a11afd27fe909$var$__assign = function() {
    $b26a11afd27fe909$var$__assign = Object.assign || function(a) {
        for(var c, f = 1, b = arguments.length; f < b; f++){
            c = arguments[f];
            for(var e in c)Object.prototype.hasOwnProperty.call(c, e) && (a[e] = c[e]);
        }
        return a;
    };
    return $b26a11afd27fe909$var$__assign.apply(this, arguments);
};
function $b26a11afd27fe909$var$__rest(a, c) {
    var f = {}, b;
    for(b in a)Object.prototype.hasOwnProperty.call(a, b) && 0 > c.indexOf(b) && (f[b] = a[b]);
    if (null != a && "function" === typeof Object.getOwnPropertySymbols) {
        var e = 0;
        for(b = Object.getOwnPropertySymbols(a); e < b.length; e++)0 > c.indexOf(b[e]) && (f[b[e]] = a[b[e]]);
    }
    return f;
}
function $b26a11afd27fe909$var$__awaiter(a, c, f, b) {
    return new (f || (f = Promise))(function(e, h) {
        function g(a) {
            try {
                k(b.next(a));
            } catch (l) {
                h(l);
            }
        }
        function d(a) {
            try {
                k(b["throw"](a));
            } catch (l) {
                h(l);
            }
        }
        function k(a) {
            a.done ? e(a.value) : new f(function(c) {
                c(a.value);
            }).then(g, d);
        }
        k((b = b.apply(a, c || [])).next());
    });
}
function $b26a11afd27fe909$var$__generator(a, c) {
    function f(a) {
        return function(c) {
            return b([
                a,
                c
            ]);
        };
    }
    function b(b) {
        if (h) throw new TypeError("Generator is already executing.");
        for(; e;)try {
            if (h = 1, g && (d = b[0] & 2 ? g["return"] : b[0] ? g["throw"] || ((d = g["return"]) && d.call(g), 0) : g.next) && !(d = d.call(g, b[1])).done) return d;
            if (g = 0, d) b = [
                b[0] & 2,
                d.value
            ];
            switch(b[0]){
                case 0:
                case 1:
                    d = b;
                    break;
                case 4:
                    return e.label++, {
                        value: b[1],
                        done: !1
                    };
                case 5:
                    e.label++;
                    g = b[1];
                    b = [
                        0
                    ];
                    continue;
                case 7:
                    b = e.ops.pop();
                    e.trys.pop();
                    continue;
                default:
                    if (!(d = e.trys, d = 0 < d.length && d[d.length - 1]) && (6 === b[0] || 2 === b[0])) {
                        e = 0;
                        continue;
                    }
                    if (3 === b[0] && (!d || b[1] > d[0] && b[1] < d[3])) e.label = b[1];
                    else if (6 === b[0] && e.label < d[1]) e.label = d[1], d = b;
                    else if (d && e.label < d[2]) e.label = d[2], e.ops.push(b);
                    else {
                        d[2] && e.ops.pop();
                        e.trys.pop();
                        continue;
                    }
            }
            b = c.call(a, e);
        } catch (l) {
            b = [
                6,
                l
            ], g = 0;
        } finally{
            h = d = 0;
        }
        if (b[0] & 5) throw b[1];
        return {
            value: b[0] ? b[1] : void 0,
            done: !0
        };
    }
    var e = {
        label: 0,
        sent: function() {
            if (d[0] & 1) throw d[1];
            return d[1];
        },
        trys: [],
        ops: []
    }, h, g, d, k;
    return k = {
        next: f(0),
        "throw": f(1),
        "return": f(2)
    }, "function" === typeof Symbol && (k[Symbol.iterator] = function() {
        return this;
    }), k;
}
var $b26a11afd27fe909$var$convertActionToBase64 = function(a) {
    return $b26a11afd27fe909$require$Buffer.from(JSON.stringify(a)).toString("base64");
}, $b26a11afd27fe909$var$createCache = function(a, c) {
    var f = {}, b = function(a) {
        delete f[$b26a11afd27fe909$var$convertActionToBase64(a)];
    };
    return {
        add: function(b, c) {
            a(b) && (f[$b26a11afd27fe909$var$convertActionToBase64(b)] = $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, c), {
                timestamp: Date.now()
            }));
        },
        get: function(a) {
            var e = f[$b26a11afd27fe909$var$convertActionToBase64(a)], g = e && c(e);
            if (g) return e;
            e && !g && b(a);
        },
        getItems: function() {
            return f;
        },
        remove: b,
        setItems: function(a) {
            f = a;
        }
    };
}, $b26a11afd27fe909$var$QueryError = function(a) {
    function c(f, b) {
        f = a.call(this, f) || this;
        Object.setPrototypeOf(f, c.prototype);
        f.name = "QueryError";
        f.response = b;
        return f;
    }
    $b26a11afd27fe909$var$__extends(c, a);
    return c;
}(Error), $b26a11afd27fe909$var$createClient = function(a) {
    void 0 === a && (a = {});
    var c = a.cacheProvider, f = $b26a11afd27fe909$var$createCache(function() {
        return !0;
    }, function() {
        return !0;
    }), b = function(a, c) {
        return $b26a11afd27fe909$var$__awaiter(void 0, void 0, void 0, function() {
            var f, e, g, d;
            return $b26a11afd27fe909$var$__generator(this, function(l) {
                switch(l.label){
                    case 0:
                        f = c[0];
                        e = c.slice(1);
                        if (!f) return [
                            3,
                            3
                        ];
                        d = b;
                        return [
                            4,
                            f(h)(a)
                        ];
                    case 1:
                        return [
                            4,
                            d.apply(void 0, [
                                l.sent(),
                                e
                            ])
                        ];
                    case 2:
                        return g = l.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        g = a, l.label = 4;
                    case 4:
                        return [
                            2,
                            g
                        ];
                }
            });
        });
    }, e = function(a, b, c) {
        return $b26a11afd27fe909$var$__awaiter(void 0, void 0, void 0, function() {
            var f, g, d, k, m;
            return $b26a11afd27fe909$var$__generator(this, function(l) {
                switch(l.label){
                    case 0:
                        f = c[0];
                        g = c.slice(1);
                        if (!f) return [
                            3,
                            3
                        ];
                        k = e;
                        m = [
                            a
                        ];
                        return [
                            4,
                            f(h)(a, b)
                        ];
                    case 1:
                        return [
                            4,
                            k.apply(void 0, m.concat([
                                l.sent(),
                                g
                            ]))
                        ];
                    case 2:
                        return d = l.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        d = b, l.label = 4;
                    case 4:
                        return [
                            2,
                            d
                        ];
                }
            });
        });
    }, h = {
        cache: c,
        query: function(f, d) {
            void 0 === d && (d = !1);
            return $b26a11afd27fe909$var$__awaiter(void 0, void 0, void 0, function() {
                var g, h, l, n, v, m, p, t, x, q, r, y, z, w, A;
                return $b26a11afd27fe909$var$__generator(this, function(k) {
                    switch(k.label){
                        case 0:
                            return k.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]), [
                                4,
                                b(f, a.requestInterceptors || [])
                            ];
                        case 1:
                            g = k.sent();
                            h = g.endpoint;
                            l = g.body;
                            n = g.responseType;
                            v = $b26a11afd27fe909$var$__rest(g, [
                                "endpoint",
                                "body",
                                "responseType"
                            ]);
                            if (c && !d && (m = c.get(f))) return [
                                2,
                                m
                            ];
                            p = v.headers;
                            l && (l instanceof FormData || l instanceof Blob || l instanceof ArrayBuffer) || (p = $b26a11afd27fe909$var$__assign({
                                "Content-Type": "application/json; charset=utf-8"
                            }, v.headers));
                            t = p && p["Content-Type"] && -1 !== p["Content-Type"].indexOf("json");
                            x = a.fetch || fetch;
                            return [
                                4,
                                x(h, $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, v), {
                                    body: l ? t ? JSON.stringify(l) : l : void 0,
                                    headers: p,
                                    responseType: n
                                }))
                            ];
                        case 2:
                            return q = k.sent(), y = e, z = [
                                g
                            ], w = {
                                error: !q.ok,
                                headers: q.headers
                            }, [
                                4,
                                $b26a11afd27fe909$var$resolveResponse(q, n)
                            ];
                        case 3:
                            return [
                                4,
                                y.apply(void 0, z.concat([
                                    (w.payload = k.sent(), w.status = q.status, w),
                                    a.responseInterceptors || []
                                ]))
                            ];
                        case 4:
                            r = k.sent();
                            c && q.ok && c.add(f, r);
                            if (r.status && g.config && g.config.emitErrorForStatuses && g.config.emitErrorForStatuses.includes(r.status)) throw new $b26a11afd27fe909$var$QueryError("request-error", r);
                            return [
                                2,
                                r
                            ];
                        case 5:
                            return A = k.sent(), [
                                2,
                                {
                                    error: !0,
                                    errorObject: A
                                }
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
        },
        suspenseCache: f
    };
    return h;
};
function $b26a11afd27fe909$var$resolveResponse(a, c) {
    return $b26a11afd27fe909$var$__awaiter(this, void 0, void 0, function() {
        var f, b, e, h;
        return $b26a11afd27fe909$var$__generator(this, function(g) {
            switch(g.label){
                case 0:
                    return c ? [
                        2,
                        a[c]()
                    ] : [
                        3,
                        1
                    ];
                case 1:
                    return f = [
                        204,
                        205
                    ], b = a.headers.get("Content-Type"), (e = -1 === f.indexOf(a.status) && b && -1 !== b.indexOf("json")) ? [
                        4,
                        a.json()
                    ] : [
                        3,
                        3
                    ];
                case 2:
                    return h = g.sent(), [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        a.text()
                    ];
                case 4:
                    h = g.sent(), g.label = 5;
                case 5:
                    return [
                        2,
                        h
                    ];
            }
        });
    });
}
var $b26a11afd27fe909$var$initialContext = {
    query: function() {
        console.warn("Add ClientProvider to use client context");
        return Promise.resolve({
            error: !0,
            status: 0
        });
    },
    suspenseCache: $b26a11afd27fe909$var$createCache(function() {
        return !0;
    }, function() {
        return !0;
    })
}, $b26a11afd27fe909$var$ClientContext = $46wWE.createContext($b26a11afd27fe909$var$initialContext), $b26a11afd27fe909$var$SET_LOADING = "response/loading", $b26a11afd27fe909$var$RESET_LOADING = "response/reset-loading", $b26a11afd27fe909$var$RESET = "response/reset", $b26a11afd27fe909$var$SET_RESPONSE = "response/set", $b26a11afd27fe909$var$responseReducer = function(a, c) {
    switch(c.type){
        case $b26a11afd27fe909$var$SET_LOADING:
            return $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, a), {
                loading: !0
            });
        case $b26a11afd27fe909$var$RESET_LOADING:
            return $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, a), {
                loading: !1
            });
        case $b26a11afd27fe909$var$SET_RESPONSE:
            if (!c.response) throw Error();
            return $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, a), {
                loading: !1,
                response: c.response
            });
        case $b26a11afd27fe909$var$RESET:
            return {
                loading: !1,
                response: {
                    error: !1
                }
            };
        default:
            throw Error();
    }
}, $b26a11afd27fe909$var$useCachedResponse = function(a) {
    var c = $46wWE.useContext($b26a11afd27fe909$var$ClientContext);
    if (c.cache) return c.cache.get(a);
}, $b26a11afd27fe909$var$useQuery = function(a, c) {
    void 0 === c && (c = !0);
    var f = $46wWE.useContext($b26a11afd27fe909$var$ClientContext), b = $b26a11afd27fe909$var$useCachedResponse(a), e = $46wWE.useRef(!0), h = $46wWE.useRef(), g = $46wWE.useReducer($b26a11afd27fe909$var$responseReducer, {
        loading: b ? !1 : c,
        response: b ? b : {
            error: !1
        }
    }), d = g[0], k = g[1];
    g = $b26a11afd27fe909$var$convertActionToBase64(a);
    var u = $46wWE.useRef(g);
    g !== u.current && (u.current = g, b && k({
        type: $b26a11afd27fe909$var$SET_RESPONSE,
        response: b
    }));
    $46wWE.useEffect(function() {
        e.current = !0;
        c && !b && l();
        return function() {
            e.current = !1;
            n();
        };
    }, [
        g
    ]);
    var l = $46wWE.useCallback(function(b) {
        void 0 === b && (b = !1);
        return $b26a11afd27fe909$var$__awaiter(void 0, void 0, void 0, function() {
            var c, g, d;
            return $b26a11afd27fe909$var$__generator(this, function(l) {
                switch(l.label){
                    case 0:
                        c = "AbortController" in window ? new AbortController : void 0;
                        g = a.signal || (c ? c.signal : void 0);
                        h.current && h.current.abort();
                        h.current = c;
                        if (!e.current) return [
                            2,
                            {
                                error: !1
                            }
                        ];
                        k({
                            type: $b26a11afd27fe909$var$SET_LOADING
                        });
                        return [
                            4,
                            f.query($b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, a), {
                                signal: a.signal || g
                            }), b)
                        ];
                    case 1:
                        return d = l.sent(), !e.current || d.errorObject && "AbortError" === d.errorObject.name || k({
                            type: $b26a11afd27fe909$var$SET_RESPONSE,
                            response: d
                        }), e.current && d.errorObject && "AbortError" === d.errorObject.name && h.current && h.current === c && (h.current = void 0, k({
                            type: $b26a11afd27fe909$var$RESET_LOADING
                        })), [
                            2,
                            d
                        ];
                }
            });
        });
    }, [
        g,
        f.query
    ]);
    g = $46wWE.useCallback(function() {
        return l(!0);
    }, [
        l
    ]);
    var n = $46wWE.useCallback(function() {
        h.current && h.current.abort();
    }, []);
    u = $46wWE.useCallback(function() {
        k({
            type: $b26a11afd27fe909$var$RESET
        });
    }, []);
    if (d.response && d.response.errorObject && d.response.errorObject instanceof $b26a11afd27fe909$var$QueryError) throw d.response.errorObject;
    return $b26a11afd27fe909$var$__assign({
        abort: n,
        loading: d.loading,
        query: g,
        reset: u
    }, d.response);
}, $b26a11afd27fe909$var$useMutation = function(a) {
    var c = $46wWE.useContext($b26a11afd27fe909$var$ClientContext), f = $46wWE.useRef(!0), b = $46wWE.useRef(), e = $46wWE.useReducer($b26a11afd27fe909$var$responseReducer, {
        loading: !1,
        response: {
            error: !1
        }
    }), h = e[0], g = e[1];
    $46wWE.useEffect(function() {
        f.current = !0;
        return function() {
            f.current = !1;
            d();
        };
    }, []);
    e = $46wWE.useCallback(function() {
        for(var d = [], e = 0; e < arguments.length; e++)d[e] = arguments[e];
        return $b26a11afd27fe909$var$__awaiter(void 0, void 0, void 0, function() {
            var e, h, l, k;
            return $b26a11afd27fe909$var$__generator(this, function(t) {
                switch(t.label){
                    case 0:
                        if (!f.current) return [
                            2,
                            {
                                error: !1
                            }
                        ];
                        e = a.apply(void 0, d);
                        h = "AbortController" in window ? new AbortController : void 0;
                        l = e.signal || (h ? h.signal : void 0);
                        b.current && b.current.abort();
                        b.current = h;
                        g({
                            type: $b26a11afd27fe909$var$SET_LOADING
                        });
                        return [
                            4,
                            c.query($b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, e), {
                                signal: e.signal || l
                            }))
                        ];
                    case 1:
                        return k = t.sent(), !f.current || k.errorObject && "AbortError" === k.errorObject.name || g({
                            type: $b26a11afd27fe909$var$SET_RESPONSE,
                            response: k
                        }), f.current && k.errorObject && "AbortError" === k.errorObject.name && b.current && b.current === h && (b.current = void 0, g({
                            type: $b26a11afd27fe909$var$RESET_LOADING
                        })), [
                            2,
                            k
                        ];
                }
            });
        });
    }, [
        a,
        c.query
    ]);
    var d = $46wWE.useCallback(function() {
        b.current && b.current.abort();
    }, []), k = $46wWE.useCallback(function() {
        g({
            type: $b26a11afd27fe909$var$RESET
        });
    }, []);
    if (h.response && h.response.errorObject && h.response.errorObject instanceof $b26a11afd27fe909$var$QueryError) throw h.response.errorObject;
    return $b26a11afd27fe909$var$__assign({
        abort: d,
        loading: h.loading,
        mutate: e,
        reset: k
    }, h.response);
}, $b26a11afd27fe909$var$useBulkMutation = function(a) {
    var c = $46wWE.useContext($b26a11afd27fe909$var$ClientContext).query, f = $46wWE.useRef(!0), b = $46wWE.useRef(), e = $46wWE.useState({
        loading: !1,
        responses: []
    }), h = e[0], g = e[1], d = $46wWE.useCallback(function() {
        b.current && b.current.abort();
    }, [
        b
    ]);
    $46wWE.useEffect(function() {
        f.current = !0;
        return function() {
            f.current = !1;
            d();
        };
    }, [
        d
    ]);
    e = $46wWE.useCallback(function(e) {
        return $b26a11afd27fe909$var$__awaiter(void 0, void 0, void 0, function() {
            var d, h, k, m;
            return $b26a11afd27fe909$var$__generator(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!f.current) return [
                            2,
                            Array.from(Array(10).keys()).map(function() {
                                return {
                                    error: !1
                                };
                            })
                        ];
                        d = "AbortController" in window ? new AbortController : void 0;
                        h = e.map(function(b) {
                            return a(b);
                        });
                        k = d ? d.signal : void 0;
                        h.forEach(function(a) {
                            return a.signal = a.signal || k;
                        });
                        b.current && b.current.abort();
                        b.current = d;
                        g(function(a) {
                            return $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, a), {
                                loading: !0
                            });
                        });
                        return [
                            4,
                            Promise.all(h.map(function(a) {
                                return c(a);
                            }))
                        ];
                    case 1:
                        return m = l.sent(), f.current && g({
                            loading: !1,
                            responses: m.map(function(a, c) {
                                if (!a.errorObject || "AbortError" !== a.errorObject.name) return h[c].signal === k && b.current === d && (b.current = void 0, g(function(a) {
                                    return $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, a), {
                                        loading: !1
                                    });
                                })), a;
                            })
                        }), [
                            2,
                            m
                        ];
                }
            });
        });
    }, [
        c,
        a
    ]);
    var k = $46wWE.useCallback(function() {
        g({
            loading: !1,
            responses: []
        });
    }, [
        g
    ]);
    return {
        abort: d,
        loading: h.loading,
        mutate: e,
        reset: k,
        responses: h.responses
    };
}, $b26a11afd27fe909$var$useSuspenseQuery = function(a) {
    var c = $46wWE.useContext($b26a11afd27fe909$var$ClientContext), f = $46wWE.useState(null), b = f[0], e = f[1], h = c.suspenseCache.get(a);
    $46wWE.useEffect(function() {
        h && h.response && null !== b && c.suspenseCache.remove(a);
        return function() {
            c.suspenseCache.remove(a);
        };
    }, [
        $b26a11afd27fe909$var$convertActionToBase64(a)
    ]);
    f = function() {
        c.suspenseCache.remove(a);
        e(!b);
    };
    if (h) {
        if (h.response) {
            if (h.response.errorObject && h.response.errorObject instanceof $b26a11afd27fe909$var$QueryError) throw h.response.errorObject;
            return $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, h.response), {
                query: f
            });
        }
        throw h.fetch;
    }
    var g = c.query(a, null !== b).then(function(b) {
        c.suspenseCache.add(a, {
            fetch: g,
            response: b
        });
    });
    c.suspenseCache.add(a, {
        fetch: g
    });
    throw g;
}, $b26a11afd27fe909$var$useClient = function() {
    return $46wWE.useContext($b26a11afd27fe909$var$ClientContext);
}, $b26a11afd27fe909$var$useParameterizedQuery = function(a) {
    var c = $b26a11afd27fe909$var$useMutation(a);
    a = c.mutate;
    c = $b26a11afd27fe909$var$__rest(c, [
        "mutate"
    ]);
    return $b26a11afd27fe909$var$__assign($b26a11afd27fe909$var$__assign({}, c), {
        query: a
    });
}, $b26a11afd27fe909$var$Query = function(a) {
    var c = a.children, f = a.initFetch;
    a = $b26a11afd27fe909$var$useQuery(a.action, void 0 === f ? !0 : f);
    return c(a);
}, $b26a11afd27fe909$var$Mutation = function(a) {
    var c = a.children;
    a = $b26a11afd27fe909$var$useMutation(a.actionCreator);
    return c(a);
}, $b26a11afd27fe909$var$SuspenseQuery = function(a) {
    var c = a.children;
    a = $b26a11afd27fe909$var$useSuspenseQuery(a.action);
    return c(a);
}, $b26a11afd27fe909$var$QueryErrorBoundary = function(a) {
    function c(c) {
        var b = a.call(this, c) || this;
        b.state = {
            hasError: !1
        };
        b.restart = function() {
            b.setState({
                hasError: !1,
                response: void 0
            });
        };
        b.state = {
            hasError: !1,
            response: void 0
        };
        return b;
    }
    $b26a11afd27fe909$var$__extends(c, a);
    c.getDerivedStateFromError = function(a) {
        if (a instanceof $b26a11afd27fe909$var$QueryError) return {
            hasError: !0,
            response: a.response
        };
    };
    c.prototype.render = function() {
        return this.state.hasError && this.state.response && this.state.response.status && this.props.statuses.includes(this.state.response.status) ? this.props.fallback(this.state.response, this.restart) : this.props.children;
    };
    return c;
}($46wWE.Component), $b26a11afd27fe909$var$ClientContextProvider = function(a) {
    var c = a.client;
    return $b26a11afd27fe909$var$React__default.createElement($b26a11afd27fe909$var$ClientContext.Provider, {
        value: {
            query: c.query,
            cache: c.cache,
            suspenseCache: c.suspenseCache
        }
    }, a.children);
};
$b26a11afd27fe909$exports.ClientContext = $b26a11afd27fe909$var$ClientContext;
$b26a11afd27fe909$exports.ClientContextProvider = $b26a11afd27fe909$var$ClientContextProvider;
$b26a11afd27fe909$exports.Mutation = $b26a11afd27fe909$var$Mutation;
$b26a11afd27fe909$exports.Query = $b26a11afd27fe909$var$Query;
$b26a11afd27fe909$exports.QueryError = $b26a11afd27fe909$var$QueryError;
$b26a11afd27fe909$exports.QueryErrorBoundary = $b26a11afd27fe909$var$QueryErrorBoundary;
$b26a11afd27fe909$exports.SuspenseQuery = $b26a11afd27fe909$var$SuspenseQuery;
$b26a11afd27fe909$exports.convertActionToBase64 = $b26a11afd27fe909$var$convertActionToBase64;
$b26a11afd27fe909$exports.createCache = $b26a11afd27fe909$var$createCache;
$b26a11afd27fe909$exports.createClient = $b26a11afd27fe909$var$createClient;
$b26a11afd27fe909$exports.useBulkMutation = $b26a11afd27fe909$var$useBulkMutation;
$b26a11afd27fe909$exports.useCachedResponse = $b26a11afd27fe909$var$useCachedResponse;
$b26a11afd27fe909$exports.useClient = $b26a11afd27fe909$var$useClient;
$b26a11afd27fe909$exports.useMutation = $b26a11afd27fe909$var$useMutation;
$b26a11afd27fe909$exports.useParameterizedQuery = $b26a11afd27fe909$var$useParameterizedQuery;
$b26a11afd27fe909$exports.useQuery = $b26a11afd27fe909$var$useQuery;
$b26a11afd27fe909$exports.useSuspenseQuery = $b26a11afd27fe909$var$useSuspenseQuery;


const $b56f79e0ce8b4d47$export$388e0302ca0d9a41 = (0, $b26a11afd27fe909$exports.createClient)();
async function $b56f79e0ce8b4d47$export$a8ffdece931ecc8(endpoint) {
    return $b56f79e0ce8b4d47$export$388e0302ca0d9a41.query({
        method: "GET",
        headers: $b56f79e0ce8b4d47$var$createHeaders(),
        endpoint: endpoint,
        responseType: "json"
    });
}
async function $b56f79e0ce8b4d47$export$7e57663f042caa12(endpoint, jsonBody) {
    return $b56f79e0ce8b4d47$export$388e0302ca0d9a41.query({
        method: "POST",
        headers: $b56f79e0ce8b4d47$var$createHeaders(),
        body: jsonBody,
        endpoint: endpoint,
        responseType: "json"
    });
}
function $b56f79e0ce8b4d47$var$createHeaders() {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json"
    };
}


const $dc040427e725bec3$export$5a5aa02804a661ac = ""; // No context path for fido demo app
const $dc040427e725bec3$export$a9a724e5d7467de1 = `${$dc040427e725bec3$export$5a5aa02804a661ac}/webapp`;
const $dc040427e725bec3$export$f6fd4406bbd70952 = `${$dc040427e725bec3$export$5a5aa02804a661ac}/`;
const $dc040427e725bec3$export$f6c409e8ade40ab2 = `${$dc040427e725bec3$export$5a5aa02804a661ac}/success`;
const $dc040427e725bec3$export$d832b8b45145d2fd = "/oauth2/authorization/oidc";
const $dc040427e725bec3$export$1dfb6c981e2aebb = "/api/user/info";






function $15efe08fe55aeef3$export$358a232cca1ab2ac(props) {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("p", {
        id: props.id,
        "aria-label": props.id,
        className: [
            props.color,
            props.className
        ].join(" "),
        onClick: props.onClick,
        title: props.title,
        children: props.text
    });
}




function $7cd51dcd135c471b$export$54ec01a60f47d33d(props) {
    function checkIfDataIsComplete() {
        let dataComplete = true;
        props.rows.forEach((row)=>{
            if (row.length !== props.numberOfCols) dataComplete = false;
        });
        return dataComplete;
    }
    if (!checkIfDataIsComplete()) return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {});
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "table",
            props.className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "table-header desktop",
                children: props.firstRowAsHeader && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "table-header-row",
                            children: props.rows[0].map((entry, i)=>{
                                return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                                    className: "table-header entry",
                                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("h3", {
                                        children: entry
                                    })
                                }, `thead-${i}`);
                            })
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("hr", {
                            className: "dark"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "table-content desktop",
                children: props.rows.map((row, index)=>{
                    const firstIndex = props.firstRowAsHeader ? 1 : 0;
                    if (props.rows.indexOf(row) === 0 && props.firstRowAsHeader) return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {});
                    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
                        children: [
                            index !== firstIndex && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("hr", {
                                className: "light"
                            }),
                            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                                className: "table-content-row",
                                children: row.map((entry, i)=>{
                                    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                                        className: "table-content entry",
                                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                            text: entry
                                        })
                                    }, `table-col-${index}-${i}`);
                                })
                            }, "table-entry-" + index)
                        ]
                    });
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "table-content mobile",
                children: props.rows.map((row, rowIndex)=>{
                    const firstIndex = props.firstRowAsHeader ? 1 : 0;
                    if (props.rows.indexOf(row) === 0 && props.firstRowAsHeader) return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {});
                    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
                        children: [
                            rowIndex !== firstIndex && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("hr", {
                                className: "light"
                            }),
                            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                                className: "table-content-row",
                                children: row.map((entry, entryIndex)=>{
                                    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                                        className: "table-content entry",
                                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                            text: props.firstRowAsHeader ? props.rows[0][entryIndex] + ": " + entry : entry
                                        })
                                    }, `table-entry-${rowIndex}-${entryIndex}`);
                                })
                            }, "table-entry-" + rowIndex)
                        ]
                    });
                })
            })
        ]
    });
}




var $be855f318d025b5d$exports = {};
function $be855f318d025b5d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$be855f318d025b5d$exports = $be855f318d025b5d$var$_objectWithoutPropertiesLoose, $be855f318d025b5d$exports.__esModule = true, $be855f318d025b5d$exports["default"] = $be855f318d025b5d$exports;


var $37e115976907f328$exports = {};
function $37e115976907f328$var$_extends() {
    return $37e115976907f328$exports = $37e115976907f328$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $37e115976907f328$exports.__esModule = true, $37e115976907f328$exports["default"] = $37e115976907f328$exports, $37e115976907f328$var$_extends.apply(null, arguments);
}
$37e115976907f328$exports = $37e115976907f328$var$_extends, $37e115976907f328$exports.__esModule = true, $37e115976907f328$exports["default"] = $37e115976907f328$exports;


var $1edde2f5a3a505b3$exports = {};
var $a4f20b346aa76ab0$exports = {};
function $a4f20b346aa76ab0$var$_setPrototypeOf(t, e) {
    return $a4f20b346aa76ab0$exports = $a4f20b346aa76ab0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a4f20b346aa76ab0$exports.__esModule = true, $a4f20b346aa76ab0$exports["default"] = $a4f20b346aa76ab0$exports, $a4f20b346aa76ab0$var$_setPrototypeOf(t, e);
}
$a4f20b346aa76ab0$exports = $a4f20b346aa76ab0$var$_setPrototypeOf, $a4f20b346aa76ab0$exports.__esModule = true, $a4f20b346aa76ab0$exports["default"] = $a4f20b346aa76ab0$exports;


function $1edde2f5a3a505b3$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $a4f20b346aa76ab0$exports(t, o);
}
$1edde2f5a3a505b3$exports = $1edde2f5a3a505b3$var$_inheritsLoose, $1edde2f5a3a505b3$exports.__esModule = true, $1edde2f5a3a505b3$exports["default"] = $1edde2f5a3a505b3$exports;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $e8160e4f46e2fa9c$var$extendStatics = function(d, b) {
    $e8160e4f46e2fa9c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e8160e4f46e2fa9c$var$extendStatics(d, b);
};
function $e8160e4f46e2fa9c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e8160e4f46e2fa9c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e8160e4f46e2fa9c$export$18ce0697a983be9b = function() {
    $e8160e4f46e2fa9c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e8160e4f46e2fa9c$export$18ce0697a983be9b.apply(this, arguments);
};
function $e8160e4f46e2fa9c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e8160e4f46e2fa9c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e8160e4f46e2fa9c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e8160e4f46e2fa9c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e8160e4f46e2fa9c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e8160e4f46e2fa9c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e8160e4f46e2fa9c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e8160e4f46e2fa9c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e8160e4f46e2fa9c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e8160e4f46e2fa9c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e8160e4f46e2fa9c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e8160e4f46e2fa9c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e8160e4f46e2fa9c$export$45d3717a4c69092e(o, m, p);
}
function $e8160e4f46e2fa9c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e8160e4f46e2fa9c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e8160e4f46e2fa9c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e8160e4f46e2fa9c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e8160e4f46e2fa9c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e8160e4f46e2fa9c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e8160e4f46e2fa9c$export$10c90e4f7922046c(v) {
    return this instanceof $e8160e4f46e2fa9c$export$10c90e4f7922046c ? (this.v = v, this) : new $e8160e4f46e2fa9c$export$10c90e4f7922046c(v);
}
function $e8160e4f46e2fa9c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e8160e4f46e2fa9c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e8160e4f46e2fa9c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e8160e4f46e2fa9c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e8160e4f46e2fa9c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e8160e4f46e2fa9c$export$19a8beecd37a4c45 === "function" ? $e8160e4f46e2fa9c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e8160e4f46e2fa9c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e8160e4f46e2fa9c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $e8160e4f46e2fa9c$var$ownKeys = function(o) {
    $e8160e4f46e2fa9c$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $e8160e4f46e2fa9c$var$ownKeys(o);
};
function $e8160e4f46e2fa9c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $e8160e4f46e2fa9c$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $e8160e4f46e2fa9c$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $e8160e4f46e2fa9c$var$__setModuleDefault(result, mod);
    return result;
}
function $e8160e4f46e2fa9c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e8160e4f46e2fa9c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e8160e4f46e2fa9c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e8160e4f46e2fa9c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e8160e4f46e2fa9c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e8160e4f46e2fa9c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e8160e4f46e2fa9c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e8160e4f46e2fa9c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $e8160e4f46e2fa9c$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $e8160e4f46e2fa9c$export$2e2bcd8739ae039 = {
    __extends: $e8160e4f46e2fa9c$export$a8ba968b8961cb8a,
    __assign: $e8160e4f46e2fa9c$export$18ce0697a983be9b,
    __rest: $e8160e4f46e2fa9c$export$3c9a16f847548506,
    __decorate: $e8160e4f46e2fa9c$export$29e00dfd3077644b,
    __param: $e8160e4f46e2fa9c$export$d5ad3fd78186038f,
    __esDecorate: $e8160e4f46e2fa9c$export$3a84e1ae4e97e9b0,
    __runInitializers: $e8160e4f46e2fa9c$export$d831c04e792af3d,
    __propKey: $e8160e4f46e2fa9c$export$6a2a36740a146cb8,
    __setFunctionName: $e8160e4f46e2fa9c$export$d1a06452d3489bc7,
    __metadata: $e8160e4f46e2fa9c$export$f1db080c865becb9,
    __awaiter: $e8160e4f46e2fa9c$export$1050f835b63b671e,
    __generator: $e8160e4f46e2fa9c$export$67ebef60e6f28a6,
    __createBinding: $e8160e4f46e2fa9c$export$45d3717a4c69092e,
    __exportStar: $e8160e4f46e2fa9c$export$f33643c0debef087,
    __values: $e8160e4f46e2fa9c$export$19a8beecd37a4c45,
    __read: $e8160e4f46e2fa9c$export$8d051b38c9118094,
    __spread: $e8160e4f46e2fa9c$export$afc72e2116322959,
    __spreadArrays: $e8160e4f46e2fa9c$export$6388937ca91ccae8,
    __spreadArray: $e8160e4f46e2fa9c$export$1216008129fb82ed,
    __await: $e8160e4f46e2fa9c$export$10c90e4f7922046c,
    __asyncGenerator: $e8160e4f46e2fa9c$export$e427f37a30a4de9b,
    __asyncDelegator: $e8160e4f46e2fa9c$export$bbd80228419bb833,
    __asyncValues: $e8160e4f46e2fa9c$export$e3b29a3d6162315f,
    __makeTemplateObject: $e8160e4f46e2fa9c$export$4fb47efe1390b86f,
    __importStar: $e8160e4f46e2fa9c$export$c21735bcef00d192,
    __importDefault: $e8160e4f46e2fa9c$export$da59b14a69baef04,
    __classPrivateFieldGet: $e8160e4f46e2fa9c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e8160e4f46e2fa9c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e8160e4f46e2fa9c$export$81fdc39f203e4e04,
    __addDisposableResource: $e8160e4f46e2fa9c$export$88ac25d8e944e405,
    __disposeResources: $e8160e4f46e2fa9c$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $e8160e4f46e2fa9c$export$889dfb5d17574b0b
};


/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $244f4a4039c39ebd$export$d9468344d3651243;
var $244f4a4039c39ebd$export$98e6a39c04603d36;
'use strict';
/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */ var $244f4a4039c39ebd$var$PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g // eslint-disable-line no-control-regex
;
var $244f4a4039c39ebd$var$TEXT_REGEXP = /^[\u000b\u0020-\u007e\u0080-\u00ff]+$/ // eslint-disable-line no-control-regex
;
var $244f4a4039c39ebd$var$TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */ var $244f4a4039c39ebd$var$QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g // eslint-disable-line no-control-regex
;
/**
 * RegExp to match chars that must be quoted-pair in RFC 7230 sec 3.2.6
 */ var $244f4a4039c39ebd$var$QUOTE_REGEXP = /([\\"])/g;
/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */ var $244f4a4039c39ebd$var$TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/;
$244f4a4039c39ebd$export$d9468344d3651243 = $244f4a4039c39ebd$var$format;
$244f4a4039c39ebd$export$98e6a39c04603d36 = $244f4a4039c39ebd$var$parse;
/**
 * Format object to media type.
 *
 * @param {object} obj
 * @return {string}
 * @public
 */ function $244f4a4039c39ebd$var$format(obj) {
    if (!obj || typeof obj !== 'object') throw new TypeError('argument obj is required');
    var parameters = obj.parameters;
    var type = obj.type;
    if (!type || !$244f4a4039c39ebd$var$TYPE_REGEXP.test(type)) throw new TypeError('invalid type');
    var string = type;
    // append parameters
    if (parameters && typeof parameters === 'object') {
        var param;
        var params = Object.keys(parameters).sort();
        for(var i = 0; i < params.length; i++){
            param = params[i];
            if (!$244f4a4039c39ebd$var$TOKEN_REGEXP.test(param)) throw new TypeError('invalid parameter name');
            string += '; ' + param + '=' + $244f4a4039c39ebd$var$qstring(parameters[param]);
        }
    }
    return string;
}
/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */ function $244f4a4039c39ebd$var$parse(string) {
    if (!string) throw new TypeError('argument string is required');
    // support req/res-like objects as argument
    var header = typeof string === 'object' ? $244f4a4039c39ebd$var$getcontenttype(string) : string;
    if (typeof header !== 'string') throw new TypeError('argument string is required to be a string');
    var index = header.indexOf(';');
    var type = index !== -1 ? header.slice(0, index).trim() : header.trim();
    if (!$244f4a4039c39ebd$var$TYPE_REGEXP.test(type)) throw new TypeError('invalid media type');
    var obj = new $244f4a4039c39ebd$var$ContentType(type.toLowerCase());
    // parse parameters
    if (index !== -1) {
        var key;
        var match;
        var value;
        $244f4a4039c39ebd$var$PARAM_REGEXP.lastIndex = index;
        while(match = $244f4a4039c39ebd$var$PARAM_REGEXP.exec(header)){
            if (match.index !== index) throw new TypeError('invalid parameter format');
            index += match[0].length;
            key = match[1].toLowerCase();
            value = match[2];
            if (value.charCodeAt(0) === 0x22 /* " */ ) {
                // remove quotes
                value = value.slice(1, -1);
                // remove escapes
                if (value.indexOf('\\') !== -1) value = value.replace($244f4a4039c39ebd$var$QESC_REGEXP, '$1');
            }
            obj.parameters[key] = value;
        }
        if (index !== header.length) throw new TypeError('invalid parameter format');
    }
    return obj;
}
/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */ function $244f4a4039c39ebd$var$getcontenttype(obj) {
    var header;
    if (typeof obj.getHeader === 'function') // res-like
    header = obj.getHeader('content-type');
    else if (typeof obj.headers === 'object') // req-like
    header = obj.headers && obj.headers['content-type'];
    if (typeof header !== 'string') throw new TypeError('content-type header is missing from object');
    return header;
}
/**
 * Quote a string if necessary.
 *
 * @param {string} val
 * @return {string}
 * @private
 */ function $244f4a4039c39ebd$var$qstring(val) {
    var str = String(val);
    // no need to quote tokens
    if ($244f4a4039c39ebd$var$TOKEN_REGEXP.test(str)) return str;
    if (str.length > 0 && !$244f4a4039c39ebd$var$TEXT_REGEXP.test(str)) throw new TypeError('invalid parameter value');
    return '"' + str.replace($244f4a4039c39ebd$var$QUOTE_REGEXP, '\\$1') + '"';
}
/**
 * Class to represent a content type.
 * @private
 */ function $244f4a4039c39ebd$var$ContentType(type) {
    this.parameters = Object.create(null);
    this.type = type;
}


var $b0f10d7992208f08$var$cache = new Map();
var $b0f10d7992208f08$var$cloneSvg = function cloneSvg(sourceSvg) {
    return sourceSvg.cloneNode(true);
};
var $b0f10d7992208f08$var$isLocal = function isLocal() {
    return window.location.protocol === 'file:';
};
var $b0f10d7992208f08$var$makeAjaxRequest = function makeAjaxRequest(url, httpRequestWithCredentials, callback) {
    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function() {
        try {
            if (!/\.svg/i.test(url) && httpRequest.readyState === 2) {
                var contentType = httpRequest.getResponseHeader('Content-Type');
                if (!contentType) throw new Error('Content type not found');
                var type = (0, $244f4a4039c39ebd$export$98e6a39c04603d36)(contentType).type;
                if (!(type === 'image/svg+xml' || type === 'text/plain')) throw new Error("Invalid content type: ".concat(type));
            }
            if (httpRequest.readyState === 4) {
                if (httpRequest.status === 404 || httpRequest.responseXML === null) throw new Error($b0f10d7992208f08$var$isLocal() ? "Note: SVG injection ajax calls do not work locally without adjusting security settings in your browser. Or consider using a local webserver." : 'Unable to load SVG file: ' + url);
                if (httpRequest.status === 200 || $b0f10d7992208f08$var$isLocal() && httpRequest.status === 0) callback(null, httpRequest);
                else throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
            }
        } catch (error) {
            httpRequest.abort();
            if (error instanceof Error) callback(error, httpRequest);
            else throw error;
        }
    };
    httpRequest.open('GET', url);
    httpRequest.withCredentials = httpRequestWithCredentials;
    if (httpRequest.overrideMimeType) httpRequest.overrideMimeType('text/xml');
    httpRequest.send();
};
var $b0f10d7992208f08$var$requestQueue = {};
var $b0f10d7992208f08$var$queueRequest = function queueRequest(url, callback) {
    $b0f10d7992208f08$var$requestQueue[url] = $b0f10d7992208f08$var$requestQueue[url] || [];
    $b0f10d7992208f08$var$requestQueue[url].push(callback);
};
var $b0f10d7992208f08$var$processRequestQueue = function processRequestQueue(url) {
    var _loop_1 = function _loop_1(i, len) {
        setTimeout(function() {
            if (Array.isArray($b0f10d7992208f08$var$requestQueue[url])) {
                var cacheValue = $b0f10d7992208f08$var$cache.get(url);
                var callback = $b0f10d7992208f08$var$requestQueue[url][i];
                if (cacheValue instanceof SVGSVGElement) callback(null, $b0f10d7992208f08$var$cloneSvg(cacheValue));
                if (cacheValue instanceof Error) callback(cacheValue);
                if (i === $b0f10d7992208f08$var$requestQueue[url].length - 1) delete $b0f10d7992208f08$var$requestQueue[url];
            }
        }, 0);
    };
    for(var i = 0, len = $b0f10d7992208f08$var$requestQueue[url].length; i < len; i++)_loop_1(i);
};
var $b0f10d7992208f08$var$loadSvgCached = function loadSvgCached(url, httpRequestWithCredentials, callback) {
    if ($b0f10d7992208f08$var$cache.has(url)) {
        var cacheValue = $b0f10d7992208f08$var$cache.get(url);
        if (cacheValue === undefined) {
            $b0f10d7992208f08$var$queueRequest(url, callback);
            return;
        }
        if (cacheValue instanceof SVGSVGElement) {
            callback(null, $b0f10d7992208f08$var$cloneSvg(cacheValue));
            return;
        }
    }
    $b0f10d7992208f08$var$cache.set(url, undefined);
    $b0f10d7992208f08$var$queueRequest(url, callback);
    $b0f10d7992208f08$var$makeAjaxRequest(url, httpRequestWithCredentials, function(error, httpRequest) {
        var _a;
        if (error) $b0f10d7992208f08$var$cache.set(url, error);
        else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) $b0f10d7992208f08$var$cache.set(url, httpRequest.responseXML.documentElement);
        $b0f10d7992208f08$var$processRequestQueue(url);
    });
};
var $b0f10d7992208f08$var$loadSvgUncached = function loadSvgUncached(url, httpRequestWithCredentials, callback) {
    $b0f10d7992208f08$var$makeAjaxRequest(url, httpRequestWithCredentials, function(error, httpRequest) {
        var _a;
        if (error) callback(error);
        else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) callback(null, httpRequest.responseXML.documentElement);
    });
};
var $b0f10d7992208f08$var$idCounter = 0;
var $b0f10d7992208f08$var$uniqueId = function uniqueId() {
    return ++$b0f10d7992208f08$var$idCounter;
};
var $b0f10d7992208f08$var$injectedElements = [];
var $b0f10d7992208f08$var$ranScripts = {};
var $b0f10d7992208f08$var$svgNamespace = 'http://www.w3.org/2000/svg';
var $b0f10d7992208f08$var$xlinkNamespace = 'http://www.w3.org/1999/xlink';
var $b0f10d7992208f08$var$injectElement = function injectElement(el, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, callback) {
    var elUrl = el.getAttribute('data-src') || el.getAttribute('src');
    if (!elUrl) {
        callback(new Error('Invalid data-src or src attribute'));
        return;
    }
    if ($b0f10d7992208f08$var$injectedElements.indexOf(el) !== -1) {
        $b0f10d7992208f08$var$injectedElements.splice($b0f10d7992208f08$var$injectedElements.indexOf(el), 1);
        el = null;
        return;
    }
    $b0f10d7992208f08$var$injectedElements.push(el);
    el.setAttribute('src', '');
    var loadSvg = cacheRequests ? $b0f10d7992208f08$var$loadSvgCached : $b0f10d7992208f08$var$loadSvgUncached;
    loadSvg(elUrl, httpRequestWithCredentials, function(error, svg) {
        if (!svg) {
            $b0f10d7992208f08$var$injectedElements.splice($b0f10d7992208f08$var$injectedElements.indexOf(el), 1);
            el = null;
            callback(error);
            return;
        }
        var elId = el.getAttribute('id');
        if (elId) svg.setAttribute('id', elId);
        var elTitle = el.getAttribute('title');
        if (elTitle) svg.setAttribute('title', elTitle);
        var elWidth = el.getAttribute('width');
        if (elWidth) svg.setAttribute('width', elWidth);
        var elHeight = el.getAttribute('height');
        if (elHeight) svg.setAttribute('height', elHeight);
        var mergedClasses = Array.from(new Set((0, $e8160e4f46e2fa9c$export$1216008129fb82ed)((0, $e8160e4f46e2fa9c$export$1216008129fb82ed)((0, $e8160e4f46e2fa9c$export$1216008129fb82ed)([], (svg.getAttribute('class') || '').split(' '), true), [
            'injected-svg'
        ], false), (el.getAttribute('class') || '').split(' '), true))).join(' ').trim();
        svg.setAttribute('class', mergedClasses);
        var elStyle = el.getAttribute('style');
        if (elStyle) svg.setAttribute('style', elStyle);
        svg.setAttribute('data-src', elUrl);
        var elData = [].filter.call(el.attributes, function(at) {
            return /^data-\w[\w-]*$/.test(at.name);
        });
        Array.prototype.forEach.call(elData, function(dataAttr) {
            if (dataAttr.name && dataAttr.value) svg.setAttribute(dataAttr.name, dataAttr.value);
        });
        if (renumerateIRIElements) {
            var iriElementsAndProperties_1 = {
                clipPath: [
                    'clip-path'
                ],
                'color-profile': [
                    'color-profile'
                ],
                cursor: [
                    'cursor'
                ],
                filter: [
                    'filter'
                ],
                linearGradient: [
                    'fill',
                    'stroke'
                ],
                marker: [
                    'marker',
                    'marker-start',
                    'marker-mid',
                    'marker-end'
                ],
                mask: [
                    'mask'
                ],
                path: [],
                pattern: [
                    'fill',
                    'stroke'
                ],
                radialGradient: [
                    'fill',
                    'stroke'
                ]
            };
            var element_1;
            var elements_1;
            var properties_1;
            var currentId_1;
            var newId_1;
            Object.keys(iriElementsAndProperties_1).forEach(function(key) {
                element_1 = key;
                properties_1 = iriElementsAndProperties_1[key];
                elements_1 = svg.querySelectorAll(element_1 + '[id]');
                var _loop_1 = function _loop_1(a, elementsLen) {
                    currentId_1 = elements_1[a].id;
                    newId_1 = currentId_1 + '-' + $b0f10d7992208f08$var$uniqueId();
                    var referencingElements;
                    Array.prototype.forEach.call(properties_1, function(property) {
                        referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId_1 + '"]');
                        for(var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++){
                            var attrValue = referencingElements[b].getAttribute(property);
                            if (attrValue && !attrValue.match(new RegExp('url\\("?#' + currentId_1 + '"?\\)'))) continue;
                            referencingElements[b].setAttribute(property, 'url(#' + newId_1 + ')');
                        }
                    });
                    var allLinks = svg.querySelectorAll('[*|href]');
                    var links = [];
                    for(var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++){
                        var href = allLinks[c].getAttributeNS($b0f10d7992208f08$var$xlinkNamespace, 'href');
                        if (href && href.toString() === '#' + elements_1[a].id) links.push(allLinks[c]);
                    }
                    for(var d = 0, linksLen = links.length; d < linksLen; d++)links[d].setAttributeNS($b0f10d7992208f08$var$xlinkNamespace, 'href', '#' + newId_1);
                    elements_1[a].id = newId_1;
                };
                for(var a = 0, elementsLen = elements_1.length; a < elementsLen; a++)_loop_1(a);
            });
        }
        svg.removeAttribute('xmlns:a');
        var scripts = svg.querySelectorAll('script');
        var scriptsToEval = [];
        var script;
        var scriptType;
        for(var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++){
            scriptType = scripts[i].getAttribute('type');
            if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
                script = scripts[i].innerText || scripts[i].textContent;
                if (script) scriptsToEval.push(script);
                svg.removeChild(scripts[i]);
            }
        }
        if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !$b0f10d7992208f08$var$ranScripts[elUrl])) {
            for(var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++)new Function(scriptsToEval[l])(window);
            $b0f10d7992208f08$var$ranScripts[elUrl] = true;
        }
        var styleTags = svg.querySelectorAll('style');
        Array.prototype.forEach.call(styleTags, function(styleTag) {
            styleTag.textContent += '';
        });
        svg.setAttribute('xmlns', $b0f10d7992208f08$var$svgNamespace);
        svg.setAttribute('xmlns:xlink', $b0f10d7992208f08$var$xlinkNamespace);
        beforeEach(svg);
        if (!el.parentNode) {
            $b0f10d7992208f08$var$injectedElements.splice($b0f10d7992208f08$var$injectedElements.indexOf(el), 1);
            el = null;
            callback(new Error('Parent node is null'));
            return;
        }
        el.parentNode.replaceChild(svg, el);
        $b0f10d7992208f08$var$injectedElements.splice($b0f10d7992208f08$var$injectedElements.indexOf(el), 1);
        el = null;
        callback(null, svg);
    });
};
var $b0f10d7992208f08$export$31d45920fabb4a69 = function SVGInjector(elements, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.afterAll, afterAll = _c === void 0 ? function() {
        return undefined;
    } : _c, _d = _b.afterEach, afterEach = _d === void 0 ? function() {
        return undefined;
    } : _d, _e = _b.beforeEach, beforeEach = _e === void 0 ? function() {
        return undefined;
    } : _e, _f = _b.cacheRequests, cacheRequests = _f === void 0 ? true : _f, _g = _b.evalScripts, evalScripts = _g === void 0 ? 'never' : _g, _h = _b.httpRequestWithCredentials, httpRequestWithCredentials = _h === void 0 ? false : _h, _j = _b.renumerateIRIElements, renumerateIRIElements = _j === void 0 ? true : _j;
    if (elements && 'length' in elements) {
        var elementsLoaded_1 = 0;
        for(var i = 0, j = elements.length; i < j; i++)$b0f10d7992208f08$var$injectElement(elements[i], evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function(error, svg) {
            afterEach(error, svg);
            if (elements && 'length' in elements && elements.length === ++elementsLoaded_1) afterAll(elementsLoaded_1);
        });
    } else if (elements) $b0f10d7992208f08$var$injectElement(elements, evalScripts, renumerateIRIElements, cacheRequests, httpRequestWithCredentials, beforeEach, function(error, svg) {
        afterEach(error, svg);
        afterAll(1);
        elements = null;
    });
    else afterAll(0);
};


var $7978e58be7328275$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7978e58be7328275$var$ReactIs, $7978e58be7328275$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$7978e58be7328275$exports = (parcelRequire("b5Cpj"))();



var $46wWE = parcelRequire("46wWE");
// Hat-tip: https://github.com/mui/material-ui/tree/master/packages/mui-utils/src.
var $6d8ff2be542c30cc$var$ownerWindow = function ownerWindow(node) {
    var doc = (node == null ? undefined : node.ownerDocument) || document;
    return doc.defaultView || window;
};
// Hat-tip: https://github.com/developit/preact-compat/blob/master/src/index.js#L402.
var $6d8ff2be542c30cc$var$shallowDiffers = function shallowDiffers(a, b) {
    for(var i in a){
        if (!(i in b)) return true;
    }
    for(var _i in b){
        if (a[_i] !== b[_i]) return true;
    }
    return false;
};
var $6d8ff2be542c30cc$var$_excluded = [
    "afterInjection",
    "beforeInjection",
    "desc",
    "evalScripts",
    "fallback",
    "httpRequestWithCredentials",
    "loading",
    "renumerateIRIElements",
    "src",
    "title",
    "useRequestCache",
    "wrapper"
];
var $6d8ff2be542c30cc$var$svgNamespace = 'http://www.w3.org/2000/svg';
var $6d8ff2be542c30cc$var$xlinkNamespace = 'http://www.w3.org/1999/xlink';
var $6d8ff2be542c30cc$export$6c09fee102878c7 = /*#__PURE__*/ function(_React$Component) {
    function ReactSVG() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.initialState = {
            hasError: false,
            isLoading: true
        };
        _this.state = _this.initialState;
        _this._isMounted = false;
        _this.reactWrapper = undefined;
        _this.nonReactWrapper = undefined;
        _this.refCallback = function(reactWrapper) {
            _this.reactWrapper = reactWrapper;
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($1edde2f5a3a505b3$exports)))(ReactSVG, _React$Component);
    var _proto = ReactSVG.prototype;
    _proto.renderSVG = function renderSVG() {
        var _this2 = this;
        /* istanbul ignore else */ if (this.reactWrapper instanceof $6d8ff2be542c30cc$var$ownerWindow(this.reactWrapper).Node) {
            var _this$props = this.props, desc = _this$props.desc, evalScripts = _this$props.evalScripts, httpRequestWithCredentials = _this$props.httpRequestWithCredentials, renumerateIRIElements = _this$props.renumerateIRIElements, src = _this$props.src, title = _this$props.title, useRequestCache = _this$props.useRequestCache;
            /* eslint-disable @typescript-eslint/no-non-null-assertion */ var onError = this.props.onError;
            var beforeInjection = this.props.beforeInjection;
            var afterInjection = this.props.afterInjection;
            var wrapper = this.props.wrapper;
            var nonReactWrapper;
            var nonReactTarget;
            if (wrapper === 'svg') {
                nonReactWrapper = document.createElementNS($6d8ff2be542c30cc$var$svgNamespace, wrapper);
                nonReactWrapper.setAttribute('xmlns', $6d8ff2be542c30cc$var$svgNamespace);
                nonReactWrapper.setAttribute('xmlns:xlink', $6d8ff2be542c30cc$var$xlinkNamespace);
                nonReactTarget = document.createElementNS($6d8ff2be542c30cc$var$svgNamespace, wrapper);
            } else {
                nonReactWrapper = document.createElement(wrapper);
                nonReactTarget = document.createElement(wrapper);
            }
            nonReactWrapper.appendChild(nonReactTarget);
            nonReactTarget.dataset.src = src;
            this.nonReactWrapper = this.reactWrapper.appendChild(nonReactWrapper);
            var handleError = function handleError(error) {
                _this2.removeSVG();
                if (!_this2._isMounted) {
                    onError(error);
                    return;
                }
                _this2.setState(function() {
                    return {
                        hasError: true,
                        isLoading: false
                    };
                }, function() {
                    onError(error);
                });
            };
            var afterEach = function afterEach(error, svg) {
                if (error) {
                    handleError(error);
                    return;
                }
                // TODO (Tane): It'd be better to cleanly unsubscribe from SVGInjector
                // callbacks instead of tracking a property like this.
                if (_this2._isMounted) _this2.setState(function() {
                    return {
                        isLoading: false
                    };
                }, function() {
                    try {
                        afterInjection(svg);
                    } catch (afterInjectionError) {
                        handleError(afterInjectionError);
                    }
                });
            };
            var beforeEach = function beforeEach(svg) {
                svg.setAttribute('role', 'img');
                if (desc) {
                    var originalDesc = svg.querySelector(':scope > desc');
                    if (originalDesc) svg.removeChild(originalDesc);
                    var newDesc = document.createElement('desc');
                    newDesc.innerHTML = desc;
                    svg.prepend(newDesc);
                }
                if (title) {
                    var originalTitle = svg.querySelector(':scope > title');
                    if (originalTitle) svg.removeChild(originalTitle);
                    var newTitle = document.createElement('title');
                    newTitle.innerHTML = title;
                    svg.prepend(newTitle);
                }
                try {
                    beforeInjection(svg);
                } catch (error) {
                    handleError(error);
                }
            };
            (0, $b0f10d7992208f08$export$31d45920fabb4a69)(nonReactTarget, {
                afterEach: afterEach,
                beforeEach: beforeEach,
                cacheRequests: useRequestCache,
                evalScripts: evalScripts,
                httpRequestWithCredentials: httpRequestWithCredentials,
                renumerateIRIElements: renumerateIRIElements
            });
        }
    };
    _proto.removeSVG = function removeSVG() {
        var _this$nonReactWrapper;
        if ((_this$nonReactWrapper = this.nonReactWrapper) != null && _this$nonReactWrapper.parentNode) {
            this.nonReactWrapper.parentNode.removeChild(this.nonReactWrapper);
            this.nonReactWrapper = null;
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.renderSVG();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this3 = this;
        if ($6d8ff2be542c30cc$var$shallowDiffers((0, (/*@__PURE__*/$parcel$interopDefault($37e115976907f328$exports)))({}, prevProps), this.props)) this.setState(function() {
            return _this3.initialState;
        }, function() {
            _this3.removeSVG();
            _this3.renderSVG();
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        this.removeSVG();
    };
    _proto.render = function render() {
        /* eslint-disable @typescript-eslint/no-unused-vars */ var _this$props2 = this.props;
        _this$props2.afterInjection;
        _this$props2.beforeInjection;
        _this$props2.desc;
        _this$props2.evalScripts;
        var Fallback = _this$props2.fallback;
        _this$props2.httpRequestWithCredentials;
        var Loading = _this$props2.loading;
        _this$props2.renumerateIRIElements;
        _this$props2.src;
        _this$props2.title;
        _this$props2.useRequestCache;
        var wrapper = _this$props2.wrapper, rest = (0, (/*@__PURE__*/$parcel$interopDefault($be855f318d025b5d$exports)))(_this$props2, $6d8ff2be542c30cc$var$_excluded);
        /* eslint-enable @typescript-eslint/no-unused-vars */ // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var Wrapper = wrapper;
        return /*#__PURE__*/ $46wWE.createElement(Wrapper, (0, (/*@__PURE__*/$parcel$interopDefault($37e115976907f328$exports)))({}, rest, {
            ref: this.refCallback
        }, wrapper === 'svg' ? {
            xmlns: $6d8ff2be542c30cc$var$svgNamespace,
            xmlnsXlink: $6d8ff2be542c30cc$var$xlinkNamespace
        } : {}), this.state.isLoading && Loading && /*#__PURE__*/ $46wWE.createElement(Loading, null), this.state.hasError && Fallback && /*#__PURE__*/ $46wWE.createElement(Fallback, null));
    };
    return ReactSVG;
}($46wWE.Component);
$6d8ff2be542c30cc$export$6c09fee102878c7.defaultProps = {
    afterInjection: function afterInjection() {
        return undefined;
    },
    beforeInjection: function beforeInjection() {
        return undefined;
    },
    desc: '',
    evalScripts: 'never',
    fallback: null,
    httpRequestWithCredentials: false,
    loading: null,
    onError: function onError() {
        return undefined;
    },
    renumerateIRIElements: true,
    title: '',
    useRequestCache: true,
    wrapper: 'div'
};
$6d8ff2be542c30cc$export$6c09fee102878c7.propTypes = {
    afterInjection: $7978e58be7328275$exports.func,
    beforeInjection: $7978e58be7328275$exports.func,
    desc: $7978e58be7328275$exports.string,
    evalScripts: $7978e58be7328275$exports.oneOf([
        'always',
        'once',
        'never'
    ]),
    fallback: $7978e58be7328275$exports.oneOfType([
        $7978e58be7328275$exports.func,
        $7978e58be7328275$exports.object,
        $7978e58be7328275$exports.string
    ]),
    httpRequestWithCredentials: $7978e58be7328275$exports.bool,
    loading: $7978e58be7328275$exports.oneOfType([
        $7978e58be7328275$exports.func,
        $7978e58be7328275$exports.object,
        $7978e58be7328275$exports.string
    ]),
    onError: $7978e58be7328275$exports.func,
    renumerateIRIElements: $7978e58be7328275$exports.bool,
    src: $7978e58be7328275$exports.string.isRequired,
    title: $7978e58be7328275$exports.string,
    useRequestCache: $7978e58be7328275$exports.bool,
    wrapper: $7978e58be7328275$exports.oneOf([
        'div',
        'span',
        'svg'
    ])
};




var $46wWE = parcelRequire("46wWE");



function $428c6867a99ff0e4$export$a8a3e93435678ff9(props) {
    switch(props.type){
        case "h1":
            return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("h1", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                style: props.style,
                children: props.text
            });
        case "h2":
            return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("h2", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                style: props.style,
                children: props.text
            });
        case "h3":
            return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("h3", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                style: props.style,
                children: props.text
            });
        case "h4":
            return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("h4", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                style: props.style,
                children: props.text
            });
        case "h5":
            return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("h5", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                style: props.style,
                children: props.text
            });
        case "h6":
            return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("h6", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                style: props.style,
                children: props.text
            });
    }
}




function $e6028c3c1843af56$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $307af824b9387905$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $e6028c3c1843af56$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $9b16bcd0300d97f8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9b16bcd0300d97f8$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $9b16bcd0300d97f8$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $eaf1f011d09a5a5c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $d9d4991687d1f007$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $eaf1f011d09a5a5c$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}





const $cce3927210294d78$export$37326c68d11eed93 = {
    "badge-error": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
                    fill: "#E61E50"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.1261 13.9733C10.2003 13.9733 9.44986 14.7237 9.44986 15.6495C9.44986 16.5752 10.2003 17.3257 11.1261 17.3257C12.0518 17.3257 12.8022 16.5752 12.8022 15.6495C12.8022 14.7237 12.0518 13.9733 11.1261 13.9733ZM12.2804 4.81717C11.9325 4.46928 11.4521 4.29534 10.8392 4.29534L9.67125 4.29534C9.43932 4.29534 9.32336 4.39473 9.32336 4.59353L9.32336 10.3337C9.32336 10.9466 9.4973 11.4271 9.84519 11.7749C10.1931 12.1228 10.6735 12.2968 11.2864 12.2968L12.4544 12.2968C12.6863 12.2968 12.8022 12.1974 12.8022 11.9986L12.8022 6.25842C12.8022 5.64547 12.6283 5.16506 12.2804 4.81717Z",
                    fill: "white"
                })
            ]
        }),
    "badge-info": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
                    fill: "#0F69AF"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.9994 7.64772C11.9252 7.64772 12.6756 6.89727 12.6756 5.97153C12.6756 5.0458 11.9252 4.29534 10.9994 4.29534C10.0737 4.29534 9.32324 5.0458 9.32324 5.97153C9.32324 6.89727 10.0737 7.64772 10.9994 7.64772ZM9.84508 16.8038C10.193 17.1517 10.6734 17.3257 11.2863 17.3257H12.4542C12.6862 17.3257 12.8021 17.2263 12.8021 17.0275V11.2873C12.8021 10.6744 12.6282 10.1939 12.2803 9.84605C11.9324 9.49816 11.452 9.32422 10.839 9.32422H9.67113C9.4392 9.32422 9.32324 9.42362 9.32324 9.62241V15.3626C9.32324 15.9755 9.49718 16.4559 9.84508 16.8038Z",
                    fill: "white"
                })
            ]
        }),
    "badge-success": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    fill: "#01884C",
                    d: "M11,22c6.1,0,11-4.9,11-11c0-6.1-4.9-11-11-11C4.9,0,0,4.9,0,11C0,17.1,4.9,22,11,22z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "none",
                    stroke: "#ffffff",
                    strokeWidth: "3",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M15.5,8.3l-5.9,5.4l-3.1-3"
                })
            ]
        }),
    "badge-warning": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
                    fill: "#FFC832"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.9997 7.64772C11.9254 7.64772 12.6759 6.89727 12.6759 5.97153C12.6759 5.0458 11.9254 4.29534 10.9997 4.29534C10.0739 4.29534 9.32349 5.0458 9.32349 5.97153C9.32349 6.89727 10.0739 7.64772 10.9997 7.64772ZM9.84532 16.8038C10.1932 17.1517 10.6736 17.3257 11.2866 17.3257H12.4545C12.6864 17.3257 12.8024 17.2263 12.8024 17.0275V11.2873C12.8024 10.6744 12.6284 10.1939 12.2805 9.84605C11.9326 9.49816 11.4522 9.32422 10.8393 9.32422H9.67138C9.43945 9.32422 9.32349 9.42362 9.32349 9.62241V15.3626C9.32349 15.9755 9.49743 16.4559 9.84532 16.8038Z",
                    fill: "#0F1A2E"
                })
            ]
        }),
    "shield-plus": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "#01884C",
                    stroke: "#01884C",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M26.7,16c0,6.5-7.1,11.3-9.7,12.8c-0.3,0.2-0.4,0.3-0.7,0.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4-0.1-0.7-0.3  c-2.6-1.5-9.7-6.3-9.7-12.8V9.6c0-1.1,0-1.6,0.2-2.1c0.2-0.4,0.4-0.8,0.7-1.1C6.6,6.2,7.1,6,8.1,5.6l7.1-2.7  c0.3-0.1,0.4-0.2,0.6-0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0.1,0.6,0.2l7.1,2.7c1,0.4,1.5,0.6,1.9,0.9c0.3,0.3,0.6,0.6,0.7,1.1  c0.2,0.5,0.2,1,0.2,2.1V16z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("line", {
                    fill: "none",
                    stroke: "#ffffff",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    x1: "16.5",
                    y1: "20",
                    x2: "16.5",
                    y2: "11"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("line", {
                    fill: "none",
                    stroke: "#ffffff",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    x1: "12",
                    y1: "15.25",
                    x2: "21",
                    y2: "15.25"
                })
            ]
        }),
    "shield-success": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "#01884C",
                    stroke: "#01884C",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M26.7,16c0,6.5-7.1,11.3-9.7,12.8c-0.3,0.2-0.4,0.3-0.7,0.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4-0.1-0.7-0.3  c-2.6-1.5-9.7-6.3-9.7-12.8V9.6c0-1.1,0-1.6,0.2-2.1c0.2-0.4,0.4-0.8,0.7-1.1C6.6,6.2,7.1,6,8.1,5.6l7.1-2.7  c0.3-0.1,0.4-0.2,0.6-0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0.1,0.6,0.2l7.1,2.7c1,0.4,1.5,0.6,1.9,0.9c0.3,0.3,0.6,0.6,0.7,1.1  c0.2,0.5,0.2,1,0.2,2.1V16z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "none",
                    stroke: "#ffffff",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M12,16.3l2.7,2.7l6-6"
                })
            ]
        }),
    "shield-warning": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "#FFC832",
                    stroke: "#FFC832",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M26.7,16c0,6.5-7.1,11.3-9.7,12.8c-0.3,0.2-0.4,0.3-0.7,0.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4-0.1-0.7-0.3  c-2.6-1.5-9.7-6.3-9.7-12.8V9.6c0-1.1,0-1.6,0.2-2.1c0.2-0.4,0.4-0.8,0.7-1.1C6.6,6.2,7.1,6,8.1,5.6l7.1-2.7  c0.3-0.1,0.4-0.2,0.6-0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0.1,0.6,0.2l7.1,2.7c1,0.4,1.5,0.6,1.9,0.9c0.3,0.3,0.6,0.6,0.7,1.1  c0.2,0.5,0.2,1,0.2,2.1V16z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    fill: "#0F1A2E",
                    d: "M15.8,12.7c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8S14,9.8,14,10.8C14,11.8,14.8,12.7,15.8,12.7z M14.6,22.6  c0.4,0.4,0.9,0.6,1.6,0.6h1.3c0.3,0,0.4-0.1,0.4-0.3v-6.3c0-0.7-0.2-1.2-0.6-1.6c-0.4-0.4-0.9-0.6-1.6-0.6h-1.3  c-0.3,0-0.4,0.1-0.4,0.3v6.3C14,21.7,14.2,22.3,14.6,22.6z"
                })
            ]
        }),
    "star-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M11.2827 3.4533C11.5131 2.98637 11.6284 2.7529 11.7848 2.6783C11.9209 2.6134 12.0791 2.6134 12.2152 2.6783C12.3717 2.7529 12.4869 2.98637 12.7174 3.4533L14.9041 7.88327C14.9721 8.02112 15.0061 8.09005 15.0558 8.14356C15.0999 8.19095 15.1527 8.22934 15.2113 8.25661C15.2776 8.28741 15.3536 8.29853 15.5057 8.32076L20.397 9.03569C20.9121 9.11098 21.1696 9.14862 21.2888 9.27443C21.3925 9.38388 21.4412 9.53428 21.4215 9.68376C21.3988 9.85557 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0075 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8583 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8583 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0075 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85557 2.57853 9.68376C2.55879 9.53428 2.60755 9.38388 2.71125 9.27443C2.83044 9.14862 3.08797 9.11098 3.60304 9.03569L8.49431 8.32076C8.64642 8.29853 8.72248 8.28741 8.78872 8.25661C8.84736 8.22934 8.90016 8.19095 8.94419 8.14356C8.99391 8.09005 9.02793 8.02112 9.09597 7.88327L11.2827 3.4533Z",
            fill: "#ffffff",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "star-01-filled": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M11.2827 3.4533C11.5131 2.98637 11.6284 2.7529 11.7848 2.6783C11.9209 2.6134 12.0791 2.6134 12.2152 2.6783C12.3717 2.7529 12.4869 2.98637 12.7174 3.4533L14.9041 7.88327C14.9721 8.02112 15.0061 8.09005 15.0558 8.14356C15.0999 8.19095 15.1527 8.22934 15.2113 8.25661C15.2776 8.28741 15.3536 8.29853 15.5057 8.32076L20.397 9.03569C20.9121 9.11098 21.1696 9.14862 21.2888 9.27443C21.3925 9.38388 21.4412 9.53428 21.4215 9.68376C21.3988 9.85557 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0075 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8583 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8583 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0075 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85557 2.57853 9.68376C2.55879 9.53428 2.60755 9.38388 2.71125 9.27443C2.83044 9.14862 3.08797 9.11098 3.60304 9.03569L8.49431 8.32076C8.64642 8.29853 8.72248 8.28741 8.78872 8.25661C8.84736 8.22934 8.90016 8.19095 8.94419 8.14356C8.99391 8.09005 9.02793 8.02112 9.09597 7.88327L11.2827 3.4533Z",
            fill: "#FFC832",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    logo: ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("g", {
                    clipPath: "url(#clip0_614_11457)",
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M29.7473 0.216309H27.36C27.2411 0.217407 27.1329 0.265187 27.0518 0.342075L22.2686 4.90481C20.63 6.46893 18.4249 7.3471 16.0003 7.3471C13.4729 7.3471 11.1862 6.3882 9.52923 4.70655C9.52923 4.70655 6.01098 1.34985 5.98071 1.31965C5.30549 0.681479 4.37619 0.240473 3.30634 0.216309H0.450324C0.201645 0.216309 0 0.421159 0 0.673791V13.4943C0 14.7596 1.00823 15.7839 2.25324 15.7839H3.12523H3.71449C3.96479 15.7839 4.16752 15.5774 4.16752 15.3236L4.1686 10.7615C4.1686 9.56915 5.12655 8.58554 6.28128 8.58554C8.43073 8.58554 9.97199 10.4561 11.3646 11.7055C13.0702 13.2361 14.3839 14.7107 16.0003 14.7107C17.6151 14.7107 18.9293 13.2361 20.6349 11.7055C22.028 10.4561 23.5693 8.58554 25.7176 8.58554C26.8664 8.58554 27.8195 9.55927 27.8309 10.7422V13.4943C27.8309 14.7596 28.8396 15.7817 30.0852 15.7817H31.0577C31.3118 15.7817 31.5475 15.7839 31.5475 15.7839C31.7973 15.7839 32 15.5774 32 15.3242C32 15.3176 32 2.61301 32 2.50592C32 1.24111 30.9907 0.216309 29.7473 0.216309Z",
                        fill: "#FFC832"
                    })
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("clipPath", {
                        id: "clip0_614_11457",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("rect", {
                            width: "32",
                            height: "15.5676",
                            fill: "white",
                            transform: "translate(0 0.216309)"
                        })
                    })
                })
            ]
        })
};
const $cce3927210294d78$export$c97c7b8ce74ef4ad = {
    "edit-02": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M18 10L14 6M2.49997 21.5L5.88434 21.124C6.29783 21.078 6.50457 21.055 6.69782 20.9925C6.86926 20.937 7.03242 20.8586 7.18286 20.7594C7.35242 20.6475 7.49951 20.5005 7.7937 20.2063L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8954 1.89543 18.1046 1.89543 17 3L3.7937 16.2063C3.49952 16.5005 3.35242 16.6475 3.24061 16.8171C3.1414 16.9676 3.06298 17.1307 3.00748 17.3022C2.94493 17.4954 2.92195 17.7021 2.87601 18.1156L2.49997 21.5Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "shield-success": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "none",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M20,12c0,4.9-5.4,8.5-7.3,9.6c-0.2,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3-0.1-0.5-0.2 C9.4,20.5,4,16.9,4,12V7.2C4,6.4,4,6,4.1,5.7c0.1-0.3,0.3-0.6,0.5-0.8C5,4.6,5.3,4.5,6.1,4.2l5.4-2c0.2-0.1,0.3-0.1,0.4-0.1 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.4,0.1l5.4,2c0.7,0.3,1.1,0.4,1.4,0.7c0.2,0.2,0.4,0.5,0.5,0.8C20,6,20,6.4,20,7.2V12z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "none",
                    stroke: "#ffffff",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M8,12.3l2.7,2.7l6-6"
                })
            ]
        }),
    "shield-plus": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "none",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M20,12c0,4.9-5.4,8.5-7.3,9.6c-0.2,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3-0.1-0.5-0.2 C9.4,20.5,4,16.9,4,12V7.2C4,6.4,4,6,4.1,5.7c0.1-0.3,0.3-0.6,0.5-0.8C5,4.6,5.3,4.5,6.1,4.2l5.4-2c0.2-0.1,0.3-0.1,0.4-0.1 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.4,0.1l5.4,2c0.7,0.3,1.1,0.4,1.4,0.7c0.2,0.2,0.4,0.5,0.5,0.8C20,6,20,6.4,20,7.2V12z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("line", {
                    fill: "none",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    x1: "12",
                    y1: "14.5",
                    x2: "12",
                    y2: "8.5"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("line", {
                    fill: "none",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    x1: "9",
                    y1: "11.5",
                    x2: "15",
                    y2: "11.5"
                })
            ]
        }),
    "shield-not": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M8.80868 3.19661L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999C20 12.7202 19.8847 13.4117 19.6818 14.0708M17.6219 17.6255C15.9362 19.5859 13.7879 20.9788 12.6996 21.6138C12.4772 21.7436 12.366 21.8085 12.2098 21.842C12.0885 21.868 11.9116 21.868 11.7904 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V5.77618C4 5.30923 4.28966 4.89125 4.72688 4.72729M3 2.99987L21 20.9999",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "passkey-filled": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "#0F1A2E",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M13.1,20.2v-3.5c-1-0.9-1.6-2.1-1.9-3.4H7.3c-1.2,0-1.8,0-2.3,0.2c-1.1,0.3-2,1.2-2.3,2.3   c-0.2,0.5-0.2,3.8-0.2,5h10.7C13.1,20.6,13.1,20.4,13.1,20.2z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                    fill: "#0F1A2E",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    cx: "8.5",
                    cy: "6.2",
                    r: "4"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "#0F1A2E",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M17.9,21c-0.3-0.3-0.6-0.6-0.8-0.8c0,0,0-5,0-5c0-0.4-0.2-0.7-0.5-0.9c-1.1-0.6-1.7-1.8-1.6-3.1   c0.2-1.4,1.1-2.4,2.5-2.7c0.2,0,0.4-0.1,0.6-0.1c1.5,0,2.8,1.1,3.1,2.6c0.2,1.4-0.6,2.8-2,3.4l-0.7,0.3l0.5,0.5   c0.3,0.3,0.6,0.6,0.9,0.9c-0.3,0.3-0.5,0.5-0.8,0.8l-0.7,0.8l0.6,0.6c0.3,0.3,0.6,0.6,0.9,0.9c-0.3,0.4-1.6,1.6-1.8,1.9L17.9,21z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "#ffffff",
                    d: "M17.1,11c0,0.6,0.4,1,1,1c0.5,0,1-0.5,1-1.1s-0.5-1-1-1C17.6,10,17.1,10.4,17.1,11z"
                })
            ]
        }),
    "book-open-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "check-circle-broken": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M22 11.0857V12.0057C21.9988 14.1621 21.3005 16.2604 20.0093 17.9875C18.7182 19.7147 16.9033 20.9782 14.8354 21.5896C12.7674 22.201 10.5573 22.1276 8.53447 21.3803C6.51168 20.633 4.78465 19.2518 3.61096 17.4428C2.43727 15.6338 1.87979 13.4938 2.02168 11.342C2.16356 9.19029 2.99721 7.14205 4.39828 5.5028C5.79935 3.86354 7.69279 2.72111 9.79619 2.24587C11.8996 1.77063 14.1003 1.98806 16.07 2.86572M22 4L12 14.01L9 11.01",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "chevron-down": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M6 9L12 15L18 9",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "chevron-left": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M15 18L9 12L15 6",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "chevron-right": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M9 18L15 12L9 6",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "chevron-up": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M18 15L12 9L6 15",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "eye-off": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    eye: ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
    "face-smile": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "tag": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M20 10.5L13.5 4H7a1 1 0 0 0-1 1v6.5L12.5 18a2.121 2.121 0 0 0 3 0l4.5-4.5a2.121 2.121 0 0 0 0-3ZM9.5 8.5h.01",
            stroke: "#0F1A2E",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            fill: "none"
        }),
    "file-search-02": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M14 11H8M10 15H8M16 7H8M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H11.5M22 22L20.5 20.5M21.5 18C21.5 19.933 19.933 21.5 18 21.5C16.067 21.5 14.5 19.933 14.5 18C14.5 16.067 16.067 14.5 18 14.5C19.933 14.5 21.5 16.067 21.5 18Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "globe-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M2 12H22M2 12C2 17.5228 6.47715 22 12 22M2 12C2 6.47715 6.47715 2 12 2M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "image-03": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21L17.2 21C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2L22 7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "key-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "laptop-02": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M21 16V7.2C21 6.0799 21 5.51984 20.782 5.09202C20.5903 4.71569 20.2843 4.40973 19.908 4.21799C19.4802 4 18.9201 4 17.8 4H6.2C5.07989 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.0799 3 7.2V16M4.66667 20H19.3333C19.9533 20 20.2633 20 20.5176 19.9319C21.2078 19.7469 21.7469 19.2078 21.9319 18.5176C22 18.2633 22 17.9533 22 17.3333C22 17.0233 22 16.8683 21.9659 16.7412C21.8735 16.3961 21.6039 16.1265 21.2588 16.0341C21.1317 16 20.9767 16 20.6667 16H3.33333C3.02334 16 2.86835 16 2.74118 16.0341C2.39609 16.1265 2.12654 16.3961 2.03407 16.7412C2 16.8683 2 17.0233 2 17.3333C2 17.9533 2 18.2633 2.06815 18.5176C2.25308 19.2078 2.79218 19.7469 3.48236 19.9319C3.73669 20 4.04669 20 4.66667 20Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "link-external-02": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "mail-02": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M21.5 18L14.8571 12M9.14286 12L2.50003 18M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "message-chat-square": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M10 15L6.92474 18.1137C6.49579 18.548 6.28131 18.7652 6.09695 18.7805C5.93701 18.7938 5.78042 18.7295 5.67596 18.6076C5.55556 18.4672 5.55556 18.162 5.55556 17.5515V15.9916C5.55556 15.444 5.10707 15.0477 4.5652 14.9683V14.9683C3.25374 14.7762 2.22378 13.7463 2.03168 12.4348C2 12.2186 2 11.9605 2 11.4444V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H14.2C15.8802 2 16.7202 2 17.362 2.32698C17.9265 2.6146 18.3854 3.07354 18.673 3.63803C19 4.27976 19 5.11984 19 6.8V11M19 22L16.8236 20.4869C16.5177 20.2742 16.3647 20.1678 16.1982 20.0924C16.0504 20.0255 15.8951 19.9768 15.7356 19.9474C15.5558 19.9143 15.3695 19.9143 14.9969 19.9143H13.2C12.0799 19.9143 11.5198 19.9143 11.092 19.6963C10.7157 19.5046 10.4097 19.1986 10.218 18.8223C10 18.3944 10 17.8344 10 16.7143V14.2C10 13.0799 10 12.5198 10.218 12.092C10.4097 11.7157 10.7157 11.4097 11.092 11.218C11.5198 11 12.0799 11 13.2 11H18.8C19.9201 11 20.4802 11 20.908 11.218C21.2843 11.4097 21.5903 11.7157 21.782 12.092C22 12.5198 22 13.0799 22 14.2V16.9143C22 17.8462 22 18.3121 21.8478 18.6797C21.6448 19.1697 21.2554 19.5591 20.7654 19.762C20.3978 19.9143 19.9319 19.9143 19 19.9143V22Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "message-text-square-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M7 8.5H12M7 12H15M9.68375 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V20.3355C3 20.8684 3 21.1348 3.10923 21.2716C3.20422 21.3906 3.34827 21.4599 3.50054 21.4597C3.67563 21.4595 3.88367 21.2931 4.29976 20.9602L6.68521 19.0518C7.17252 18.662 7.41617 18.4671 7.68749 18.3285C7.9282 18.2055 8.18443 18.1156 8.44921 18.0613C8.74767 18 9.0597 18 9.68375 18Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    passcode: ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M12 12H12.005M17 12H17.005M7 12H7.005M5.2 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H5.2C4.0799 17 3.51984 17 3.09202 16.782C2.71569 16.5903 2.40973 16.2843 2.21799 15.908C2 15.4802 2 14.9201 2 13.8V10.2C2 9.0799 2 8.51984 2.21799 8.09202C2.40973 7.71569 2.71569 7.40973 3.09202 7.21799C3.51984 7 4.0799 7 5.2 7ZM12.25 12C12.25 12.1381 12.1381 12.25 12 12.25C11.8619 12.25 11.75 12.1381 11.75 12C11.75 11.8619 11.8619 11.75 12 11.75C12.1381 11.75 12.25 11.8619 12.25 12ZM17.25 12C17.25 12.1381 17.1381 12.25 17 12.25C16.8619 12.25 16.75 12.1381 16.75 12C16.75 11.8619 16.8619 11.75 17 11.75C17.1381 11.75 17.25 11.8619 17.25 12ZM7.25 12C7.25 12.1381 7.13807 12.25 7 12.25C6.86193 12.25 6.75 12.1381 6.75 12C6.75 11.8619 6.86193 11.75 7 11.75C7.13807 11.75 7.25 11.8619 7.25 12Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    passkey: ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M11 13.25H7.34C6.11 13.25 5.5 13.25 5 13.4C3.87 13.74 2.99 14.62 2.65 15.75C2.5 16.25 2.5 19.52 2.5 20.75M12.5 6.21C12.5 8.4 10.73 10.17 8.54 10.17C6.35 10.17 4.58 8.4 4.58 6.21C4.58 4.02 6.35 2.25 8.54 2.25C10.73 2.25 12.5 4.02 12.5 6.21Z",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M19.4401 14.99C19.7601 15.32 20.0601 15.63 20.3701 15.94C20.7101 16.29 20.7101 16.28 20.3801 16.61C19.9801 17.02 19.6001 17.45 19.2001 17.88C19.5901 18.27 20.0301 18.73 20.4901 19.15C20.6801 19.33 20.6401 19.44 20.4901 19.6C19.7201 20.39 18.9601 21.19 18.1701 22C17.6501 21.47 17.1501 20.99 16.6801 20.49C16.6101 20.42 16.6101 20.26 16.6101 20.15C16.6101 18.5 16.6101 16.84 16.6101 15.19C16.6101 14.97 16.5401 14.86 16.3601 14.77C15.0301 14.03 14.3401 12.64 14.5301 11.18C14.7301 9.63 15.7601 8.38 17.4701 8.08C19.5401 7.71 21.3601 9.06 21.7101 11.06C21.9901 12.68 21.0401 14.33 19.4501 15.01L19.4401 14.99Z",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M17.1201 10.99C17.1201 11.6 17.5501 12.03 18.1701 12.03C18.6801 12.03 19.1701 11.51 19.1701 10.97C19.1701 10.43 18.7001 9.98 18.1301 9.98C17.5501 9.98 17.1201 10.41 17.1201 10.99Z",
                    fill: "#0F1A2E"
                })
            ]
        }),
    "phone-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M12 17.5H12.01M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22ZM12.5 17.5C12.5 17.7761 12.2761 18 12 18C11.7239 18 11.5 17.7761 11.5 17.5C11.5 17.2239 11.7239 17 12 17C12.2761 17 12.5 17.2239 12.5 17.5Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    printer: ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M18 7V5.2C18 4.0799 18 3.51984 17.782 3.09202C17.5903 2.71569 17.2843 2.40973 16.908 2.21799C16.4802 2 15.9201 2 14.8 2H9.2C8.0799 2 7.51984 2 7.09202 2.21799C6.71569 2.40973 6.40973 2.71569 6.21799 3.09202C6 3.51984 6 4.0799 6 5.2V7M6 18C5.07003 18 4.60504 18 4.22354 17.8978C3.18827 17.6204 2.37962 16.8117 2.10222 15.7765C2 15.395 2 14.93 2 14V11.8C2 10.1198 2 9.27976 2.32698 8.63803C2.6146 8.07354 3.07354 7.6146 3.63803 7.32698C4.27976 7 5.11984 7 6.8 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V14C22 14.93 22 15.395 21.8978 15.7765C21.6204 16.8117 20.8117 17.6204 19.7765 17.8978C19.395 18 18.93 18 18 18M15 10.5H18M9.2 22H14.8C15.9201 22 16.4802 22 16.908 21.782C17.2843 21.5903 17.5903 21.2843 17.782 20.908C18 20.4802 18 19.9201 18 18.8V17.2C18 16.0799 18 15.5198 17.782 15.092C17.5903 14.7157 17.2843 14.4097 16.908 14.218C16.4802 14 15.9201 14 14.8 14H9.2C8.0799 14 7.51984 14 7.09202 14.218C6.71569 14.4097 6.40973 14.7157 6.21799 15.092C6 15.5198 6 16.0799 6 17.2V18.8C6 19.9201 6 20.4802 6.21799 20.908C6.40973 21.2843 6.71569 21.5903 7.09202 21.782C7.51984 22 8.07989 22 9.2 22Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "refresh-ccw-04": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M17 18.8746C19.1213 17.3291 20.5 14.8255 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5H11.5M12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 9.17446 4.87867 6.67093 7 5.1254M11 22.4L13 20.4L11 18.4M13 5.6L11 3.6L13 1.6",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "switch-horizontal-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M20 17H4M4 17L8 13M4 17L8 21M4 7H20M20 7L16 3M20 7L16 11",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "thumbs-up": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "user-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "user-right-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M19 21L22 18M22 18L19 15M22 18H16M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "users-01": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
            d: "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
            stroke: "#0F1A2E",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
    "burger-menu": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("rect", {
                    x: "5",
                    y: "6",
                    width: "14",
                    height: "2",
                    rx: "1"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("rect", {
                    x: "5",
                    y: "11",
                    width: "14",
                    height: "2",
                    rx: "1"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("rect", {
                    x: "5",
                    y: "16",
                    width: "14",
                    height: "2",
                    rx: "1"
                })
            ]
        }),
    cross: ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M6 6L18 18",
                    stroke: "#0F1A2E",
                    strokeWidth: "3",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M6 18L18 6",
                    stroke: "#0F1A2E",
                    strokeWidth: "3",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
    "input-delete": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    fill: "#0F1A2E",
                    d: "M10,20c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10C4.5,0,0,4.5,0,10C0,15.5,4.5,20,10,20z"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "none",
                    stroke: "#ffffff",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M6.7,6.7l6.7,6.7 M6.7,13.3l6.7-6.7"
                })
            ]
        }),
    magnifier: ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                    fill: "none",
                    stroke: "#0f1a2e",
                    strokeWidth: "2",
                    cx: "6.5",
                    cy: "6.5",
                    r: "5.5"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    fill: "none",
                    stroke: "#0f1a2e",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M11,11l4,4"
                })
            ]
        }),
    "real-arrow": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M10 16L7 12L10 8",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M7 12.0001H17",
                    stroke: "#0F1A2E",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
    "lock": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    d: "M7 10V7a5 5 0 0 1 10 0v3",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("rect", {
                    x: "5",
                    y: "10",
                    width: "14",
                    height: "10",
                    rx: "2",
                    "stroke-width": "2"
                })
            ]
        }),
    "passkey-guard": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {
            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("g", {
                transform: "translate(1.5 0)",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                    style: {
                        fill: "#0F1A2E",
                        stroke: "unset"
                    },
                    d: "M6.96221 1.01826C0.00967455 3.22273 0.125699 3.1781 0.0632243 3.49047C-0.0528 4.06167 0.000749663 7.44422 0.143549 8.51522C0.991419 14.9412 4.0259 19.8321 9.31839 23.3128L10.3626 24L11.505 23.2592C13.7452 21.7955 15.2803 20.3765 16.7439 18.4219C17.574 17.3063 17.931 16.7172 18.52 15.5392C20.1354 12.3083 20.9297 8.47952 20.7602 4.71319L20.6977 3.22272L18.761 2.59798C17.1545 2.06248 12.0405 0.438141 10.7553 0.0454435C10.4072 -0.0705808 10.2912 -0.0348797 6.96221 1.01826ZM13.5577 3.66005C18.6093 5.22191 18.6628 5.23976 18.6628 5.46289C18.6628 5.56999 18.6003 6.15903 18.5289 6.77485C18.4575 7.39068 18.3951 7.94402 18.3951 7.99757C18.3951 8.06005 18.3326 8.1136 18.2612 8.1136C18.0738 8.1136 11.9602 6.24828 10.8178 5.83773L10.4251 5.70386L8.40805 6.36431C7.29243 6.73023 6.15004 7.09615 5.87336 7.17648C5.48959 7.28357 5.36464 7.3639 5.36464 7.48885C5.36464 7.5781 5.46282 8.21177 5.58777 8.89007C6.16789 12.0227 7.47985 14.5128 9.72894 16.7172L10.3537 17.3331L10.7553 17.0028C11.6567 16.2621 12.9687 14.611 13.6024 13.3972C13.7898 13.0491 13.9326 12.7456 13.9147 12.7367C13.8969 12.7278 13.1026 12.701 12.1476 12.6742L10.4072 12.6207L10.3805 11.2106L10.3537 9.80933H14.1557C17.3508 9.80933 17.9488 9.82719 17.9488 9.93428C17.9488 10.2645 16.8957 13.1026 16.387 14.1379C15.0304 16.9047 13.6738 18.4576 10.4786 20.903C10.2734 21.0548 7.9975 19.1716 6.85511 17.8864C5.49852 16.3602 4.40075 14.5128 3.64213 12.4868C3.02631 10.8268 2.56221 8.47952 2.45511 6.40001L2.39264 5.18621L2.87458 5.04341C3.76708 4.77567 5.75734 4.142 7.9975 3.41907C9.22914 3.01745 10.2644 2.68723 10.3001 2.6783C10.3448 2.66938 11.8085 3.11563 13.5577 3.66005Z",
                    fill: "#0F1A2E"
                })
            })
        })
};
const $cce3927210294d78$export$fd0cd725930ce3d = {
    // Default size 120,130  "../../../../assets/img/cp_onboarding.svg";
    "cpOnboarding": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("clipPath", {
                            id: "clippath",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                fill: "#149b5f",
                                cx: "60",
                                cy: "60",
                                r: "60"
                            })
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("clipPath", {
                            id: "clippath-1",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                fill: "none",
                                cx: "60",
                                cy: "60",
                                r: "60"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                            fill: "#149b5f",
                            cx: "60",
                            cy: "60",
                            r: "60"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("g", {
                            clipPath: "url(#clippath)",
                            className: "cls-8",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                fill: "#149b5f",
                                cx: "60",
                                cy: "60",
                                r: "60"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                            fill: "#b3d362",
                            cx: "113.43",
                            cy: "34.15",
                            r: "16.57"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M124.09,28.23l-.53-.54c-.59-.61-1.57-.62-2.17-.02l-10.38,10.16c-.27,.26-.7,.26-.96-.01l-3.1-3.17c-.75-.77-1.98-.78-2.75-.03l-.04,.04c-.72,.7-.73,1.85-.03,2.56l5.5,5.54c.49,.49,1.28,.5,1.77,.01l12.68-12.39c.6-.59,.61-1.55,.02-2.15Z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                    className: "cls-7",
                    clipPath: "url(#clippath-1)",
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                                    children: [
                                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("polyline", {
                                            fill: "#ebcf99",
                                            points: "43.12 96.57 49.56 89.37 46.9 81.4 81.7 80.07 81.73 89.87 87.64 95.21 86.93 129.38 43.63 135.59 45.06 95.64"
                                        }),
                                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("polyline", {
                                            fill: "#ebcf99",
                                            points: "43.12 96.57 49.56 89.37 46.9 81.4 81.7 80.07 81.73 89.87 87.64 95.21 86.93 129.38 43.63 135.59 45.06 95.64"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#ebcf99",
                                    d: "M79.51,105.06s-6.83,20.53-12.88,24.9c-7.5-4.71-15.79-25.04-15.79-25.04l-.06-22.37,27.67-.46,1.06,22.97Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#e3bb82",
                                    d: "M50.57,92.18c9.4,18.2,31.67,17.04,31.67,17.04l.14-16.23-.92-7.05-34.87-4.86s3.99,10.59,3.99,11.09Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M49.94,97.44l16.12,126.34s-8.41,41.62-57.91,76.55c-49.49,34.93-96.83,17.53-159.49,75.61,38.2-50.93,104.65-54.23,145.69-76.06,41.04-21.82,43.93-89.99,42.87-104.84-1.06-14.85-23.22-78.97-23.22-78.97l35.95-18.63Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#fff",
                                    d: "M48.05,104.74c17.45,68.99-2.05,114.49-7.77,142.35-.54,2.28-9.44,27.37-9.44,27.37,0,0,35.16,19.33,86.1,1.32-12.18-59.36-10.64-93.18-27.21-175.43-1.1,2.83-6.25,12.82-18.55,14.56-14.16,1.6-22.02-8.87-23.14-10.17Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M14.71,217.32c4.88,13.31-16.84,25.29-16.84,25.29,0,0-45.69-39.54-48.72-42.37-3.03-2.83-5.13-8.95-1.48-13.23C-35.79,167.64,10.87,113.58,21.9,107.16c4.91-2.86,8.98-4.58,12.24-5.32,.56-.13,7.67-.53,7.67-.53l-17.61,57.87-40.66,33.39s30.08,23.98,31.18,24.76Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M55.23,101.32l-6.95-15.67-7.3,11.59s-10.45,2.4-18.94,4.79c-.89,.25-1.76,.5-2.6,.76,.78,.96,1.48,2,2.08,3.07,2.01,3.57,3.22,7.57,4.05,11.56,.78,3.74,1.22,7.55,1.33,11.37,.17,5.91-.54,11.82-1.59,17.63-.17,.95-5.46,10.69-5.64,11.63,33.7,38.45,13.02,112.66-80.41,169.42C119.71,281.66,40.3,175.4,55.23,101.32Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M130.22,438.75c21.07-62.72,4.85-149.18,.55-167.17-18.96-77.53-14.91-72.21-12.88-154.79,.32-12.85-27.86-19.72-36.35-29.54-7.31,108.26,42.61,121.64,48.68,351.51Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M113.83,109.01s17.18,0,20.62,20.62c3.44,20.62-1.15,74.91-1.15,74.91,0,0-.76,14.13-11.45,19.09s-15.65-9.54-15.65-9.54l7.64-105.07Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M31.05,22.62c1.45,5.76,10.92,8.35,21.16,5.78,10.24-2.58,17.36-9.34,15.91-15.1-1.45-5.76-8.19-11.38-21.72-7.97-13.89,3.49-16.81,11.54-15.36,17.3Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M62.81,28.53l-3.6-14.3,2.83,14.49s-11.14,3.48-14.63,6.86c-13.19,12.76-7.25,34.19-2.14,44.53-15-9.3-18.92-25.69-19.47-34.33-1.54-23.98,17.06-35.19,36.01-34.23,27.48,.28,35.2,40.39,24.08,55.42-4.31-10.99-23.08-38.43-23.08-38.43Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M86.78,35.34c-4.2-16.7-21.15-26.84-37.85-22.63-16.7,4.2-26.83,21.15-22.63,37.85,4.2,16.7,21.15,26.84,37.85,22.63,16.7-4.2,26.84-21.15,22.63-37.85Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#ecd099",
                                    d: "M51.39,19.12c13.84-3.29,27.73,5.13,31.24,18.86,.03,.08,.06,.16,.08,.25,.04,.22,.1,.47,.16,.76,.06,.3,.12,.59,.17,.88,1.26,6.5,4.46,23.59,3.34,33.26-1.08,9.22-8.42,18.18-10.32,20.39-1.46,1.88-3.54,3.29-6.04,3.89-2.62,.62-5.25,.23-7.47-.91-3.15-1.35-12.86-5.99-17.77-13.42-5.08-7.69-9.93-23.07-11.96-30.08-.27-.82-.53-1.66-.73-2.52-3.33-13.99,5.31-28.02,19.3-31.35Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M64.16,33.34l-1.72-9.59-.09,9.68s-14.21,3.26-17.7,6.64c-13.19,12.76-7.86,25.25-2.71,37.81-10.03-7.5-15.63-21.68-16.18-30.33-1.54-23.98,14.26-36.27,33.22-35.3,12.49,5.49,17.03,14.01,27.28,22.28,3.84,15.27,3.62,36.99,.18,25.69-7.76-25.44-22.28-26.89-22.28-26.89Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M57.91,34.17c-14.14,4.58-16.71,17.09-17.4,23.64-.64,6.05,.98,12.55,2.65,17.05-1.33-1.76-15.82-33.29,14.29-42.92-.02,0,.44,2.23,.46,2.23Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    stroke: "#e3bb82",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: 10,
                                    fill: "none",
                                    strokeWidth: "1.26px",
                                    d: "M71.19,73.74c-.3,.13-.61,.19-.97,.25-.95,.16-1.66,.69-2.1,1.47l-.09,.17c-.41,.9-1.24,1.59-2.28,1.77-1.03,.18-2.02-.18-2.7-.86l-.18-.21c-.67-.55-1.56-.82-2.48-.66-.31,.05-.57,.12-.86,.11"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    strokeWidth: ".63px",
                                    stroke: "#e3bb82",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: 10,
                                    fill: "none",
                                    d: "M66.57,65.95s-1.82-2.41-2.04-3.73,.68-4.19,.68-4.19"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("ellipse", {
                                    cx: "75.39",
                                    cy: "60.06",
                                    rx: "2",
                                    ry: "2.01",
                                    transform: "translate(-13.89 23.72) rotate(-16.39)"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                    fill: "#fff",
                                    cx: "75.82",
                                    cy: "59.36",
                                    r: ".64"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M68.42,59.82c-.56,.37,.42,.49,.42,.49,0,0,2.37-1.38,4.9-1.66,2-.23,3.59-.59,4.22-.18,.04,.03,.09,.06,.13,.1,.61,.51-.7,1.94-.7,1.94,0,0,2.3-1.71,2.37-3.29-5.31-.23-7.33-.05-11.34,2.6Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M55.99,62.39c.62,.27-.28,.58-.28,.58,0,0-2.67-.89-5.19-.52-2,.3-3.59,.52-4.09,1.08-.03,.04-.07,.08-.1,.13-.46,.65,1.17,1.7,1.17,1.7,0,0-2.66-1.07-3.14-2.57,5.03-1.47,7.8-2.07,11.63-.4Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("rect", {
                                    fill: "#ecd099",
                                    x: "35.59",
                                    y: "61.52",
                                    width: "4.37",
                                    height: "17.22",
                                    rx: "2.18",
                                    ry: "2.18",
                                    transform: "translate(-21.63 17.06) rotate(-19.91)"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M55.46,58.32c.66,.45-.09,1.53-1.29,1.42-1.2-.11-3.87-1.43-6.62-.93-2.76,.5-4.09,2.34-4.46,2.58s-.72-.15-.52-.47c.21-.33,2.07-2.54,5.2-2.99,3.13-.45,7.02-.05,7.68,.4Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M65.43,49.85c-.59,.54,.31,1.5,1.48,1.22,1.17-.28,3.62-1.98,6.42-1.88,2.8,.1,4.39,1.72,4.79,1.91s.69-.25,.44-.54c-.25-.29-2.42-2.21-5.58-2.2-3.16,0-6.96,.96-7.54,1.51Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("ellipse", {
                                    cx: "52.85",
                                    cy: "63.99",
                                    rx: "2",
                                    ry: "2.01",
                                    transform: "translate(-15.91 17.52) rotate(-16.39)"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                    fill: "#fff",
                                    cx: "53.1",
                                    cy: "63.3",
                                    r: ".64"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#fff",
                                    d: "M73.97,80.11c-10.5,1.04-19.48-1.01-19.48-1.01,0,0,5.25,7.9,11.47,7.35,6.3-.56,7.87-5.97,8.01-6.34Z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                            fill: "none",
                            cx: "60",
                            cy: "60",
                            r: "60"
                        })
                    ]
                })
            ]
        }),
    "cpOnboardingNoCheck": ()=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("clipPath", {
                            id: "clippath",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                fill: "#149b5f",
                                cx: "60",
                                cy: "60",
                                r: "60"
                            })
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("clipPath", {
                            id: "clippath-1",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                fill: "none",
                                cx: "60",
                                cy: "60",
                                r: "60"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                            fill: "#149b5f",
                            cx: "60",
                            cy: "60",
                            r: "60"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("g", {
                            clipPath: "url(#clippath)",
                            className: "cls-8",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                fill: "#149b5f",
                                cx: "60",
                                cy: "60",
                                r: "60"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                    className: "cls-7",
                    clipPath: "url(#clippath-1)",
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                            children: [
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("g", {
                                    children: [
                                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("polyline", {
                                            fill: "#ebcf99",
                                            points: "43.12 96.57 49.56 89.37 46.9 81.4 81.7 80.07 81.73 89.87 87.64 95.21 86.93 129.38 43.63 135.59 45.06 95.64"
                                        }),
                                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("polyline", {
                                            fill: "#ebcf99",
                                            points: "43.12 96.57 49.56 89.37 46.9 81.4 81.7 80.07 81.73 89.87 87.64 95.21 86.93 129.38 43.63 135.59 45.06 95.64"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#ebcf99",
                                    d: "M79.51,105.06s-6.83,20.53-12.88,24.9c-7.5-4.71-15.79-25.04-15.79-25.04l-.06-22.37,27.67-.46,1.06,22.97Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#e3bb82",
                                    d: "M50.57,92.18c9.4,18.2,31.67,17.04,31.67,17.04l.14-16.23-.92-7.05-34.87-4.86s3.99,10.59,3.99,11.09Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M49.94,97.44l16.12,126.34s-8.41,41.62-57.91,76.55c-49.49,34.93-96.83,17.53-159.49,75.61,38.2-50.93,104.65-54.23,145.69-76.06,41.04-21.82,43.93-89.99,42.87-104.84-1.06-14.85-23.22-78.97-23.22-78.97l35.95-18.63Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#fff",
                                    d: "M48.05,104.74c17.45,68.99-2.05,114.49-7.77,142.35-.54,2.28-9.44,27.37-9.44,27.37,0,0,35.16,19.33,86.1,1.32-12.18-59.36-10.64-93.18-27.21-175.43-1.1,2.83-6.25,12.82-18.55,14.56-14.16,1.6-22.02-8.87-23.14-10.17Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M14.71,217.32c4.88,13.31-16.84,25.29-16.84,25.29,0,0-45.69-39.54-48.72-42.37-3.03-2.83-5.13-8.95-1.48-13.23C-35.79,167.64,10.87,113.58,21.9,107.16c4.91-2.86,8.98-4.58,12.24-5.32,.56-.13,7.67-.53,7.67-.53l-17.61,57.87-40.66,33.39s30.08,23.98,31.18,24.76Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M55.23,101.32l-6.95-15.67-7.3,11.59s-10.45,2.4-18.94,4.79c-.89,.25-1.76,.5-2.6,.76,.78,.96,1.48,2,2.08,3.07,2.01,3.57,3.22,7.57,4.05,11.56,.78,3.74,1.22,7.55,1.33,11.37,.17,5.91-.54,11.82-1.59,17.63-.17,.95-5.46,10.69-5.64,11.63,33.7,38.45,13.02,112.66-80.41,169.42C119.71,281.66,40.3,175.4,55.23,101.32Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M130.22,438.75c21.07-62.72,4.85-149.18,.55-167.17-18.96-77.53-14.91-72.21-12.88-154.79,.32-12.85-27.86-19.72-36.35-29.54-7.31,108.26,42.61,121.64,48.68,351.51Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#057ebd",
                                    d: "M113.83,109.01s17.18,0,20.62,20.62c3.44,20.62-1.15,74.91-1.15,74.91,0,0-.76,14.13-11.45,19.09s-15.65-9.54-15.65-9.54l7.64-105.07Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M31.05,22.62c1.45,5.76,10.92,8.35,21.16,5.78,10.24-2.58,17.36-9.34,15.91-15.1-1.45-5.76-8.19-11.38-21.72-7.97-13.89,3.49-16.81,11.54-15.36,17.3Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M62.81,28.53l-3.6-14.3,2.83,14.49s-11.14,3.48-14.63,6.86c-13.19,12.76-7.25,34.19-2.14,44.53-15-9.3-18.92-25.69-19.47-34.33-1.54-23.98,17.06-35.19,36.01-34.23,27.48,.28,35.2,40.39,24.08,55.42-4.31-10.99-23.08-38.43-23.08-38.43Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M86.78,35.34c-4.2-16.7-21.15-26.84-37.85-22.63-16.7,4.2-26.83,21.15-22.63,37.85,4.2,16.7,21.15,26.84,37.85,22.63,16.7-4.2,26.84-21.15,22.63-37.85Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#ecd099",
                                    d: "M51.39,19.12c13.84-3.29,27.73,5.13,31.24,18.86,.03,.08,.06,.16,.08,.25,.04,.22,.1,.47,.16,.76,.06,.3,.12,.59,.17,.88,1.26,6.5,4.46,23.59,3.34,33.26-1.08,9.22-8.42,18.18-10.32,20.39-1.46,1.88-3.54,3.29-6.04,3.89-2.62,.62-5.25,.23-7.47-.91-3.15-1.35-12.86-5.99-17.77-13.42-5.08-7.69-9.93-23.07-11.96-30.08-.27-.82-.53-1.66-.73-2.52-3.33-13.99,5.31-28.02,19.3-31.35Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M64.16,33.34l-1.72-9.59-.09,9.68s-14.21,3.26-17.7,6.64c-13.19,12.76-7.86,25.25-2.71,37.81-10.03-7.5-15.63-21.68-16.18-30.33-1.54-23.98,14.26-36.27,33.22-35.3,12.49,5.49,17.03,14.01,27.28,22.28,3.84,15.27,3.62,36.99,.18,25.69-7.76-25.44-22.28-26.89-22.28-26.89Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M57.91,34.17c-14.14,4.58-16.71,17.09-17.4,23.64-.64,6.05,.98,12.55,2.65,17.05-1.33-1.76-15.82-33.29,14.29-42.92-.02,0,.44,2.23,.46,2.23Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    stroke: "#e3bb82",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: 10,
                                    fill: "none",
                                    strokeWidth: "1.26px",
                                    d: "M71.19,73.74c-.3,.13-.61,.19-.97,.25-.95,.16-1.66,.69-2.1,1.47l-.09,.17c-.41,.9-1.24,1.59-2.28,1.77-1.03,.18-2.02-.18-2.7-.86l-.18-.21c-.67-.55-1.56-.82-2.48-.66-.31,.05-.57,.12-.86,.11"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    strokeWidth: ".63px",
                                    stroke: "#e3bb82",
                                    strokeLinecap: "round",
                                    strokeMiterlimit: 10,
                                    fill: "none",
                                    d: "M66.57,65.95s-1.82-2.41-2.04-3.73,.68-4.19,.68-4.19"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("ellipse", {
                                    cx: "75.39",
                                    cy: "60.06",
                                    rx: "2",
                                    ry: "2.01",
                                    transform: "translate(-13.89 23.72) rotate(-16.39)"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                    fill: "#fff",
                                    cx: "75.82",
                                    cy: "59.36",
                                    r: ".64"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M68.42,59.82c-.56,.37,.42,.49,.42,.49,0,0,2.37-1.38,4.9-1.66,2-.23,3.59-.59,4.22-.18,.04,.03,.09,.06,.13,.1,.61,.51-.7,1.94-.7,1.94,0,0,2.3-1.71,2.37-3.29-5.31-.23-7.33-.05-11.34,2.6Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M55.99,62.39c.62,.27-.28,.58-.28,.58,0,0-2.67-.89-5.19-.52-2,.3-3.59,.52-4.09,1.08-.03,.04-.07,.08-.1,.13-.46,.65,1.17,1.7,1.17,1.7,0,0-2.66-1.07-3.14-2.57,5.03-1.47,7.8-2.07,11.63-.4Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("rect", {
                                    fill: "#ecd099",
                                    x: "35.59",
                                    y: "61.52",
                                    width: "4.37",
                                    height: "17.22",
                                    rx: "2.18",
                                    ry: "2.18",
                                    transform: "translate(-21.63 17.06) rotate(-19.91)"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M55.46,58.32c.66,.45-.09,1.53-1.29,1.42-1.2-.11-3.87-1.43-6.62-.93-2.76,.5-4.09,2.34-4.46,2.58s-.72-.15-.52-.47c.21-.33,2.07-2.54,5.2-2.99,3.13-.45,7.02-.05,7.68,.4Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    d: "M65.43,49.85c-.59,.54,.31,1.5,1.48,1.22,1.17-.28,3.62-1.98,6.42-1.88,2.8,.1,4.39,1.72,4.79,1.91s.69-.25,.44-.54c-.25-.29-2.42-2.21-5.58-2.2-3.16,0-6.96,.96-7.54,1.51Z"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("ellipse", {
                                    cx: "52.85",
                                    cy: "63.99",
                                    rx: "2",
                                    ry: "2.01",
                                    transform: "translate(-15.91 17.52) rotate(-16.39)"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                                    fill: "#fff",
                                    cx: "53.1",
                                    cy: "63.3",
                                    r: ".64"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("path", {
                                    fill: "#fff",
                                    d: "M73.97,80.11c-10.5,1.04-19.48-1.01-19.48-1.01,0,0,5.25,7.9,11.47,7.35,6.3-.56,7.87-5.97,8.01-6.34Z"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("circle", {
                            fill: "none",
                            cx: "60",
                            cy: "60",
                            r: "60"
                        })
                    ]
                })
            ]
        })
};


function $f4d1d798408df2f5$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f4d1d798408df2f5$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f4d1d798408df2f5$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f4d1d798408df2f5$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f4d1d798408df2f5$export$2e2bcd8739ae039 = $f4d1d798408df2f5$export$4f5d2d50c9deca37;


function $b546cd5b68e37a70$var$filterIcons(variant, name) {
    switch(variant){
        case 'colorize':
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, $cce3927210294d78$export$c97c7b8ce74ef4ad)[name]();
        case 'legacy':
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, $cce3927210294d78$export$fd0cd725930ce3d)[name]();
        default:
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, $cce3927210294d78$export$37326c68d11eed93)[name]();
    }
}
function $b546cd5b68e37a70$var$Icon({ size: size, props: props, title: title, variant: variant, name: name, role: role }) {
    let width;
    let height;
    if (typeof size === "number") {
        width = size;
        height = size;
    } else {
        width = size.width;
        height = size.height;
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("svg", (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({
        fill: variant === 'colorize' ? undefined : 'currentColor',
        // eslint-disable-next-line react/prop-types
        className: (0, $f4d1d798408df2f5$export$2e2bcd8739ae039)('icon', `icon--${variant}`, props.className),
        viewBox: `0 0 ${width} ${height}`,
        width: width,
        height: height,
        role: role,
        "data-testid": "icon"
    }, props), {
        children: [
            title && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("title", {
                children: title
            }),
            $b546cd5b68e37a70$var$filterIcons(variant, name)
        ]
    }));
}
function $b546cd5b68e37a70$export$6d94deba6d109841(_param) {
    var { role: role = 'img', name: name, size: size = 32, title: title } = _param, props = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
        "role",
        "name",
        "size",
        "title"
    ]);
    return $b546cd5b68e37a70$var$Icon({
        variant: 'untitled',
        size: size,
        title: title,
        props: props,
        name: name,
        role: role
    });
}
function $b546cd5b68e37a70$export$354bf2e0ef935856(_param) {
    var { role: role = 'img', name: name, size: size = 24, title: title } = _param, props = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
        "role",
        "name",
        "size",
        "title"
    ]);
    return $b546cd5b68e37a70$var$Icon({
        variant: 'colorize',
        size: size,
        title: title,
        props: props,
        name: name,
        role: role
    });
}
function $b546cd5b68e37a70$export$8b7335e1f761b6d3(_param) {
    var { role: role = 'img', name: name, size: size = {
        width: 130,
        height: 120
    }, title: title } = _param, props = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
        "role",
        "name",
        "size",
        "title"
    ]);
    return $b546cd5b68e37a70$var$Icon({
        variant: 'legacy',
        size: size,
        title: title,
        props: props,
        name: name,
        role: role
    });
}







function $d22b18efd12698a3$export$c25acd513dcc8062(props) {
    var _props_initiallyActive;
    const [isActive, setIsActive] = (0, $46wWE.useState)((_props_initiallyActive = props.initiallyActive) !== null && _props_initiallyActive !== void 0 ? _props_initiallyActive : false);
    const handleClick = ()=>{
        setIsActive(!isActive);
        if (props.onClick) props.onClick();
    };
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("button", {
        id: props.buttonId,
        "aria-label": props.buttonId,
        type: "button",
        disabled: props.disabled,
        className: [
            "storybook-icon-button",
            props.className
        ].join(" "),
        onClick: handleClick,
        style: props === null || props === void 0 ? void 0 : props.style,
        children: [
            props.label && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $428c6867a99ff0e4$export$a8a3e93435678ff9), {
                text: props.label,
                type: props.headlineSize ? props.headlineSize : "h3"
            }),
            props.icon && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $b546cd5b68e37a70$export$354bf2e0ef935856), {
                name: isActive ? "chevron-down" : "chevron-left",
                alt: props.alt
            })
        ]
    });
}






const $6aaf2cb5d81db2fa$var$isString = (obj)=>typeof obj === 'string';
const $6aaf2cb5d81db2fa$var$defer = ()=>{
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
};
const $6aaf2cb5d81db2fa$var$makeString = (object)=>{
    if (object == null) return '';
    return '' + object;
};
const $6aaf2cb5d81db2fa$var$copy = (a, s, t)=>{
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
};
const $6aaf2cb5d81db2fa$var$lastOfPathSeparatorRegExp = /###/g;
const $6aaf2cb5d81db2fa$var$cleanKey = (key)=>key && key.indexOf('###') > -1 ? key.replace($6aaf2cb5d81db2fa$var$lastOfPathSeparatorRegExp, '.') : key;
const $6aaf2cb5d81db2fa$var$canNotTraverseDeeper = (object)=>!object || $6aaf2cb5d81db2fa$var$isString(object);
const $6aaf2cb5d81db2fa$var$getLastOfPath = (object, path, Empty)=>{
    const stack = !$6aaf2cb5d81db2fa$var$isString(path) ? path : path.split('.');
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if ($6aaf2cb5d81db2fa$var$canNotTraverseDeeper(object)) return {};
        const key = $6aaf2cb5d81db2fa$var$cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if ($6aaf2cb5d81db2fa$var$canNotTraverseDeeper(object)) return {};
    return {
        obj: object,
        k: $6aaf2cb5d81db2fa$var$cleanKey(stack[stackIndex])
    };
};
const $6aaf2cb5d81db2fa$var$setPath = (object, path, newValue)=>{
    const { obj: obj, k: k } = $6aaf2cb5d81db2fa$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $6aaf2cb5d81db2fa$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $6aaf2cb5d81db2fa$var$getLastOfPath(object, p, Object);
        if ((last === null || last === void 0 ? void 0 : last.obj) && typeof last.obj[`${last.k}.${e}`] !== 'undefined') last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
};
const $6aaf2cb5d81db2fa$var$pushPath = (object, path, newValue, concat)=>{
    const { obj: obj, k: k } = $6aaf2cb5d81db2fa$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    obj[k].push(newValue);
};
const $6aaf2cb5d81db2fa$var$getPath = (object, path)=>{
    const { obj: obj, k: k } = $6aaf2cb5d81db2fa$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    if (!Object.prototype.hasOwnProperty.call(obj, k)) return undefined;
    return obj[k];
};
const $6aaf2cb5d81db2fa$var$getPathWithDefaults = (data, defaultData, key)=>{
    const value = $6aaf2cb5d81db2fa$var$getPath(data, key);
    if (value !== undefined) return value;
    return $6aaf2cb5d81db2fa$var$getPath(defaultData, key);
};
const $6aaf2cb5d81db2fa$var$deepExtend = (target, source, overwrite)=>{
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if ($6aaf2cb5d81db2fa$var$isString(target[prop]) || target[prop] instanceof String || $6aaf2cb5d81db2fa$var$isString(source[prop]) || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $6aaf2cb5d81db2fa$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
};
const $6aaf2cb5d81db2fa$var$regexEscape = (str)=>str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
var $6aaf2cb5d81db2fa$var$_entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
const $6aaf2cb5d81db2fa$var$escape = (data)=>{
    if ($6aaf2cb5d81db2fa$var$isString(data)) return data.replace(/[&<>"'\/]/g, (s)=>$6aaf2cb5d81db2fa$var$_entityMap[s]);
    return data;
};
class $6aaf2cb5d81db2fa$var$RegExpCache {
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
}
const $6aaf2cb5d81db2fa$var$chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
const $6aaf2cb5d81db2fa$var$looksLikeObjectPathRegExpCache = new $6aaf2cb5d81db2fa$var$RegExpCache(20);
const $6aaf2cb5d81db2fa$var$looksLikeObjectPath = (key, nsSeparator, keySeparator)=>{
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = $6aaf2cb5d81db2fa$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $6aaf2cb5d81db2fa$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
};
const $6aaf2cb5d81db2fa$var$deepFind = (obj, path, keySeparator = '.')=>{
    if (!obj) return undefined;
    if (obj[path]) {
        if (!Object.prototype.hasOwnProperty.call(obj, path)) return undefined;
        return obj[path];
    }
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== 'object') return undefined;
        let next;
        let nextPath = '';
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    'string',
                    'number',
                    'boolean'
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
};
const $6aaf2cb5d81db2fa$var$getCleanedCode = (code)=>code === null || code === void 0 ? void 0 : code.replace('_', '-');
const $6aaf2cb5d81db2fa$var$consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        var _console_type_apply, _console_type, _console;
        (_console = console) === null || _console === void 0 ? void 0 : (_console_type = _console[type]) === null || _console_type === void 0 ? void 0 : (_console_type_apply = _console_type.apply) === null || _console_type_apply === void 0 ? void 0 : _console_type_apply.call(_console_type, console, args);
    }
};
class $6aaf2cb5d81db2fa$var$Logger {
    init(concreteLogger, options = {}) {
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || $6aaf2cb5d81db2fa$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log(...args) {
        return this.forward(args, 'log', '', true);
    }
    warn(...args) {
        return this.forward(args, 'warn', '', true);
    }
    error(...args) {
        return this.forward(args, 'error', '');
    }
    deprecate(...args) {
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if ($6aaf2cb5d81db2fa$var$isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $6aaf2cb5d81db2fa$var$Logger(this.logger, (0, $307af824b9387905$export$71511d61b312f219)({
            prefix: `${this.prefix}:${moduleName}:`
        }, this.options));
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $6aaf2cb5d81db2fa$var$Logger(this.logger, options);
    }
    constructor(concreteLogger, options = {}){
        this.init(concreteLogger, options);
    }
}
var $6aaf2cb5d81db2fa$var$baseLogger = new $6aaf2cb5d81db2fa$var$Logger();
class $6aaf2cb5d81db2fa$var$EventEmitter {
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event, ...args) {
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = Array.from(this.observers['*'].entries());
            cloned.forEach(([observer, numTimesAdded])=>{
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
    constructor(){
        this.observers = {};
    }
}
class $6aaf2cb5d81db2fa$var$ResourceStore extends $6aaf2cb5d81db2fa$var$EventEmitter {
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key, options = {}) {
        var _this_data_lng, _this_data;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf('.') > -1) path = lng.split('.');
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if ($6aaf2cb5d81db2fa$var$isString(key) && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $6aaf2cb5d81db2fa$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf('.') > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join('.');
        }
        if (result || !ignoreJSONStructure || !$6aaf2cb5d81db2fa$var$isString(key)) return result;
        return $6aaf2cb5d81db2fa$var$deepFind((_this_data = this.data) === null || _this_data === void 0 ? void 0 : (_this_data_lng = _this_data[lng]) === null || _this_data_lng === void 0 ? void 0 : _this_data_lng[ns], key, keySeparator);
    }
    addResource(lng, ns, key, value, options = {
        silent: false
    }) {
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $6aaf2cb5d81db2fa$var$setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources, options = {
        silent: false
    }) {
        for(const m in resources)if ($6aaf2cb5d81db2fa$var$isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite, options = {
        silent: false,
        skipCopy: false
    }) {
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $6aaf2cb5d81db2fa$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $6aaf2cb5d81db2fa$var$deepExtend(pack, resources, overwrite);
        else pack = (0, $307af824b9387905$export$71511d61b312f219)({}, pack, resources);
        $6aaf2cb5d81db2fa$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
    constructor(data, options = {
        ns: [
            'translation'
        ],
        defaultNS: 'translation'
    }){
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
}
var $6aaf2cb5d81db2fa$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            var _this_processors_processor;
            var _this_processors_processor_process;
            value = (_this_processors_processor_process = (_this_processors_processor = this.processors[processor]) === null || _this_processors_processor === void 0 ? void 0 : _this_processors_processor.process(value, key, options, translator)) !== null && _this_processors_processor_process !== void 0 ? _this_processors_processor_process : value;
        });
        return value;
    }
};
const $6aaf2cb5d81db2fa$var$PATH_KEY = Symbol('i18next/PATH_KEY');
function $6aaf2cb5d81db2fa$var$createProxy() {
    const state = [];
    const handler = Object.create(null);
    let proxy;
    handler.get = (target, key)=>{
        var _proxy_revoke;
        proxy === null || proxy === void 0 ? void 0 : (_proxy_revoke = proxy.revoke) === null || _proxy_revoke === void 0 ? void 0 : _proxy_revoke.call(proxy);
        if (key === $6aaf2cb5d81db2fa$var$PATH_KEY) return state;
        state.push(key);
        proxy = Proxy.revocable(target, handler);
        return proxy.proxy;
    };
    return Proxy.revocable(Object.create(null), handler).proxy;
}
function $6aaf2cb5d81db2fa$export$ec2cccc18ab4c2ae(selector, opts) {
    const { [$6aaf2cb5d81db2fa$var$PATH_KEY]: path } = selector($6aaf2cb5d81db2fa$var$createProxy());
    var _opts_keySeparator;
    return path.join((_opts_keySeparator = opts === null || opts === void 0 ? void 0 : opts.keySeparator) !== null && _opts_keySeparator !== void 0 ? _opts_keySeparator : '.');
}
const $6aaf2cb5d81db2fa$var$checkedLoadedFor = {};
const $6aaf2cb5d81db2fa$var$shouldHandleAsObject = (res)=>!$6aaf2cb5d81db2fa$var$isString(res) && typeof res !== 'boolean' && typeof res !== 'number';
class $6aaf2cb5d81db2fa$var$Translator extends $6aaf2cb5d81db2fa$var$EventEmitter {
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key, o = {
        interpolation: {}
    }) {
        const opt = (0, $307af824b9387905$export$71511d61b312f219)({}, o);
        if (key == null) return false;
        const resolved = this.resolve(key, opt);
        if ((resolved === null || resolved === void 0 ? void 0 : resolved.res) === undefined) return false;
        const isObject = $6aaf2cb5d81db2fa$var$shouldHandleAsObject(resolved.res);
        if (opt.returnObjects === false && isObject) return false;
        return true;
    }
    extractFromKey(key, opt) {
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        let namespaces = opt.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !opt.keySeparator && !this.options.userDefinedNsSeparator && !opt.nsSeparator && !$6aaf2cb5d81db2fa$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: $6aaf2cb5d81db2fa$var$isString(namespaces) ? [
                    namespaces
                ] : namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        return {
            key: key,
            namespaces: $6aaf2cb5d81db2fa$var$isString(namespaces) ? [
                namespaces
            ] : namespaces
        };
    }
    translate(keys, o, lastKey) {
        let opt = typeof o === 'object' ? (0, $307af824b9387905$export$71511d61b312f219)({}, o) : o;
        if (typeof opt !== 'object' && this.options.overloadTranslationOptionHandler) opt = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof opt === 'object') opt = (0, $307af824b9387905$export$71511d61b312f219)({}, opt);
        if (!opt) opt = {};
        if (keys == null) return '';
        if (typeof keys === 'function') keys = $6aaf2cb5d81db2fa$export$ec2cccc18ab4c2ae(keys, (0, $307af824b9387905$export$71511d61b312f219)({}, this.options, opt));
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = opt.returnDetails !== undefined ? opt.returnDetails : this.options.returnDetails;
        const keySeparator = opt.keySeparator !== undefined ? opt.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], opt);
        const namespace = namespaces[namespaces.length - 1];
        let nsSeparator = opt.nsSeparator !== undefined ? opt.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const lng = opt.lng || this.language;
        const appendNamespaceToCIMode = opt.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if ((lng === null || lng === void 0 ? void 0 : lng.toLowerCase()) === 'cimode') {
            if (appendNamespaceToCIMode) {
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(opt)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(opt)
            };
            return key;
        }
        const resolved = this.resolve(keys, opt);
        let res = resolved === null || resolved === void 0 ? void 0 : resolved.res;
        const resUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.usedKey) || key;
        const resExactUsedKey = (resolved === null || resolved === void 0 ? void 0 : resolved.exactUsedKey) || key;
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = opt.joinArrays !== undefined ? opt.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const needsPluralHandling = opt.count !== undefined && !$6aaf2cb5d81db2fa$var$isString(opt.count);
        const hasDefaultValue = $6aaf2cb5d81db2fa$var$Translator.hasDefaultValue(opt);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, opt) : '';
        const defaultValueSuffixOrdinalFallback = opt.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, opt.count, {
            ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
        const defaultValue = needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] || opt[`defaultValue${defaultValueSuffix}`] || opt[`defaultValue${defaultValueSuffixOrdinalFallback}`] || opt.defaultValue;
        let resForObjHndl = res;
        if (handleAsObjectInI18nFormat && !res && hasDefaultValue) resForObjHndl = defaultValue;
        const handleAsObject = $6aaf2cb5d81db2fa$var$shouldHandleAsObject(resForObjHndl);
        const resType = Object.prototype.toString.apply(resForObjHndl);
        if (handleAsObjectInI18nFormat && resForObjHndl && handleAsObject && noObject.indexOf(resType) < 0 && !($6aaf2cb5d81db2fa$var$isString(joinArrays) && Array.isArray(resForObjHndl))) {
            if (!opt.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, resForObjHndl, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, opt), {
                    ns: namespaces
                })) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(opt);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = Array.isArray(resForObjHndl);
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in resForObjHndl)if (Object.prototype.hasOwnProperty.call(resForObjHndl, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    if (hasDefaultValue && !res) copy[m] = this.translate(deepKey, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, opt), {
                        defaultValue: $6aaf2cb5d81db2fa$var$shouldHandleAsObject(defaultValue) ? defaultValue[m] : undefined,
                        joinArrays: false,
                        ns: namespaces
                    }));
                    else copy[m] = this.translate(deepKey, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, opt), {
                        joinArrays: false,
                        ns: namespaces
                    }));
                    if (copy[m] === deepKey) copy[m] = resForObjHndl[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && $6aaf2cb5d81db2fa$var$isString(joinArrays) && Array.isArray(res)) {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, opt, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = opt.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, opt), {
                        keySeparator: false
                    }));
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, opt.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(opt.lng || this.language);
                else lngs.push(opt.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    var _this_backendConnector;
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, opt);
                    else if ((_this_backendConnector = this.backendConnector) === null || _this_backendConnector === void 0 ? void 0 : _this_backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, opt);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, opt);
                        if (needsZeroSuffixLookup && opt[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, opt[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, opt, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}${nsSeparator}${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}${nsSeparator}${key}` : key, usedDefault ? res : undefined, opt);
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(opt);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, opt, resolved, lastKey) {
        var _this_i18nFormat;
        if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.parse) res = this.i18nFormat.parse(res, (0, $307af824b9387905$export$71511d61b312f219)({}, this.options.interpolation.defaultVariables, opt), opt.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!opt.skipInterpolation) {
            var _opt_interpolation;
            if (opt.interpolation) this.interpolator.init((0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, opt), {
                interpolation: (0, $307af824b9387905$export$71511d61b312f219)({}, this.options.interpolation, opt.interpolation)
            }));
            const skipOnVariables = $6aaf2cb5d81db2fa$var$isString(res) && ((opt === null || opt === void 0 ? void 0 : (_opt_interpolation = opt.interpolation) === null || _opt_interpolation === void 0 ? void 0 : _opt_interpolation.skipOnVariables) !== undefined ? opt.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = opt.replace && !$6aaf2cb5d81db2fa$var$isString(opt.replace) ? opt.replace : opt;
            if (this.options.interpolation.defaultVariables) data = (0, $307af824b9387905$export$71511d61b312f219)({}, this.options.interpolation.defaultVariables, data);
            res = this.interpolator.interpolate(res, data, opt.lng || this.language || resolved.usedLng, opt);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) opt.nest = false;
            }
            if (!opt.lng && resolved && resolved.res) opt.lng = this.language || resolved.usedLng;
            if (opt.nest !== false) res = this.interpolator.nest(res, (...args)=>{
                if ((lastKey === null || lastKey === void 0 ? void 0 : lastKey[0]) === args[0] && !opt.context) {
                    this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return this.translate(...args, key);
            }, opt);
            if (opt.interpolation) this.interpolator.reset();
        }
        const postProcess = opt.postProcess || this.options.postProcess;
        const postProcessorNames = $6aaf2cb5d81db2fa$var$isString(postProcess) ? [
            postProcess
        ] : postProcess;
        if (res != null && (postProcessorNames === null || postProcessorNames === void 0 ? void 0 : postProcessorNames.length) && opt.applyPostProcessor !== false) res = $6aaf2cb5d81db2fa$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0, $307af824b9387905$export$71511d61b312f219)({
            i18nResolved: (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, resolved), {
                usedParams: this.getUsedParamsDetails(opt)
            })
        }, opt) : opt, this);
        return res;
    }
    resolve(keys, opt = {}) {
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if ($6aaf2cb5d81db2fa$var$isString(keys)) keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, opt);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = opt.count !== undefined && !$6aaf2cb5d81db2fa$var$isString(opt.count);
            const needsZeroSuffixLookup = needsPluralHandling && !opt.ordinal && opt.count === 0;
            const needsContextHandling = opt.context !== undefined && ($6aaf2cb5d81db2fa$var$isString(opt.context) || typeof opt.context === 'number') && opt.context !== '';
            const codes = opt.lngs ? opt.lngs : this.languageUtils.toResolveHierarchy(opt.lng || this.language, opt.fallbackLng);
            namespaces.forEach((ns)=>{
                var _this_utils, _this_utils1;
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$6aaf2cb5d81db2fa$var$checkedLoadedFor[`${codes[0]}-${ns}`] && ((_this_utils = this.utils) === null || _this_utils === void 0 ? void 0 : _this_utils.hasLoadedNamespace) && !((_this_utils1 = this.utils) === null || _this_utils1 === void 0 ? void 0 : _this_utils1.hasLoadedNamespace(usedNS))) {
                    $6aaf2cb5d81db2fa$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    var _this_i18nFormat;
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, opt);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, opt.count, opt);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            finalKeys.push(key + pluralSuffix);
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator || '_'}${opt.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                if (opt.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                finalKeys.push(contextKey + pluralSuffix);
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, opt);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key, options = {}) {
        var _this_i18nFormat;
        if ((_this_i18nFormat = this.i18nFormat) === null || _this_i18nFormat === void 0 ? void 0 : _this_i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails(options = {}) {
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && !$6aaf2cb5d81db2fa$var$isString(options.replace);
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = (0, $307af824b9387905$export$71511d61b312f219)({}, this.options.interpolation.defaultVariables, data);
        if (!useOptionsReplaceForData) {
            data = (0, $307af824b9387905$export$71511d61b312f219)({}, data);
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
    constructor(services, options = {}){
        super();
        $6aaf2cb5d81db2fa$var$copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = $6aaf2cb5d81db2fa$var$baseLogger.create('translator');
    }
}
class $6aaf2cb5d81db2fa$var$LanguageUtil {
    getScriptPartFromCode(code) {
        code = $6aaf2cb5d81db2fa$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = $6aaf2cb5d81db2fa$var$getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if ($6aaf2cb5d81db2fa$var$isString(code) && code.indexOf('-') > -1) {
            let formattedCode;
            try {
                formattedCode = Intl.getCanonicalLocales(code)[0];
            } catch (e) {}
            if (formattedCode && this.options.lowerCaseLng) formattedCode = formattedCode.toLowerCase();
            if (formattedCode) return formattedCode;
            if (this.options.lowerCaseLng) return code.toLowerCase();
            return code;
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngScOnly = this.getScriptPartFromCode(code);
            if (this.isSupportedCode(lngScOnly)) return found = lngScOnly;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if ($6aaf2cb5d81db2fa$var$isString(fallbacks)) fallbacks = [
            fallbacks
        ];
        if (Array.isArray(fallbacks)) return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes((fallbackCode === false ? [] : fallbackCode) || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if ($6aaf2cb5d81db2fa$var$isString(code) && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if ($6aaf2cb5d81db2fa$var$isString(code)) addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $6aaf2cb5d81db2fa$var$baseLogger.create('languageUtils');
    }
}
const $6aaf2cb5d81db2fa$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
const $6aaf2cb5d81db2fa$var$dummyRule = {
    select: (count)=>count === 1 ? 'one' : 'other',
    resolvedOptions: ()=>({
            pluralCategories: [
                'one',
                'other'
            ]
        })
};
class $6aaf2cb5d81db2fa$var$PluralResolver {
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    clearCache() {
        this.pluralRulesCache = {};
    }
    getRule(code, options = {}) {
        const cleanedCode = $6aaf2cb5d81db2fa$var$getCleanedCode(code === 'dev' ? 'en' : code);
        const type = options.ordinal ? 'ordinal' : 'cardinal';
        const cacheKey = JSON.stringify({
            cleanedCode: cleanedCode,
            type: type
        });
        if (cacheKey in this.pluralRulesCache) return this.pluralRulesCache[cacheKey];
        let rule;
        try {
            rule = new Intl.PluralRules(cleanedCode, {
                type: type
            });
        } catch (err) {
            if (!Intl) {
                this.logger.error('No Intl support, please use an Intl polyfill!');
                return $6aaf2cb5d81db2fa$var$dummyRule;
            }
            if (!code.match(/-|_/)) return $6aaf2cb5d81db2fa$var$dummyRule;
            const lngPart = this.languageUtils.getLanguagePartFromCode(code);
            rule = this.getRule(lngPart, options);
        }
        this.pluralRulesCache[cacheKey] = rule;
        return rule;
    }
    needsPlural(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        return (rule === null || rule === void 0 ? void 0 : rule.resolvedOptions().pluralCategories.length) > 1;
    }
    getPluralFormsOfKey(code, key, options = {}) {
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code, options = {}) {
        let rule = this.getRule(code, options);
        if (!rule) rule = this.getRule('dev', options);
        if (!rule) return [];
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$6aaf2cb5d81db2fa$var$suffixesOrder[pluralCategory1] - $6aaf2cb5d81db2fa$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    getSuffix(code, count, options = {}) {
        const rule = this.getRule(code, options);
        if (rule) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        this.logger.warn(`no plural rule found for: ${code}`);
        return this.getSuffix('dev', count, options);
    }
    constructor(languageUtils, options = {}){
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $6aaf2cb5d81db2fa$var$baseLogger.create('pluralResolver');
        this.pluralRulesCache = {};
    }
}
const $6aaf2cb5d81db2fa$var$deepFindWithDefaults = (data, defaultData, key, keySeparator = '.', ignoreJSONStructure = true)=>{
    let path = $6aaf2cb5d81db2fa$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && $6aaf2cb5d81db2fa$var$isString(key)) {
        path = $6aaf2cb5d81db2fa$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $6aaf2cb5d81db2fa$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
};
const $6aaf2cb5d81db2fa$var$regexSafe = (val)=>val.replace(/\$/g, '$$$$');
class $6aaf2cb5d81db2fa$var$Interpolator {
    init(options = {}) {
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const { escape: escape$1, escapeValue: escapeValue, useRawValueToEscape: useRawValueToEscape, prefix: prefix, prefixEscaped: prefixEscaped, suffix: suffix, suffixEscaped: suffixEscaped, formatSeparator: formatSeparator, unescapeSuffix: unescapeSuffix, unescapePrefix: unescapePrefix, nestingPrefix: nestingPrefix, nestingPrefixEscaped: nestingPrefixEscaped, nestingSuffix: nestingSuffix, nestingSuffixEscaped: nestingSuffixEscaped, nestingOptionsSeparator: nestingOptionsSeparator, maxReplaces: maxReplaces, alwaysFormat: alwaysFormat } = options.interpolation;
        this.escape = escape$1 !== undefined ? escape$1 : $6aaf2cb5d81db2fa$var$escape;
        this.escapeValue = escapeValue !== undefined ? escapeValue : true;
        this.useRawValueToEscape = useRawValueToEscape !== undefined ? useRawValueToEscape : false;
        this.prefix = prefix ? $6aaf2cb5d81db2fa$var$regexEscape(prefix) : prefixEscaped || '{{';
        this.suffix = suffix ? $6aaf2cb5d81db2fa$var$regexEscape(suffix) : suffixEscaped || '}}';
        this.formatSeparator = formatSeparator || ',';
        this.unescapePrefix = unescapeSuffix ? '' : unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : unescapeSuffix || '';
        this.nestingPrefix = nestingPrefix ? $6aaf2cb5d81db2fa$var$regexEscape(nestingPrefix) : nestingPrefixEscaped || $6aaf2cb5d81db2fa$var$regexEscape('$t(');
        this.nestingSuffix = nestingSuffix ? $6aaf2cb5d81db2fa$var$regexEscape(nestingSuffix) : nestingSuffixEscaped || $6aaf2cb5d81db2fa$var$regexEscape(')');
        this.nestingOptionsSeparator = nestingOptionsSeparator || ',';
        this.maxReplaces = maxReplaces || 1000;
        this.alwaysFormat = alwaysFormat !== undefined ? alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if ((existingRegExp === null || existingRegExp === void 0 ? void 0 : existingRegExp.source) === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, 'g');
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        var _options_interpolation;
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $6aaf2cb5d81db2fa$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, options, data), {
                    interpolationkey: key
                })) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($6aaf2cb5d81db2fa$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, options, data), {
                interpolationkey: k
            }));
        };
        this.resetRegExp();
        const missingInterpolationHandler = (options === null || options === void 0 ? void 0 : options.missingInterpolationHandler) || this.options.missingInterpolationHandler;
        const skipOnVariables = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.skipOnVariables) !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>$6aaf2cb5d81db2fa$var$regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? $6aaf2cb5d81db2fa$var$regexSafe(this.escape(val)) : $6aaf2cb5d81db2fa$var$regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = $6aaf2cb5d81db2fa$var$isString(temp) ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (!$6aaf2cb5d81db2fa$var$isString(value) && !this.useRawValueToEscape) value = $6aaf2cb5d81db2fa$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc, options = {}) {
        let match;
        let value;
        let clonedOptions;
        const handleHasOptions = (key, inheritedOptions)=>{
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            var _matchedSingleQuotes_length;
            if (((_matchedSingleQuotes_length = matchedSingleQuotes === null || matchedSingleQuotes === void 0 ? void 0 : matchedSingleQuotes.length) !== null && _matchedSingleQuotes_length !== void 0 ? _matchedSingleQuotes_length : 0) % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = (0, $307af824b9387905$export$71511d61b312f219)({}, inheritedOptions, clonedOptions);
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        };
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = (0, $307af824b9387905$export$71511d61b312f219)({}, options);
            clonedOptions = clonedOptions.replace && !$6aaf2cb5d81db2fa$var$isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            const keyEndIndex = /{.*}/.test(match[1]) ? match[1].lastIndexOf('}') + 1 : match[1].indexOf(this.formatSeparator);
            if (keyEndIndex !== -1) {
                formatters = match[1].slice(keyEndIndex).split(this.formatSeparator).map((elem)=>elem.trim()).filter(Boolean);
                match[1] = match[1].slice(0, keyEndIndex);
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && !$6aaf2cb5d81db2fa$var$isString(value)) return value;
            if (!$6aaf2cb5d81db2fa$var$isString(value)) value = $6aaf2cb5d81db2fa$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (formatters.length) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, options), {
                    interpolationkey: match[1].trim()
                })), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
    constructor(options = {}){
        var _options_interpolation;
        this.logger = $6aaf2cb5d81db2fa$var$baseLogger.create('interpolator');
        this.options = options;
        this.format = (options === null || options === void 0 ? void 0 : (_options_interpolation = options.interpolation) === null || _options_interpolation === void 0 ? void 0 : _options_interpolation.format) || ((value)=>value);
        this.init(options);
    }
}
const $6aaf2cb5d81db2fa$var$parseFormatStr = (formatStr)=>{
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (opt) {
                    const [key, ...rest] = opt.split(':');
                    const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                    const trimmedKey = key.trim();
                    if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
                    if (val === 'false') formatOptions[trimmedKey] = false;
                    if (val === 'true') formatOptions[trimmedKey] = true;
                    if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
                }
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
};
const $6aaf2cb5d81db2fa$var$createCachedFormatter = (fn)=>{
    const cache = {};
    return (v, l, o)=>{
        let optForCache = o;
        if (o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey]) optForCache = (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, optForCache), {
            [o.interpolationkey]: undefined
        });
        const key = l + JSON.stringify(optForCache);
        let frm = cache[key];
        if (!frm) {
            frm = fn($6aaf2cb5d81db2fa$var$getCleanedCode(l), o);
            cache[key] = frm;
        }
        return frm(v);
    };
};
const $6aaf2cb5d81db2fa$var$createNonCachedFormatter = (fn)=>(v, l, o)=>fn($6aaf2cb5d81db2fa$var$getCleanedCode(l), o)(v);
class $6aaf2cb5d81db2fa$var$Formatter {
    init(services, options = {
        interpolation: {}
    }) {
        this.formatSeparator = options.interpolation.formatSeparator || ',';
        const cf = options.cacheInBuiltFormats ? $6aaf2cb5d81db2fa$var$createCachedFormatter : $6aaf2cb5d81db2fa$var$createNonCachedFormatter;
        this.formats = {
            number: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, (0, $307af824b9387905$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val);
            }),
            currency: cf((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, opt), {
                    style: 'currency'
                }));
                return (val)=>formatter.format(val);
            }),
            datetime: cf((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, (0, $307af824b9387905$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val);
            }),
            relativetime: cf((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, (0, $307af824b9387905$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: cf((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, (0, $307af824b9387905$export$71511d61b312f219)({}, opt));
                return (val)=>formatter.format(val);
            })
        };
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $6aaf2cb5d81db2fa$var$createCachedFormatter(fc);
    }
    format(value, format, lng, options = {}) {
        const formats = format.split(this.formatSeparator);
        if (formats.length > 1 && formats[0].indexOf('(') > 1 && formats[0].indexOf(')') < 0 && formats.find((f)=>f.indexOf(')') > -1)) {
            const lastIndex = formats.findIndex((f)=>f.indexOf(')') > -1);
            formats[0] = [
                formats[0],
                ...formats.splice(1, lastIndex)
            ].join(this.formatSeparator);
        }
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $6aaf2cb5d81db2fa$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    var _options_formatParams;
                    const valOptions = (options === null || options === void 0 ? void 0 : (_options_formatParams = options.formatParams) === null || _options_formatParams === void 0 ? void 0 : _options_formatParams[options.interpolationkey]) || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, (0, $307af824b9387905$export$71511d61b312f219)({}, formatOptions, options, valOptions));
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
    constructor(options = {}){
        this.logger = $6aaf2cb5d81db2fa$var$baseLogger.create('formatter');
        this.options = options;
        this.init(options);
    }
}
const $6aaf2cb5d81db2fa$var$removePending = (q, name)=>{
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
};
class $6aaf2cb5d81db2fa$var$Connector extends $6aaf2cb5d81db2fa$var$EventEmitter {
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (!err && data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        if (err && data) this.state[name] = 0;
        const loaded = {};
        this.queue.forEach((q)=>{
            $6aaf2cb5d81db2fa$var$pushPath(q.loaded, [
                lng
            ], ns);
            $6aaf2cb5d81db2fa$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName, tried = 0, wait = this.retryTimeout, callback) {
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces, options = {}, callback) {
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if ($6aaf2cb5d81db2fa$var$isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
        if ($6aaf2cb5d81db2fa$var$isString(namespaces)) namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name, prefix = '') {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}, clb = ()=>{}) {
        var _this_services_utils, _this_services, _this_services_utils1, _this_services1, _this_backend;
        if (((_this_services = this.services) === null || _this_services === void 0 ? void 0 : (_this_services_utils = _this_services.utils) === null || _this_services_utils === void 0 ? void 0 : _this_services_utils.hasLoadedNamespace) && !((_this_services1 = this.services) === null || _this_services1 === void 0 ? void 0 : (_this_services_utils1 = _this_services1.utils) === null || _this_services_utils1 === void 0 ? void 0 : _this_services_utils1.hasLoadedNamespace(namespace))) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if ((_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : _this_backend.create) {
            const opts = (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, options), {
                isUpdate: isUpdate
            });
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
    constructor(backend, store, services, options = {}){
        var _this_backend_init, _this_backend;
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $6aaf2cb5d81db2fa$var$baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        (_this_backend = this.backend) === null || _this_backend === void 0 ? void 0 : (_this_backend_init = _this_backend.init) === null || _this_backend_init === void 0 ? void 0 : _this_backend_init.call(_this_backend, services, options.backend, options);
    }
}
const $6aaf2cb5d81db2fa$var$get = ()=>({
        debug: false,
        initAsync: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: (args)=>{
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if ($6aaf2cb5d81db2fa$var$isString(args[1])) ret.defaultValue = args[1];
            if ($6aaf2cb5d81db2fa$var$isString(args[2])) ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        },
        cacheInBuiltFormats: true
    });
const $6aaf2cb5d81db2fa$var$transformOptions = (options)=>{
    var _options_supportedLngs_indexOf, _options_supportedLngs;
    if ($6aaf2cb5d81db2fa$var$isString(options.ns)) options.ns = [
        options.ns
    ];
    if ($6aaf2cb5d81db2fa$var$isString(options.fallbackLng)) options.fallbackLng = [
        options.fallbackLng
    ];
    if ($6aaf2cb5d81db2fa$var$isString(options.fallbackNS)) options.fallbackNS = [
        options.fallbackNS
    ];
    if (((_options_supportedLngs = options.supportedLngs) === null || _options_supportedLngs === void 0 ? void 0 : (_options_supportedLngs_indexOf = _options_supportedLngs.indexOf) === null || _options_supportedLngs_indexOf === void 0 ? void 0 : _options_supportedLngs_indexOf.call(_options_supportedLngs, 'cimode')) < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    if (typeof options.initImmediate === 'boolean') options.initAsync = options.initImmediate;
    return options;
};
const $6aaf2cb5d81db2fa$var$noop = ()=>{};
const $6aaf2cb5d81db2fa$var$bindMemberFunctions = (inst)=>{
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
};
class $6aaf2cb5d81db2fa$var$I18n extends $6aaf2cb5d81db2fa$var$EventEmitter {
    init(options = {}, callback) {
        this.isInitializing = true;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (options.defaultNS == null && options.ns) {
            if ($6aaf2cb5d81db2fa$var$isString(options.ns)) options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $6aaf2cb5d81db2fa$var$get();
        this.options = (0, $307af824b9387905$export$71511d61b312f219)({}, defOpts, this.options, $6aaf2cb5d81db2fa$var$transformOptions(options));
        this.options.interpolation = (0, $307af824b9387905$export$71511d61b312f219)({}, defOpts.interpolation, this.options.interpolation);
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        const createClassOnDemand = (ClassOrObject)=>{
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        };
        if (!this.options.isClone) {
            if (this.modules.logger) $6aaf2cb5d81db2fa$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $6aaf2cb5d81db2fa$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else formatter = $6aaf2cb5d81db2fa$var$Formatter;
            const lu = new $6aaf2cb5d81db2fa$var$LanguageUtil(this.options);
            this.store = new $6aaf2cb5d81db2fa$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $6aaf2cb5d81db2fa$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $6aaf2cb5d81db2fa$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            const usingLegacyFormatFunction = this.options.interpolation.format && this.options.interpolation.format !== defOpts.interpolation.format;
            if (usingLegacyFormatFunction) this.logger.deprecate(`init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting`);
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                if (s.formatter.init) s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $6aaf2cb5d81db2fa$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $6aaf2cb5d81db2fa$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $6aaf2cb5d81db2fa$var$Translator(this.services, this.options);
            this.translator.on('*', (event, ...args)=>{
                this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $6aaf2cb5d81db2fa$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = (...args)=>this.store[fcName](...args);
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = (...args)=>{
                this.store[fcName](...args);
                return this;
            };
        });
        const deferred = $6aaf2cb5d81db2fa$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initAsync) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language, callback = $6aaf2cb5d81db2fa$var$noop) {
        let usedCallback = callback;
        const usedLng = $6aaf2cb5d81db2fa$var$isString(language) ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            var _this_options_preload_forEach, _this_options_preload;
            if ((usedLng === null || usedLng === void 0 ? void 0 : usedLng.toLowerCase()) === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            (_this_options_preload = this.options.preload) === null || _this_options_preload === void 0 ? void 0 : (_this_options_preload_forEach = _this_options_preload.forEach) === null || _this_options_preload_forEach === void 0 ? void 0 : _this_options_preload_forEach.call(_this_options_preload, (l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $6aaf2cb5d81db2fa$var$defer();
        if (typeof lngs === 'function') {
            callback = lngs;
            lngs = undefined;
        }
        if (typeof ns === 'function') {
            callback = ns;
            ns = undefined;
        }
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $6aaf2cb5d81db2fa$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') $6aaf2cb5d81db2fa$var$postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
        if (!this.resolvedLanguage && this.languages.indexOf(l) < 0 && this.store.hasLanguageSomeTranslations(l)) {
            this.resolvedLanguage = l;
            this.languages.unshift(l);
        }
    }
    changeLanguage(lng, callback) {
        this.isLanguageChangingTo = lng;
        const deferred = $6aaf2cb5d81db2fa$var$defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                if (this.isLanguageChangingTo === lng) {
                    setLngProps(l);
                    this.translator.changeLanguage(l);
                    this.isLanguageChangingTo = undefined;
                    this.emit('languageChanged', l);
                    this.logger.log('languageChanged', l);
                }
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve((...args)=>this.t(...args));
            if (callback) callback(err, (...args)=>this.t(...args));
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const fl = $6aaf2cb5d81db2fa$var$isString(lngs) ? lngs : lngs && lngs[0];
            const l = this.store.hasLanguageSomeTranslations(fl) ? fl : this.services.languageUtils.getBestMatchFromCodes($6aaf2cb5d81db2fa$var$isString(lngs) ? [
                lngs
            ] : lngs);
            if (l) {
                var _this_services_languageDetector_cacheUserLanguage, _this_services_languageDetector;
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                (_this_services_languageDetector = this.services.languageDetector) === null || _this_services_languageDetector === void 0 ? void 0 : (_this_services_languageDetector_cacheUserLanguage = _this_services_languageDetector.cacheUserLanguage) === null || _this_services_languageDetector_cacheUserLanguage === void 0 ? void 0 : _this_services_languageDetector_cacheUserLanguage.call(_this_services_languageDetector, l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        const fixedT = (key, opts, ...rest)=>{
            let o;
            if (typeof opts !== 'object') o = this.options.overloadTranslationOptionHandler([
                key,
                opts
            ].concat(rest));
            else o = (0, $307af824b9387905$export$71511d61b312f219)({}, opts);
            o.lng = o.lng || fixedT.lng;
            o.lngs = o.lngs || fixedT.lngs;
            o.ns = o.ns || fixedT.ns;
            if (o.keyPrefix !== '') o.keyPrefix = o.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = this.options.keySeparator || '.';
            let resultKey;
            if (o.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>{
                if (typeof k === 'function') k = $6aaf2cb5d81db2fa$export$ec2cccc18ab4c2ae(k, (0, $307af824b9387905$export$71511d61b312f219)({}, this.options, opts));
                return `${o.keyPrefix}${keySeparator}${k}`;
            });
            else {
                if (typeof key === 'function') key = $6aaf2cb5d81db2fa$export$ec2cccc18ab4c2ae(key, (0, $307af824b9387905$export$71511d61b312f219)({}, this.options, opts));
                resultKey = o.keyPrefix ? `${o.keyPrefix}${keySeparator}${key}` : key;
            }
            return this.t(resultKey, o);
        };
        if ($6aaf2cb5d81db2fa$var$isString(lng)) fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t(...args) {
        var _this_translator;
        return (_this_translator = this.translator) === null || _this_translator === void 0 ? void 0 : _this_translator.translate(...args);
    }
    exists(...args) {
        var _this_translator;
        return (_this_translator = this.translator) === null || _this_translator === void 0 ? void 0 : _this_translator.exists(...args);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns, options = {}) {
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 0 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $6aaf2cb5d81db2fa$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if ($6aaf2cb5d81db2fa$var$isString(ns)) ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $6aaf2cb5d81db2fa$var$defer();
        if ($6aaf2cb5d81db2fa$var$isString(lngs)) lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        var _this_languages, _this_services;
        if (!lng) lng = this.resolvedLanguage || (((_this_languages = this.languages) === null || _this_languages === void 0 ? void 0 : _this_languages.length) > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        try {
            const l = new Intl.Locale(lng);
            if (l && l.getTextInfo) {
                const ti = l.getTextInfo();
                if (ti && ti.direction) return ti.direction;
            }
        } catch (e) {}
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = ((_this_services = this.services) === null || _this_services === void 0 ? void 0 : _this_services.languageUtils) || new $6aaf2cb5d81db2fa$var$LanguageUtil($6aaf2cb5d81db2fa$var$get());
        if (lng.toLowerCase().indexOf('-latn') > 1) return 'ltr';
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance(options = {}, callback) {
        const instance = new $6aaf2cb5d81db2fa$var$I18n(options, callback);
        instance.createInstance = $6aaf2cb5d81db2fa$var$I18n.createInstance;
        return instance;
    }
    cloneInstance(options = {}, callback = $6aaf2cb5d81db2fa$var$noop) {
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, this.options, options), {
            isClone: true
        });
        const clone = new $6aaf2cb5d81db2fa$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = (0, $307af824b9387905$export$71511d61b312f219)({}, this.services);
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            const clonedData = Object.keys(this.store.data).reduce((prev, l)=>{
                prev[l] = (0, $307af824b9387905$export$71511d61b312f219)({}, this.store.data[l]);
                prev[l] = Object.keys(prev[l]).reduce((acc, n)=>{
                    acc[n] = (0, $307af824b9387905$export$71511d61b312f219)({}, prev[l][n]);
                    return acc;
                }, prev[l]);
                return prev;
            }, {});
            clone.store = new $6aaf2cb5d81db2fa$var$ResourceStore(clonedData, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $6aaf2cb5d81db2fa$var$Translator(clone.services, mergedOptions);
        clone.translator.on('*', (event, ...args)=>{
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
    constructor(options = {}, callback){
        super();
        this.options = $6aaf2cb5d81db2fa$var$transformOptions(options);
        this.services = {};
        this.logger = $6aaf2cb5d81db2fa$var$baseLogger;
        this.modules = {
            external: []
        };
        $6aaf2cb5d81db2fa$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initAsync) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
}
const $6aaf2cb5d81db2fa$export$2e2bcd8739ae039 = $6aaf2cb5d81db2fa$var$I18n.createInstance();
const $6aaf2cb5d81db2fa$export$99152e8d49ca4e7d = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.createInstance;
const $6aaf2cb5d81db2fa$export$147ec2801e896265 = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.dir;
const $6aaf2cb5d81db2fa$export$2cd8252107eb640b = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.init;
const $6aaf2cb5d81db2fa$export$d3d08d944062d7e = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.loadResources;
const $6aaf2cb5d81db2fa$export$a5d9bf5d83fcab09 = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.reloadResources;
const $6aaf2cb5d81db2fa$export$1f96ae73734a86cc = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.use;
const $6aaf2cb5d81db2fa$export$61465194746e7fd2 = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.changeLanguage;
const $6aaf2cb5d81db2fa$export$f90d180fc7da3b3b = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.getFixedT;
const $6aaf2cb5d81db2fa$export$625550452a3fa3ec = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.t;
const $6aaf2cb5d81db2fa$export$f7e9f41ea797a17 = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.exists;
const $6aaf2cb5d81db2fa$export$2b4b218e406d2d00 = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.setDefaultNamespace;
const $6aaf2cb5d81db2fa$export$93d9ee97c1ad3f31 = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.hasLoadedNamespace;
const $6aaf2cb5d81db2fa$export$83be934b53fff43b = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.loadNamespaces;
const $6aaf2cb5d81db2fa$export$8cd7e7a54fa865bc = $6aaf2cb5d81db2fa$export$2e2bcd8739ae039.loadLanguages;











function $1f537e0bfb469332$export$a39947a896defee6(_param) {
    var { children: children, flexDirection: flexDirection = "row", gap: gap = "4", justifyContent: justifyContent = "start", alignItems: alignItems = "start", flexWrap: flexWrap = "wrap", className: className, Comp: Comp = "div", style: style, fullWidthChildren: fullWidthChildren = true, type: type } = _param, props = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
        "children",
        "flexDirection",
        "gap",
        "justifyContent",
        "alignItems",
        "flexWrap",
        "className",
        "Comp",
        "style",
        "fullWidthChildren",
        "type"
    ]);
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(Comp, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({
        type: type,
        style: (0, $307af824b9387905$export$71511d61b312f219)({
            gap: `${gap}px`,
            justifyContent: justifyContent,
            alignItems: alignItems,
            flexWrap: flexWrap,
            flexDirection: flexDirection
        }, style),
        className: (0, $f4d1d798408df2f5$export$2e2bcd8739ae039)("spacing", {
            "fullWidthChildren": fullWidthChildren
        }, className)
    }, props), {
        children: children
    }));
}




function $44d65d2a768a7a29$export$353f5b6fc5456de1(props) {
    let cssMode = "";
    if (props.mode) cssMode = `storybook-button--${props.mode}`;
    function Content() {
        return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {
            children: (props === null || props === void 0 ? void 0 : props.icon) ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $1f537e0bfb469332$export$a39947a896defee6), {
                alignItems: "center",
                children: [
                    props === null || props === void 0 ? void 0 : props.icon,
                    props.label
                ]
            }) : props.label
        });
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("button", {
        id: props.id,
        "aria-label": props.id,
        type: props.type ? props.type : "button",
        disabled: props.disabled,
        form: props.form,
        className: [
            "storybook-button",
            cssMode,
            props.className,
            props.border ? `storybook-button--border` : ``
        ].join(" "),
        onClick: props.onClick,
        title: props.hoverText,
        style: props.style,
        children: props.loading ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $1f537e0bfb469332$export$a39947a896defee6), {
            flexWrap: "nowrap",
            alignItems: "center",
            gap: "8",
            justifyContent: "center",
            children: [
                (props === null || props === void 0 ? void 0 : props.loading) && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("span", {
                    className: "loading-wrapper",
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("span", {
                        className: "loader"
                    })
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(Content, {})
            ]
        }) : /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(Content, {})
    });
}







var $46wWE = parcelRequire("46wWE");




var $46wWE = parcelRequire("46wWE");

var $b905d66d60a2c9e4$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $b905d66d60a2c9e4$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $3657b57b1a1900f2$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $3657b57b1a1900f2$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($b905d66d60a2c9e4$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3657b57b1a1900f2$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3657b57b1a1900f2$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3657b57b1a1900f2$var$i = /^\s*$/, $3657b57b1a1900f2$var$s = Object.create(null);
function $3657b57b1a1900f2$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($3657b57b1a1900f2$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $3657b57b1a1900f2$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $3657b57b1a1900f2$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($3657b57b1a1900f2$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $3657b57b1a1900f2$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $3657b57b1a1900f2$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $3657b57b1a1900f2$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $3657b57b1a1900f2$var$a("", t);
        }, "");
    }
};
var $3657b57b1a1900f2$export$2e2bcd8739ae039 = $3657b57b1a1900f2$var$c;



const $931ea6f6949516fe$export$c106dd0671a0fc2d = (i18n, code, msg, rest)=>{
    var _i18n_services_logger, _i18n_services, _i18n_services_logger1, _i18n_services1, _console;
    const args = [
        msg,
        (0, $307af824b9387905$export$71511d61b312f219)({
            code: code
        }, rest || {})
    ];
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services = i18n.services) === null || _i18n_services === void 0 ? void 0 : (_i18n_services_logger = _i18n_services.logger) === null || _i18n_services_logger === void 0 ? void 0 : _i18n_services_logger.forward) return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
    if ($931ea6f6949516fe$export$844ec244b1367d54(args[0])) args[0] = `react-i18next:: ${args[0]}`;
    if (i18n === null || i18n === void 0 ? void 0 : (_i18n_services1 = i18n.services) === null || _i18n_services1 === void 0 ? void 0 : (_i18n_services_logger1 = _i18n_services1.logger) === null || _i18n_services_logger1 === void 0 ? void 0 : _i18n_services_logger1.warn) i18n.services.logger.warn(...args);
    else if ((_console = console) === null || _console === void 0 ? void 0 : _console.warn) console.warn(...args);
};
const $931ea6f6949516fe$var$alreadyWarned = {};
const $931ea6f6949516fe$export$5b28268982f175ba = (i18n, code, msg, rest)=>{
    if ($931ea6f6949516fe$export$844ec244b1367d54(msg) && $931ea6f6949516fe$var$alreadyWarned[msg]) return;
    if ($931ea6f6949516fe$export$844ec244b1367d54(msg)) $931ea6f6949516fe$var$alreadyWarned[msg] = new Date();
    $931ea6f6949516fe$export$c106dd0671a0fc2d(i18n, code, msg, rest);
};
const $931ea6f6949516fe$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
const $931ea6f6949516fe$export$83be934b53fff43b = (i18n, ns, cb)=>{
    i18n.loadNamespaces(ns, $931ea6f6949516fe$var$loadedClb(i18n, cb));
};
const $931ea6f6949516fe$export$8cd7e7a54fa865bc = (i18n, lng, ns, cb)=>{
    if ($931ea6f6949516fe$export$844ec244b1367d54(ns)) ns = [
        ns
    ];
    if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return $931ea6f6949516fe$export$83be934b53fff43b(i18n, ns, cb);
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $931ea6f6949516fe$var$loadedClb(i18n, cb));
};
const $931ea6f6949516fe$export$93d9ee97c1ad3f31 = (ns, i18n, options = {})=>{
    if (!i18n.languages || !i18n.languages.length) {
        $931ea6f6949516fe$export$5b28268982f175ba(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
            languages: i18n.languages
        });
        return true;
    }
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
};
const $931ea6f6949516fe$export$be63e0664592e141 = (Component)=>Component.displayName || Component.name || ($931ea6f6949516fe$export$844ec244b1367d54(Component) && Component.length > 0 ? Component : 'Unknown');
const $931ea6f6949516fe$export$844ec244b1367d54 = (obj)=>typeof obj === 'string';
const $931ea6f6949516fe$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'object' && obj !== null;



const $cafcf4bc61a1f5d1$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $cafcf4bc61a1f5d1$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const $cafcf4bc61a1f5d1$var$unescapeHtmlEntity = (m)=>$cafcf4bc61a1f5d1$var$htmlEntities[m];
const $cafcf4bc61a1f5d1$export$e8bacd2802a88316 = (text)=>text.replace($cafcf4bc61a1f5d1$var$matchHtmlEntity, $cafcf4bc61a1f5d1$var$unescapeHtmlEntity);


let $1189582b795e34b5$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: $cafcf4bc61a1f5d1$export$e8bacd2802a88316
};
const $1189582b795e34b5$export$2e2366488d12e20d = (options = {})=>{
    $1189582b795e34b5$var$defaultOptions = (0, $307af824b9387905$export$71511d61b312f219)({}, $1189582b795e34b5$var$defaultOptions, options);
};
const $1189582b795e34b5$export$212bb2fc580a90a8 = ()=>$1189582b795e34b5$var$defaultOptions;


let $5305cfda55d75976$var$i18nInstance;
const $5305cfda55d75976$export$a039134f2fc7e0 = (instance)=>{
    $5305cfda55d75976$var$i18nInstance = instance;
};
const $5305cfda55d75976$export$64af334f494c2f47 = ()=>$5305cfda55d75976$var$i18nInstance;


const $ba5827dc75f195ba$var$hasChildren = (node, checkLength)=>{
    var _node_props;
    if (!node) return false;
    var _node_props_children;
    const base = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
};
const $ba5827dc75f195ba$var$getChildren = (node)=>{
    var _node_props, _node_props1;
    if (!node) return [];
    var _node_props_children;
    const children = (_node_props_children = (_node_props = node.props) === null || _node_props === void 0 ? void 0 : _node_props.children) !== null && _node_props_children !== void 0 ? _node_props_children : node.children;
    return ((_node_props1 = node.props) === null || _node_props1 === void 0 ? void 0 : _node_props1.i18nIsDynamicList) ? $ba5827dc75f195ba$var$getAsArray(children) : children;
};
const $ba5827dc75f195ba$var$hasValidReactChildren = (children)=>Array.isArray(children) && children.every((0, $46wWE.isValidElement));
const $ba5827dc75f195ba$var$getAsArray = (data)=>Array.isArray(data) ? data : [
        data
    ];
const $ba5827dc75f195ba$var$mergeProps = (source, target)=>{
    const newTarget = (0, $307af824b9387905$export$71511d61b312f219)({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
};
const $ba5827dc75f195ba$export$4f7a36dd898f1267 = (children, i18nOptions, i18n, i18nKey)=>{
    if (!children) return '';
    let stringNode = '';
    const childrenArray = $ba5827dc75f195ba$var$getAsArray(children);
    var _i18nOptions_transKeepBasicHtmlNodesFor;
    const keepArray = (i18nOptions === null || i18nOptions === void 0 ? void 0 : i18nOptions.transSupportBasicHtmlNodes) ? (_i18nOptions_transKeepBasicHtmlNodesFor = i18nOptions.transKeepBasicHtmlNodesFor) !== null && _i18nOptions_transKeepBasicHtmlNodesFor !== void 0 ? _i18nOptions_transKeepBasicHtmlNodesFor : [] : [];
    childrenArray.forEach((child, childIndex)=>{
        if ((0, $931ea6f6949516fe$export$844ec244b1367d54)(child)) {
            stringNode += `${child}`;
            return;
        }
        if ((0, $46wWE.isValidElement)(child)) {
            const { props: props, type: type } = child;
            const childPropsCount = Object.keys(props).length;
            const shouldKeepChild = keepArray.indexOf(type) > -1;
            const childChildren = props.children;
            if (!childChildren && shouldKeepChild && !childPropsCount) {
                stringNode += `<${type}/>`;
                return;
            }
            if (!childChildren && (!shouldKeepChild || childPropsCount) || props.i18nIsDynamicList) {
                stringNode += `<${childIndex}></${childIndex}>`;
                return;
            }
            if (shouldKeepChild && childPropsCount === 1 && (0, $931ea6f6949516fe$export$844ec244b1367d54)(childChildren)) {
                stringNode += `<${type}>${childChildren}</${type}>`;
                return;
            }
            const content = $ba5827dc75f195ba$export$4f7a36dd898f1267(childChildren, i18nOptions, i18n, i18nKey);
            stringNode += `<${childIndex}>${content}</${childIndex}>`;
            return;
        }
        if (child === null) {
            (0, $931ea6f6949516fe$export$c106dd0671a0fc2d)(i18n, 'TRANS_NULL_VALUE', `Passed in a null value as child`, {
                i18nKey: i18nKey
            });
            return;
        }
        if ((0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(child)) {
            const { format: format } = child, clone = (0, $d9d4991687d1f007$export$71511d61b312f219)(child, [
                "format"
            ]);
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
                return;
            }
            (0, $931ea6f6949516fe$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_OBJ', `Invalid child - Object should only have keys {{ value, format }} (format is optional).`, {
                i18nKey: i18nKey,
                child: child
            });
            return;
        }
        (0, $931ea6f6949516fe$export$c106dd0671a0fc2d)(i18n, 'TRANS_INVALID_VAR', `Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.`, {
            i18nKey: i18nKey,
            child: child
        });
    });
    return stringNode;
};
const $ba5827dc75f195ba$var$escapeLiteralLessThan = (str, keepArray = [], knownComponentsMap = {})=>{
    if (!str) return str;
    const knownNames = Object.keys(knownComponentsMap);
    const allValidNames = [
        ...keepArray,
        ...knownNames
    ];
    let result = '';
    let i = 0;
    while(i < str.length)if (str[i] === '<') {
        let isValidTag = false;
        const closingMatch = str.slice(i).match(/^<\/(\d+|[a-zA-Z][a-zA-Z0-9-]*)>/);
        if (closingMatch) {
            const tagName = closingMatch[1];
            if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                isValidTag = true;
                result += closingMatch[0];
                i += closingMatch[0].length;
            }
        }
        if (!isValidTag) {
            const openingMatch = str.slice(i).match(/^<(\d+|[a-zA-Z][a-zA-Z0-9-]*)(\s+[\w-]+(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?)*\s*(\/)?>/);
            if (openingMatch) {
                const tagName = openingMatch[1];
                if (/^\d+$/.test(tagName) || allValidNames.includes(tagName)) {
                    isValidTag = true;
                    result += openingMatch[0];
                    i += openingMatch[0].length;
                }
            }
        }
        if (!isValidTag) {
            result += '&lt;';
            i += 1;
        }
    } else {
        result += str[i];
        i += 1;
    }
    return result;
};
const $ba5827dc75f195ba$var$renderNodes = (children, knownComponentsMap, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape)=>{
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !knownComponentsMap && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = knownComponentsMap !== null && knownComponentsMap !== void 0 ? knownComponentsMap : {};
    const getData = (childs)=>{
        const childrenArray = $ba5827dc75f195ba$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if ((0, $931ea6f6949516fe$export$844ec244b1367d54)(child)) return;
            if ($ba5827dc75f195ba$var$hasChildren(child)) getData($ba5827dc75f195ba$var$getChildren(child));
            else if ((0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(child) && !(0, $46wWE.isValidElement)(child)) Object.assign(data, child);
        });
    };
    getData(children);
    const escapedString = $ba5827dc75f195ba$var$escapeLiteralLessThan(targetString, keepArray, data);
    const ast = (0, $3657b57b1a1900f2$export$2e2bcd8739ae039).parse(`<0>${escapedString}</0>`);
    const opts = (0, $307af824b9387905$export$71511d61b312f219)({}, data, combinedTOpts);
    const renderInner = (child, node, rootReactNode)=>{
        var _child_props;
        const childs = $ba5827dc75f195ba$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $ba5827dc75f195ba$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || ((_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.i18nIsDynamicList) ? childs : mappedChildren;
    };
    const pushTranslatedJSX = (child, inner, mem, i, isVoid)=>{
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $46wWE.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $46wWE.Children).map([
            child
        ], (c)=>{
            const INTERNAL_DYNAMIC_MARKER = 'data-i18n-is-dynamic-list';
            const override = {
                key: i,
                [INTERNAL_DYNAMIC_MARKER]: undefined
            };
            if (c && c.props) Object.keys(c.props).forEach((k)=>{
                if (k === 'ref' || k === 'children' || k === 'i18nIsDynamicList' || k === INTERNAL_DYNAMIC_MARKER) return;
                override[k] = c.props[k];
            });
            return (0, $46wWE.cloneElement)(c, override, isVoid ? null : inner);
        }));
    };
    const mapAST = (reactNode, astNode, rootReactNode)=>{
        const reactNodes = $ba5827dc75f195ba$var$getAsArray(reactNode);
        const astNodes = $ba5827dc75f195ba$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            var _node_children_, _node_children;
            const translationContent = ((_node_children = node.children) === null || _node_children === void 0 ? void 0 : (_node_children_ = _node_children[0]) === null || _node_children_ === void 0 ? void 0 : _node_children_.content) && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && knownComponentsMap) tmp = knownComponentsMap[node.name];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $ba5827dc75f195ba$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $46wWE.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $ba5827dc75f195ba$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(child) && child.dummy && !isElement;
                const isKnownComponent = (0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(knownComponentsMap) && Object.hasOwnProperty.call(knownComponentsMap, node.name);
                if ((0, $931ea6f6949516fe$export$844ec244b1367d54)(child)) {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($ba5827dc75f195ba$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $46wWE.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $46wWE.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if ((0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(child) && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $46wWE.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    };
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $ba5827dc75f195ba$var$getAsArray(children || []));
    return $ba5827dc75f195ba$var$getChildren(result[0]);
};
const $ba5827dc75f195ba$var$fixComponentProps = (component, index, translation)=>{
    const componentKey = component.key || index;
    const comp = (0, $46wWE.cloneElement)(component, {
        key: componentKey
    });
    if (!comp.props || !comp.props.children || translation.indexOf(`${index}/>`) < 0 && translation.indexOf(`${index} />`) < 0) return comp;
    function Componentized() {
        return (0, $46wWE.createElement)((0, $46wWE.Fragment), null, comp);
    }
    return (0, $46wWE.createElement)(Componentized, {
        key: componentKey
    });
};
const $ba5827dc75f195ba$var$generateArrayComponents = (components, translation)=>components.map((c, index)=>$ba5827dc75f195ba$var$fixComponentProps(c, index, translation));
const $ba5827dc75f195ba$var$generateObjectComponents = (components, translation)=>{
    const componentMap = {};
    Object.keys(components).forEach((c)=>{
        Object.assign(componentMap, {
            [c]: $ba5827dc75f195ba$var$fixComponentProps(components[c], c, translation)
        });
    });
    return componentMap;
};
const $ba5827dc75f195ba$var$generateComponents = (components, translation, i18n, i18nKey)=>{
    if (!components) return null;
    if (Array.isArray(components)) return $ba5827dc75f195ba$var$generateArrayComponents(components, translation);
    if ((0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(components)) return $ba5827dc75f195ba$var$generateObjectComponents(components, translation);
    (0, $931ea6f6949516fe$export$5b28268982f175ba)(i18n, 'TRANS_INVALID_COMPONENTS', `<Trans /> "components" prop expects an object or array`, {
        i18nKey: i18nKey
    });
    return null;
};
const $ba5827dc75f195ba$var$isComponentsMap = (object)=>{
    if (!(0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(object)) return false;
    if (Array.isArray(object)) return false;
    return Object.keys(object).reduce((acc, key)=>acc && Number.isNaN(Number.parseFloat(key)), true);
};
function $ba5827dc75f195ba$export$8d6a9236f2e3f2ce(_param) {
    var { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape } = _param, additionalProps = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
        "children",
        "count",
        "parent",
        "i18nKey",
        "context",
        "tOptions",
        "values",
        "defaults",
        "components",
        "ns",
        "i18n",
        "t",
        "shouldUnescape"
    ]);
    var _i18n_options, _i18n_options1, _i18n_options_interpolation, _i18n_options2, _i18n_options_interpolation1, _i18n_options3;
    const i18n = i18nFromProps || (0, $5305cfda55d75976$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $931ea6f6949516fe$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `Trans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    const reactI18nextOptions = (0, $307af824b9387905$export$71511d61b312f219)({}, (0, $1189582b795e34b5$export$212bb2fc580a90a8)(), (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.react);
    let namespaces = ns || t.ns || ((_i18n_options1 = i18n.options) === null || _i18n_options1 === void 0 ? void 0 : _i18n_options1.defaultNS);
    namespaces = (0, $931ea6f6949516fe$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = $ba5827dc75f195ba$export$4f7a36dd898f1267(children, reactI18nextOptions, i18n, i18nKey);
    const defaultValue = defaults || (tOptions === null || tOptions === void 0 ? void 0 : tOptions.defaultValue) || nodeAsString || reactI18nextOptions.transEmptyNodeValue || (typeof i18nKey === 'function' ? (0, $6aaf2cb5d81db2fa$export$ec2cccc18ab4c2ae)(i18nKey) : i18nKey);
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if ((_i18n_options2 = i18n.options) === null || _i18n_options2 === void 0 ? void 0 : (_i18n_options_interpolation = _i18n_options2.interpolation) === null || _i18n_options_interpolation === void 0 ? void 0 : _i18n_options_interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? (0, $307af824b9387905$export$71511d61b312f219)({}, values, i18n.options.interpolation.defaultVariables) : (0, $307af824b9387905$export$71511d61b312f219)({}, i18n.options.interpolation.defaultVariables);
    const interpolationOverride = values || count !== undefined && !((_i18n_options3 = i18n.options) === null || _i18n_options3 === void 0 ? void 0 : (_i18n_options_interpolation1 = _i18n_options3.interpolation) === null || _i18n_options_interpolation1 === void 0 ? void 0 : _i18n_options_interpolation1.alwaysFormat) || !children ? tOptions.interpolation : {
        interpolation: (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, tOptions.interpolation), {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    const combinedTOpts = (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)((0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, tOptions), {
        context: context || tOptions.context,
        count: count
    }), values, interpolationOverride), {
        defaultValue: defaultValue,
        ns: namespaces
    });
    let translation = key ? t(key, combinedTOpts) : defaultValue;
    if (translation === key && defaultValue) translation = defaultValue;
    const generatedComponents = $ba5827dc75f195ba$var$generateComponents(components, translation, i18n, i18nKey);
    let indexedChildren = generatedComponents || children;
    let componentsMap = null;
    if ($ba5827dc75f195ba$var$isComponentsMap(generatedComponents)) {
        componentsMap = generatedComponents;
        indexedChildren = children;
    }
    const content = $ba5827dc75f195ba$var$renderNodes(indexedChildren, componentsMap, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== null && parent !== void 0 ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $46wWE.createElement)(useAsParent, additionalProps, content) : content;
}




var $46wWE = parcelRequire("46wWE");




const $0ab9c89aa0526111$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init (instance) {
        (0, $1189582b795e34b5$export$2e2366488d12e20d)(instance.options.react);
        (0, $5305cfda55d75976$export$a039134f2fc7e0)(instance);
    }
};


const $e3f0cf3618fc3835$export$5603ab5ced17ce64 = (0, $46wWE.createContext)();
class $e3f0cf3618fc3835$export$ea171b67e3820290 {
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
    constructor(){
        this.usedNamespaces = {};
    }
}
const $e3f0cf3618fc3835$export$30ff0342ccf735a = (ForComponent)=>async (ctx)=>{
        var _ForComponent_getInitialProps;
        var _ref;
        const componentsInitialProps = (_ref = await ((_ForComponent_getInitialProps = ForComponent.getInitialProps) === null || _ForComponent_getInitialProps === void 0 ? void 0 : _ForComponent_getInitialProps.call(ForComponent, ctx))) !== null && _ref !== void 0 ? _ref : {};
        const i18nInitialProps = $e3f0cf3618fc3835$export$704200e5d0b9e8f();
        return (0, $307af824b9387905$export$71511d61b312f219)({}, componentsInitialProps, i18nInitialProps);
    };
const $e3f0cf3618fc3835$export$704200e5d0b9e8f = ()=>{
    var _i18n_reportNamespaces;
    const i18n = (0, $5305cfda55d75976$export$64af334f494c2f47)();
    var _i18n_reportNamespaces_getUsedNamespaces;
    const namespaces = (_i18n_reportNamespaces_getUsedNamespaces = (_i18n_reportNamespaces = i18n.reportNamespaces) === null || _i18n_reportNamespaces === void 0 ? void 0 : _i18n_reportNamespaces.getUsedNamespaces()) !== null && _i18n_reportNamespaces_getUsedNamespaces !== void 0 ? _i18n_reportNamespaces_getUsedNamespaces : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
};


function $f2206e97e7d445a8$export$8d6a9236f2e3f2ce(_param) {
    var { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape } = _param, additionalProps = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
        "children",
        "count",
        "parent",
        "i18nKey",
        "context",
        "tOptions",
        "values",
        "defaults",
        "components",
        "ns",
        "i18n",
        "t",
        "shouldUnescape"
    ]);
    var _i18n_options;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $46wWE.useContext)((0, $e3f0cf3618fc3835$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $5305cfda55d75976$export$64af334f494c2f47)();
    const t = tFromProps || (i18n === null || i18n === void 0 ? void 0 : i18n.t.bind(i18n));
    return (0, $ba5827dc75f195ba$export$8d6a9236f2e3f2ce)((0, $307af824b9387905$export$71511d61b312f219)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || (t === null || t === void 0 ? void 0 : t.ns) || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS),
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}




var $46wWE = parcelRequire("46wWE");



var $46wWE = parcelRequire("46wWE");


class $13c9c1137d48c378$export$aa9e222d9ffc5d1b extends Error {
    constructor(message, position, translationString){
        super(message);
        this.name = 'TranslationParserError';
        this.position = position;
        this.translationString = translationString;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $13c9c1137d48c378$export$aa9e222d9ffc5d1b);
    }
}


const $0220ae9471455369$var$commonEntities = {
    '&nbsp;': '\u00A0',
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
    '&copy;': "\xa9",
    '&reg;': "\xae",
    '&trade;': "\u2122",
    '&hellip;': "\u2026",
    '&ndash;': "\u2013",
    '&mdash;': "\u2014",
    '&lsquo;': '\u2018',
    '&rsquo;': '\u2019',
    '&sbquo;': '\u201A',
    '&ldquo;': '\u201C',
    '&rdquo;': '\u201D',
    '&bdquo;': '\u201E',
    '&dagger;': "\u2020",
    '&Dagger;': "\u2021",
    '&bull;': "\u2022",
    '&prime;': "\u2032",
    '&Prime;': "\u2033",
    '&lsaquo;': "\u2039",
    '&rsaquo;': "\u203A",
    '&sect;': "\xa7",
    '&para;': "\xb6",
    '&middot;': "\xb7",
    '&ensp;': '\u2002',
    '&emsp;': '\u2003',
    '&thinsp;': '\u2009',
    '&euro;': "\u20AC",
    '&pound;': "\xa3",
    '&yen;': "\xa5",
    '&cent;': "\xa2",
    '&curren;': "\xa4",
    '&times;': "\xd7",
    '&divide;': "\xf7",
    '&minus;': "\u2212",
    '&plusmn;': "\xb1",
    '&ne;': "\u2260",
    '&le;': "\u2264",
    '&ge;': "\u2265",
    '&asymp;': "\u2248",
    '&equiv;': "\u2261",
    '&infin;': "\u221E",
    '&int;': "\u222B",
    '&sum;': "\u2211",
    '&prod;': "\u220F",
    '&radic;': "\u221A",
    '&part;': "\u2202",
    '&permil;': "\u2030",
    '&deg;': "\xb0",
    '&micro;': "\xb5",
    '&larr;': "\u2190",
    '&uarr;': "\u2191",
    '&rarr;': "\u2192",
    '&darr;': "\u2193",
    '&harr;': "\u2194",
    '&crarr;': "\u21B5",
    '&lArr;': "\u21D0",
    '&uArr;': "\u21D1",
    '&rArr;': "\u21D2",
    '&dArr;': "\u21D3",
    '&hArr;': "\u21D4",
    '&alpha;': "\u03B1",
    '&beta;': "\u03B2",
    '&gamma;': "\u03B3",
    '&delta;': "\u03B4",
    '&epsilon;': "\u03B5",
    '&zeta;': "\u03B6",
    '&eta;': "\u03B7",
    '&theta;': "\u03B8",
    '&iota;': "\u03B9",
    '&kappa;': "\u03BA",
    '&lambda;': "\u03BB",
    '&mu;': "\u03BC",
    '&nu;': "\u03BD",
    '&xi;': "\u03BE",
    '&omicron;': "\u03BF",
    '&pi;': "\u03C0",
    '&rho;': "\u03C1",
    '&sigma;': "\u03C3",
    '&tau;': "\u03C4",
    '&upsilon;': "\u03C5",
    '&phi;': "\u03C6",
    '&chi;': "\u03C7",
    '&psi;': "\u03C8",
    '&omega;': "\u03C9",
    '&Alpha;': "\u0391",
    '&Beta;': "\u0392",
    '&Gamma;': "\u0393",
    '&Delta;': "\u0394",
    '&Epsilon;': "\u0395",
    '&Zeta;': "\u0396",
    '&Eta;': "\u0397",
    '&Theta;': "\u0398",
    '&Iota;': "\u0399",
    '&Kappa;': "\u039A",
    '&Lambda;': "\u039B",
    '&Mu;': "\u039C",
    '&Nu;': "\u039D",
    '&Xi;': "\u039E",
    '&Omicron;': "\u039F",
    '&Pi;': "\u03A0",
    '&Rho;': "\u03A1",
    '&Sigma;': "\u03A3",
    '&Tau;': "\u03A4",
    '&Upsilon;': "\u03A5",
    '&Phi;': "\u03A6",
    '&Chi;': "\u03A7",
    '&Psi;': "\u03A8",
    '&Omega;': "\u03A9",
    '&Agrave;': "\xc0",
    '&Aacute;': "\xc1",
    '&Acirc;': "\xc2",
    '&Atilde;': "\xc3",
    '&Auml;': "\xc4",
    '&Aring;': "\xc5",
    '&AElig;': "\xc6",
    '&Ccedil;': "\xc7",
    '&Egrave;': "\xc8",
    '&Eacute;': "\xc9",
    '&Ecirc;': "\xca",
    '&Euml;': "\xcb",
    '&Igrave;': "\xcc",
    '&Iacute;': "\xcd",
    '&Icirc;': "\xce",
    '&Iuml;': "\xcf",
    '&ETH;': "\xd0",
    '&Ntilde;': "\xd1",
    '&Ograve;': "\xd2",
    '&Oacute;': "\xd3",
    '&Ocirc;': "\xd4",
    '&Otilde;': "\xd5",
    '&Ouml;': "\xd6",
    '&Oslash;': "\xd8",
    '&Ugrave;': "\xd9",
    '&Uacute;': "\xda",
    '&Ucirc;': "\xdb",
    '&Uuml;': "\xdc",
    '&Yacute;': "\xdd",
    '&THORN;': "\xde",
    '&szlig;': "\xdf",
    '&agrave;': "\xe0",
    '&aacute;': "\xe1",
    '&acirc;': "\xe2",
    '&atilde;': "\xe3",
    '&auml;': "\xe4",
    '&aring;': "\xe5",
    '&aelig;': "\xe6",
    '&ccedil;': "\xe7",
    '&egrave;': "\xe8",
    '&eacute;': "\xe9",
    '&ecirc;': "\xea",
    '&euml;': "\xeb",
    '&igrave;': "\xec",
    '&iacute;': "\xed",
    '&icirc;': "\xee",
    '&iuml;': "\xef",
    '&eth;': "\xf0",
    '&ntilde;': "\xf1",
    '&ograve;': "\xf2",
    '&oacute;': "\xf3",
    '&ocirc;': "\xf4",
    '&otilde;': "\xf5",
    '&ouml;': "\xf6",
    '&oslash;': "\xf8",
    '&ugrave;': "\xf9",
    '&uacute;': "\xfa",
    '&ucirc;': "\xfb",
    '&uuml;': "\xfc",
    '&yacute;': "\xfd",
    '&thorn;': "\xfe",
    '&yuml;': "\xff",
    '&iexcl;': "\xa1",
    '&iquest;': "\xbf",
    '&fnof;': "\u0192",
    '&circ;': "\u02C6",
    '&tilde;': "\u02DC",
    '&OElig;': "\u0152",
    '&oelig;': "\u0153",
    '&Scaron;': "\u0160",
    '&scaron;': "\u0161",
    '&Yuml;': "\u0178",
    '&ordf;': "\xaa",
    '&ordm;': "\xba",
    '&macr;': "\xaf",
    '&acute;': "\xb4",
    '&cedil;': "\xb8",
    '&sup1;': "\xb9",
    '&sup2;': "\xb2",
    '&sup3;': "\xb3",
    '&frac14;': "\xbc",
    '&frac12;': "\xbd",
    '&frac34;': "\xbe",
    '&spades;': "\u2660",
    '&clubs;': "\u2663",
    '&hearts;': "\u2665",
    '&diams;': "\u2666",
    '&loz;': "\u25CA",
    '&oline;': "\u203E",
    '&frasl;': "\u2044",
    '&weierp;': "\u2118",
    '&image;': "\u2111",
    '&real;': "\u211C",
    '&alefsym;': "\u2135"
};
const $0220ae9471455369$var$entityPattern = new RegExp(Object.keys($0220ae9471455369$var$commonEntities).map((entity)=>entity.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
const $0220ae9471455369$export$5cfeaa4af6841c8f = (text)=>text.replace($0220ae9471455369$var$entityPattern, (match)=>$0220ae9471455369$var$commonEntities[match]).replace(/&#(\d+);/g, (_, num)=>String.fromCharCode(parseInt(num, 10))).replace(/&#x([0-9a-fA-F]+);/g, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));


const $4a72e87e214f3233$export$660b2ee2d4fb4eff = (translation)=>{
    const tokens = [];
    let position = 0;
    let currentText = '';
    const flushText = ()=>{
        if (currentText) {
            tokens.push({
                type: 'Text',
                value: currentText,
                position: position - currentText.length
            });
            currentText = '';
        }
    };
    while(position < translation.length){
        const char = translation[position];
        if (char === '<') {
            const tagMatch = translation.slice(position).match(/^<(\d+)>/);
            if (tagMatch) {
                flushText();
                tokens.push({
                    type: 'TagOpen',
                    value: tagMatch[0],
                    position: position,
                    tagNumber: parseInt(tagMatch[1], 10)
                });
                position += tagMatch[0].length;
            } else {
                const closeTagMatch = translation.slice(position).match(/^<\/(\d+)>/);
                if (closeTagMatch) {
                    flushText();
                    tokens.push({
                        type: 'TagClose',
                        value: closeTagMatch[0],
                        position: position,
                        tagNumber: parseInt(closeTagMatch[1], 10)
                    });
                    position += closeTagMatch[0].length;
                } else {
                    currentText += char;
                    position += 1;
                }
            }
        } else {
            currentText += char;
            position += 1;
        }
    }
    flushText();
    return tokens;
};




var $46wWE = parcelRequire("46wWE");



const $ca3d0fc08aa93f66$var$renderDeclarationNode = (declaration, children, childDeclarations)=>{
    const { type: type, props: props = {} } = declaration;
    if (props.children && Array.isArray(props.children) && childDeclarations) {
        const { children: _childrenToRemove } = props, propsWithoutChildren = (0, $d9d4991687d1f007$export$71511d61b312f219)(props, [
            "children"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement(type, propsWithoutChildren, ...children);
    }
    if (children.length === 0) return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement(type, props);
    if (children.length === 1) return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement(type, props, children[0]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement(type, props, ...children);
};
const $ca3d0fc08aa93f66$export$1038df9fa5e5f35f = (translation, declarations = [])=>{
    if (!translation) return [];
    const tokens = (0, $4a72e87e214f3233$export$660b2ee2d4fb4eff)(translation);
    const result = [];
    const stack = [];
    const literalTagNumbers = new Set();
    const getCurrentDeclarations = ()=>{
        var _parentFrame_declaration_props;
        if (stack.length === 0) return declarations;
        const parentFrame = stack[stack.length - 1];
        if (((_parentFrame_declaration_props = parentFrame.declaration.props) === null || _parentFrame_declaration_props === void 0 ? void 0 : _parentFrame_declaration_props.children) && Array.isArray(parentFrame.declaration.props.children)) return parentFrame.declaration.props.children;
        return parentFrame.declarations;
    };
    tokens.forEach((token)=>{
        switch(token.type){
            case 'Text':
                {
                    const decoded = (0, $0220ae9471455369$export$5cfeaa4af6841c8f)(token.value);
                    const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    targetArray.push(decoded);
                }
                break;
            case 'TagOpen':
                {
                    const { tagNumber: tagNumber } = token;
                    const currentDeclarations = getCurrentDeclarations();
                    const declaration = currentDeclarations[tagNumber];
                    if (!declaration) {
                        literalTagNumbers.add(tagNumber);
                        const literalText = `<${tagNumber}>`;
                        const targetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        targetArray.push(literalText);
                        break;
                    }
                    stack.push({
                        tagNumber: tagNumber,
                        children: [],
                        position: token.position,
                        declaration: declaration,
                        declarations: currentDeclarations
                    });
                }
                break;
            case 'TagClose':
                {
                    const { tagNumber: tagNumber } = token;
                    if (literalTagNumbers.has(tagNumber)) {
                        const literalText = `</${tagNumber}>`;
                        const literalTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                        literalTargetArray.push(literalText);
                        literalTagNumbers.delete(tagNumber);
                        break;
                    }
                    if (stack.length === 0) throw new (0, $13c9c1137d48c378$export$aa9e222d9ffc5d1b)(`Unexpected closing tag </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const frame = stack.pop();
                    if (frame.tagNumber !== tagNumber) throw new (0, $13c9c1137d48c378$export$aa9e222d9ffc5d1b)(`Mismatched tags: expected </${frame.tagNumber}> but got </${tagNumber}> at position ${token.position}`, token.position, translation);
                    const element = $ca3d0fc08aa93f66$var$renderDeclarationNode(frame.declaration, frame.children, frame.declarations);
                    const elementTargetArray = stack.length > 0 ? stack[stack.length - 1].children : result;
                    elementTargetArray.push(element);
                }
                break;
        }
    });
    if (stack.length > 0) {
        const unclosed = stack[stack.length - 1];
        throw new (0, $13c9c1137d48c378$export$aa9e222d9ffc5d1b)(`Unclosed tag <${unclosed.tagNumber}> at position ${unclosed.position}`, unclosed.position, translation);
    }
    return result;
};




function $2f4be9c56a246e73$export$c70a6545d92ee1d4({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    var _i18n_t, _i18n_options, _i18n_options_interpolation, _i18n_options1;
    const i18n = i18nFromProps || (0, $5305cfda55d75976$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $931ea6f6949516fe$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', `IcuTrans: You need to pass in an i18next instance using i18nextReactModule`, {
            i18nKey: i18nKey
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).Fragment, {}, defaultTranslation);
    }
    const t = tFromProps || ((_i18n_t = i18n.t) === null || _i18n_t === void 0 ? void 0 : _i18n_t.bind(i18n)) || ((k)=>k);
    let namespaces = ns || t.ns || ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS);
    namespaces = (0, $931ea6f6949516fe$export$844ec244b1367d54)(namespaces) ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    let mergedValues = values;
    if ((_i18n_options1 = i18n.options) === null || _i18n_options1 === void 0 ? void 0 : (_i18n_options_interpolation = _i18n_options1.interpolation) === null || _i18n_options_interpolation === void 0 ? void 0 : _i18n_options_interpolation.defaultVariables) mergedValues = values && Object.keys(values).length > 0 ? (0, $307af824b9387905$export$71511d61b312f219)({}, values, i18n.options.interpolation.defaultVariables) : (0, $307af824b9387905$export$71511d61b312f219)({}, i18n.options.interpolation.defaultVariables);
    const translation = t(i18nKey, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({
        defaultValue: defaultTranslation
    }, mergedValues), {
        ns: namespaces
    }));
    try {
        const rendered = (0, $ca3d0fc08aa93f66$export$1038df9fa5e5f35f)(translation, content);
        return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).Fragment, {}, ...rendered);
    } catch (error) {
        (0, $931ea6f6949516fe$export$c106dd0671a0fc2d)(i18n, 'ICU_TRANS_RENDER_ERROR', `IcuTrans component error for key "${i18nKey}": ${error.message}`, {
            i18nKey: i18nKey,
            error: error
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).Fragment, {}, translation);
    }
}
$2f4be9c56a246e73$export$c70a6545d92ee1d4.displayName = 'IcuTransWithoutContext';



function $3681b3367caa478c$export$c8b7e2ca8249a4be({ i18nKey: i18nKey, defaultTranslation: defaultTranslation, content: content, ns: ns, values: values = {}, i18n: i18nFromProps, t: tFromProps }) {
    var _i18n_options;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $46wWE.useContext)((0, $e3f0cf3618fc3835$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $5305cfda55d75976$export$64af334f494c2f47)();
    const t = tFromProps || (i18n === null || i18n === void 0 ? void 0 : i18n.t.bind(i18n));
    return (0, $2f4be9c56a246e73$export$c70a6545d92ee1d4)({
        i18nKey: i18nKey,
        defaultTranslation: defaultTranslation,
        content: content,
        ns: ns || (t === null || t === void 0 ? void 0 : t.ns) || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS),
        values: values,
        i18n: i18n,
        t: tFromProps
    });
}
$3681b3367caa478c$export$c8b7e2ca8249a4be.displayName = 'IcuTrans';





var $46wWE = parcelRequire("46wWE");
var $872d439805ba53ee$exports = {};
'use strict';

$872d439805ba53ee$exports = (parcelRequire("8nNUC"));




const $0e22ef777d2e9544$var$notReadyT = (k, optsOrDefaultValue)=>{
    if ((0, $931ea6f6949516fe$export$844ec244b1367d54)(optsOrDefaultValue)) return optsOrDefaultValue;
    if ((0, $931ea6f6949516fe$export$a6cdc56e425d0d0a)(optsOrDefaultValue) && (0, $931ea6f6949516fe$export$844ec244b1367d54)(optsOrDefaultValue.defaultValue)) return optsOrDefaultValue.defaultValue;
    return Array.isArray(k) ? k[k.length - 1] : k;
};
const $0e22ef777d2e9544$var$notReadySnapshot = {
    t: $0e22ef777d2e9544$var$notReadyT,
    ready: false
};
const $0e22ef777d2e9544$var$dummySubscribe = ()=>()=>{};
const $0e22ef777d2e9544$export$9fc83ad70ead8663 = (ns, props = {})=>{
    var _i18n_options, _i18n_reportNamespaces_addUsedNamespaces, _i18n_reportNamespaces;
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $46wWE.useContext)((0, $e3f0cf3618fc3835$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $5305cfda55d75976$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $e3f0cf3618fc3835$export$ea171b67e3820290)();
    if (!i18n) (0, $931ea6f6949516fe$export$5b28268982f175ba)(i18n, 'NO_I18NEXT_INSTANCE', 'useTranslation: You will need to pass in an i18next instance by using initReactI18next');
    const i18nOptions = (0, $46wWE.useMemo)(()=>{
        var _i18n_options;
        return (0, $307af824b9387905$export$71511d61b312f219)({}, (0, $1189582b795e34b5$export$212bb2fc580a90a8)(), i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.react, props);
    }, [
        i18n,
        props
    ]);
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    const nsOrContext = ns || defaultNSFromContext || (i18n === null || i18n === void 0 ? void 0 : (_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.defaultNS);
    const unstableNamespaces = (0, $931ea6f6949516fe$export$844ec244b1367d54)(nsOrContext) ? [
        nsOrContext
    ] : nsOrContext || [
        'translation'
    ];
    const namespaces = (0, $46wWE.useMemo)(()=>unstableNamespaces, unstableNamespaces);
    i18n === null || i18n === void 0 ? void 0 : (_i18n_reportNamespaces = i18n.reportNamespaces) === null || _i18n_reportNamespaces === void 0 ? void 0 : (_i18n_reportNamespaces_addUsedNamespaces = _i18n_reportNamespaces.addUsedNamespaces) === null || _i18n_reportNamespaces_addUsedNamespaces === void 0 ? void 0 : _i18n_reportNamespaces_addUsedNamespaces.call(_i18n_reportNamespaces, namespaces);
    const revisionRef = (0, $46wWE.useRef)(0);
    const subscribe = (0, $46wWE.useCallback)((callback)=>{
        if (!i18n) return $0e22ef777d2e9544$var$dummySubscribe;
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        const wrappedCallback = ()=>{
            revisionRef.current += 1;
            callback();
        };
        if (bindI18n) i18n.on(bindI18n, wrappedCallback);
        if (bindI18nStore) i18n.store.on(bindI18nStore, wrappedCallback);
        return ()=>{
            if (bindI18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, wrappedCallback));
            if (bindI18nStore) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, wrappedCallback));
        };
    }, [
        i18n,
        i18nOptions
    ]);
    const snapshotRef = (0, $46wWE.useRef)();
    const getSnapshot = (0, $46wWE.useCallback)(()=>{
        if (!i18n) return $0e22ef777d2e9544$var$notReadySnapshot;
        const calculatedReady = !!(i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $931ea6f6949516fe$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
        const currentLng = props.lng || i18n.language;
        const currentRevision = revisionRef.current;
        const lastSnapshot = snapshotRef.current;
        if (lastSnapshot && lastSnapshot.ready === calculatedReady && lastSnapshot.lng === currentLng && lastSnapshot.keyPrefix === keyPrefix && lastSnapshot.revision === currentRevision) return lastSnapshot;
        const calculatedT = i18n.getFixedT(currentLng, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
        const newSnapshot = {
            t: calculatedT,
            ready: calculatedReady,
            lng: currentLng,
            keyPrefix: keyPrefix,
            revision: currentRevision
        };
        snapshotRef.current = newSnapshot;
        return newSnapshot;
    }, [
        i18n,
        namespaces,
        keyPrefix,
        i18nOptions,
        props.lng
    ]);
    const [loadCount, setLoadCount] = (0, $46wWE.useState)(0);
    const { t: t, ready: ready } = (0, $872d439805ba53ee$exports.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0, $46wWE.useEffect)(()=>{
        if (i18n && !ready && !useSuspense) {
            const onLoaded = ()=>setLoadCount((c)=>c + 1);
            if (props.lng) (0, $931ea6f6949516fe$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
            else (0, $931ea6f6949516fe$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
        }
    }, [
        i18n,
        props.lng,
        namespaces,
        ready,
        useSuspense,
        loadCount
    ]);
    const finalI18n = i18n || {};
    const wrapperRef = (0, $46wWE.useRef)(null);
    const wrapperLangRef = (0, $46wWE.useRef)();
    const createI18nWrapper = (original)=>{
        const descriptors = Object.getOwnPropertyDescriptors(original);
        if (descriptors.__original) delete descriptors.__original;
        const wrapper = Object.create(Object.getPrototypeOf(original), descriptors);
        if (!Object.prototype.hasOwnProperty.call(wrapper, '__original')) try {
            Object.defineProperty(wrapper, '__original', {
                value: original,
                writable: false,
                enumerable: false,
                configurable: false
            });
        } catch (_) {}
        return wrapper;
    };
    const ret = (0, $46wWE.useMemo)(()=>{
        const original = finalI18n;
        const lang = original === null || original === void 0 ? void 0 : original.language;
        let i18nWrapper = original;
        if (original) {
            if (wrapperRef.current && wrapperRef.current.__original === original) {
                if (wrapperLangRef.current !== lang) {
                    i18nWrapper = createI18nWrapper(original);
                    wrapperRef.current = i18nWrapper;
                    wrapperLangRef.current = lang;
                } else i18nWrapper = wrapperRef.current;
            } else {
                i18nWrapper = createI18nWrapper(original);
                wrapperRef.current = i18nWrapper;
                wrapperLangRef.current = lang;
            }
        }
        const arr = [
            t,
            i18nWrapper,
            ready
        ];
        arr.t = t;
        arr.i18n = i18nWrapper;
        arr.ready = ready;
        return arr;
    }, [
        t,
        finalI18n,
        ready,
        finalI18n.resolvedLanguage,
        finalI18n.language,
        finalI18n.languages
    ]);
    if (i18n && useSuspense && !ready) throw new Promise((resolve)=>{
        const onLoaded = ()=>resolve();
        if (props.lng) (0, $931ea6f6949516fe$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, onLoaded);
        else (0, $931ea6f6949516fe$export$83be934b53fff43b)(i18n, namespaces, onLoaded);
    });
    return ret;
};






var $46wWE = parcelRequire("46wWE");


const $c5affcd6a436dfba$export$2dcb0053efd21124 = (ns, options = {})=>function Extend(WrappedComponent) {
        function I18nextWithTranslation(_param) {
            var { forwardedRef: forwardedRef } = _param, rest = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
                "forwardedRef"
            ]);
            const [t, i18n, ready] = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)(ns, (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, rest), {
                keyPrefix: options.keyPrefix
            }));
            const passDownProps = (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, rest), {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $46wWE.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $931ea6f6949516fe$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $46wWE.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $46wWE.forwardRef)(forwardRef) : I18nextWithTranslation;
    };




const $f2f646da7e636459$export$b63289fbda65eed1 = (_param)=>{
    var { ns: ns, children: children } = _param, options = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
        "ns",
        "children"
    ]);
    const [t, i18n, ready] = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
};



var $46wWE = parcelRequire("46wWE");

function $667f7a49f6320c71$export$1325e8699caa160f({ i18n: i18n, defaultNS: defaultNS, children: children }) {
    const value = (0, $46wWE.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $46wWE.createElement)((0, $e3f0cf3618fc3835$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $46wWE = parcelRequire("46wWE");

var $46wWE = parcelRequire("46wWE");

const $5c207ccbf879cfff$export$3526fb65ade8d8b7 = (initialI18nStore, initialLanguage, props = {})=>{
    var _i18n_options;
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $46wWE.useContext)((0, $e3f0cf3618fc3835$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $5305cfda55d75976$export$64af334f494c2f47)();
    if ((_i18n_options = i18n.options) === null || _i18n_options === void 0 ? void 0 : _i18n_options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
};




const $2eae79b32f292ffc$export$80dfa519af1c8605 = ()=>function Extend(WrappedComponent) {
        function I18nextWithSSR(_param) {
            var { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage } = _param, rest = (0, $d9d4991687d1f007$export$71511d61b312f219)(_param, [
                "initialI18nStore",
                "initialLanguage"
            ]);
            (0, $5c207ccbf879cfff$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $46wWE.createElement)(WrappedComponent, (0, $307af824b9387905$export$71511d61b312f219)({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $e3f0cf3618fc3835$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $931ea6f6949516fe$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };







const $314120a67d0b377e$export$324d90190a8b822a = ()=>'';
const $314120a67d0b377e$export$2da9be4cfdb689b1 = ()=>'';
const $314120a67d0b377e$export$98e628dec113755e = ()=>'';
const $314120a67d0b377e$export$2e6c959c16ff56b8 = ()=>'';
const $314120a67d0b377e$export$4e35d5c922a95490 = ()=>'';
const $314120a67d0b377e$export$720a3b9db04b7a0f = ()=>'';


function $d1a3372e6796a71d$export$eff53e581ec9b13a(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $44d65d2a768a7a29$export$353f5b6fc5456de1), {
        label: t(props.i18n),
        mode: props.mode,
        className: props.className,
        onClick: props.onClick,
        disabled: props.disabled,
        border: props.border,
        id: props.id,
        type: props.type,
        hoverText: props.hoverText,
        icon: props.icon
    });
}








function $3a4f7e3d1369ff17$export$edde36960b8a13dc({ id: id, color: color, values: values, className: className, styles: styles, title: title, i18n: i18n, options: options, components: components, children: children }) {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("p", {
        "aria-label": id,
        id: id,
        className: [
            color,
            className
        ].join(" "),
        style: styles,
        title: title,
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $f2206e97e7d445a8$export$8d6a9236f2e3f2ce), {
            i18nKey: i18n,
            values: values,
            tOptions: (0, $307af824b9387905$export$71511d61b312f219)({}, options),
            components: components,
            children: children
        })
    });
}








function $c04612c89ad095ee$export$8310c02dbd1dcd43({ id: id, className: className, i18n: i18n, options: options, type: type, style: style }) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $428c6867a99ff0e4$export$a8a3e93435678ff9), {
        id: id,
        className: className,
        text: t(i18n, (0, $307af824b9387905$export$71511d61b312f219)({}, options)),
        type: type,
        style: style
    });
}




var $0205ff3323223c25$exports = {};
$0205ff3323223c25$exports = $parcel$resolve("Ry0pz");


function $5b05d51dad27ac0d$export$db881fc880a1af58() {
    const [returnUrl, setReturnUrl] = (0, $46wWE.useState)("");
    const [fullName, setFullName] = (0, $46wWE.useState)("");
    const [claims, setClaims] = (0, $46wWE.useState)([]);
    const [tableVisible, setTableVisible] = (0, $46wWE.useState)(false);
    async function fetchUserInfo() {
        const { status: status, payload: payload } = await (0, $b56f79e0ce8b4d47$export$a8ffdece931ecc8)((0, $dc040427e725bec3$export$1dfb6c981e2aebb));
        if (status === 401) window.location.assign((0, $dc040427e725bec3$export$d832b8b45145d2fd));
        if (status === 200 && payload) {
            var _payload_returnUrl;
            setReturnUrl((_payload_returnUrl = payload.returnUrl) !== null && _payload_returnUrl !== void 0 ? _payload_returnUrl : "");
            var _payload_fullName;
            setFullName((_payload_fullName = payload.fullName) !== null && _payload_fullName !== void 0 ? _payload_fullName : "");
            var _payload_claims;
            // the values of the claims object are typically strings but can also be arrays, so we convert them to strings
            setClaims(Object.entries((_payload_claims = payload.claims) !== null && _payload_claims !== void 0 ? _payload_claims : {}).map(([k, v])=>[
                    k,
                    String(v)
                ]));
        }
    }
    (0, $46wWE.useEffect)(()=>{
        fetchUserInfo();
    }, []);
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "header-svg",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                    className: "center-svg",
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $6d8ff2be542c30cc$export$6c09fee102878c7), {
                        className: "Merck-Regular",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0205ff3323223c25$exports))).toString()
                    })
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $c04612c89ad095ee$export$8310c02dbd1dcd43), {
                i18n: "fidodemo.success-greeting",
                options: {
                    fullName: fullName
                },
                type: "h3"
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                id: "fidodemo-succes-message",
                i18n: "fidodemo.success-message"
            }),
            returnUrl && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("a", {
                href: returnUrl,
                className: "back-button",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $d1a3372e6796a71d$export$eff53e581ec9b13a), {
                    i18n: "fidodemo.back-button",
                    mode: "yellow"
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "details-table-collapsible",
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $d22b18efd12698a3$export$c25acd513dcc8062), {
                        buttonId: "fido-details-table-collapsible",
                        icon: "arrow",
                        label: (0, $6aaf2cb5d81db2fa$export$625550452a3fa3ec)("fidodemo.success-details"),
                        onClick: ()=>setTableVisible(!tableVisible)
                    }),
                    tableVisible && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("hr", {
                                className: "hr-dark"
                            }),
                            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $7cd51dcd135c471b$export$54ec01a60f47d33d), {
                                rows: claims,
                                numberOfCols: 2,
                                firstRowAsHeader: false,
                                className: "details-table"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}






var $a29fd55c0701b91d$exports = {};
$a29fd55c0701b91d$exports = $parcel$resolve("l9tJ7");


var $5a9dad2eead421f2$exports = {};
$5a9dad2eead421f2$exports = $parcel$resolve("387UB");


var $cf327e182d542a3c$exports = {};
$cf327e182d542a3c$exports = $parcel$resolve("28dEk");


var $8e856ced514e9749$exports = {};
$8e856ced514e9749$exports = $parcel$resolve("3BoJ7");


var $e0402c80051bfa0e$exports = {};
$e0402c80051bfa0e$exports = $parcel$resolve("35MLC");


var $59142d729110ac2e$exports = {};
$59142d729110ac2e$exports = $parcel$resolve("i1UsS");


var $2e8fc887b69b62e1$exports = {};
$2e8fc887b69b62e1$exports = $parcel$resolve("e7ACG");


var $7b6e6f5adb614555$exports = {};
$7b6e6f5adb614555$exports = $parcel$resolve("8EHLx");


var $ae0c8af364914b1e$exports = {};
$ae0c8af364914b1e$exports = $parcel$resolve("ku8O5");


var $32e806241f2a18f5$exports = {};
$32e806241f2a18f5$exports = $parcel$resolve("bayQ3");


var $8fdc46e08c1b73c0$exports = {};
$8fdc46e08c1b73c0$exports = $parcel$resolve("7DB0o");


var $0c714ce0d314e7a9$exports = {};
$0c714ce0d314e7a9$exports = $parcel$resolve("8ZgKO");


var $1d344ab4fef82d2e$exports = {};
$1d344ab4fef82d2e$exports = $parcel$resolve("95lB7");


var $a77de29ccd763c4f$exports = {};
$a77de29ccd763c4f$exports = $parcel$resolve("9dFw2");


var $03d0c8be92dd38a0$exports = {};
$03d0c8be92dd38a0$exports = $parcel$resolve("4C8to");


var $d51bb8176522ee35$exports = {};
$d51bb8176522ee35$exports = $parcel$resolve("bPWBC");


var $3159a25dbf774227$exports = {};
$3159a25dbf774227$exports = $parcel$resolve("8zXb5");


var $aaa585849837e88a$exports = {};
$aaa585849837e88a$exports = $parcel$resolve("9xypP");


var $c67474dca8b02f71$exports = {};
$c67474dca8b02f71$exports = $parcel$resolve("jGKIN");


var $c7cdbae387c36f22$exports = {};
$c7cdbae387c36f22$exports = $parcel$resolve("b14Ku");


var $0b45aa436dfc9d44$exports = {};
$0b45aa436dfc9d44$exports = $parcel$resolve("j9Sd7");


var $4abff82269beb2d2$exports = {};
$4abff82269beb2d2$exports = $parcel$resolve("j5dXk");


var $727337ee6dac6402$exports = {};
$727337ee6dac6402$exports = $parcel$resolve("5Gzwd");


var $e7728e0a20d0c1cc$exports = {};
$e7728e0a20d0c1cc$exports = $parcel$resolve("ajLlI");


var $5b5278f892501064$exports = {};
$5b5278f892501064$exports = $parcel$resolve("jdx40");


var $10dff005c5531a60$exports = {};
$10dff005c5531a60$exports = $parcel$resolve("bVysc");


var $72feb6b7651021d4$exports = {};
$72feb6b7651021d4$exports = $parcel$resolve("djEhh");


var $32c6fac65df2771e$exports = {};
$32c6fac65df2771e$exports = $parcel$resolve("aoS90");


var $735e3e057fc02eb0$exports = {};
$735e3e057fc02eb0$exports = $parcel$resolve("8E9k8");


var $acc81c7e46eb6f12$exports = {};
$acc81c7e46eb6f12$exports = $parcel$resolve("e862t");


var $28c0550f825e6ff4$exports = {};
$28c0550f825e6ff4$exports = $parcel$resolve("e6hTU");


var $90dfe0602b54b71b$exports = {};
$90dfe0602b54b71b$exports = $parcel$resolve("6qDg0");


var $3dc037c42c6f7121$exports = {};
$3dc037c42c6f7121$exports = $parcel$resolve("g6zCj");


var $5fe57e489c50bc2a$exports = {};
$5fe57e489c50bc2a$exports = $parcel$resolve("4qC36");


var $c3604bf273e60ce1$exports = {};
$c3604bf273e60ce1$exports = $parcel$resolve("1diU2");


var $3129e852eb2e1400$exports = {};
$3129e852eb2e1400$exports = $parcel$resolve("h9gxV");


var $c36f348ee3bef44d$exports = {};
$c36f348ee3bef44d$exports = $parcel$resolve("iwDis");


var $6d33ea96de8826e4$exports = {};
$6d33ea96de8826e4$exports = $parcel$resolve("5dCoN");


var $3922c35a2368658f$exports = {};
$3922c35a2368658f$exports = $parcel$resolve("W3KSq");


var $5bd2479e8094d981$exports = {};
$5bd2479e8094d981$exports = $parcel$resolve("6C6PU");


var $1834688e497120e8$exports = {};
$1834688e497120e8$exports = $parcel$resolve("kIylU");


var $415dba170b2da42f$exports = {};
$415dba170b2da42f$exports = $parcel$resolve("6vm3r");


var $014a988abce36b22$exports = {};
$014a988abce36b22$exports = $parcel$resolve("4ANee");


var $d22c396e3aa3f2e4$exports = {};
$d22c396e3aa3f2e4$exports = $parcel$resolve("dNrbM");


var $a89adad7ea295ba2$exports = {};
$a89adad7ea295ba2$exports = $parcel$resolve("dgRDk");


var $004a3cb490e759bd$exports = {};
$004a3cb490e759bd$exports = $parcel$resolve("X4CUq");


var $8ba3e3a6d9ce78a0$exports = {};
$8ba3e3a6d9ce78a0$exports = $parcel$resolve("5WPBO");


var $1152c5be275f319f$exports = {};
$1152c5be275f319f$exports = $parcel$resolve("34b6e");


var $56f808ce93d940c8$exports = {};
$56f808ce93d940c8$exports = $parcel$resolve("dAW5h");


var $3706187b2f2106b4$exports = {};
$3706187b2f2106b4$exports = $parcel$resolve("idkqo");


var $08dc1803b3727f4a$exports = {};
$08dc1803b3727f4a$exports = $parcel$resolve("4zErv");


var $bcf7f63deabec1c3$exports = {};
$bcf7f63deabec1c3$exports = $parcel$resolve("d3GCi");


var $7372e02e2fde9e0d$exports = {};
$7372e02e2fde9e0d$exports = $parcel$resolve("6vpfg");


var $90669e5f45420669$exports = {};
$90669e5f45420669$exports = $parcel$resolve("3BSGj");


var $1a99bd98bfabadab$exports = {};
$1a99bd98bfabadab$exports = $parcel$resolve("2fgBa");


var $5740d77e1fe139ee$exports = {};
$5740d77e1fe139ee$exports = $parcel$resolve("gxHZS");


var $624a05c172eb2938$exports = {};
$624a05c172eb2938$exports = $parcel$resolve("5Mbd6");


var $236cf27418a2f2e8$exports = {};
$236cf27418a2f2e8$exports = $parcel$resolve("isows");


var $d9694e9cfb540574$exports = {};
$d9694e9cfb540574$exports = $parcel$resolve("cdZpZ");


var $56dc35498b4004f8$exports = {};
$56dc35498b4004f8$exports = $parcel$resolve("cS9xu");


var $26c5514026b3367d$exports = {};
$26c5514026b3367d$exports = $parcel$resolve("4T45f");


var $196a77ed7ad003d6$exports = {};
$196a77ed7ad003d6$exports = $parcel$resolve("3xQ6T");


var $c5ea7944d8564ad8$exports = {};
$c5ea7944d8564ad8$exports = $parcel$resolve("hAvtE");


var $cafc515b8afdda76$exports = {};
$cafc515b8afdda76$exports = $parcel$resolve("5XkEO");


var $2f2cd55bd5e17863$exports = {};
$2f2cd55bd5e17863$exports = $parcel$resolve("i6dKc");


var $d149b5b8a12e0935$exports = {};
$d149b5b8a12e0935$exports = $parcel$resolve("bPFzA");













var $1a70a7f9149b2753$exports = {};
$1a70a7f9149b2753$exports = $parcel$resolve("1SGsS");


var $9bf6ee6292457400$exports = {};
$9bf6ee6292457400$exports = $parcel$resolve("UHmAL");


var $93cd0742d03568de$exports = {};
$93cd0742d03568de$exports = $parcel$resolve("ki0qe");


var $a7a1c799cf6d84f2$exports = {};
$a7a1c799cf6d84f2$exports = $parcel$resolve("dBT9i");


var $2a4490cf938b4210$exports = {};
$2a4490cf938b4210$exports = $parcel$resolve("4b3b7");


var $d1d20ef4c51edad3$exports = {};
$d1d20ef4c51edad3$exports = $parcel$resolve("dPb9k");


var $54876247db4f2eac$exports = {};
$54876247db4f2eac$exports = $parcel$resolve("jvJP4");


var $676e87c357b93bb7$exports = {};
$676e87c357b93bb7$exports = $parcel$resolve("j96t7");


var $50b752a00e238fcf$exports = {};
$50b752a00e238fcf$exports = $parcel$resolve("6CfMz");


var $850ec17fe0b3d3b7$exports = {};
$850ec17fe0b3d3b7$exports = $parcel$resolve("kmuN7");


var $54c7381be40a6569$exports = {};
$54c7381be40a6569$exports = $parcel$resolve("fBB8w");


var $d522e1d459fc426d$exports = {};
$d522e1d459fc426d$exports = $parcel$resolve("9auJa");


var $30dbcac468c50ccf$exports = {};
$30dbcac468c50ccf$exports = $parcel$resolve("7Tp3x");


var $5a6cd1094b40ab6e$exports = {};
$5a6cd1094b40ab6e$exports = $parcel$resolve("2rbmG");


var $d4fcefb786e8f2ce$exports = {};
$d4fcefb786e8f2ce$exports = $parcel$resolve("e92hD");


function $3e787ebbd2ddabdc$export$f04a61298a47a40f(props) {
    let iconSelected = "";
    const sizeStyle = props.sizeInPx ? {
        width: props.sizeInPx + "px",
        height: props.sizeInPx + "px"
    } : {};
    switch(props.icon){
        case "account":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($a29fd55c0701b91d$exports)));
            break;
        case "android":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($5a9dad2eead421f2$exports)));
            break;
        case "apple":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($cf327e182d542a3c$exports)));
            break;
        case "touchid":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($e0402c80051bfa0e$exports)));
            break;
        case "faceid":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($8e856ced514e9749$exports)));
            break;
        case "arrow":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($59142d729110ac2e$exports)));
            break;
        case "checkmark_purple_thin":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($7b6e6f5adb614555$exports)));
            break;
        case "checkmark_purple":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($2e8fc887b69b62e1$exports)));
            break;
        case "checkmark_yellow":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($ae0c8af364914b1e$exports)));
            break;
        case "cp_manage":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($32e806241f2a18f5$exports)));
            break;
        case "cp_password":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($8fdc46e08c1b73c0$exports)));
            break;
        case "cp_password_owned_ctrl":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($0c714ce0d314e7a9$exports)));
            break;
        case "cp_onboarding":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($1d344ab4fef82d2e$exports)));
            break;
        case "cp_problems":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($a77de29ccd763c4f$exports)));
            break;
        case "cross_cyan":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($03d0c8be92dd38a0$exports)));
            break;
        case "cross_purple":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d51bb8176522ee35$exports)));
            break;
        case "cross_red":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($3159a25dbf774227$exports)));
            break;
        case "cross_yellow":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($aaa585849837e88a$exports)));
            break;
        case "plus_purple":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($c67474dca8b02f71$exports)));
            break;
        case "minus_purple":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($c7cdbae387c36f22$exports)));
            break;
        case "feedback":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($0b45aa436dfc9d44$exports)));
            break;
        case "help":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($4abff82269beb2d2$exports)));
            break;
        case "hero_authenticated":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($727337ee6dac6402$exports)));
            break;
        case "hero_done":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($e7728e0a20d0c1cc$exports)));
            break;
        case "hero_welcome":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($5b5278f892501064$exports)));
            break;
        case "menu":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($72feb6b7651021d4$exports)));
            break;
        case "empty-circle":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($32c6fac65df2771e$exports)));
            break;
        case "x-circle":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($acc81c7e46eb6f12$exports)));
            break;
        case "x-circle-red":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($28c0550f825e6ff4$exports)));
            break;
        case "check-circle":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($735e3e057fc02eb0$exports)));
            break;
        case "logout":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($90dfe0602b54b71b$exports)));
            break;
        case "globe":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($3dc037c42c6f7121$exports)));
            break;
        case "camera":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($5fe57e489c50bc2a$exports)));
            break;
        case "camera_black":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($c3604bf273e60ce1$exports)));
            break;
        case "eye_open":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($3129e852eb2e1400$exports)));
            break;
        case "eye_closed":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($c36f348ee3bef44d$exports)));
            break;
        case "search":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($6d33ea96de8826e4$exports)));
            break;
        case "home":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($3922c35a2368658f$exports)));
            break;
        case "userguide":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($5bd2479e8094d981$exports)));
            break;
        case "book":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($1834688e497120e8$exports)));
            break;
        case "user":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($415dba170b2da42f$exports)));
            break;
        case "users":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($014a988abce36b22$exports)));
            break;
        case "error":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($10dff005c5531a60$exports)));
            break;
        case "warning":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d22c396e3aa3f2e4$exports)));
            break;
        case "success":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($a89adad7ea295ba2$exports)));
            break;
        case "info":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($004a3cb490e759bd$exports)));
            break;
        case "sad":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($8ba3e3a6d9ce78a0$exports)));
            break;
        case "other":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($1152c5be275f319f$exports)));
            break;
        case "other-disabled":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($56f808ce93d940c8$exports)));
            break;
        case "fido-passkey":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($3706187b2f2106b4$exports)));
            break;
        case "fido-passkey-disabled":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($08dc1803b3727f4a$exports)));
            break;
        case "apple-disabled":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($bcf7f63deabec1c3$exports)));
            break;
        case "windows-disabled":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($7372e02e2fde9e0d$exports)));
            break;
        case "android-disabled":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($90669e5f45420669$exports)));
            break;
        case "securitykey":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($1a99bd98bfabadab$exports)));
            break;
        case "step_1":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($5740d77e1fe139ee$exports)));
            break;
        case "step_2_fido":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($624a05c172eb2938$exports)));
            break;
        case "step_2_onboarding":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($236cf27418a2f2e8$exports)));
            break;
        case "step_2_password":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d9694e9cfb540574$exports)));
            break;
        case "step_3_fido":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($56dc35498b4004f8$exports)));
            break;
        case "step_3_onboarding":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($26c5514026b3367d$exports)));
            break;
        case "step_3_password":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($196a77ed7ad003d6$exports)));
            break;
        case "step_3_detached":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($c5ea7944d8564ad8$exports)));
            break;
        case "loading_cyan":
            iconSelected = (0, {});
            break;
        case "loading_yellow":
            iconSelected = (0, {});
            break;
        case "loading_purple":
            iconSelected = (0, {});
            break;
        case "device_switch_1":
            iconSelected = (0, {});
            break;
        case "device_switch_2":
            iconSelected = (0, {});
            break;
        case "device_switch_3":
            iconSelected = (0, {});
            break;
        case "android_authenticator_animation":
            iconSelected = (0, {});
            break;
        case "fido_hardwaretoken_animation":
            iconSelected = (0, {});
            break;
        case "iphone_fido_animation":
            iconSelected = (0, {});
            break;
        case "macbook_touchid_animation":
            iconSelected = (0, {});
            break;
        case "windows_hello_animation":
            iconSelected = (0, {});
            break;
        case "windows":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($2f2cd55bd5e17863$exports)));
            break;
        case "windows_hello":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d149b5b8a12e0935$exports)));
            break;
        case "smiley_unhappy":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($cafc515b8afdda76$exports)));
            break;
        case "fidodemo-start":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($1a70a7f9149b2753$exports)));
            break;
        case "windows_with_bluetooth_1_de":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($93cd0742d03568de$exports)));
            break;
        case "windows_with_bluetooth_2_de":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($a7a1c799cf6d84f2$exports)));
            break;
        case "windows_with_bluetooth_1_en":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($2a4490cf938b4210$exports)));
            break;
        case "windows_with_bluetooth_2_en":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d1d20ef4c51edad3$exports)));
            break;
        case "windows_without_bluetooth_1_de":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($54876247db4f2eac$exports)));
            break;
        case "windows_without_bluetooth_2_de":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($676e87c357b93bb7$exports)));
            break;
        case "windows_without_bluetooth_1_en":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($50b752a00e238fcf$exports)));
            break;
        case "windows_without_bluetooth_2_en":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($850ec17fe0b3d3b7$exports)));
            break;
        case "macos_without_bluetooth_1_de":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($54c7381be40a6569$exports)));
            break;
        case "macos_without_bluetooth_2_de":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d522e1d459fc426d$exports)));
            break;
        case "macos_without_bluetooth_1_en":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($30dbcac468c50ccf$exports)));
            break;
        case "macos_without_bluetooth_2_en":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($5a6cd1094b40ab6e$exports)));
            break;
        case "macos_with_bluetooth_1_de":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d4fcefb786e8f2ce$exports)));
            break;
        case "macos_with_bluetooth_1_en":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($d4fcefb786e8f2ce$exports)));
            break;
        case "copy_to_clipboard":
            iconSelected = (0, (/*@__PURE__*/$parcel$interopDefault($9bf6ee6292457400$exports)));
            break;
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("img", {
        onClick: props.onClick ? props.onClick : ()=>{},
        crossOrigin: "anonymous",
        id: props.id,
        "aria-label": props.id,
        className: [
            "icon",
            props.className
        ].join(" "),
        src: iconSelected,
        alt: props.alt ? props.alt : iconSelected + " icon",
        style: sizeStyle,
        title: props.titleText
    });
}






function $be519324e594a464$export$bc2fb203e7c919f() {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3e787ebbd2ddabdc$export$f04a61298a47a40f), {
                icon: "fidodemo-start",
                className: "start-image"
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                i18n: "fidodemo.start-1"
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                i18n: "fidodemo.start-2"
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("a", {
                href: (0, $dc040427e725bec3$export$d832b8b45145d2fd),
                className: "start-button",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $d1a3372e6796a71d$export$eff53e581ec9b13a), {
                    id: "fidodemo-start-button",
                    i18n: "fidodemo.start-button",
                    mode: "yellow"
                })
            })
        ]
    });
}



function $eb195b5bc020d9f5$export$6a6b5184c40f41af() {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $9db2e3ca9c00f750$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $9db2e3ca9c00f750$export$e7b0ac011bb776c6), {
                path: (0, $dc040427e725bec3$export$f6fd4406bbd70952),
                element: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $be519324e594a464$export$bc2fb203e7c919f), {})
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $9db2e3ca9c00f750$export$e7b0ac011bb776c6), {
                path: (0, $dc040427e725bec3$export$f6c409e8ade40ab2),
                element: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $5b05d51dad27ac0d$export$db881fc880a1af58), {})
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $9db2e3ca9c00f750$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $9db2e3ca9c00f750$export$444b3ab0cb9aec40), {
                    to: (0, $dc040427e725bec3$export$f6fd4406bbd70952)
                })
            })
        ]
    });
}









function $3d2f1d64e081dbfe$export$a6c7ac8248d6e38a(props) {
    let newClassName = props.className || "";
    if (props.underline === true) newClassName += " underline";
    if (props.strong === true) newClassName += " strong";
    if (props.link === undefined) return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("span", {
        onClick: props.onClick,
        id: props.id,
        "aria-label": props.id,
        className: [
            "link",
            props.color ? props.color : "",
            newClassName
        ].join(' '),
        children: props.text || props.children || "Link"
    });
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("a", {
        onClick: props.onClick,
        id: props.id,
        "aria-label": props.id,
        href: props.link,
        className: [
            "link",
            props.color ? props.color : "",
            newClassName
        ].join(' '),
        target: props.openInNewTab ? '_blank' : '',
        rel: "noopener noreferrer",
        children: props.text || props.children || props.link
    });
}




function $6d214e592ba1b16f$export$a06f1c675e846f6f(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    var _props_meBaseUrl;
    const meBaseUrl = (_props_meBaseUrl = props.meBaseUrl) !== null && _props_meBaseUrl !== void 0 ? _props_meBaseUrl : "";
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("footer", {
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
            className: "main-container-footer",
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                    className: "content-container-footer",
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "footer-item",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3d2f1d64e081dbfe$export$a6c7ac8248d6e38a), {
                                underline: true,
                                link: t('global.footer.imprint.link', {
                                    companyDomain: props.companyName
                                }),
                                openInNewTab: true,
                                text: t('global.footer.imprint.label')
                            })
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "footer-item",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3d2f1d64e081dbfe$export$a6c7ac8248d6e38a), {
                                underline: true,
                                link: t('global.footer.privacystatement.link', {
                                    companyDomain: props.companyName
                                }),
                                openInNewTab: true,
                                text: t('global.footer.privacystatement.label')
                            })
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "footer-item",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3d2f1d64e081dbfe$export$a6c7ac8248d6e38a), {
                                underline: true,
                                link: meBaseUrl + "/termsofuse",
                                openInNewTab: true,
                                text: t('global.footer.termsofuse.label')
                            })
                        }),
                        props.showGenderInfo && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "footer-item",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3d2f1d64e081dbfe$export$a6c7ac8248d6e38a), {
                                underline: true,
                                link: meBaseUrl + "/gender-hinweis",
                                openInNewTab: true,
                                text: t('global.footer.genderinfo.label')
                            })
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "footer-item",
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("a", {
                                href: meBaseUrl + "/cp/fidoCredentials",
                                children: t('global.footer.portal.label')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                    id: "copyright",
                    className: "footer-item",
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                        i18n: "global.footer.copyrightnote",
                        values: {
                            year: new Date().getFullYear()
                        }
                    })
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                    id: "love",
                    className: "footer-item",
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                            i18n: "global.footer.note.1"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                            id: "footer-emoji",
                            text: "\u2764\uFE0F"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                            i18n: "global.footer.note.2"
                        })
                    ]
                }),
                props.version && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                    id: "versionNumber",
                    onClick: props.onVersionClick,
                    text: props.version
                })
            ]
        })
    });
}




function $0ed8a78b3a6e8e3d$var$getGlobals() {
    var _uiParameterContainer_dataset;
    const uiParameterContainer = document.getElementById("uiParameter");
    let versionInfo = uiParameterContainer === null || uiParameterContainer === void 0 ? void 0 : (_uiParameterContainer_dataset = uiParameterContainer.dataset) === null || _uiParameterContainer_dataset === void 0 ? void 0 : _uiParameterContainer_dataset.versionInfo;
    if (!versionInfo || versionInfo === "%versionInfo%") versionInfo = "Version 0.0.1";
    return {
        versionInfo: versionInfo
    };
}
const $0ed8a78b3a6e8e3d$export$816be348776d53c1 = $0ed8a78b3a6e8e3d$var$getGlobals();



function $e26d9f45b4c62f85$export$44a75b4cf356df93() {
    if (window.location.hostname.search("merckgroup.com") > 0) return "merckgroup.com";
    return "emdgroup.com";
}



var $e7ccf24539311065$exports = {};
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $e7ccf24539311065$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});



var $46wWE = parcelRequire("46wWE");
/**
 * A function to wrap elements with a "wrapper" on a condition
 * @param {object} wrappingOptions
 *  condition == boolean condition, when to wrap
 *  wrapper == style to wrap. e.g <div>{children}</div>
 *  children == react passes whatever is between tags as children. Don't supply this yourself.
 */ var $3c7a91e04175cf70$export$39aecc95f0365819 = function ConditionalWrapper(_ref) {
    var condition = _ref.condition, wrapper = _ref.wrapper, children = _ref.children;
    return condition ? wrapper(children) : children;
};
function $3c7a91e04175cf70$var$_extends() {
    $3c7a91e04175cf70$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c7a91e04175cf70$var$_extends.apply(this, arguments);
}
function $3c7a91e04175cf70$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $3c7a91e04175cf70$var$_setPrototypeOf(subClass, superClass);
}
function $3c7a91e04175cf70$var$_setPrototypeOf(o, p) {
    $3c7a91e04175cf70$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3c7a91e04175cf70$var$_setPrototypeOf(o, p);
}
function $3c7a91e04175cf70$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3c7a91e04175cf70$export$8eb3892b442747bd = {
    TOP: "top",
    BOTTOM: "bottom",
    NONE: "none"
};
var $3c7a91e04175cf70$export$a83cc8fc1e235be1;
(function(SAME_SITE_OPTIONS) {
    SAME_SITE_OPTIONS["STRICT"] = "strict";
    SAME_SITE_OPTIONS["LAX"] = "lax";
    SAME_SITE_OPTIONS["NONE"] = "none";
})($3c7a91e04175cf70$export$a83cc8fc1e235be1 || ($3c7a91e04175cf70$export$a83cc8fc1e235be1 = {}));
var $3c7a91e04175cf70$export$294703df038a1b6f = {
    HIDDEN: "hidden",
    SHOW: "show",
    BY_COOKIE_VALUE: "byCookieValue"
};
var $3c7a91e04175cf70$export$2ba1cf4ce66b15cf = "CookieConsent";
var $3c7a91e04175cf70$var$_excluded = [
    "children"
];
var $3c7a91e04175cf70$var$DefaultButtonComponent = function DefaultButtonComponent(_ref) {
    var children = _ref.children, props = $3c7a91e04175cf70$var$_objectWithoutPropertiesLoose(_ref, $3c7a91e04175cf70$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement("button", Object.assign({}, props), children);
};
var $3c7a91e04175cf70$var$defaultCookieConsentProps = {
    disableStyles: false,
    hideOnAccept: true,
    hideOnDecline: true,
    location: $3c7a91e04175cf70$export$8eb3892b442747bd.BOTTOM,
    visible: $3c7a91e04175cf70$export$294703df038a1b6f.BY_COOKIE_VALUE,
    onAccept: function onAccept(_acceptedByScrolling) {},
    onDecline: function onDecline() {},
    cookieName: $3c7a91e04175cf70$export$2ba1cf4ce66b15cf,
    cookieValue: "true",
    declineCookieValue: "false",
    setDeclineCookie: true,
    buttonText: "I understand",
    declineButtonText: "I decline",
    debug: false,
    expires: 365,
    containerClasses: "CookieConsent",
    contentClasses: "",
    buttonClasses: "",
    buttonWrapperClasses: "",
    declineButtonClasses: "",
    buttonId: "rcc-confirm-button",
    declineButtonId: "rcc-decline-button",
    extraCookieOptions: {},
    disableButtonStyles: false,
    enableDeclineButton: false,
    flipButtons: false,
    sameSite: $3c7a91e04175cf70$export$a83cc8fc1e235be1.LAX,
    ButtonComponent: $3c7a91e04175cf70$var$DefaultButtonComponent,
    overlay: false,
    overlayClasses: "",
    onOverlayClick: function onOverlayClick() {},
    acceptOnOverlayClick: false,
    ariaAcceptLabel: "Accept cookies",
    ariaDeclineLabel: "Decline cookies",
    acceptOnScroll: false,
    acceptOnScrollPercentage: 25,
    customContentAttributes: {},
    customContainerAttributes: {},
    customButtonProps: {},
    customDeclineButtonProps: {},
    customButtonWrapperAttributes: {},
    style: {},
    buttonStyle: {},
    declineButtonStyle: {},
    contentStyle: {},
    overlayStyle: {}
};
var $3c7a91e04175cf70$var$defaultState = {
    visible: false,
    style: {
        alignItems: "baseline",
        background: "#353535",
        color: "white",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        left: "0",
        position: "fixed",
        width: "100%",
        zIndex: "999"
    },
    buttonStyle: {
        background: "#ffd42d",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "black",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    declineButtonStyle: {
        background: "#c12a2a",
        border: "0",
        borderRadius: "0px",
        boxShadow: "none",
        color: "#e5e5e5",
        cursor: "pointer",
        flex: "0 0 auto",
        padding: "5px 10px",
        margin: "15px"
    },
    contentStyle: {
        flex: "1 0 300px",
        margin: "15px"
    },
    overlayStyle: {
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: "999",
        backgroundColor: "rgba(0,0,0,0.3)"
    }
};
/**
 * Returns the value of the consent cookie
 * Retrieves the regular value first and if not found the legacy one according
 * to: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
 * @param {*} name optional name of the cookie
 */ var $3c7a91e04175cf70$export$a8e4ce6c059bdd6b = function getCookieConsentValue(name) {
    if (name === void 0) name = $3c7a91e04175cf70$export$2ba1cf4ce66b15cf;
    var cookieValue = (0, (/*@__PURE__*/$parcel$interopDefault($e7ccf24539311065$exports))).get(name); // if the cookieValue is undefined check for the legacy cookie
    if (cookieValue === undefined) return (0, (/*@__PURE__*/$parcel$interopDefault($e7ccf24539311065$exports))).get($3c7a91e04175cf70$export$ee149ea8a5f63691(name));
    return cookieValue;
};
/**
 * Reset the consent cookie
 * Remove the cookie on browser in order to allow user to change their consent
 * @param {*} name optional name of the cookie
 */ var $3c7a91e04175cf70$export$f3238b6dfe3e6b67 = function resetCookieConsentValue(name) {
    if (name === void 0) name = $3c7a91e04175cf70$export$2ba1cf4ce66b15cf;
    (0, (/*@__PURE__*/$parcel$interopDefault($e7ccf24539311065$exports))).remove(name);
};
/**
 * Get the legacy cookie name by the regular cookie name
 * @param {string} name of cookie to get
 */ var $3c7a91e04175cf70$export$ee149ea8a5f63691 = function getLegacyCookieName(name) {
    return name + "-legacy";
};
var $3c7a91e04175cf70$export$e06767a507a85916 = /*#__PURE__*/ function(_Component) {
    $3c7a91e04175cf70$var$_inheritsLoose(CookieConsent, _Component);
    function CookieConsent() {
        var _this;
        _this = _Component.apply(this, arguments) || this;
        _this.state = $3c7a91e04175cf70$var$defaultState;
        /**
     * checks whether scroll has exceeded set amount and fire accept if so.
     */ _this.handleScroll = function() {
            var acceptOnScrollPercentage = _this.props.acceptOnScrollPercentage; // (top / height) - height * 100
            var rootNode = document.documentElement;
            var body = document.body;
            var top = "scrollTop";
            var height = "scrollHeight";
            var percentage = (rootNode[top] || body[top]) / ((rootNode[height] || body[height]) - rootNode.clientHeight) * 100;
            if (percentage > acceptOnScrollPercentage) _this.accept(true);
        };
        _this.removeScrollListener = function() {
            var acceptOnScroll = _this.props.acceptOnScroll;
            if (acceptOnScroll) window.removeEventListener("scroll", _this.handleScroll);
        };
        return _this;
    }
    var _proto = CookieConsent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var debug = this.props.debug; // if cookie undefined or debug
        if (this.getCookieValue() === undefined || debug) {
            this.setState({
                visible: true
            }); // if acceptOnScroll is set to true and (cookie is undefined or debug is set to true), add a listener.
            if (this.props.acceptOnScroll) window.addEventListener("scroll", this.handleScroll, {
                passive: true
            });
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // remove listener if still set
        this.removeScrollListener();
    };
    _proto.accept = function accept(acceptedByScrolling) {
        var _acceptedByScrolling;
        if (acceptedByScrolling === void 0) acceptedByScrolling = false;
        var _this$props = this.props, cookieName = _this$props.cookieName, cookieValue = _this$props.cookieValue, hideOnAccept = _this$props.hideOnAccept, onAccept = _this$props.onAccept;
        this.setCookie(cookieName, cookieValue);
        onAccept((_acceptedByScrolling = acceptedByScrolling) != null ? _acceptedByScrolling : false);
        if (hideOnAccept) {
            this.setState({
                visible: false
            });
            this.removeScrollListener();
        }
    };
    _proto.overlayClick = function overlayClick() {
        var _this$props2 = this.props, acceptOnOverlayClick = _this$props2.acceptOnOverlayClick, onOverlayClick = _this$props2.onOverlayClick;
        if (acceptOnOverlayClick) this.accept();
        onOverlayClick();
    };
    _proto.decline = function decline() {
        var _this$props3 = this.props, cookieName = _this$props3.cookieName, declineCookieValue = _this$props3.declineCookieValue, hideOnDecline = _this$props3.hideOnDecline, onDecline = _this$props3.onDecline, setDeclineCookie = _this$props3.setDeclineCookie;
        if (setDeclineCookie) this.setCookie(cookieName, declineCookieValue);
        onDecline();
        if (hideOnDecline) this.setState({
            visible: false
        });
    };
    _proto.setCookie = function setCookie(cookieName, cookieValue) {
        var _this$props4 = this.props, extraCookieOptions = _this$props4.extraCookieOptions, expires = _this$props4.expires, sameSite = _this$props4.sameSite;
        var cookieSecurity = this.props.cookieSecurity;
        if (cookieSecurity === undefined) cookieSecurity = window.location ? window.location.protocol === "https:" : true;
        var cookieOptions = $3c7a91e04175cf70$var$_extends({
            expires: expires
        }, extraCookieOptions, {
            sameSite: sameSite,
            secure: cookieSecurity
        }); // Fallback for older browsers where can not set SameSite=None,
        // SEE: https://web.dev/samesite-cookie-recipes/#handling-incompatible-clients
        if (sameSite === $3c7a91e04175cf70$export$a83cc8fc1e235be1.NONE) (0, (/*@__PURE__*/$parcel$interopDefault($e7ccf24539311065$exports))).set($3c7a91e04175cf70$export$ee149ea8a5f63691(cookieName), cookieValue, cookieOptions);
         // set the regular cookie
        (0, (/*@__PURE__*/$parcel$interopDefault($e7ccf24539311065$exports))).set(cookieName, cookieValue, cookieOptions);
    };
    _proto.getCookieValue = function getCookieValue() {
        var cookieName = this.props.cookieName;
        return $3c7a91e04175cf70$export$a8e4ce6c059bdd6b(cookieName);
    };
    _proto.render = function render() {
        var _this2 = this;
        // If the bar shouldn't be visible don't render anything.
        switch(this.props.visible){
            case $3c7a91e04175cf70$export$294703df038a1b6f.HIDDEN:
                return null;
            case $3c7a91e04175cf70$export$294703df038a1b6f.BY_COOKIE_VALUE:
                if (!this.state.visible) return null;
                break;
        }
        var _this$props5 = this.props, location = _this$props5.location, style = _this$props5.style, buttonStyle = _this$props5.buttonStyle, declineButtonStyle = _this$props5.declineButtonStyle, contentStyle = _this$props5.contentStyle, disableStyles = _this$props5.disableStyles, buttonText = _this$props5.buttonText, declineButtonText = _this$props5.declineButtonText, containerClasses = _this$props5.containerClasses, contentClasses = _this$props5.contentClasses, buttonClasses = _this$props5.buttonClasses, buttonWrapperClasses = _this$props5.buttonWrapperClasses, declineButtonClasses = _this$props5.declineButtonClasses, buttonId = _this$props5.buttonId, declineButtonId = _this$props5.declineButtonId, disableButtonStyles = _this$props5.disableButtonStyles, enableDeclineButton = _this$props5.enableDeclineButton, flipButtons = _this$props5.flipButtons, ButtonComponent = _this$props5.ButtonComponent, overlay = _this$props5.overlay, overlayClasses = _this$props5.overlayClasses, overlayStyle = _this$props5.overlayStyle, ariaAcceptLabel = _this$props5.ariaAcceptLabel, ariaDeclineLabel = _this$props5.ariaDeclineLabel, customContainerAttributes = _this$props5.customContainerAttributes, customContentAttributes = _this$props5.customContentAttributes, customButtonProps = _this$props5.customButtonProps, customDeclineButtonProps = _this$props5.customDeclineButtonProps, customButtonWrapperAttributes = _this$props5.customButtonWrapperAttributes;
        var myStyle = {};
        var myButtonStyle = {};
        var myDeclineButtonStyle = {};
        var myContentStyle = {};
        var myOverlayStyle = {};
        if (disableStyles) {
            // if styles are disabled use the provided styles (or none)
            myStyle = Object.assign({}, style);
            myButtonStyle = Object.assign({}, buttonStyle);
            myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            myContentStyle = Object.assign({}, contentStyle);
            myOverlayStyle = Object.assign({}, overlayStyle);
        } else {
            // if styles aren't disabled merge them with the styles that are provided (or use default styles)
            myStyle = Object.assign({}, $3c7a91e04175cf70$var$_extends({}, this.state.style, style));
            myContentStyle = Object.assign({}, $3c7a91e04175cf70$var$_extends({}, this.state.contentStyle, contentStyle));
            myOverlayStyle = Object.assign({}, $3c7a91e04175cf70$var$_extends({}, this.state.overlayStyle, overlayStyle)); // switch to disable JUST the button styles
            if (disableButtonStyles) {
                myButtonStyle = Object.assign({}, buttonStyle);
                myDeclineButtonStyle = Object.assign({}, declineButtonStyle);
            } else {
                myButtonStyle = Object.assign({}, $3c7a91e04175cf70$var$_extends({}, this.state.buttonStyle, buttonStyle));
                myDeclineButtonStyle = Object.assign({}, $3c7a91e04175cf70$var$_extends({}, this.state.declineButtonStyle, declineButtonStyle));
            }
        } // syntactic sugar to enable user to easily select top / bottom
        switch(location){
            case $3c7a91e04175cf70$export$8eb3892b442747bd.TOP:
                myStyle.top = "0";
                break;
            case $3c7a91e04175cf70$export$8eb3892b442747bd.BOTTOM:
                myStyle.bottom = "0";
                break;
        }
        var buttonsToRender = []; // add decline button
        enableDeclineButton && buttonsToRender.push((0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement(ButtonComponent, Object.assign({
            key: "declineButton",
            style: myDeclineButtonStyle,
            className: declineButtonClasses,
            id: declineButtonId,
            "aria-label": ariaDeclineLabel,
            onClick: function onClick() {
                _this2.decline();
            }
        }, customDeclineButtonProps), declineButtonText)); // add accept button
        buttonsToRender.push((0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement(ButtonComponent, Object.assign({
            key: "acceptButton",
            style: myButtonStyle,
            className: buttonClasses,
            id: buttonId,
            "aria-label": ariaAcceptLabel,
            onClick: function onClick() {
                _this2.accept();
            }
        }, customButtonProps), buttonText));
        if (flipButtons) buttonsToRender.reverse();
        return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement($3c7a91e04175cf70$export$39aecc95f0365819, {
            condition: overlay,
            wrapper: function wrapper(children) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement("div", {
                    style: myOverlayStyle,
                    className: overlayClasses,
                    onClick: function onClick() {
                        _this2.overlayClick();
                    }
                }, children);
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement("div", Object.assign({
            className: "" + containerClasses,
            style: myStyle
        }, customContainerAttributes), (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement("div", Object.assign({
            style: myContentStyle,
            className: contentClasses
        }, customContentAttributes), this.props.children), (0, (/*@__PURE__*/$parcel$interopDefault($46wWE))).createElement("div", Object.assign({
            className: "" + buttonWrapperClasses
        }, customButtonWrapperAttributes), buttonsToRender.map(function(button) {
            return button;
        }))));
    };
    return CookieConsent;
}((0, $46wWE.Component));
$3c7a91e04175cf70$export$e06767a507a85916.defaultProps = $3c7a91e04175cf70$var$defaultCookieConsentProps;
var $3c7a91e04175cf70$export$2e2bcd8739ae039 = $3c7a91e04175cf70$export$e06767a507a85916;




function $ed37f4e04fd828b5$export$44fbea0b26cea290() {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    const companyDomain = (0, $e26d9f45b4c62f85$export$44a75b4cf356df93)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3c7a91e04175cf70$export$2e2bcd8739ae039), {
        ariaAcceptLabel: "cookie-button",
        buttonId: "cookie-button",
        location: "bottom",
        buttonText: t("global.cookie.confirm"),
        cookieName: "cookie_notice_accepted",
        style: {
            background: "rgb(45, 190, 205)",
            color: "white",
            alignItems: "center",
            minHeight: "75px",
            zIndex: 9999
        },
        declineButtonStyle: {
            fontSize: "13px",
            width: "80px"
        },
        expires: 150,
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
            className: "columns",
            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "column is-full",
                style: {
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("span", {
                    children: [
                        t("global.cookie.banner"),
                        " ",
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("a", {
                            href: t("global.footer.privacystatement.link", {
                                companyDomain: companyDomain
                            }),
                            style: {
                                textDecoration: "underline",
                                color: "white"
                            },
                            children: t("global.cookie.policy")
                        })
                    ]
                })
            })
        })
    });
}



parcelRequire("1GfRv");
function $a6a7df8a67f1c71c$export$1098d4de7cbde8b() {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {});
}





var $46wWE = parcelRequire("46wWE");





function $f87b701227eefa49$export$54c2e3dc7acea9f5(props) {
    function ListContent() {
        return props.subitems.map((child, index)=>{
            const idAndKey = props.id ? props.id + "-" + index.toString() : "list" + index;
            return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("li", {
                        id: idAndKey,
                        children: child
                    }, idAndKey),
                    props.useBreaksBetweenItems && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("br", {})
                ]
            });
        });
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: "listWrapper",
        children: [
            props.intro && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                text: props.intro
            }),
            props.type === "unordered" ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("ul", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(ListContent, {})
            }, props.id) : /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("ol", {
                "aria-label": props.id,
                id: props.id,
                className: props.className,
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(ListContent, {})
            }, props.id)
        ]
    });
}











function $0ddb7ce6392652a2$export$990656f854962d6b(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3d2f1d64e081dbfe$export$a6c7ac8248d6e38a), (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, props), {
        text: t(props.i18n)
    }));
}














function $c84bf066aac0907f$export$7b04fd966b4d789d(props) {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("button", {
        "aria-label": props.id,
        id: props.id,
        onClick: props.onClick,
        className: "navigation-entry",
        children: [
            props.icon ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $b546cd5b68e37a70$export$354bf2e0ef935856), {
                name: props.icon
            }) : /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {}),
            props.i18nNote ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "navigation-entry-note",
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                        i18n: props.i18nLabel,
                        className: "strong"
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                        i18n: props.i18nNote
                    })
                ]
            }) : /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                i18n: props.i18nLabel,
                className: "strong"
            }),
            props.children
        ]
    });
}








var $46wWE = parcelRequire("46wWE");


function $53c672eae9ed9fb5$export$69b1032f2ecdf404({ className: className, id: id, pulledRight: pulledRight, buttonSubmit: buttonSubmit, buttonCancel: buttonCancel, buttonSkip: buttonSkip, buttonBack: buttonBack, keyControlEnabled: keyControlEnabled, children: children, formId: formId }) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    (0, $46wWE.useEffect)(()=>{
        if (buttonSubmit) {
            const handleKeyDown = (event)=>{
                const element = document.getElementById(buttonSubmit.id);
                if (event.key === "Enter" && !event.repeat && element) {
                    const focusedElem = document.activeElement;
                    if (focusedElem && focusedElem.closest("form")) // No special handling needed for form childs.
                    return;
                    element.dispatchEvent(new MouseEvent("click", {
                        bubbles: true
                    }));
                }
            };
            if (keyControlEnabled) {
                document.addEventListener("keydown", handleKeyDown);
                return ()=>{
                    document.removeEventListener("keydown", handleKeyDown);
                };
            }
        }
    }, [
        keyControlEnabled,
        buttonSubmit
    ]);
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)($53c672eae9ed9fb5$export$ac88c09275a93df9, {
        id: id,
        className: className,
        pulledRight: pulledRight,
        children: [
            buttonCancel && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $44d65d2a768a7a29$export$353f5b6fc5456de1), {
                mode: "white",
                disabled: buttonCancel.disabled,
                onClick: buttonCancel.onClick,
                id: buttonCancel.id,
                label: buttonCancel.label || t('button.cancel')
            }),
            children,
            buttonSkip && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $44d65d2a768a7a29$export$353f5b6fc5456de1), {
                mode: "white",
                disabled: buttonSkip.disabled,
                onClick: buttonSkip.onClick,
                id: buttonSkip.id,
                label: buttonSkip.label || t('button.skip')
            }),
            buttonBack && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $44d65d2a768a7a29$export$353f5b6fc5456de1), {
                mode: "white",
                disabled: buttonBack.disabled,
                onClick: buttonBack.onClick,
                id: buttonBack.id,
                label: buttonBack.label || t('button.back')
            }),
            buttonSubmit && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $44d65d2a768a7a29$export$353f5b6fc5456de1), {
                type: "submit",
                form: formId || buttonSubmit.id + "-form",
                mode: "yellow",
                disabled: buttonSubmit.disabled,
                id: buttonSubmit.id || "submitButtonId",
                label: buttonSubmit.label || t('button.next'),
                loading: buttonSubmit.loading
            })
        ]
    });
}
function $53c672eae9ed9fb5$export$ac88c09275a93df9({ children: children, id: id, pulledRight: pulledRight, className: className }) {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
        id: id,
        className: [
            "buttonGroup",
            pulledRight ? "pulledRight" : "",
            className || ""
        ].join(" "),
        children: children
    });
}








function $713fc3b2d3b4f999$export$48513f6b9f8ce62d(props) {
    const handleChange = ()=>props.checked ? props.setChecked(false) : props.setChecked(true);
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "checkbox-wrapper",
            props.className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "checkbox-input",
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            "aria-label": props.id,
                            id: props.id,
                            type: "checkbox",
                            checked: props.checked,
                            onChange: handleChange
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "text",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                            "aria-label": props.id,
                            htmlFor: props.id,
                            children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                text: props.label,
                                className: props.bold ? "strong" : ""
                            })
                        })
                    })
                ]
            }),
            props.error && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                id: props.id ? props.id + "-error" : undefined,
                className: "checkbox_message",
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "checkbox_corner error"
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                        className: "checkbox_text error",
                        i18n: props.error
                    })
                ]
            }),
            props.warning && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                id: props.id ? props.id + "-warning" : undefined,
                className: "checkbox_message",
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "checkbox_corner warning"
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                        className: "checkbox_text warning",
                        i18n: props.warning
                    })
                ]
            })
        ]
    });
}







var $46wWE = parcelRequire("46wWE");



var $46wWE = parcelRequire("46wWE");
const $11824572b88db920$var$DigitRowContext = /*#__PURE__*/ (0, $46wWE.createContext)(undefined);
const $11824572b88db920$export$48fa5ab812999308 = ()=>{
    const context = (0, $46wWE.useContext)($11824572b88db920$var$DigitRowContext);
    if (context === undefined) throw new Error("useDigitRowContext must be used within a DigitRowProvider");
    return context;
};
function $11824572b88db920$export$e25f92f211ddcd3d({ children: children, onChange: onChange }) {
    const [digits, setDigits] = (0, $46wWE.useState)([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
    ]);
    const setDigit = (index, value, upperCase)=>{
        const newDigits = [
            ...digits
        ];
        if (value && upperCase) newDigits[index] = value.toUpperCase();
        else if (value && upperCase === false) newDigits[index] = value.toLowerCase();
        else newDigits[index] = value;
        setDigits(newDigits);
    };
    const setValue = (values, upperCase)=>{
        if (values && upperCase) setDigits(values.toUpperCase().split(""));
        else if (values && upperCase === false) setDigits(values.toLowerCase().split(""));
        else {
            const newDigits = values.split("");
            setDigits(newDigits);
        }
    };
    (0, $46wWE.useEffect)(()=>{
        const digitsText = digits.join("");
        console.log("Digits text: ", digitsText);
        onChange(digitsText);
    }, [
        digits,
        onChange
    ]);
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)($11824572b88db920$var$DigitRowContext.Provider, {
        value: {
            digits: digits,
            setDigit: setDigit,
            setValue: setValue
        },
        children: children
    });
}




function $5ae2ec030706d631$export$ac1439c7c53681be({ upperCase: upperCase, index: index, count: count, autoFocus: autoFocus, type: type = "password", onBlur: onBlur, fieldId: fieldId }) {
    const { digits: digits, setDigit: setDigit, setValue: setValue } = (0, $11824572b88db920$export$48fa5ab812999308)();
    const [metaPressed, setMetaPressed] = (0, $46wWE.useState)(false);
    const value = digits[index];
    const isAutoFocused = index === 0 ? autoFocus : false;
    const inputRef = (0, $46wWE.useRef)(null);
    function focusInput(sibling) {
        var _inputRef_current_previousElementSibling, _inputRef_current;
        if (sibling === "next") {
            var _inputRef_current1;
            const nextElement = (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1["nextElementSibling"];
            if ((nextElement === null || nextElement === void 0 ? void 0 : nextElement.selectionStart) && nextElement.selectionStart >= 0) nextElement.selectionStart = 0;
            nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
        } else (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : (_inputRef_current_previousElementSibling = _inputRef_current["previousElementSibling"]) === null || _inputRef_current_previousElementSibling === void 0 ? void 0 : _inputRef_current_previousElementSibling.focus();
    }
    function handleChange(event) {
        var _event_target;
        const value = (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value;
        setDigit(index, value[0], upperCase);
        console.log(`Digit value:`, digits);
        // We have to set cursor to the next input. If user do not release the key there is no up phase.
        if (!metaPressed && value && value.length >= 1) focusInput("next");
    }
    function handleKeyDown(event) {
        const input = event.currentTarget;
        // key up + meta events is not always working so we save the information from key down.
        const isMetaKey = event.ctrlKey || event.metaKey;
        setMetaPressed(isMetaKey);
        if (!isMetaKey && event.key === "Backspace" && input.selectionStart == 0) {
            focusInput("previous");
            return;
        }
        // If user types a new letter it erases an existing one.
        if (!isMetaKey && event.key !== "Backspace" && input.selectionStart == 0 && (value === null || value === void 0 ? void 0 : value.length) === 1) {
            setDigit(index, "", upperCase);
            return;
        }
    }
    function handlePaste(event) {
        event.preventDefault();
        const value = event.clipboardData.getData("text");
        setValue(value.slice(0, count), upperCase);
    }
    (0, $46wWE.useEffect)(()=>{
        if (isAutoFocused && inputRef.current) inputRef.current.focus();
    }, [
        isAutoFocused
    ]);
    const inputId = fieldId ? fieldId + "_" + index : undefined;
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
        "aria-label": inputId,
        id: inputId,
        pattern: type === "number" || type === "otp" ? "[0-9]" : undefined,
        type: type === "password" || type === "otp" ? "password" : "text",
        maxLength: 1,
        inputMode: type === "number" || type === "otp" ? "numeric" : "text",
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onPaste: handlePaste,
        onBlur: onBlur,
        ref: inputRef,
        value: value,
        className: (0, $f4d1d798408df2f5$export$2e2bcd8739ae039)("digit", {
            filled: value !== ""
        })
    });
}
function $5ae2ec030706d631$export$eabdbbad8115236a({ digits: digits, count: count = 3, onChange: onChange, onBlur: onBlur, type: type = "password", textLeftOfDigits: textLeftOfDigits, fieldId: fieldId, upperCase: upperCase }) {
    const fields = Array.from({
        length: count
    }, (_, index)=>/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)($5ae2ec030706d631$export$ac1439c7c53681be, {
            upperCase: upperCase,
            count: count,
            fieldId: fieldId,
            value: digits && digits[index],
            index: index,
            autoFocus: index === 0,
            type: type,
            onBlur: onBlur
        }, index));
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $11824572b88db920$export$e25f92f211ddcd3d), {
        onChange: onChange,
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $1f537e0bfb469332$export$a39947a896defee6), {
            justifyContent: "center",
            alignItems: "center",
            fullWidthChildren: false,
            flexWrap: "nowrap",
            children: [
                textLeftOfDigits && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("span", {
                    children: textLeftOfDigits
                }),
                fields
            ]
        })
    });
}
function $5ae2ec030706d631$export$86f235ef554f8320({ digits: digits, count: count, onChange: onChange, type: type, error: error, onBlur: onBlur, fieldId: fieldId, label: label, upperCase: upperCase }) {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: "digitInputWrapper",
        children: [
            label && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "digitInputLabel",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                    text: label
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "digitInput digit" + count,
                "aria-label": fieldId,
                id: fieldId,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)($5ae2ec030706d631$export$eabdbbad8115236a, {
                        upperCase: upperCase,
                        fieldId: fieldId,
                        digits: digits,
                        type: type,
                        textLeftOfDigits: undefined,
                        count: count,
                        onBlur: onBlur,
                        onChange: onChange
                    }),
                    error && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "textInput-notifications",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                            id: fieldId ? fieldId + "-error" : undefined,
                            className: "textInput_message",
                            children: [
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                                    className: "textInput_corner error"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("p", {
                                    className: " textInput_text error",
                                    children: error
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}








var $46wWE = parcelRequire("46wWE");



function $80d0829ba5e1c528$var$ErrorComponent({ i18n: i18n, fieldId: fieldId }) {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
        className: "textInput-notifications",
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
            id: fieldId ? fieldId + "-error" : undefined,
            className: "textInput_message",
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                    className: "textInput_corner error"
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                    className: "textInput_text error",
                    i18n: i18n
                })
            ]
        })
    });
}
function $80d0829ba5e1c528$export$e09d3f8093ed952e({ id: id, placeholderText: placeholderText, onChange: onChange, name: name, labelText: labelText, defaultValue: defaultValue }) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    const [selected, setSelected] = (0, $46wWE.useState)(defaultValue || 0);
    function formatSeconds(sec) {
        if (!sec || isNaN(sec)) return t("timechooser.invalidInput");
        let total = sec;
        const years = Math.floor(total / 31536000);
        total %= 31536000;
        const months = Math.floor(total / 2592000);
        total %= 2592000;
        const weeks = Math.floor(total / 604800);
        total %= 604800;
        const days = Math.floor(total / 86400);
        total %= 86400;
        const hours = Math.floor(total / 3600);
        total %= 3600;
        const minutes = Math.floor(total / 60);
        const secs = total % 60;
        const parts = [];
        if (years > 0) parts.push(t("timechooser.year", {
            count: years
        }));
        if (months > 0) parts.push(t("timechooser.month", {
            count: months
        }));
        if (weeks > 0) parts.push(t("timechooser.week", {
            count: weeks
        }));
        if (days > 0) parts.push(t("timechooser.day", {
            count: days
        }));
        if (hours > 0) parts.push(t("timechooser.hour", {
            count: hours
        }));
        if (minutes > 0) parts.push(t("timechooser.minute", {
            count: minutes
        }));
        if (secs > 0 || parts.length === 0) parts.push(t("timechooser.second", {
            count: secs
        }));
        return parts.join(", ");
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
            className: "textInput",
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                    className: "textInput_label",
                    children: labelText
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                    className: "input-password-wrapper",
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                        type: "number",
                        value: selected,
                        id: id,
                        name: name,
                        onChange: (e)=>{
                            const val = parseInt(e.target.value, 10);
                            if (selected !== val) {
                                setSelected(val);
                                if (onChange) onChange(val);
                            }
                        },
                        className: "textInput_input",
                        placeholder: placeholderText
                    })
                }),
                selected !== undefined && !isNaN(selected) && selected !== 0 && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                    className: "note",
                    text: formatSeconds(selected)
                }),
                selected === 0 && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)($80d0829ba5e1c528$var$ErrorComponent, {
                    i18n: "timechooser.invalidInputNull"
                }),
                (selected === undefined || isNaN(selected)) && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)($80d0829ba5e1c528$var$ErrorComponent, {
                    i18n: "timechooser.invalidInput"
                })
            ]
        })
    });
}










function $fdde7bf62d6d6728$export$9b2973464f783e9d(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "radiobutton-wrapper",
            props.className,
            props.hide ? "hide" : "",
            props.recommended ? "highlight" : "no-highlight"
        ].join(" "),
        children: [
            props.recommended && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "recommended-container",
                onClick: props.disabled ? ()=>{} : props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "recommended",
                        children: t("button.recommended")
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                        i18n: "fidoRegistration.startRegistration.currentDev"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "radiobutton-input-row",
                onClick: props.disabled ? ()=>{} : props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            id: props.id,
                            "aria-label": props.id,
                            type: "radio",
                            readOnly: true,
                            disabled: props.disabled,
                            checked: props.disabled ? false : props.selected
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: [
                            "image",
                            props.disabled ? "disabled" : ""
                        ].join(" "),
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3e787ebbd2ddabdc$export$f04a61298a47a40f), {
                            icon: props.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: props.disabled ? "disabled" : "",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                            htmlFor: props.id,
                            "aria-label": props.id,
                            children: props.label
                        })
                    })
                ]
            }),
            props.disabled && props.disabledDescription && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "radiobutton-content-row disable-description",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                    text: props.disabledDescription,
                    className: "note"
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: [
                    "radiobutton-content-row",
                    props.selected ? "" : "hide"
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "image",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3e787ebbd2ddabdc$export$f04a61298a47a40f), {
                            id: props.id ? props.id + "-image" : undefined,
                            icon: props.selected ? props.image : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: [
                            "text"
                        ].join(" "),
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                            text: props.text
                        })
                    })
                ]
            })
        ]
    });
}







function $87f22f1b465bbc95$export$fedad49d7d809de1(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "radiobutton-wrapper",
            props.className,
            props.hide ? "hide" : "",
            props.recommended ? "highlight" : "no-highlight"
        ].join(" "),
        children: [
            props.recommended && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "recommended",
                onClick: props.disabled ? ()=>{} : props.onClick,
                children: t("button.recommended")
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "radiobutton-input-row",
                onClick: props.disabled ? ()=>{} : props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            id: props.id,
                            "aria-label": props.id,
                            type: "radio",
                            readOnly: true,
                            disabled: props.disabled,
                            checked: props.disabled ? false : props.selected
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: [
                            "image",
                            props.disabled ? "disabled" : ""
                        ].join(" "),
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3e787ebbd2ddabdc$export$f04a61298a47a40f), {
                            icon: props.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: props.disabled ? "disabled" : "",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("label", {
                            htmlFor: props.id,
                            "aria-label": props.id,
                            children: [
                                props.label,
                                " ",
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("span", {
                                    className: [
                                        props.disabled ? "disabled font-weight-normal" : ""
                                    ].join(" "),
                                    children: props.labelNote
                                })
                            ]
                        })
                    })
                ]
            }),
            props.selected && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "radiobutton-content-row",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                    className: "text",
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                        text: props.text
                    })
                })
            })
        ]
    });
}






function $d9de01842e535943$export$f8cd7254b5528264(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    const getLeadingWord = (index)=>{
        if (index + 1 === 1) return t('button.radio.listingNumeric.first');
        else if (index + 1 === 2) return t('button.radio.listingNumeric.second');
        else if (index + 1 === 3) return t('button.radio.listingNumeric.third');
        else return t('button.radio.listingNumeric.step');
    };
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "radiobutton-wrapper",
            props.className,
            props.hide ? "hide" : "",
            props.recommended ? "highlight" : "no-highlight"
        ].join(" "),
        children: [
            props.recommended && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "recommended",
                onClick: props.onClick,
                children: t("button.recommended")
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "radiobutton-input-row",
                onClick: props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            id: props.id,
                            "aria-label": props.id,
                            readOnly: true,
                            type: "radio",
                            checked: props.selected
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                            htmlFor: props.id,
                            "aria-label": props.id,
                            children: props.label
                        })
                    })
                ]
            }),
            props.selected && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                style: props.spacing === false ? {
                    marginTop: "20px"
                } : {},
                className: "radiobutton-content-row listing",
                children: props.steps.map((str, index)=>{
                    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        children: !(props.spacing === false) ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                            className: "step",
                            children: [
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                    text: getLeadingWord(index),
                                    className: "radiobutton-content-row tabulator strong"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                    text: str
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                            className: "step",
                            children: [
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                    text: getLeadingWord(index),
                                    className: "mainColor strong"
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                    text: str,
                                    className: "mainColor"
                                })
                            ]
                        })
                    }, index);
                })
            })
        ]
    });
}






function $f431ba0f69faccc3$export$ad12a6896abe06e7(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    const getLeadingWord = (index)=>{
        return t('button.radio.listingStep.step') + index + ": ";
    };
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "radiobutton-wrapper",
            props.className,
            props.hide ? "hide" : "",
            props.recommended ? "highlight" : "no-highlight"
        ].join(" "),
        children: [
            props.recommended && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "recommended",
                onClick: props.onClick,
                children: t("button.recommended")
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "radiobutton-input-row",
                onClick: props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            id: props.id,
                            "aria-label": props.id,
                            readOnly: true,
                            type: "radio",
                            checked: props.selected
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                            htmlFor: props.id,
                            "aria-label": props.id,
                            children: props.label
                        })
                    })
                ]
            }),
            props.selected && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "radiobutton-content-row listing",
                children: props.steps.map((str, index)=>{
                    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                        className: "step",
                        children: [
                            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                    text: getLeadingWord(index)
                                })
                            }),
                            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                                text: str
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}






function $f5f1b7b638df7b19$export$1bc79bc389cba017(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "radiobutton-wrapper",
            props.className,
            props.hide ? "hide" : "",
            props.recommended ? "highlight" : "no-highlight"
        ].join(" "),
        onClick: props.disabled || !props.recommended ? undefined : props.onClick,
        children: [
            props.recommended && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                    className: "recommended-container",
                    onClick: props.disabled || props.recommended ? undefined : props.onClick,
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "recommended",
                            children: t("button.recommended")
                        }),
                        props.recommendedLabel && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                            text: props.recommendedLabel
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "radiobutton-input-row",
                onClick: props.disabled || props.recommended ? undefined : props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            id: props.id,
                            "aria-label": props.id,
                            type: "radio",
                            readOnly: true,
                            checked: props.selected
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                            htmlFor: props.id,
                            "aria-label": props.id,
                            children: props.label
                        })
                    })
                ]
            })
        ]
    });
}





function $ba8419db1043f9ed$export$d7a717e377d9a922(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "radiobutton-wrapper",
            props.className,
            props.hide ? "hide" : "",
            props.recommended ? "highlight" : "no-highlight"
        ].join(" "),
        children: [
            props.recommended && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "recommended",
                onClick: props.onClick,
                children: t("button.recommended")
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "radiobutton-input-row",
                onClick: props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            id: props.id,
                            type: "radio",
                            readOnly: true,
                            checked: props.selected
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                            htmlFor: props.id,
                            children: props.label
                        })
                    })
                ]
            }),
            props.selected && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "radiobutton-content-row",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("textarea", {
                    maxLength: props.maxLength,
                    className: "textarea",
                    name: "fido-enforce-disable-text",
                    rows: 3,
                    cols: 70,
                    onChange: (event)=>{
                        props.onTextChange(event.target.value);
                    },
                    placeholder: t('disableFidoEnforcement.textarea.placeholder')
                })
            })
        ]
    });
}






function $44f0b2007a1fd8bf$export$228d24c324c54eac(props) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: [
            "radiobutton-wrapper",
            props.className,
            props.hide ? "hide" : "",
            props.recommended ? "highlight" : "no-highlight"
        ].join(" "),
        children: [
            props.recommended && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "recommended",
                onClick: props.onClick,
                children: t("button.recommended")
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "radiobutton-input-row",
                onClick: props.onClick,
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            id: props.id,
                            "aria-label": props.id,
                            type: "radio",
                            readOnly: true,
                            checked: props.selected
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                            htmlFor: props.id,
                            "aria-label": props.id,
                            children: props.label
                        })
                    })
                ]
            }),
            props.selected && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "radiobutton-content-row",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                    className: "text",
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                        text: props.text ? props.text : ""
                    })
                })
            })
        ]
    });
}






function $1c82a1aaab81983a$export$c062ce1cc79ad58a(props) {
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
        className: [
            "radiobutton-group",
            props.className
        ].join(" "),
        children: props.children
    });
}






var $46wWE = parcelRequire("46wWE");




function $7526e7439afd99e0$export$c86715117507e8e5({ fieldId: fieldId, error: error, labelText: labelText, icon: icon, disabled: disabled, className: className, placeholderText: placeholderText, name: name, note: note, blurred: blurred, autofocus: autofocus, value: value, defaultValue: defaultValue, onChange: onChange, onBlur: onBlur, autoComplete: autoComplete }) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    const [blur, setBlur] = (0, $46wWE.useState)(true);
    const [warning, setWarning] = (0, $46wWE.useState)("");
    function checkCapslock(keyEvent) {
        if (keyEvent.getModifierState("CapsLock")) setWarning(t("textinput.caps"));
        else setWarning("");
    }
    function handleIconClick() {
        return blur ? setBlur(false) : setBlur(true);
    }
    function ErrorAndWarning() {
        if (error || warning) return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
            className: "textInput-notifications",
            children: [
                error && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                    id: fieldId ? fieldId + "-error" : undefined,
                    className: "textInput_message",
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "textInput_corner error"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                            className: "textInput_text error",
                            i18n: error
                        })
                    ]
                }),
                warning && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                    id: fieldId ? fieldId + "-warning" : undefined,
                    className: "textInput_message",
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                            className: "textInput_corner warning"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                            className: "textInput_text warning",
                            i18n: warning
                        })
                    ]
                })
            ]
        });
        else return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {});
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: "textInput",
        children: [
            labelText && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                className: "textInput_label",
                htmlFor: fieldId,
                "aria-label": fieldId,
                children: labelText
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "input-password-wrapper",
                children: [
                    icon && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3e787ebbd2ddabdc$export$f04a61298a47a40f), {
                        className: "img-left",
                        icon: "search",
                        sizeInPx: 16
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                        "aria-label": fieldId,
                        id: fieldId,
                        disabled: disabled,
                        className: [
                            'textInput_input',
                            className,
                            icon ? "icon" : ""
                        ].join(' '),
                        placeholder: placeholderText,
                        name: name,
                        type: blurred && blur ? "password" : "text",
                        autoComplete: autoComplete !== null && autoComplete !== void 0 ? autoComplete : undefined,
                        defaultValue: defaultValue,
                        onKeyDown: blurred && blur ? checkCapslock : undefined,
                        onChange: (e)=>onChange && onChange(e.target.value),
                        value: value,
                        onBlur: onBlur,
                        autoFocus: autofocus
                    }),
                    blurred && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3e787ebbd2ddabdc$export$f04a61298a47a40f), {
                        className: "img-right",
                        icon: blur ? "eye_closed" : "eye_open",
                        sizeInPx: 16,
                        onClick: handleIconClick,
                        titleText: blur ? t("textinput.password.hide") : t("textinput.password.show")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(ErrorAndWarning, {}),
            note && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $3a4f7e3d1369ff17$export$edde36960b8a13dc), {
                className: "note",
                i18n: note
            })
        ]
    });
}








function $45e2daa95f2ab6cc$export$bea8ebba691c5813(props) {
    function handleState() {
        return props.toggleState ? props.setToggleState(false) : props.setToggleState(true);
    }
    const sizeMap = {
        small: {
            width: "32px",
            height: "20px",
            checkSize: "14px"
        },
        medium: {
            width: "48px",
            height: "24px",
            checkSize: "18px"
        },
        large: {
            width: "60px",
            height: "31px",
            checkSize: "24px"
        }
    };
    const size = sizeMap[props.size || "large"];
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
        className: "toggle-wrapper",
        style: (0, $9b16bcd0300d97f8$export$71511d61b312f219)((0, $307af824b9387905$export$71511d61b312f219)({}, props === null || props === void 0 ? void 0 : props.style), {
            "--toggle-width": size.width,
            "--toggle-height": size.height,
            "--check-size": size.checkSize
        }),
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
            className: [
                "toggle checkcross",
                props.disabled ? "disabled" : "",
                props.className
            ].join(" "),
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                    checked: props.toggleState,
                    id: props.id,
                    "aria-label": props.id,
                    className: "toggle-input",
                    type: "checkbox",
                    onChange: handleState,
                    disabled: props.disabled
                }),
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("label", {
                    className: "toggle-item",
                    htmlFor: props.id,
                    "aria-label": props.id,
                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "check"
                    })
                })
            ]
        })
    });
}








function $96a68b1332cf1754$var$NavigationMenu({ userPrincipalName: userPrincipalName, username: username, toggleCollapse: toggleCollapse, collapseVisible: collapseVisible, entries: entries }) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    const [, setCurrentLang] = (0, $46wWE.useState)("de");
    const sidebarRef = (0, $46wWE.useRef)(null);
    (0, $46wWE.useEffect)(()=>{
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target) && collapseVisible) toggleCollapse();
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        collapseVisible,
        toggleCollapse
    ]);
    function changeLanguage() {
        var _i18next_resolvedLanguage;
        const lang = ((_i18next_resolvedLanguage = (0, $6aaf2cb5d81db2fa$export$2e2bcd8739ae039).resolvedLanguage) === null || _i18next_resolvedLanguage === void 0 ? void 0 : _i18next_resolvedLanguage.includes("de")) ? "en" : "de";
        (0, $6aaf2cb5d81db2fa$export$2e2bcd8739ae039).changeLanguage(lang, (err)=>{
            setCurrentLang(lang);
            if (err) return console.log("[CS] something went wrong loading", err);
        });
    }
    function UpperInformation() {
        if (collapseVisible) {
            // in open state
            if (username && userPrincipalName) return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "navigation-welcome",
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                        className: "strong name",
                        text: username
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $15efe08fe55aeef3$export$358a232cca1ab2ac), {
                        className: "mail",
                        text: userPrincipalName
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "navigation-welcome",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $c04612c89ad095ee$export$8310c02dbd1dcd43), {
                    type: "h4",
                    i18n: "navigation.welcome"
                })
            });
        } else // in close state
        return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
            className: "navigation-menu-heading"
        });
    }
    function CombineMenuEntries() {
        return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $c84bf066aac0907f$export$7b04fd966b4d789d), {
                    id: "navigation-language",
                    icon: "globe-01",
                    i18nLabel: t("navigation.changeLang.label"),
                    onClick: changeLanguage
                }),
                entries.map((entry)=>{
                    if (entry.id === "navigation-logout") return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $44d65d2a768a7a29$export$353f5b6fc5456de1), {
                        id: entry.id,
                        onClick: entry.onClick,
                        label: t(entry.i18nLabel)
                    }, entry.id);
                    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $c84bf066aac0907f$export$7b04fd966b4d789d), {
                        id: entry.id,
                        i18nLabel: entry.i18nLabel,
                        icon: entry.icon,
                        onClick: ()=>{
                            if (entry.onClick) {
                                entry.onClick();
                                setTimeout(toggleCollapse, 50); // to avoid flickering
                            }
                        },
                        i18nNote: entry.i18nNote
                    }, entry.id);
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
        className: "navigation-wrapper",
        ref: sidebarRef,
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                className: "navigation-header",
                onClick: toggleCollapse,
                children: collapseVisible ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $b546cd5b68e37a70$export$354bf2e0ef935856), {
                    id: "loginCollapse",
                    className: "toggle-container",
                    style: {
                        marginRight: "16px",
                        height: "50px"
                    },
                    name: "cross"
                }) : /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $b546cd5b68e37a70$export$354bf2e0ef935856), {
                    id: "loginCollapse",
                    className: "toggle-container",
                    name: "burger-menu"
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(UpperInformation, {}),
                    collapseVisible && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "navigation-content",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)(CombineMenuEntries, {})
                    })
                ]
            })
        ]
    });
}
function $96a68b1332cf1754$export$b8a61e5c71402559({ username: username, userPrincipalName: userPrincipalName, entries: entries, subpage: subpage, title: title }) {
    const { t: t } = (0, $0e22ef777d2e9544$export$9fc83ad70ead8663)();
    const navigate = (0, $9db2e3ca9c00f750$export$9770f232ac06a008)();
    const [collapseContentVisible, setCollapseContentVisible] = (0, $46wWE.useState)(false);
    function toggleCollapse() {
        if (collapseContentVisible) setCollapseContentVisible(false);
        else setCollapseContentVisible(true);
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("nav", {
        role: "navigation",
        "aria-label": "Navigation",
        className: collapseContentVisible ? "active navigation" : "",
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $1f537e0bfb469332$export$a39947a896defee6), {
                fullWidthChildren: false,
                alignItems: "center",
                gap: "16",
                children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("button", {
                    className: "storybook-icon-button navigation-header-button",
                    onClick: ()=>navigate("/cp/fidoCredentials"),
                    style: {
                        cursor: "pointer"
                    },
                    children: [
                        subpage ? /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $b546cd5b68e37a70$export$354bf2e0ef935856), {
                            style: {
                                fill: "var(--button-label-color)",
                                color: "var(--button-label-color)"
                            },
                            name: "real-arrow",
                            role: "img"
                        }) : /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $b546cd5b68e37a70$export$6d94deba6d109841), {
                            name: "logo",
                            viewBox: "0 0 32 16"
                        }),
                        title && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("span", {
                            className: "navigation-title",
                            children: t(title)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)($96a68b1332cf1754$var$NavigationMenu, {
                userPrincipalName: userPrincipalName,
                username: username,
                toggleCollapse: toggleCollapse,
                collapseVisible: collapseContentVisible,
                entries: entries
            })
        ]
    });
}




var $e1c0ee3ec692701e$var$dist = {};
var $e1c0ee3ec692701e$var$hasRequiredDist;
function $e1c0ee3ec692701e$var$requireDist() {
    if ($e1c0ee3ec692701e$var$hasRequiredDist) return $e1c0ee3ec692701e$var$dist;
    $e1c0ee3ec692701e$var$hasRequiredDist = 1;
    Object.defineProperty($e1c0ee3ec692701e$var$dist, "__esModule", {
        value: true
    });
    $e1c0ee3ec692701e$var$dist.parse = parse;
    $e1c0ee3ec692701e$var$dist.serialize = serialize;
    /**
	 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
	 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
	 * which has been replaced by the token definition in RFC 7230 appendix B.
	 *
	 * cookie-name       = token
	 * token             = 1*tchar
	 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
	 *                     "*" / "+" / "-" / "." / "^" / "_" /
	 *                     "`" / "|" / "~" / DIGIT / ALPHA
	 *
	 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
	 * Allow same range as cookie value, except `=`, which delimits end of name.
	 */ const cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
    /**
	 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
	 *
	 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
	 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
	 *                     ; US-ASCII characters excluding CTLs,
	 *                     ; whitespace DQUOTE, comma, semicolon,
	 *                     ; and backslash
	 *
	 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
	 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
	 */ const cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
    /**
	 * RegExp to match domain-value in RFC 6265 sec 4.1.1
	 *
	 * domain-value      = <subdomain>
	 *                     ; defined in [RFC1034], Section 3.5, as
	 *                     ; enhanced by [RFC1123], Section 2.1
	 * <subdomain>       = <label> | <subdomain> "." <label>
	 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
	 *                     Labels must be 63 characters or less.
	 *                     'let-dig' not 'letter' in the first char, per RFC1123
	 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
	 * <let-dig-hyp>     = <let-dig> | "-"
	 * <let-dig>         = <letter> | <digit>
	 * <letter>          = any one of the 52 alphabetic characters A through Z in
	 *                     upper case and a through z in lower case
	 * <digit>           = any one of the ten digits 0 through 9
	 *
	 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
	 *
	 * > (Note that a leading %x2E ("."), if present, is ignored even though that
	 * character is not permitted, but a trailing %x2E ("."), if present, will
	 * cause the user agent to ignore the attribute.)
	 */ const domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
    /**
	 * RegExp to match path-value in RFC 6265 sec 4.1.1
	 *
	 * path-value        = <any CHAR except CTLs or ";">
	 * CHAR              = %x01-7F
	 *                     ; defined in RFC 5234 appendix B.1
	 */ const pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
    const __toString = Object.prototype.toString;
    const NullObject = /* @__PURE__ */ (()=>{
        const C = function() {};
        C.prototype = Object.create(null);
        return C;
    })();
    /**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 */ function parse(str, options) {
        const obj = new NullObject();
        const len = str.length;
        // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
        if (len < 2) return obj;
        const dec = (options === null || options === void 0 ? void 0 : options.decode) || decode;
        let index = 0;
        do {
            const eqIdx = str.indexOf("=", index);
            if (eqIdx === -1) break; // No more cookie pairs.
            const colonIdx = str.indexOf(";", index);
            const endIdx = colonIdx === -1 ? len : colonIdx;
            if (eqIdx > endIdx) {
                // backtrack on prior semicolon
                index = str.lastIndexOf(";", eqIdx - 1) + 1;
                continue;
            }
            const keyStartIdx = startIndex(str, index, eqIdx);
            const keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
            const key = str.slice(keyStartIdx, keyEndIdx);
            // only assign once
            if (obj[key] === undefined) {
                let valStartIdx = startIndex(str, eqIdx + 1, endIdx);
                let valEndIdx = endIndex(str, endIdx, valStartIdx);
                const value = dec(str.slice(valStartIdx, valEndIdx));
                obj[key] = value;
            }
            index = endIdx + 1;
        }while (index < len);
        return obj;
    }
    function startIndex(str, index, max) {
        do {
            const code = str.charCodeAt(index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
        }while (++index < max);
        return max;
    }
    function endIndex(str, index, min) {
        while(index > min){
            const code = str.charCodeAt(--index);
            if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
        }
        return min;
    }
    /**
	 * Serialize data into a cookie header.
	 *
	 * Serialize a name value pair into a cookie string suitable for
	 * http headers. An optional options object specifies cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 */ function serialize(name, val, options) {
        const enc = (options === null || options === void 0 ? void 0 : options.encode) || encodeURIComponent;
        if (!cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
        const value = enc(val);
        if (!cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
        let str = name + "=" + value;
        if (!options) return str;
        if (options.maxAge !== undefined) {
            if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
            str += "; Max-Age=" + options.maxAge;
        }
        if (options.domain) {
            if (!domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
            str += "; Domain=" + options.domain;
        }
        if (options.path) {
            if (!pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
            str += "; Path=" + options.path;
        }
        if (options.expires) {
            if (!isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
            str += "; Expires=" + options.expires.toUTCString();
        }
        if (options.httpOnly) str += "; HttpOnly";
        if (options.secure) str += "; Secure";
        if (options.partitioned) str += "; Partitioned";
        if (options.priority) {
            const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
            switch(priority){
                case "low":
                    str += "; Priority=Low";
                    break;
                case "medium":
                    str += "; Priority=Medium";
                    break;
                case "high":
                    str += "; Priority=High";
                    break;
                default:
                    throw new TypeError(`option priority is invalid: ${options.priority}`);
            }
        }
        if (options.sameSite) {
            const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
            switch(sameSite){
                case true:
                case "strict":
                    str += "; SameSite=Strict";
                    break;
                case "lax":
                    str += "; SameSite=Lax";
                    break;
                case "none":
                    str += "; SameSite=None";
                    break;
                default:
                    throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
            }
        }
        return str;
    }
    /**
	 * URL-decode string value. Optimized to skip native call when no %.
	 */ function decode(str) {
        if (str.indexOf("%") === -1) return str;
        try {
            return decodeURIComponent(str);
        } catch (e) {
            return str;
        }
    }
    /**
	 * Determine if value is a Date.
	 */ function isDate(val) {
        return __toString.call(val) === "[object Date]";
    }
    return $e1c0ee3ec692701e$var$dist;
}
var $e1c0ee3ec692701e$var$distExports = $e1c0ee3ec692701e$var$requireDist();
function $e1c0ee3ec692701e$var$hasDocumentCookie() {
    const testingValue = typeof $parcel$global === 'undefined' ? undefined : $parcel$global.TEST_HAS_DOCUMENT_COOKIE;
    if (typeof testingValue === 'boolean') return testingValue;
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $e1c0ee3ec692701e$var$parseCookies(cookies) {
    if (typeof cookies === 'string') return $e1c0ee3ec692701e$var$distExports.parse(cookies);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $e1c0ee3ec692701e$var$readCookie(value, options = {}) {
    const cleanValue = $e1c0ee3ec692701e$var$cleanupCookieValue(value);
    if (!options.doNotParse) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $e1c0ee3ec692701e$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}
class $e1c0ee3ec692701e$export$2e2bcd8739ae039 {
    _emitChange(params) {
        for(let i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    }
    _checkChanges(previousCookies) {
        const names = new Set(Object.keys(previousCookies).concat(Object.keys(this.cookies)));
        names.forEach((name)=>{
            if (previousCookies[name] !== this.cookies[name]) this._emitChange({
                name: name,
                value: $e1c0ee3ec692701e$var$readCookie(this.cookies[name])
            });
        });
    }
    _startPolling() {
        this.pollingInterval = setInterval(this.update, 300);
    }
    _stopPolling() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
    }
    get(name, options = {}) {
        if (!options.doNotUpdate) this.update();
        return $e1c0ee3ec692701e$var$readCookie(this.cookies[name], options);
    }
    getAll(options = {}) {
        if (!options.doNotUpdate) this.update();
        const result = {};
        for(let name in this.cookies)result[name] = $e1c0ee3ec692701e$var$readCookie(this.cookies[name], options);
        return result;
    }
    set(name, value, options) {
        if (options) options = Object.assign(Object.assign({}, this.defaultSetOptions), options);
        else options = this.defaultSetOptions;
        const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        this.cookies = Object.assign(Object.assign({}, this.cookies), {
            [name]: stringValue
        });
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $e1c0ee3ec692701e$var$distExports.serialize(name, stringValue, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    }
    remove(name, options) {
        const finalOptions = options = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = Object.assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $e1c0ee3ec692701e$var$distExports.serialize(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    }
    addChangeListener(callback) {
        this.changeListeners.push(callback);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.addEventListener('change', this.update);
            else this._startPolling();
        }
    }
    removeChangeListener(callback) {
        const idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
        if (this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0) {
            if (typeof window === 'object' && 'cookieStore' in window) window.cookieStore.removeEventListener('change', this.update);
            else this._stopPolling();
        }
    }
    removeAllChangeListeners() {
        while(this.changeListeners.length > 0)this.removeChangeListener(this.changeListeners[0]);
    }
    constructor(cookies, defaultSetOptions = {}){
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.update = ()=>{
            if (!this.HAS_DOCUMENT_COOKIE) return;
            const previousCookies = this.cookies;
            this.cookies = $e1c0ee3ec692701e$var$distExports.parse(document.cookie);
            this._checkChanges(previousCookies);
        };
        const domCookies = typeof document === 'undefined' ? '' : document.cookie;
        this.cookies = $e1c0ee3ec692701e$var$parseCookies(cookies || domCookies);
        this.defaultSetOptions = defaultSetOptions;
        this.HAS_DOCUMENT_COOKIE = $e1c0ee3ec692701e$var$hasDocumentCookie();
    }
}



var $46wWE = parcelRequire("46wWE");
const $08f7d42c16ccb70a$var$CookiesContext = $46wWE.createContext(null);
const { Provider: $08f7d42c16ccb70a$var$Provider, Consumer: $08f7d42c16ccb70a$var$Consumer } = $08f7d42c16ccb70a$var$CookiesContext;
const $08f7d42c16ccb70a$export$f049e22368c2ed81 = (props)=>{
    const cookies = $46wWE.useMemo(()=>{
        if (props.cookies) return props.cookies;
        else return new (0, $e1c0ee3ec692701e$export$2e2bcd8739ae039)(undefined, props.defaultSetOptions);
    }, [
        props.cookies,
        props.defaultSetOptions
    ]);
    return $46wWE.createElement($08f7d42c16ccb70a$var$Provider, {
        value: cookies
    }, props.children);
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $08f7d42c16ccb70a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
function $08f7d42c16ccb70a$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $08f7d42c16ccb70a$var$reactIs = {
    exports: {}
};
var $08f7d42c16ccb70a$var$reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $08f7d42c16ccb70a$var$hasRequiredReactIs_production_min;
function $08f7d42c16ccb70a$var$requireReactIs_production_min() {
    if ($08f7d42c16ccb70a$var$hasRequiredReactIs_production_min) return $08f7d42c16ccb70a$var$reactIs_production_min;
    $08f7d42c16ccb70a$var$hasRequiredReactIs_production_min = 1;
    var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
        if ("object" === typeof a && null !== a) {
            var u = a.$$typeof;
            switch(u){
                case c:
                    switch(a = a.type, a){
                        case l:
                        case m:
                        case e:
                        case g:
                        case f:
                        case p:
                            return a;
                        default:
                            switch(a = a && a.$$typeof, a){
                                case k:
                                case n:
                                case t:
                                case r:
                                case h:
                                    return a;
                                default:
                                    return u;
                            }
                    }
                case d:
                    return u;
            }
        }
    }
    function A(a) {
        return z(a) === m;
    }
    $08f7d42c16ccb70a$var$reactIs_production_min.AsyncMode = l;
    $08f7d42c16ccb70a$var$reactIs_production_min.ConcurrentMode = m;
    $08f7d42c16ccb70a$var$reactIs_production_min.ContextConsumer = k;
    $08f7d42c16ccb70a$var$reactIs_production_min.ContextProvider = h;
    $08f7d42c16ccb70a$var$reactIs_production_min.Element = c;
    $08f7d42c16ccb70a$var$reactIs_production_min.ForwardRef = n;
    $08f7d42c16ccb70a$var$reactIs_production_min.Fragment = e;
    $08f7d42c16ccb70a$var$reactIs_production_min.Lazy = t;
    $08f7d42c16ccb70a$var$reactIs_production_min.Memo = r;
    $08f7d42c16ccb70a$var$reactIs_production_min.Portal = d;
    $08f7d42c16ccb70a$var$reactIs_production_min.Profiler = g;
    $08f7d42c16ccb70a$var$reactIs_production_min.StrictMode = f;
    $08f7d42c16ccb70a$var$reactIs_production_min.Suspense = p;
    $08f7d42c16ccb70a$var$reactIs_production_min.isAsyncMode = function(a) {
        return A(a) || z(a) === l;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isConcurrentMode = A;
    $08f7d42c16ccb70a$var$reactIs_production_min.isContextConsumer = function(a) {
        return z(a) === k;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isContextProvider = function(a) {
        return z(a) === h;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isElement = function(a) {
        return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isForwardRef = function(a) {
        return z(a) === n;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isFragment = function(a) {
        return z(a) === e;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isLazy = function(a) {
        return z(a) === t;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isMemo = function(a) {
        return z(a) === r;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isPortal = function(a) {
        return z(a) === d;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isProfiler = function(a) {
        return z(a) === g;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isStrictMode = function(a) {
        return z(a) === f;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isSuspense = function(a) {
        return z(a) === p;
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.isValidElementType = function(a) {
        return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    $08f7d42c16ccb70a$var$reactIs_production_min.typeOf = z;
    return $08f7d42c16ccb70a$var$reactIs_production_min;
}
var $08f7d42c16ccb70a$var$reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $08f7d42c16ccb70a$var$hasRequiredReactIs_development;
function $08f7d42c16ccb70a$var$requireReactIs_development() {
    if ($08f7d42c16ccb70a$var$hasRequiredReactIs_development) return $08f7d42c16ccb70a$var$reactIs_development;
    $08f7d42c16ccb70a$var$hasRequiredReactIs_development = 1;
    return $08f7d42c16ccb70a$var$reactIs_development;
}
var $08f7d42c16ccb70a$var$hasRequiredReactIs;
function $08f7d42c16ccb70a$var$requireReactIs() {
    if ($08f7d42c16ccb70a$var$hasRequiredReactIs) return $08f7d42c16ccb70a$var$reactIs.exports;
    $08f7d42c16ccb70a$var$hasRequiredReactIs = 1;
    $08f7d42c16ccb70a$var$reactIs.exports = $08f7d42c16ccb70a$var$requireReactIs_production_min();
    return $08f7d42c16ccb70a$var$reactIs.exports;
}
var $08f7d42c16ccb70a$var$hoistNonReactStatics_cjs;
var $08f7d42c16ccb70a$var$hasRequiredHoistNonReactStatics_cjs;
function $08f7d42c16ccb70a$var$requireHoistNonReactStatics_cjs() {
    if ($08f7d42c16ccb70a$var$hasRequiredHoistNonReactStatics_cjs) return $08f7d42c16ccb70a$var$hoistNonReactStatics_cjs;
    $08f7d42c16ccb70a$var$hasRequiredHoistNonReactStatics_cjs = 1;
    var reactIs = $08f7d42c16ccb70a$var$requireReactIs();
    /**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */ var REACT_STATICS = {
        childContextTypes: true,
        contextType: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromError: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    var FORWARD_REF_STATICS = {
        '$$typeof': true,
        render: true,
        defaultProps: true,
        displayName: true,
        propTypes: true
    };
    var MEMO_STATICS = {
        '$$typeof': true,
        compare: true,
        defaultProps: true,
        displayName: true,
        propTypes: true,
        type: true
    };
    var TYPE_STATICS = {};
    TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
    TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
    function getStatics(component) {
        // React v16.11 and below
        if (reactIs.isMemo(component)) return MEMO_STATICS;
         // React v16.12 and above
        return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
    }
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = Object.prototype;
    function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') {
            // don't hoist over string (html) components
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
            var keys = getOwnPropertyNames(sourceComponent);
            if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            var targetStatics = getStatics(targetComponent);
            var sourceStatics = getStatics(sourceComponent);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try {
                        // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
        }
        return targetComponent;
    }
    $08f7d42c16ccb70a$var$hoistNonReactStatics_cjs = hoistNonReactStatics;
    return $08f7d42c16ccb70a$var$hoistNonReactStatics_cjs;
}
var $08f7d42c16ccb70a$var$hoistNonReactStatics_cjsExports = $08f7d42c16ccb70a$var$requireHoistNonReactStatics_cjs();
var $08f7d42c16ccb70a$var$hoistStatics = /*@__PURE__*/ $08f7d42c16ccb70a$var$getDefaultExportFromCjs($08f7d42c16ccb70a$var$hoistNonReactStatics_cjsExports);
function $08f7d42c16ccb70a$export$7c2cd585733fa877(WrappedComponent) {
    // @ts-ignore
    const name = WrappedComponent.displayName || WrappedComponent.name;
    class CookieWrapper extends $46wWE.Component {
        listen() {
            this.props.cookies.addChangeListener(this.onChange);
        }
        unlisten(cookies) {
            (cookies || this.props.cookies).removeChangeListener(this.onChange);
        }
        componentDidMount() {
            this.listen();
        }
        componentDidUpdate(prevProps) {
            if (prevProps.cookies !== this.props.cookies) {
                this.unlisten(prevProps.cookies);
                this.listen();
            }
        }
        componentWillUnmount() {
            this.unlisten();
        }
        render() {
            const _a = this.props, { forwardedRef: forwardedRef, cookies: cookies } = _a, restProps = $08f7d42c16ccb70a$var$__rest(_a, [
                "forwardedRef",
                "cookies"
            ]);
            const allCookies = cookies.getAll({
                doNotUpdate: true
            });
            return $46wWE.createElement(WrappedComponent, Object.assign({}, restProps, {
                ref: forwardedRef,
                cookies: cookies,
                allCookies: allCookies
            }));
        }
        constructor(){
            super(...arguments);
            this.onChange = ()=>{
                // Make sure to update children with new values
                this.forceUpdate();
            };
        }
    }
    CookieWrapper.displayName = `withCookies(${name})`;
    CookieWrapper.WrappedComponent = WrappedComponent;
    const ForwardedComponent = $46wWE.forwardRef((props, ref)=>{
        return $46wWE.createElement($08f7d42c16ccb70a$var$Consumer, null, (cookies)=>$46wWE.createElement(CookieWrapper, Object.assign({
                cookies: cookies
            }, props, {
                forwardedRef: ref
            })));
    });
    ForwardedComponent.displayName = CookieWrapper.displayName;
    ForwardedComponent.WrappedComponent = CookieWrapper.WrappedComponent;
    return $08f7d42c16ccb70a$var$hoistStatics(ForwardedComponent, WrappedComponent);
}
function $08f7d42c16ccb70a$var$isInBrowser() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}
function $08f7d42c16ccb70a$export$14c4ae2979db17de(dependencies, options) {
    const cookies = (0, $46wWE.useContext)($08f7d42c16ccb70a$var$CookiesContext);
    if (!cookies) throw new Error('Missing <CookiesProvider>');
    const defaultOptions = {
        doNotUpdate: true
    };
    const getOptions = Object.assign(Object.assign({}, defaultOptions), options);
    const [allCookies, setCookies] = (0, $46wWE.useState)(()=>cookies.getAll(getOptions));
    if ($08f7d42c16ccb70a$var$isInBrowser()) (0, $46wWE.useLayoutEffect)(()=>{
        function onChange() {
            if (!cookies) throw new Error('Missing <CookiesProvider>');
            const newCookies = cookies.getAll(getOptions);
            if ($08f7d42c16ccb70a$var$shouldUpdate(dependencies || null, newCookies, allCookies)) setCookies(newCookies);
        }
        cookies.addChangeListener(onChange);
        return ()=>{
            cookies.removeChangeListener(onChange);
        };
    }, [
        cookies,
        allCookies
    ]);
    const setCookie = (0, $46wWE.useMemo)(()=>cookies.set.bind(cookies), [
        cookies
    ]);
    const removeCookie = (0, $46wWE.useMemo)(()=>cookies.remove.bind(cookies), [
        cookies
    ]);
    const updateCookies = (0, $46wWE.useMemo)(()=>cookies.update.bind(cookies), [
        cookies
    ]);
    return [
        allCookies,
        setCookie,
        removeCookie,
        updateCookies
    ];
}
function $08f7d42c16ccb70a$var$shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) return true;
    for (let dependency of dependencies){
        if (newCookies[dependency] !== oldCookies[dependency]) return true;
    }
    return false;
}



var $46wWE = parcelRequire("46wWE");
function $4aa2591ba47495b3$export$cad1a703886b4e3a({ logout: logout, account: account, contextPath: contextPath }) {
    const [cookies] = (0, $08f7d42c16ccb70a$export$14c4ae2979db17de)();
    const xsrfToken = cookies["XSRF-TOKEN"] || "";
    const formRef = (0, $46wWE.useRef)(null);
    (0, $46wWE.useEffect)(()=>{
        if (logout) {
            var _formRef_current;
            if (account) sessionStorage.setItem("force_login", "true");
            (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.submit();
        }
    }, [
        logout
    ]);
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $79c5e17b43bddc25$exports.Fragment), {
        children: logout && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("form", {
            action: `${contextPath}/logout`,
            method: "post",
            ref: formRef,
            children: [
                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                    type: "hidden",
                    name: "_csrf",
                    value: xsrfToken
                }),
                account && /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            type: "hidden",
                            name: "login",
                            value: "true"
                        }),
                        /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("input", {
                            type: "hidden",
                            name: "username",
                            value: account
                        })
                    ]
                })
            ]
        })
    });
}





var $4QmxT = parcelRequire("4QmxT");
function $0511694809450401$export$8d713f03a31872c4() {
    const acceptedValues = [
        "chrome",
        "firefox",
        "edge",
        "safari",
        "opera",
        "microsoft edge"
    ];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4QmxT))).name) {
        const val = (0, (/*@__PURE__*/$parcel$interopDefault($4QmxT))).name.trim();
        if (acceptedValues.includes(val.toLowerCase())) return val;
    }
    return "";
}
function $0511694809450401$export$e0604b13f38c5574() {
    //"BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle", "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
    const acceptedValues = [
        "ipad",
        "iphone"
    ];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4QmxT))).product) {
        const product = (0, (/*@__PURE__*/$parcel$interopDefault($4QmxT))).product.trim();
        if (acceptedValues.includes(product.toLowerCase())) return product;
    }
    return null;
}
function $0511694809450401$var$innerGetCurrentPlatform(acceptedValues, valProducer) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4QmxT))).os && (0, (/*@__PURE__*/$parcel$interopDefault($4QmxT))).os.family) {
        const val = valProducer();
        if (acceptedValues.includes(val)) return val;
    }
    return "other";
}
function $0511694809450401$export$c5f119cb923ce72c() {
    return $0511694809450401$var$innerGetCurrentPlatform([
        "Windows",
        "OS X",
        "Android",
        "iOS"
    ], ()=>{
        var _platform_os;
        return ((_platform_os = (0, (/*@__PURE__*/$parcel$interopDefault($4QmxT))).os) === null || _platform_os === void 0 ? void 0 : _platform_os.family) || "other";
    });
}
function $0511694809450401$export$3f371c276fa175de() {
    return $0511694809450401$export$c5f119cb923ce72c() === "Android";
}
function $0511694809450401$export$b98b2984b983287d() {
    return $0511694809450401$export$c5f119cb923ce72c().replace(/\s/g, "").toLowerCase();
}
function $0511694809450401$export$d07f57595c356899(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function $0511694809450401$export$252987abfd0090f7() {
    window.onbeforeunload = function() {
        return "";
    };
}
function $0511694809450401$export$617414071bb8c194() {
    window.onbeforeunload = null;
}
function $0511694809450401$export$336aca70919da38d(url) {
    window.open(url, "_blank", "noopener, noreferrer");
}
function $0511694809450401$export$e0f041868fb1d862(url) {
    $0511694809450401$export$617414071bb8c194();
    window.open(url, "_self", "noopener, noreferrer");
}
function $0511694809450401$export$c33481fdeca79d87(entry) {
    const exp = new RegExp("{{(.*?)}}", "g");
    const matches = entry.description.match(exp);
    if (!matches || matches.length === 0 || !entry.links) return undefined;
    const info = [];
    let text = entry.description;
    for (const match of matches){
        const innerMatch = match.substring(2, match.length - 2);
        if (!(innerMatch in entry.links)) continue;
        const arr = text.split(match);
        text = "";
        for(let i = 1; i < arr.length; i++){
            if (i !== 1) text = text + match;
            text = text + arr[i];
        }
        info.push({
            text: arr[0],
            url: entry.links[innerMatch]
        });
    }
    info.push({
        text: text,
        url: null
    });
    return info;
}
function $0511694809450401$export$d3b0f77b63f210d6() {
    switch($0511694809450401$export$b98b2984b983287d()){
        case "windows":
            return "Windows Hello";
        case "ios":
            return $0511694809450401$export$e0604b13f38c5574() || "iPhone";
        case "osx":
            {
                const productName = $0511694809450401$export$e0604b13f38c5574(); // this uses the user agent
                if (productName) return productName;
                // No user agent data for product or macbook
                const isPad = navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
                return isPad ? "iPad" : "Macbook";
            }
        case "android":
            return "Android Device";
        default:
            return "Device";
    }
}
function $0511694809450401$export$23dd1e59d0463c6c(name) {
    // if user used our name suggestions, we can identify the platform
    if (!name) return "fido-passkey";
    if (name.includes("iPhone") || name.includes("Macbook")) return "apple";
    else if (name.includes("Windows")) return "windows_hello";
    else if (name.includes("Android")) return "android";
    else if (name.includes("Security") || name.includes("Key")) return "fido-passkey";
    else return "fido-passkey";
}
function $0511694809450401$var$secureRandomCharUnbiased(chars) {
    const max = Math.floor(256 / chars.length) * chars.length;
    let random = new Uint8Array(1);
    do crypto.getRandomValues(random);
    while (random[0] >= max);
    return chars.charAt(random[0] % chars.length);
}
function $0511694809450401$export$7de75ff18d00ace7(length, characters) {
    const chars = characters || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += $0511694809450401$var$secureRandomCharUnbiased(chars);
    return result;
}
const $0511694809450401$export$943d597e6039c649 = '/cp/api';
const $0511694809450401$export$a9a724e5d7467de1 = '/cp/webapp';
const $0511694809450401$export$bcb673b8a0b7ff6e = '/cp';
const $0511694809450401$export$3156423073af36b4 = "/cp/fidoCredentials";
const $0511694809450401$export$9566a9005daffb7c = "/cp/protection";
const $0511694809450401$export$2b763517b62fd5ce = "/cp/less-secure-sign-ins";
const $0511694809450401$export$8f6fdb27182bf17e = ()=>window.origin + $0511694809450401$export$3156423073af36b4;
const $0511694809450401$export$75b00b050dce42e3 = ()=>window.origin + $0511694809450401$export$9566a9005daffb7c;
const $0511694809450401$export$5a0fa4b09790c7c2 = ()=>window.origin + $0511694809450401$export$2b763517b62fd5ce;


function $ca1f98805a4b2441$export$86fbec116b87613f() {
    const companyDomain = (0, $e26d9f45b4c62f85$export$44a75b4cf356df93)();
    const meBaseUrl = location.origin.replace("https://fidodemo", "https://me");
    function openFaqUrl() {
        var _i18next_resolvedLanguage;
        let url;
        if ((_i18next_resolvedLanguage = (0, $6aaf2cb5d81db2fa$export$2e2bcd8739ae039).resolvedLanguage) === null || _i18next_resolvedLanguage === void 0 ? void 0 : _i18next_resolvedLanguage.includes("de")) url = "https://evarooms.merckgroup.com/Topic/EUS/de-de/projekte/moving-beyond-passwords";
        else url = "https://evarooms.merckgroup.com/Topic/EUS/en-us/projects/moving-beyond-passwords/faq";
        (0, $0511694809450401$export$336aca70919da38d)(url);
    }
    return /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)((0, $79c5e17b43bddc25$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $96a68b1332cf1754$export$b8a61e5c71402559), {
                entries: [
                    {
                        id: "navigation-faq",
                        icon: "message-chat-square",
                        i18nLabel: "navigation.faq.label",
                        onClick: openFaqUrl
                    }
                ]
            }),
            /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                className: "main-container-wrapper",
                children: [
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $a6a7df8a67f1c71c$export$1098d4de7cbde8b), {}),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                        className: "main-content-wrapper",
                        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsxs)("div", {
                            className: "main-page-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("div", {
                                    className: "main-heading",
                                    children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $428c6867a99ff0e4$export$a8a3e93435678ff9), {
                                        text: (0, $6aaf2cb5d81db2fa$export$625550452a3fa3ec)("fidodemo.heading"),
                                        type: "h3"
                                    })
                                }),
                                /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $eb195b5bc020d9f5$export$6a6b5184c40f41af), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $6d214e592ba1b16f$export$a06f1c675e846f6f), {
                        companyName: companyDomain,
                        showGenderInfo: (0, $6aaf2cb5d81db2fa$export$2e2bcd8739ae039) && (0, $6aaf2cb5d81db2fa$export$2e2bcd8739ae039).language.startsWith("de"),
                        version: (0, $0ed8a78b3a6e8e3d$export$816be348776d53c1).versionInfo,
                        meBaseUrl: meBaseUrl
                    }),
                    /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $ed37f4e04fd828b5$export$44fbea0b26cea290), {})
                ]
            })
        ]
    });
}




function $c078c2d6d040e637$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c078c2d6d040e637$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c078c2d6d040e637$var$_typeof(o);
}
var $c078c2d6d040e637$var$arr = [];
var $c078c2d6d040e637$var$each = $c078c2d6d040e637$var$arr.forEach;
var $c078c2d6d040e637$var$slice = $c078c2d6d040e637$var$arr.slice;
function $c078c2d6d040e637$export$ebe90cb607ad99e(obj) {
    $c078c2d6d040e637$var$each.call($c078c2d6d040e637$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $c078c2d6d040e637$export$87022daa49baf612() {
    return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : $c078c2d6d040e637$var$_typeof(XMLHttpRequest)) === 'object';
}
function $c078c2d6d040e637$var$isPromise(maybePromise) {
    return !!maybePromise && typeof maybePromise.then === 'function';
}
function $c078c2d6d040e637$export$1625492ec82002b9(maybePromise) {
    if ($c078c2d6d040e637$var$isPromise(maybePromise)) return maybePromise;
    return Promise.resolve(maybePromise);
}



var $9c16482ea5ff2e28$exports = {};
var $9c16482ea5ff2e28$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $9c16482ea5ff2e28$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $9c16482ea5ff2e28$var$fetchApi = window.fetch;

if (typeof window === 'undefined') {
    var $9c16482ea5ff2e28$var$f = $9c16482ea5ff2e28$var$fetchApi || (parcelRequire("1zCs8"));
    if ($9c16482ea5ff2e28$var$f.default) $9c16482ea5ff2e28$var$f = $9c16482ea5ff2e28$var$f.default;
    $9c16482ea5ff2e28$exports.default = $9c16482ea5ff2e28$var$f;
    $9c16482ea5ff2e28$exports = $9c16482ea5ff2e28$exports.default;
}


function $249223a2c24320a3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $249223a2c24320a3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $249223a2c24320a3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $249223a2c24320a3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $249223a2c24320a3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $249223a2c24320a3$var$_defineProperty(e, r, t) {
    return (r = $249223a2c24320a3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $249223a2c24320a3$var$_toPropertyKey(t) {
    var i = $249223a2c24320a3$var$_toPrimitive(t, "string");
    return "symbol" == $249223a2c24320a3$var$_typeof(i) ? i : i + "";
}
function $249223a2c24320a3$var$_toPrimitive(t, r) {
    if ("object" != $249223a2c24320a3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $249223a2c24320a3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $249223a2c24320a3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $249223a2c24320a3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $249223a2c24320a3$var$_typeof(o);
}
var $249223a2c24320a3$var$fetchApi = typeof fetch === 'function' ? fetch : undefined;
if (typeof $parcel$global !== 'undefined' && $parcel$global.fetch) $249223a2c24320a3$var$fetchApi = $parcel$global.fetch;
else if (typeof window !== 'undefined' && window.fetch) $249223a2c24320a3$var$fetchApi = window.fetch;
var $249223a2c24320a3$var$XmlHttpRequestApi;
if ((0, $c078c2d6d040e637$export$87022daa49baf612)()) {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.XMLHttpRequest) $249223a2c24320a3$var$XmlHttpRequestApi = $parcel$global.XMLHttpRequest;
    else if (typeof window !== 'undefined' && window.XMLHttpRequest) $249223a2c24320a3$var$XmlHttpRequestApi = window.XMLHttpRequest;
}
var $249223a2c24320a3$var$ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.ActiveXObject) $249223a2c24320a3$var$ActiveXObjectApi = $parcel$global.ActiveXObject;
    else if (typeof window !== 'undefined' && window.ActiveXObject) $249223a2c24320a3$var$ActiveXObjectApi = window.ActiveXObject;
}
if (!$249223a2c24320a3$var$fetchApi && $9c16482ea5ff2e28$exports && !$249223a2c24320a3$var$XmlHttpRequestApi && !$249223a2c24320a3$var$ActiveXObjectApi) $249223a2c24320a3$var$fetchApi = $9c16482ea5ff2e28$exports.default || $9c16482ea5ff2e28$exports;
if (typeof $249223a2c24320a3$var$fetchApi !== 'function') $249223a2c24320a3$var$fetchApi = undefined;
var $249223a2c24320a3$var$addQueryString = function addQueryString(url, params) {
    if (params && $249223a2c24320a3$var$_typeof(params) === 'object') {
        var queryString = '';
        for(var paramName in params)queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
        if (!queryString) return url;
        url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
    }
    return url;
};
var $249223a2c24320a3$var$fetchIt = function fetchIt(url, fetchOptions, callback, altFetch) {
    var resolver = function resolver(response) {
        if (!response.ok) return callback(response.statusText || 'Error', {
            status: response.status
        });
        response.text().then(function(data) {
            callback(null, {
                status: response.status,
                data: data
            });
        }).catch(callback);
    };
    if (altFetch) {
        var altResponse = altFetch(url, fetchOptions);
        if (altResponse instanceof Promise) {
            altResponse.then(resolver).catch(callback);
            return;
        }
    }
    if (typeof fetch === 'function') fetch(url, fetchOptions).then(resolver).catch(callback);
    else $249223a2c24320a3$var$fetchApi(url, fetchOptions).then(resolver).catch(callback);
};
var $249223a2c24320a3$var$omitFetchOptions = false;
var $249223a2c24320a3$var$requestWithFetch = function requestWithFetch(options, url, payload, callback) {
    if (options.queryStringParams) url = $249223a2c24320a3$var$addQueryString(url, options.queryStringParams);
    var headers = $249223a2c24320a3$var$_objectSpread({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
    if (typeof window === 'undefined' && typeof $parcel$global !== 'undefined' && typeof $parcel$global.process !== 'undefined' && $parcel$global.process.versions && $parcel$global.process.versions.node) headers['User-Agent'] = "i18next-http-backend (node/".concat($parcel$global.process.version, "; ").concat($parcel$global.process.platform, " ").concat($parcel$global.process.arch, ")");
    if (payload) headers['Content-Type'] = 'application/json';
    var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
    var fetchOptions = $249223a2c24320a3$var$_objectSpread({
        method: payload ? 'POST' : 'GET',
        body: payload ? options.stringify(payload) : undefined,
        headers: headers
    }, $249223a2c24320a3$var$omitFetchOptions ? {} : reqOptions);
    var altFetch = typeof options.alternateFetch === 'function' && options.alternateFetch.length >= 1 ? options.alternateFetch : undefined;
    try {
        $249223a2c24320a3$var$fetchIt(url, fetchOptions, callback, altFetch);
    } catch (e) {
        if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) return callback(e);
        try {
            Object.keys(reqOptions).forEach(function(opt) {
                delete fetchOptions[opt];
            });
            $249223a2c24320a3$var$fetchIt(url, fetchOptions, callback, altFetch);
            $249223a2c24320a3$var$omitFetchOptions = true;
        } catch (err) {
            callback(err);
        }
    }
};
var $249223a2c24320a3$var$requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
    if (payload && $249223a2c24320a3$var$_typeof(payload) === 'object') payload = $249223a2c24320a3$var$addQueryString('', payload).slice(1);
    if (options.queryStringParams) url = $249223a2c24320a3$var$addQueryString(url, options.queryStringParams);
    try {
        var x;
        if ($249223a2c24320a3$var$XmlHttpRequestApi) x = new $249223a2c24320a3$var$XmlHttpRequestApi();
        else x = new $249223a2c24320a3$var$ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
        x.open(payload ? 'POST' : 'GET', url, 1);
        if (!options.crossDomain) x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.withCredentials = !!options.withCredentials;
        if (payload) x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        if (x.overrideMimeType) x.overrideMimeType('application/json');
        var h = options.customHeaders;
        h = typeof h === 'function' ? h() : h;
        if (h) for(var i in h)x.setRequestHeader(i, h[i]);
        x.onreadystatechange = function() {
            x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
                status: x.status,
                data: x.responseText
            });
        };
        x.send(payload);
    } catch (e) {
        console && console.log(e);
    }
};
var $249223a2c24320a3$var$request = function request(options, url, payload, callback) {
    if (typeof payload === 'function') {
        callback = payload;
        payload = undefined;
    }
    callback = callback || function() {};
    if ($249223a2c24320a3$var$fetchApi && url.indexOf('file:') !== 0) return $249223a2c24320a3$var$requestWithFetch(options, url, payload, callback);
    if ((0, $c078c2d6d040e637$export$87022daa49baf612)() || typeof ActiveXObject === 'function') return $249223a2c24320a3$var$requestWithXmlHttpRequest(options, url, payload, callback);
    callback(new Error('No fetch and no xhr implementation found!'));
};
var $249223a2c24320a3$export$2e2bcd8739ae039 = $249223a2c24320a3$var$request;


function $2365987ed99f15c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2365987ed99f15c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2365987ed99f15c0$var$_typeof(o);
}
function $2365987ed99f15c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2365987ed99f15c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2365987ed99f15c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2365987ed99f15c0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2365987ed99f15c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2365987ed99f15c0$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $2365987ed99f15c0$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $2365987ed99f15c0$var$_toPropertyKey(o.key), o);
    }
}
function $2365987ed99f15c0$var$_createClass(e, r, t) {
    return r && $2365987ed99f15c0$var$_defineProperties(e.prototype, r), t && $2365987ed99f15c0$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $2365987ed99f15c0$var$_defineProperty(e, r, t) {
    return (r = $2365987ed99f15c0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2365987ed99f15c0$var$_toPropertyKey(t) {
    var i = $2365987ed99f15c0$var$_toPrimitive(t, "string");
    return "symbol" == $2365987ed99f15c0$var$_typeof(i) ? i : i + "";
}
function $2365987ed99f15c0$var$_toPrimitive(t, r) {
    if ("object" != $2365987ed99f15c0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2365987ed99f15c0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2365987ed99f15c0$var$getDefaults = function getDefaults() {
    return {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
        addPath: '/locales/add/{{lng}}/{{ns}}',
        parse: function parse(data) {
            return JSON.parse(data);
        },
        stringify: JSON.stringify,
        parsePayload: function parsePayload(namespace, key, fallbackValue) {
            return $2365987ed99f15c0$var$_defineProperty({}, key, fallbackValue || '');
        },
        parseLoadPayload: function parseLoadPayload(languages, namespaces) {
            return undefined;
        },
        request: (0, $249223a2c24320a3$export$2e2bcd8739ae039),
        reloadInterval: typeof window !== 'undefined' ? false : 3600000,
        customHeaders: {},
        queryStringParams: {},
        crossDomain: false,
        withCredentials: false,
        overrideMimeType: false,
        requestOptions: {
            mode: 'cors',
            credentials: 'same-origin',
            cache: 'default'
        }
    };
};
var $2365987ed99f15c0$var$Backend = function() {
    function Backend(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $2365987ed99f15c0$var$_classCallCheck(this, Backend);
        this.services = services;
        this.options = options;
        this.allOptions = allOptions;
        this.type = 'backend';
        this.init(services, options, allOptions);
    }
    return $2365987ed99f15c0$var$_createClass(Backend, [
        {
            key: "init",
            value: function init(services) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $2365987ed99f15c0$var$_objectSpread($2365987ed99f15c0$var$_objectSpread($2365987ed99f15c0$var$_objectSpread({}, $2365987ed99f15c0$var$getDefaults()), this.options || {}), options);
                this.allOptions = allOptions;
                if (this.services && this.options.reloadInterval) {
                    var timer = setInterval(function() {
                        return _this.reload();
                    }, this.options.reloadInterval);
                    if ($2365987ed99f15c0$var$_typeof(timer) === 'object' && typeof timer.unref === 'function') timer.unref();
                }
            }
        },
        {
            key: "readMulti",
            value: function readMulti(languages, namespaces, callback) {
                this._readAny(languages, languages, namespaces, namespaces, callback);
            }
        },
        {
            key: "read",
            value: function read(language, namespace, callback) {
                this._readAny([
                    language
                ], language, [
                    namespace
                ], namespace, callback);
            }
        },
        {
            key: "_readAny",
            value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
                var _this2 = this;
                var loadPath = this.options.loadPath;
                if (typeof this.options.loadPath === 'function') loadPath = this.options.loadPath(languages, namespaces);
                loadPath = (0, $c078c2d6d040e637$export$1625492ec82002b9)(loadPath);
                loadPath.then(function(resolvedLoadPath) {
                    if (!resolvedLoadPath) return callback(null, {});
                    var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
                        lng: languages.join('+'),
                        ns: namespaces.join('+')
                    });
                    _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
                });
            }
        },
        {
            key: "loadUrl",
            value: function loadUrl(url, callback, languages, namespaces) {
                var _this3 = this;
                var lng = typeof languages === 'string' ? [
                    languages
                ] : languages;
                var ns = typeof namespaces === 'string' ? [
                    namespaces
                ] : namespaces;
                var payload = this.options.parseLoadPayload(lng, ns);
                this.options.request(this.options, url, payload, function(err, res) {
                    if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
                    if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
                    if (!res && err && err.message) {
                        var errorMessage = err.message.toLowerCase();
                        var isNetworkError = [
                            'failed',
                            'fetch',
                            'network',
                            'load'
                        ].find(function(term) {
                            return errorMessage.indexOf(term) > -1;
                        });
                        if (isNetworkError) return callback('failed loading ' + url + ': ' + err.message, true);
                    }
                    if (err) return callback(err, false);
                    var ret, parseErr;
                    try {
                        if (typeof res.data === 'string') ret = _this3.options.parse(res.data, languages, namespaces);
                        else ret = res.data;
                    } catch (e) {
                        parseErr = 'failed parsing ' + url + ' to json';
                    }
                    if (parseErr) return callback(parseErr, false);
                    callback(null, ret);
                });
            }
        },
        {
            key: "create",
            value: function create(languages, namespace, key, fallbackValue, callback) {
                var _this4 = this;
                if (!this.options.addPath) return;
                if (typeof languages === 'string') languages = [
                    languages
                ];
                var payload = this.options.parsePayload(namespace, key, fallbackValue);
                var finished = 0;
                var dataArray = [];
                var resArray = [];
                languages.forEach(function(lng) {
                    var addPath = _this4.options.addPath;
                    if (typeof _this4.options.addPath === 'function') addPath = _this4.options.addPath(lng, namespace);
                    var url = _this4.services.interpolator.interpolate(addPath, {
                        lng: lng,
                        ns: namespace
                    });
                    _this4.options.request(_this4.options, url, payload, function(data, res) {
                        finished += 1;
                        dataArray.push(data);
                        resArray.push(res);
                        if (finished === languages.length) {
                            if (typeof callback === 'function') callback(dataArray, resArray);
                        }
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                var _this5 = this;
                var _this$services = this.services, backendConnector = _this$services.backendConnector, languageUtils = _this$services.languageUtils, logger = _this$services.logger;
                var currentLanguage = backendConnector.language;
                if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
                var toLoad = [];
                var append = function append(lng) {
                    var lngs = languageUtils.toResolveHierarchy(lng);
                    lngs.forEach(function(l) {
                        if (toLoad.indexOf(l) < 0) toLoad.push(l);
                    });
                };
                append(currentLanguage);
                if (this.allOptions.preload) this.allOptions.preload.forEach(function(l) {
                    return append(l);
                });
                toLoad.forEach(function(lng) {
                    _this5.allOptions.ns.forEach(function(ns) {
                        backendConnector.read(lng, ns, 'read', null, null, function(err, data) {
                            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
                            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
                            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
                        });
                    });
                });
            }
        }
    ]);
}();
$2365987ed99f15c0$var$Backend.type = 'backend';
var $2365987ed99f15c0$export$2e2bcd8739ae039 = $2365987ed99f15c0$var$Backend;


const { slice: $225d9e3f02b23ec7$var$slice, forEach: $225d9e3f02b23ec7$var$forEach } = [];
function $225d9e3f02b23ec7$var$defaults(obj) {
    $225d9e3f02b23ec7$var$forEach.call($225d9e3f02b23ec7$var$slice.call(arguments, 1), (source)=>{
        if (source) {
            for(const prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $225d9e3f02b23ec7$var$hasXSS(input) {
    if (typeof input !== 'string') return false;
    // Common XSS attack patterns
    const xssPatterns = [
        /<\s*script.*?>/i,
        /<\s*\/\s*script\s*>/i,
        /<\s*img.*?on\w+\s*=/i,
        /<\s*\w+\s*on\w+\s*=.*?>/i,
        /javascript\s*:/i,
        /vbscript\s*:/i,
        /expression\s*\(/i,
        /eval\s*\(/i,
        /alert\s*\(/i,
        /document\.cookie/i,
        /document\.write\s*\(/i,
        /window\.location/i,
        /innerHTML/i
    ];
    return xssPatterns.some((pattern)=>pattern.test(input));
}
// eslint-disable-next-line no-control-regex
const $225d9e3f02b23ec7$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const $225d9e3f02b23ec7$var$serializeCookie = function(name, val) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        path: '/'
    };
    const opt = options;
    const value = encodeURIComponent(val);
    let str = `${name}=${value}`;
    if (opt.maxAge > 0) {
        const maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += `; Max-Age=${Math.floor(maxAge)}`;
    }
    if (opt.domain) {
        if (!$225d9e3f02b23ec7$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += `; Domain=${opt.domain}`;
    }
    if (opt.path) {
        if (!$225d9e3f02b23ec7$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += `; Path=${opt.path}`;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += `; Expires=${opt.expires.toUTCString()}`;
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    if (opt.partitioned) str += '; Partitioned';
    return str;
};
const $225d9e3f02b23ec7$var$cookie = {
    create (name, value, minutes, domain) {
        let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $225d9e3f02b23ec7$var$serializeCookie(name, value, cookieOptions);
    },
    read (name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove (name, domain) {
        this.create(name, '', -1, domain);
    }
};
var $225d9e3f02b23ec7$var$cookie$1 = {
    name: 'cookie',
    // Deconstruct the options object and extract the lookupCookie property
    lookup (_ref) {
        let { lookupCookie: lookupCookie } = _ref;
        if (lookupCookie && typeof document !== 'undefined') return $225d9e3f02b23ec7$var$cookie.read(lookupCookie) || undefined;
        return undefined;
    },
    // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
    cacheUserLanguage (lng, _ref2) {
        let { lookupCookie: lookupCookie, cookieMinutes: cookieMinutes, cookieDomain: cookieDomain, cookieOptions: cookieOptions } = _ref2;
        if (lookupCookie && typeof document !== 'undefined') $225d9e3f02b23ec7$var$cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
};
var $225d9e3f02b23ec7$var$querystring = {
    name: 'querystring',
    // Deconstruct the options object and extract the lookupQuerystring property
    lookup (_ref) {
        let { lookupQuerystring: lookupQuerystring } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            var _window_location_hash;
            let { search: search } = window.location;
            if (!window.location.search && ((_window_location_hash = window.location.hash) === null || _window_location_hash === void 0 ? void 0 : _window_location_hash.indexOf('?')) > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            const query = search.substring(1);
            const params = query.split('&');
            for(let i = 0; i < params.length; i++){
                const pos = params[i].indexOf('=');
                if (pos > 0) {
                    const key = params[i].substring(0, pos);
                    if (key === lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $225d9e3f02b23ec7$var$hash = {
    name: 'hash',
    // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
    lookup (_ref) {
        let { lookupHash: lookupHash, lookupFromHashIndex: lookupFromHashIndex } = _ref;
        let found;
        if (typeof window !== 'undefined') {
            const { hash: hash } = window.location;
            if (hash && hash.length > 2) {
                const query = hash.substring(1);
                if (lookupHash) {
                    const params = query.split('&');
                    for(let i = 0; i < params.length; i++){
                        const pos = params[i].indexOf('=');
                        if (pos > 0) {
                            const key = params[i].substring(0, pos);
                            if (key === lookupHash) found = params[i].substring(pos + 1);
                        }
                    }
                }
                if (found) return found;
                if (!found && lookupFromHashIndex > -1) {
                    var _language_index;
                    const language = hash.match(/\/([a-zA-Z-]*)/g);
                    if (!Array.isArray(language)) return undefined;
                    const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
                    return (_language_index = language[index]) === null || _language_index === void 0 ? void 0 : _language_index.replace('/', '');
                }
            }
        }
        return found;
    }
};
let $225d9e3f02b23ec7$var$hasLocalStorageSupport = null;
const $225d9e3f02b23ec7$var$localStorageAvailable = ()=>{
    if ($225d9e3f02b23ec7$var$hasLocalStorageSupport !== null) return $225d9e3f02b23ec7$var$hasLocalStorageSupport;
    try {
        $225d9e3f02b23ec7$var$hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
        if (!$225d9e3f02b23ec7$var$hasLocalStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $225d9e3f02b23ec7$var$hasLocalStorageSupport = false;
    }
    return $225d9e3f02b23ec7$var$hasLocalStorageSupport;
};
var $225d9e3f02b23ec7$var$localStorage = {
    name: 'localStorage',
    // Deconstruct the options object and extract the lookupLocalStorage property
    lookup (_ref) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref;
        if (lookupLocalStorage && $225d9e3f02b23ec7$var$localStorageAvailable()) return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
        return undefined;
    },
    // Deconstruct the options object and extract the lookupLocalStorage property
    cacheUserLanguage (lng, _ref2) {
        let { lookupLocalStorage: lookupLocalStorage } = _ref2;
        if (lookupLocalStorage && $225d9e3f02b23ec7$var$localStorageAvailable()) window.localStorage.setItem(lookupLocalStorage, lng);
    }
};
let $225d9e3f02b23ec7$var$hasSessionStorageSupport = null;
const $225d9e3f02b23ec7$var$sessionStorageAvailable = ()=>{
    if ($225d9e3f02b23ec7$var$hasSessionStorageSupport !== null) return $225d9e3f02b23ec7$var$hasSessionStorageSupport;
    try {
        $225d9e3f02b23ec7$var$hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
        if (!$225d9e3f02b23ec7$var$hasSessionStorageSupport) return false;
        const testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $225d9e3f02b23ec7$var$hasSessionStorageSupport = false;
    }
    return $225d9e3f02b23ec7$var$hasSessionStorageSupport;
};
var $225d9e3f02b23ec7$var$sessionStorage = {
    name: 'sessionStorage',
    lookup (_ref) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref;
        if (lookupSessionStorage && $225d9e3f02b23ec7$var$sessionStorageAvailable()) return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
        return undefined;
    },
    cacheUserLanguage (lng, _ref2) {
        let { lookupSessionStorage: lookupSessionStorage } = _ref2;
        if (lookupSessionStorage && $225d9e3f02b23ec7$var$sessionStorageAvailable()) window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
};
var $225d9e3f02b23ec7$var$navigator$1 = {
    name: 'navigator',
    lookup (options) {
        const found = [];
        if (typeof navigator !== 'undefined') {
            const { languages: languages, userLanguage: userLanguage, language: language } = navigator;
            if (languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(let i = 0; i < languages.length; i++)found.push(languages[i]);
            if (userLanguage) found.push(userLanguage);
            if (language) found.push(language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $225d9e3f02b23ec7$var$htmlTag = {
    name: 'htmlTag',
    // Deconstruct the options object and extract the htmlTag property
    lookup (_ref) {
        let { htmlTag: htmlTag } = _ref;
        let found;
        const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') found = internalHtmlTag.getAttribute('lang');
        return found;
    }
};
var $225d9e3f02b23ec7$var$path = {
    name: 'path',
    // Deconstruct the options object and extract the lookupFromPathIndex property
    lookup (_ref) {
        var _language_index;
        let { lookupFromPathIndex: lookupFromPathIndex } = _ref;
        if (typeof window === 'undefined') return undefined;
        const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
        if (!Array.isArray(language)) return undefined;
        const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
        return (_language_index = language[index]) === null || _language_index === void 0 ? void 0 : _language_index.replace('/', '');
    }
};
var $225d9e3f02b23ec7$var$subdomain = {
    name: 'subdomain',
    lookup (_ref) {
        var _window_location_hostname, _window_location;
        let { lookupFromSubdomainIndex: lookupFromSubdomainIndex } = _ref;
        // If given get the subdomain index else 1
        const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group match which should be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        const language = typeof window !== 'undefined' && ((_window_location = window.location) === null || _window_location === void 0 ? void 0 : (_window_location_hostname = _window_location.hostname) === null || _window_location_hostname === void 0 ? void 0 : _window_location_hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i));
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[internalLookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
let $225d9e3f02b23ec7$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $225d9e3f02b23ec7$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
const $225d9e3f02b23ec7$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$225d9e3f02b23ec7$var$canCookies) $225d9e3f02b23ec7$var$order.splice(1, 1);
const $225d9e3f02b23ec7$var$getDefaults = ()=>({
        order: $225d9e3f02b23ec7$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: (l)=>l
    });
class $225d9e3f02b23ec7$export$2e2bcd8739ae039 {
    init() {
        let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            languageUtils: {}
        };
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.services = services;
        this.options = $225d9e3f02b23ec7$var$defaults(options, this.options || {}, $225d9e3f02b23ec7$var$getDefaults());
        if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = (l)=>l.replace('-', '_');
        // backwards compatibility
        if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
        this.i18nOptions = i18nOptions;
        this.addDetector($225d9e3f02b23ec7$var$cookie$1);
        this.addDetector($225d9e3f02b23ec7$var$querystring);
        this.addDetector($225d9e3f02b23ec7$var$localStorage);
        this.addDetector($225d9e3f02b23ec7$var$sessionStorage);
        this.addDetector($225d9e3f02b23ec7$var$navigator$1);
        this.addDetector($225d9e3f02b23ec7$var$htmlTag);
        this.addDetector($225d9e3f02b23ec7$var$path);
        this.addDetector($225d9e3f02b23ec7$var$subdomain);
        this.addDetector($225d9e3f02b23ec7$var$hash);
    }
    addDetector(detector) {
        this.detectors[detector.name] = detector;
        return this;
    }
    detect() {
        let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
        let detected = [];
        detectionOrder.forEach((detectorName)=>{
            if (this.detectors[detectorName]) {
                let lookup = this.detectors[detectorName].lookup(this.options);
                if (lookup && typeof lookup === 'string') lookup = [
                    lookup
                ];
                if (lookup) detected = detected.concat(lookup);
            }
        });
        detected = detected.filter((d)=>d !== undefined && d !== null && !$225d9e3f02b23ec7$var$hasXSS(d)).map((d)=>this.options.convertDetectedLanguage(d));
        if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
        return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
    cacheUserLanguage(lng) {
        let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
        if (!caches) return;
        if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
        caches.forEach((cacheName)=>{
            if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
        });
    }
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
}
$225d9e3f02b23ec7$export$2e2bcd8739ae039.type = 'languageDetector';



var $a9c8fd28034e5718$exports = {};
'use strict';
function $a9c8fd28034e5718$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a9c8fd28034e5718$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a9c8fd28034e5718$var$checkDCE();

$a9c8fd28034e5718$exports = (parcelRequire("6nJ62"));


const $1173bffe88267656$var$root = (0, $a9c8fd28034e5718$exports.createRoot)(document.getElementById('root'));
(0, $6aaf2cb5d81db2fa$export$2e2bcd8739ae039).use((0, $2365987ed99f15c0$export$2e2bcd8739ae039)).use((0, $225d9e3f02b23ec7$export$2e2bcd8739ae039)).use((0, $0ab9c89aa0526111$export$ae7e14d40d89f296)).init({
    fallbackLng: "en",
    // have a common namespace used around the full app
    ns: [
        "translations"
    ],
    defaultNS: "translations",
    backend: {
        // for all available options read the backend's repository readme file
        loadPath: `${(0, $dc040427e725bec3$export$a9a724e5d7467de1)}/assets/text/locale/{{lng}}`
    },
    debug: false,
    interpolation: {
        escapeValue: false // not needed for react!
    },
    react: {
        transKeepBasicHtmlNodesFor: [
            'br',
            'strong',
            'i',
            'p',
            'b',
            'ul',
            'li',
            'a'
        ]
    }
}).then(()=>$1173bffe88267656$var$root.render(/*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $de85a50705c2b3be$export$9ba4e89fdfa1fc54), {
        future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true
        },
        children: /*#__PURE__*/ (0, $79c5e17b43bddc25$exports.jsx)((0, $ca1f98805a4b2441$export$86fbec116b87613f), {})
    })));


//# sourceMappingURL=fidodemo.337095c1.js.map
